(function() {
    'use strict';

    angular
        .module('ordiniApp', [
            'ngStorage', 
            'tmh.dynamicLocale',
            'pascalprecht.translate', 
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'infinite-scroll',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar'
        ])
        .run(run);

    run.$inject = ['stateHandler', 'translationHandler'];

    function run(stateHandler, translationHandler) {
        stateHandler.initialize();
        translationHandler.initialize();
    }
})();

(function() {
    //'use strict';

    angular
        .module('ordiniApp')
        .controller('MultipleSendController',MultipleSendController);

    MultipleSendController.$inject = ['$uibModalInstance', '$filter', 'controller', 'entityName', 'entity', 'Decisione', 'Dichiarazione', 'Ordine', 'Permissions'];

    function MultipleSendController($uibModalInstance, $filter, controller, entityName, entity, Decisione, Dichiarazione, Ordine, Permissions) {
        var vm = this;

    	vm.utenteLogin = Permissions.getAccount().login;
        vm.clear = clear;
        vm.confirm = confirm;
        vm.controller = controller;
        vm.entityName = entityName;
        vm.error = null;
        vm.decisione = null;
        vm.dichiarazione = null;
        vm.ordine = null;
        vm.cbDecisione = true;
        vm.cbDichiarazione = true;
        vm.cbOrdine = true;
        vm.decisioneOK = true;
        vm.dichiarazioneOK = true;
        vm.ordineOK = true;
        vm.statoValido = statoValido;
        vm.addMessage=addMessage;
        vm.inviaEnabled = true;
        vm.errorRows = 0;
        
        {
			if (vm.entityName=='ordine') {
				vm.ordine = entity;
				
	        	Dichiarazione.get({id : vm.ordine.dichiarazione.id}, function(result) {
		 			vm.dichiarazione=result;
		        });

	        	Decisione.get({id : vm.ordine.dichiarazione.decisione.id}, function(result) {
		 			vm.decisione=result;
		        });

			} else if (vm.entityName=='dichiarazione') {
				vm.dichiarazione = entity;
					
	        	Decisione.get({id : vm.dichiarazione.decisione.id}, function(result) {
		 			vm.decisione=result;
		        });
			}
        }
 
        function statoValido (stato) {
        	if (stato=='IN_COMPILAZIONE'||
        			stato=='RIFIUTATO_DA_RESPONSABILE'||
        			stato=='RIFIUTATO_DA_AMMINISTRAZIONE'||
        			stato=='RIFIUTATO_DA_DIRETTORE')
        		return true;
        	else
        		return false;
        }
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function decisioneUpdate () {
    		vm.decisione.stato="INVIATO";
    		vm.decisioneOK=false;
    		Decisione.update(vm.decisione, onDecisioneSaveSuccess, onDecisioneSaveError);
        }

        function dichiarazioneUpdate () {
			if (vm.dichiarazione.decisione.impegno.gae.finanziamento.responsabileFondi.direttore == true ||
				vm.dichiarazione.decisione.impegno.gae.finanziamento.responsabileFondi.user.login == vm.utenteLogin)
				vm.dichiarazione.stato='INVIATO_A_AMMINISTRAZIONE';
			else
				vm.dichiarazione.stato='INVIATO';
    		vm.dichiarazioneOK=false;
			Dichiarazione.update(vm.dichiarazione, onDichiarazioneSaveSuccess, onDichiarazioneSaveError);
        }

        function ordineUpdate () {
			if (vm.ordine.dichiarazione.decisione.impegno.gae.finanziamento.responsabileFondi.direttore == true ||
				vm.ordine.dichiarazione.decisione.impegno.gae.finanziamento.responsabileFondi.user.login == vm.utenteLogin)
				vm.ordine.stato='INVIATO_A_AMMINISTRAZIONE';
			else
				vm.ordine.stato='INVIATO';
    		vm.ordineOK=false;
			Ordine.update(vm.ordine, onOrdineSaveSuccess, onOrdineSaveError);
        }

        function confirm (id) {
        	if (vm.decisione!=null&&vm.cbDecisione&&vm.entityName!='decisione'&&vm.statoValido(vm.decisione.stato)) {
        		decisioneUpdate();
        	}
        	if (vm.dichiarazione!=null&&vm.cbDichiarazione&&vm.entityName!='dichiarazione'&&vm.statoValido(vm.dichiarazione.stato)) {
        		dichiarazioneUpdate();
        	}
        	if (vm.ordine!=null&&vm.cbOrdine&&vm.entityName!='ordine'&&vm.statoValido(vm.ordine.stato)) {
        		ordineUpdate();
        	}

        	var send=false;
        	if ((vm.cbDecisione&&vm.entityName=='decisione')||
        			(vm.cbDichiarazione&&vm.entityName=='dichiarazione')||
        			(vm.cbOrdine&&vm.entityName=='ordine'))
        		send=true;
        	
        	if (vm.decisioneOK&&vm.dichiarazioneOK&&vm.ordineOK)
	        	$uibModalInstance.close(send);
        }
        
        function onDecisioneSaveSuccess (result) {
        	vm.decisioneOK=true;
			vm.dichiarazione=result;
			
        	var send=false;
        	if ((vm.cbDecisione&&vm.entityName=='decisione')||
        			(vm.cbDichiarazione&&vm.entityName=='dichiarazione')||
        			(vm.cbOrdine&&vm.entityName=='ordine'))
        		send=true;

        	vm.addMessage("La Decisione di contrattare è stata inviata correttamente");

        	if (vm.decisioneOK&&vm.dichiarazioneOK&&vm.ordineOK)
	        	$uibModalInstance.close(send);
        }

        function onDecisioneSaveError () {
    		// rimetto in compilazione per riabilitare il checkbox
    		vm.decisione.stato="IN_COMPILAZIONE";
    		vm.addMessage("Non è stato possibile inviare la Decisione di contrattare, correggere l'errore segnalato e inviarlo nuovamente.");
            vm.inviaEnabled = false;
        }

        function onDichiarazioneSaveSuccess (result) {
        	vm.dichiarazioneOK=true;
			vm.dichiarazione=result;

        	var send=false;
        	if ((vm.cbDecisione&&vm.entityName=='decisione')||
        			(vm.cbDichiarazione&&vm.entityName=='dichiarazione')||
        			(vm.cbOrdine&&vm.entityName=='ordine'))
        		send=true;

        	vm.addMessage("La Dichiarazione RUP è stata inviata correttamente");

        	if (vm.decisioneOK&&vm.dichiarazioneOK&&vm.ordineOK)
	        	$uibModalInstance.close(send);
        }

        function onDichiarazioneSaveError () {
    		// rimetto in compilazione per riabilitare il checkbox
    		vm.dichiarazione.stato="IN_COMPILAZIONE";
        	vm.addMessage("Non è stato possibile inviare la Dichiarazione RUP, correggere l'errore segnalato e inviarlo nuovamente.");
            vm.inviaEnabled = false;
        }

        function onOrdineSaveSuccess (result) {
        	vm.ordineOK=true;
			vm.ordine=result;

        	var send=false;
        	if ((vm.cbDecisione&&vm.entityName=='decisione')||
        			(vm.cbDichiarazione&&vm.entityName=='dichiarazione')||
        			(vm.cbOrdine&&vm.entityName=='ordine'))
        		send=true;

        	vm.addMessage("L'Ordine è stato inviato correttamente");

        	if (vm.decisioneOK&&vm.dichiarazioneOK&&vm.ordineOK)
	        	$uibModalInstance.close(send);
        }

        function onOrdineSaveError () {
    		// rimetto in compilazione per riabilitare il checkbox
    		vm.ordine.stato="IN_COMPILAZIONE";
        	vm.addMessage("Non è stato possibile inviare l'Ordine, correggere l'errore segnalato e inviarlo nuovamente.");
            vm.inviaEnabled = false;
        }

        function addMessage (msg) {
        	if (vm.error==null||vm.error=="") {
        		vm.error=msg;
        		vm.errorRows=vm.errorRows+Math.ceil(msg.length/80);
        	}		
        	else {
        		vm.error=vm.error+"\n\n"+msg;
        		vm.errorRows=vm.errorRows+Math.ceil(msg.length/80)+1;
        	}
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('Permissions', Permissions);

    Permissions.$inject = ['$http', 'Principal'];

    function Permissions ($http, Principal) {
        var service = {
           	getAccount: getAccount,
        	loadPermissionTree: loadPermissionTree,
        	getPermissionTree: getPermissionTree,
        	hasRole: hasRole,
        	hasOneOfRoles: hasOneOfRoles,
        	loadRoles: loadRoles,
        	hasPermission: hasPermission
        };

        var vm = this;
        vm.account=null;
        vm.permissionTree=null;
        vm.roles=null;
        
        loadPermissionTree();
        loadRoles();

        return service;
        
        function getAccount() {
        	if (vm.account==null)
        		loadRoles();
        	return vm.account;
        }

        function loadPermissionTree () {
            return $http.get('api/util/permission-tree').then(getTree);

            function getTree (response) {
            	vm.permissionTree=response.data
            	return response;
            }
        }

        function getPermissionTree () {
        	if (vm.permissionTree==null)
        		loadPermissionTree();
        }

        function hasRole (role) {
        	if (vm.roles!=null) {
            	var i, len;
            	for (i = 0, len = vm.roles.length; i < len; i++) {
            		if (vm.roles[i]===role)
            			return true;
            	}
        	}
        	return false;
        }

        function hasOneOfRoles (roles) {
        	if (vm.roles!=null) {
	        	var i, len;
	        	for (i = 0, len = vm.roles.length; i < len; i++) {
	            	var j, len2, text;        	
	            	for (j = 0, len2 = roles.length; j < len2; j++) {
	            		if (vm.roles[i]===roles[j])
	            			return true;
	            	}
	        	}
        	}
        	return false;
        }

        function loadRoles () {
            
        	Principal.identity().then(function(account) {
                vm.account = account;
                if (account!=null)
                	vm.roles = account.authorities;
            });

        }

// non più usato, ora uso il service Principal        
//        function loadRoles () {
//            return $http.get('/api/util/roles').then(getRoles);
//        		
//            function getRoles (response) {
//            	vm.roles=response.data
//            	return response;
//            }
//        }

        function hasPermission(func, operation) {

        	if (vm.permissionTree!=null) {
	        	var roles = vm.permissionTree.roleFunctions;
				for (var i = 0; i < vm.roles.length; i++) {
		        	var functions = vm.permissionTree.roleFunctions[vm.roles[i]];
		        	if (functions!=null) {
			        	var operations = functions[func];
			        	if (operations!=null) {
							for (var j = 0; j < operations.length; j++) {
					        	if (operations[j]===operation)
					        		return true;
							}
						}
		        	}
				}
        	}
        	return false;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('MailSigns', MailSigns);

    MailSigns.$inject = ['$http'];

    function MailSigns ($http) {
        var service = {
        	sendMail: sendMail,
        	sendMailMepa: sendMailMepa
        };

        return service;
        
        function sendMail (vmp, id) {
            return $http({
        			url: 'api/mail-signs/', 
        			method: 'POST',
        			params: {id: id}
            	}).then(getResponse, onError);

            function getResponse (response) {
            	vmp.mailSent(response);
            	return response;
            }

            function onError (response) {
            	return response;
            }
        }

        function sendMailMepa (vmp, id) {
            return $http({
        			url: 'api/mail-signs-mepa/', 
        			method: 'POST',
        			params: {id: id}
            	}).then(getResponse, onError);

            function getResponse (response) {
            	vmp.mailSent(response);
            	return response;
            }

            function onError (response) {
            	return response;
            }
        }
    }
})();

(function() {
    //'use strict';

    angular
        .module('ordiniApp')
        .controller('EntityRejectController',EntityRejectController);

    EntityRejectController.$inject = ['$uibModalInstance', '$filter', 'controller', 'entityName'];

    function EntityRejectController($uibModalInstance, $filter, controller, entityName) {
        var vm = this;

        vm.motivazioneRifiuto = "";
        vm.clear = clear;
        vm.confirm = confirm;
        vm.controller = controller;
        vm.entityName = entityName;
        vm.error = null;
        vm.motivazioneRifiutoMaxLength=1000; // lunghezza del campo motivazioneRifiuto
        vm.dichiarazioneMotivazioneRifiutoMaxLength=10000; // lunghezza del campo motivazioneRifiuto dell'entità entityName
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirm (id) {
        	
        	var localDate = new Date;
        	
        	data = $filter('date')(localDate, "dd/MM/yyyy HH:mm:ss");
        	
        	var tipoRifiuto="RIFIUTATO_DA_AMMINISTRAZIONE";
        	if (vm.controller[vm.entityName].stato=="INVIATO_A_DIRETTORE")
        		tipoRifiuto="RIFIUTATO_DA_DIRETTORE";
        	else if (vm.controller[vm.entityName].stato=="INVIATO_A_RESPONSABILE")
        		tipoRifiuto="RIFIUTATO_DA_RESPONSABILE";
        	
        	var motivazioni="";
        	if (vm.controller[vm.entityName].motivazioneRifiuto!=null)
        		motivazioni="\n\n"+vm.controller[vm.entityName].motivazioneRifiuto;
        	
        	var newMotivazione =
        		tipoRifiuto+" in data "+data+" con motivazione:\n"+ 	
        		vm.motivazioneRifiuto+
        		motivazioni;

        	if (vm.motivazioneRifiuto.length==0) {
        		vm.error="E' necessario inserire la motivazione del rifiuto.";
        	} else if (vm.motivazioneRifiuto.length>vm.motivazioneRifiutoMaxLength || newMotivazione.length>vm.dichiarazioneMotivazioneRifiutoMaxLength) {
        		vm.error="La motivazione rifiuto inserita è troppo grande, provare a diminuire la lunghezza del testo.";
        	} else {
        		vm.controller[vm.entityName].motivazioneRifiuto=newMotivazione;

            	$uibModalInstance.close(true);
        	}
        }
    }
})();

var currencySymbols =
{ "AED": "د.إ"
, "AFN": "؋"
, "ALL": "L"
, "ANG": "ƒ"
, "AOA": "Kz"
, "ARS": "$"
, "AUD": "$"
, "AWG": "ƒ"
, "AZN": "₼"
, "BAM": "KM"
, "BBD": "$"
, "BDT": "৳"
, "BGN": "лв"
, "BHD": ".د.ب"
, "BIF": "FBu"
, "BMD": "$"
, "BND": "$"
, "BOB": "Bs."
, "BRL": "R$"
, "BSD": "$"
, "BTN": "Nu."
, "BWP": "P"
, "BYR": "p."
, "BZD": "BZ$"
, "CAD": "$"
, "CDF": "FC"
, "CHF": "Fr."
, "CLP": "$"
, "CNY": "¥"
, "COP": "$"
, "CRC": "₡"
, "CUC": "$"
, "CUP": "₱"
, "CVE": "$"
, "CZK": "Kč"
, "DJF": "Fdj"
, "DKK": "kr"
, "DOP": "RD$"
, "DZD": "دج"
, "EEK": "kr"
, "EGP": "£"
, "ERN": "Nfk"
, "ETB": "Br"
, "EUR": "€"
, "FJD": "$"
, "FKP": "£"
, "GBP": "£"
, "GEL": "₾"
, "GGP": "£"
, "GHC": "₵"
, "GHS": "GH₵"
, "GIP": "£"
, "GMD": "D"
, "GNF": "FG"
, "GTQ": "Q"
, "GYD": "$"
, "HKD": "$"
, "HNL": "L"
, "HRK": "kn"
, "HTG": "G"
, "HUF": "Ft"
, "IDR": "Rp"
, "ILS": "₪"
, "IMP": "£"
, "INR": "₹"
, "IQD": "ع.د"
, "IRR": "﷼"
, "ISK": "kr"
, "JEP": "£"
, "JMD": "J$"
, "JPY": "¥"
, "KES": "KSh"
, "KGS": "лв"
, "KHR": "៛"
, "KMF": "CF"
, "KPW": "₩"
, "KRW": "₩"
, "KYD": "$"
, "KZT": "₸"
, "LAK": "₭"
, "LBP": "£"
, "LKR": "₨"
, "LRD": "$"
, "LSL": "M"
, "LTL": "Lt"
, "LVL": "Ls"
, "MAD": "MAD"
, "MDL": "lei"
, "MGA": "Ar"
, "MKD": "ден"
, "MMK": "K"
, "MNT": "₮"
, "MOP": "MOP$"
, "MUR": "₨"
, "MVR": "Rf"
, "MWK": "MK"
, "MXN": "$"
, "MYR": "RM"
, "MZN": "MT"
, "NAD": "$"
, "NGN": "₦"
, "NIO": "C$"
, "NOK": "kr"
, "NPR": "₨"
, "NZD": "$"
, "OMR": "﷼"
, "PAB": "B/."
, "PEN": "S/."
, "PGK": "K"
, "PHP": "₱"
, "PKR": "₨"
, "PLN": "zł"
, "PYG": "Gs"
, "QAR": "﷼"
, "RMB": "￥"
, "RON": "lei"
, "RSD": "Дин."
, "RUB": "₽"
, "RWF": "R₣"
, "SAR": "﷼"
, "SBD": "$"
, "SCR": "₨"
, "SDG": "ج.س."
, "SEK": "kr"
, "SGD": "$"
, "SHP": "£"
, "SLL": "Le"
, "SOS": "S"
, "SRD": "$"
, "SSP": "£"
, "STD": "Db"
, "SVC": "$"
, "SYP": "£"
, "SZL": "E"
, "THB": "฿"
, "TJS": "SM"
, "TMT": "T"
, "TND": "د.ت"
, "TOP": "T$"
, "TRL": "₤"
, "TRY": "₺"
, "TTD": "TT$"
, "TVD": "$"
, "TWD": "NT$"
, "TZS": "TSh"
, "UAH": "₴"
, "UGX": "USh"
, "USD": "$"
, "UYU": "$U"
, "UZS": "лв"
, "VEF": "Bs"
, "VND": "₫"
, "VUV": "VT"
, "WST": "WS$"
, "XAF": "FCFA"
, "XBT": "Ƀ" 
, "XCD": "$"
, "XOF": "CFA" 
, "XPF": "₣" 
, "YER": "﷼"
, "ZAR": "R"
, "ZWD": "Z$"
};

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('Currencies', Currencies);

    Currencies.$inject = ['$http'];

    function Currencies ($http) {
        var service = {
        	loadCurrencyList: loadCurrencyList
        };

        var vm = this;
        return service;
        
        function loadCurrencyList (vmp) {
            return $http.get('api/util/currencies').then(getList);

            function getList (response) {
            	vmp.currencies=response.data;
            	return response;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('AdminCommands', AdminCommands);

    AdminCommands.$inject = ['$http'];

    function AdminCommands ($http) {
        var service = {
        	updateStatoDecisione: updateStatoDecisione,
        	updateStatoDichiarazione: updateStatoDichiarazione,
        	updateStatoOrdine: updateStatoOrdine
        };

        return service;
        
        function updateStatoDecisione (vmp, id, stato) {
            return $http({
        			url: 'api/update-stato-decisione/', 
        			method: 'POST',
        			params: {id: id, stato: stato}
            	}).then(getResponse, onError);

            function getResponse (response) {
            	vmp.updateStatoDone(response);
            	return response;
            }

            function onError (response) {
            	return response;
            }
        }

        function updateStatoDichiarazione (vmp, id, stato) {
            return $http({
        			url: 'api/update-stato-dichiarazione/', 
        			method: 'POST',
        			params: {id: id, stato: stato}
            	}).then(getResponse, onError);

            function getResponse (response) {
            	vmp.updateStatoDone(response);
            	return response;
            }

            function onError (response) {
            	return response;
            }
        }
        
        function updateStatoOrdine (vmp, id, stato) {
            return $http({
        			url: 'api/update-stato-ordine/', 
        			method: 'POST',
        			params: {id: id, stato: stato}
            	}).then(getResponse, onError);

            function getResponse (response) {
            	vmp.updateStatoDone(response);
            	return response;
            }

            function onError (response) {
            	return response;
            }
        }

    }
})();

function modalScrollTop() {
	// inca$ - blocco di codice per fare scroll to top

	// copiamo tutti i valori delle setzioni
	// che andremo a cambiare per fare lo scroll
	var css1 = jQuery('.modal-content').css('overflow');
	var css2 = jQuery('.modal-content').css('max-height');
	var css3 = jQuery('.modal-body').css('overflow');
	var css4 = jQuery('.modal-body').css('max-height');

	// impostiamo i valori neccessari per lo scroll
	jQuery('.modal-content').css({'overflow': 'auto'});
	jQuery('.modal-content').css({'max-height': 60});
	jQuery('.modal-body').css({'overflow': 'auto'});
	jQuery('.modal-body').css({'max-height': 60});

	// effettuiamo lo scroll to top
	jQuery('.modal-body').animate({ scrollTop: "0px" });

	// reimpostiamo i valori a quelli corretti
	jQuery('.modal-content').css({'overflow': css1});
	jQuery('.modal-content').css({'max-height': css2});
	jQuery('.modal-body').css({'overflow': css3});
	jQuery('.modal-body').css({'max-height': css4});
};

(function () {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('Sessions', Sessions);

    Sessions.$inject = ['$resource'];

    function Sessions ($resource) {
        return $resource('api/account/sessions/:series', {}, {
            'getAll': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account', 'JhiTrackerService'];

    function Principal ($q, Account, JhiTrackerService) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
                JhiTrackerService.connect();
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage' , 'JhiTrackerService'];

    function AuthServerProvider ($http, $localStorage , JhiTrackerService) {
        var service = {
            getToken: getToken,
            hasValidToken: hasValidToken,
            login: login,
            logout: logout
        };

        return service;

        function getToken () {
            var token = $localStorage.authenticationToken;
            return token;
        }

        function hasValidToken () {
            var token = this.getToken();
            return !!token;
        }

        function login (credentials) {
            var data = 'j_username=' + encodeURIComponent(credentials.username) +
                '&j_password=' + encodeURIComponent(credentials.password) +
                '&remember-me=' + credentials.rememberMe + '&submit=Login';

            return $http.post('api/authentication', data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).success(function (response) {
                return response;
            });
        }

        function logout () {
            JhiTrackerService.disconnect();

            
            // logout from the server
            $http.post('api/logout').success(function (response) {
                delete $localStorage.authenticationToken;
                // to get a new csrf token call the api
                $http.get('api/account');
                return response;
            });
            
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish', 'JhiTrackerService'];

    function Auth ($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish, JhiTrackerService) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    JhiTrackerService.sendActivity();
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }


        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('SearchController',SearchController);

    SearchController.$inject = ['$uibModalInstance', 'miSearchService', '$filter', '$scope', 'pScope', 'search', 'controller', 'field', 'type', 'domain'];

    
    function SearchController($uibModalInstance, miSearchService, $filter, $scope, pScope, search, controller, field, type, domain) {
        var vm = this;

        vm.pScope=pScope;
        vm.search = search;
        vm.controller = controller;
        vm.field = field;
        vm.type = type;
        vm.domain=domain;

        vm.clear = clear;
        vm.confirmSearch = confirmSearch;
        vm.addCondition = addCondition;
        vm.dateformat='dd/MM/yyyy';
        vm.datetimeformat='dd/MM/yyyy HH:mm:ss';
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.datePickerOpenStatus.dataIniziale = false;
        vm.datePickerOpenStatus.dataFinale = false;
        vm.datePickerOpenStatus.dataOraIniziale = false;
        vm.datePickerOpenStatus.dataOraFinale = false;
        vm.isDomain = isDomain;
        vm.isDate = isDate;
        vm.isDatetime = isDatetime;
        vm.isBoolean = isBoolean;
        vm.isText = isText;
        vm.isFirstCondition = isFirstCondition;
        vm.isOnlyOneCondition = isOnlyOneCondition;
        vm.availableOptions;
        vm.updateDomain=updateDomain;
        
        var init = function () {
            vm.condition="AND";

            if (isBoolean()) {
	            vm.relations = {
		    		model: null,
		    	    availableOptions: [
						{relation: 'UGUALE', name: 'uguale a'}
					]
	            };
	            vm.relations.model="UGUALE";
            } else if (isDate() || isDatetime()) {
	            vm.relations = {
		    		model: null,
		    	    availableOptions: [
						{id: 'UGUALE', name: 'uguale a'},
						{id: 'DIVERSO', name: 'diverso da'},
						{id: 'MAGGIORE', name: 'maggiore di'},
						{id: 'MAGGIOREUG', name: 'maggiore o uguale a'},
						{id: 'MINORE', name: 'minore di'},
						{id: 'MINOREEUG', name: 'minore o uguale a'},
						{id: 'COMPRESO', name: 'compreso tra i valori'},
						{id: 'NONCOMPRESO', name: 'non compreso tra i valori'}
					]
	            };
	            vm.relations.model="UGUALE";
            } else if (isDomain()) {
	            vm.relations = {
		    		model: null,
		    	    availableOptions: [
						{id: 'UGUALE', name: 'uguale a'},
						{id: 'DIVERSO', name: 'diverso da'},
					]
	            };
	            vm.relations.model="UGUALE";
            } else {
	            vm.relations = {
    	    		model: null,
    	    	    availableOptions: [
    					{id: 'UGUALE', name: 'uguale a'},
    					{id: 'DIVERSO', name: 'diverso da'},
    					{id: 'CONTIENE', name: 'contiene'},
    					{id: 'NONCONTIENE', name: 'non contiene'},
    					{id: 'MAGGIORE', name: 'maggiore di'},
    					{id: 'MAGGIOREUG', name: 'maggiore o uguale a'},
    					{id: 'MINORE', name: 'minore di'},
    					{id: 'MINOREEUG', name: 'minore o uguale a'},
    					{id: 'COMPRESO', name: 'compreso tra i valori'},
    					{id: 'NONCOMPRESO', name: 'non compreso tra i valori'}
    				]
                };
                vm.relations.model="CONTIENE";
            }

            if (vm.domain!=null) {
	            miSearchService.getDomain(vm).then(function(domain) {
	            });
            }
        }
        init();
        

        function updateDomain (data) {
        	
            vm.domains = {
	    		model: null,
	    	    availableOptions: []
            };

            var values = getDescendantProp(data, vm.domain);
            //var entries = Object.entries(values); // metodo incompatibile con Safari e altri
            var entries = new Array;
            
            var ent=0;
            Object.keys(values).forEach(function (prop) {
            	var value = values[prop];
            	entries[ent]=[prop, value];
            	ent++;
           	});

			for (var i = 0; i < entries.length; i++) {
				if (entries[i][0]!=null && entries[i][1]!="")
					vm.domains.availableOptions.push({
				        id: entries[i][0],
				        name: entries[i][1]
				    });
			}
            
        }

        function isDomain () {
        	return !(vm.domain==null||vm.domain=="");
        }

        function isDate () {
            return vm.type=="date";
        }

        function isDatetime () {
            return vm.type=="datetime";
        }

        function isBoolean () {
            return vm.type=="boolean";
        }

        function isFirstCondition () {
            var query = vm.pScope.vm.searchQuery;
        	if (query==null || query=="")
        		return true;
        	return false;
        }
    	
        function isOnlyOneCondition () {
        	return vm.relations.model!='COMPRESO'&&vm.relations.model!='NONCOMPRESO'
        }
        
    	function isText () {
            return (vm.type==null||vm.type=="") && !isDomain();
        }
   
        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function addCondition () {
        	
        	var relazione = "";
        	var valIni = null;
        	var valFin = null;
        	
        	if (isDate()) {
        		valIni = $filter('date')(vm.dataIniziale, "yyyy-MM-dd");
        		valFin = $filter('date')(vm.dataFinale, "yyyy-MM-dd");

        		if (valIni==null || valIni=="")
        			valIni = "*";
        		if (valFin==null || valFin=="")
        			valFin = "*";
        	
        	} else if (isDatetime()) {
        		valIni = $filter('date')(vm.dataOraIniziale, "yyyy-MM-ddTHH:mm:ss");
        		valFin = $filter('date')(vm.dataOraFinale, "yyyy-MM-ddTHH:mm:ss");
        		
        		if (valIni==null || valIni=="")
        			valIni = "*";
        		if (valFin==null || valFin=="")
        			valFin = "*";

        	} else {
            	if (vm.valoreIniziale==null)
            		valIni=false;
            	else { 
            		valIni = vm.valoreIniziale;
            		valFin = vm.valoreFinale;
            	}		
        	}

    		if (vm.relations.model=="UGUALE") {
    			if (isDomain()) {
    				var arrayLength = 0;
					if (vm.domains.model!=null)
						arrayLength=vm.domains.model.length;
    				if (arrayLength>0) {
    					if (arrayLength>1)
    						relazione = "(";
	    				for (var i = 0; i < arrayLength; i++) {
	        				relazione = relazione+vm.field+":"+vm.domains.model[i];
	        				if (i<arrayLength-1)
	        					relazione = relazione+" OR ";
	    				}
    					if (arrayLength>1)
    						relazione = relazione+")";
    				}
    			} else
    				relazione = vm.field+":"+"\""+valIni+"\"";
        	} else if (vm.relations.model=="DIVERSO") {
    			if (isDomain()) {
    				var arrayLength = 0;
					if (vm.domains.model!=null)
						arrayLength=vm.domains.model.length;
    				if (arrayLength>0) {
        				relazione = "NOT ";
    					if (arrayLength>1)
            				relazione = relazione+"(";
	    				for (var i = 0; i < arrayLength; i++) {
	        				relazione = relazione+vm.field+":"+vm.domains.model[i];
	        				if (i<arrayLength-1)
	        					relazione = relazione+" OR ";
	    				}
    					if (arrayLength>1)
    						relazione = relazione+")";
    				}
    			} else
    				relazione = "NOT "+vm.field+":"+"\""+valIni+"\"";
        	} else if (vm.relations.model=="CONTIENE") {
   				relazione = vm.field+":\"*"+valIni+"*\"";
        	} else if (vm.relations.model=="NONCONTIENE") {
   				relazione = "NOT "+vm.field+":\"*"+valIni+"*\"";
        	} else if (vm.relations.model=="MAGGIORE") {
        		if (isDate()||isDatetime()) {
        			relazione = vm.field+":["+valIni+" TO *]";
        		} else
        			relazione = vm.field+":>"+"\""+valIni+"\"";
        	} else if (vm.relations.model=="MAGGIOREUG") {
        		if (isDate()||isDatetime()) {
        			relazione = vm.field+":["+valIni+" TO *]";
        		} else
        			relazione = vm.field+":>="+valIni;
        	} else if (vm.relations.model=="MINORE") {
        		if (isDate()||isDatetime()) {
        			relazione = vm.field+":[* TO "+valIni+"]";
        		} else
        			relazione = vm.field+":<"+valIni;
        	} else if (vm.relations.model=="MINOREEUG") {
        		if (isDate()||isDatetime()) {
        			relazione = vm.field+":[* TO "+valIni+"]";
        		} else
        			relazione = vm.field+":<="+valIni;
        	} else if (vm.relations.model=="COMPRESO") {
        		relazione = vm.field+":["+"\""+valIni+"\""+" TO "+"\""+valFin+"\""+"]";
        	} else if (vm.relations.model=="NONCOMPRESO") {
        		relazione = vm.field+":<"+valIni+" OR "+vm.field+":>"+valFin;
        	}
        	
            var query = vm.pScope.vm.searchQuery;
        	if (query==null || query=="")
        		vm.pScope.vm.searchQuery = relazione;
        	else
        		vm.pScope.vm.searchQuery = query+" "+vm.condition+" "+relazione;

            vm.search.searchQuery=vm.pScope.vm.searchQuery;
            
//            $("#searchQuery")
//              .val(search.searchQuery)
//              .trigger('change');

//            $uibModalInstance.dismiss('cancel');
            $uibModalInstance.close(true);
            
        }

        function confirmSearch () {
        	addCondition();
        	vm.controller.search(search.searchQuery);
        }

        function getDescendantProp(obj, desc) {
            var arr = desc.split(".");
            while(arr.length && (obj = obj[arr.shift()]));
            return obj;
        }
        
}
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('miSearchService', miSearchService);

    miSearchService.$inject = ['$http'];

    function miSearchService ($http) {
        var service = {
        	getDomain: getDomain
        };

        var vm = this;
        vm.controller=null;

        return service;
        
        
        function getDomain (controller) {
        	vm.controller=controller;
        	var domainName=vm.controller.domain;
        	if (domainName!=null) {
            	var radix="ordiniApp"+".";
            	var fileName=domainName.substring(radix.length,domainName.length)+".json";
            	var fileName=fileName.substr(0,1).toLowerCase()+fileName.substr(1);
                return $http.get('i18n/it/'+fileName).then(getDomainValues);
        	} else
        		return null;

            function getDomainValues (response) {
            	vm.controller.updateDomain(response.data);
            	return response;
            }
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .directive('miSearch', miSearch);

    function miSearch() {
        var directive = {
            restrict: 'A',
            scope: {
                fieldType: "@fieldType",
                fieldDomain: "@fieldDomain"
            },
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
            	var elem = element.parent().children().first()[0];
            	var field = elem.attributes['jh-sort-by'].value;
            	var type = scope.fieldType;
            	var domain = scope.fieldDomain;
            	scope.$parent.vm.searchForm(field,type,domain);
            });
        }
    }
    
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('NavbarController', NavbarController);

    // inca$ - visualizzazione entità in base ai permessi
    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService', 'Permissions'];

    function NavbarController ($state, Auth, Principal, ProfileService, LoginService, Permissions) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;
        // inca$ - abilitazione voci menu
        vm.show = show;
        vm.showSuperUser = showSuperUser;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;


        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

        // inca$ - abilitazione voci menu
        function show(func) {
            return Permissions.hasPermission(func, "view");
        }

        // inca$ - abilitazione voci menu jhipster solo per superutente
        function showSuperUser() {
            return Permissions.hasRole('ROLE_SUPERUTENTE');
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .directive('activeLink', activeLink);

    function activeLink() {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var clazz = attrs.activeLink;
            var path = attrs.href;
            path = path.substring(1); //hack because path does bot return including hashbang
            scope.location = location;
            scope.$watch('location.path()', function(newPath) {
                if (path === newPath) {
                    element.addClass(clazz);
                } else {
                    element.removeClass(clazz);
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', 'Principal', 'LoginService', '$state'];

    function HomeController ($scope, Principal, LoginService, $state) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('VoceBilancioDialogController', VoceBilancioDialogController);

    VoceBilancioDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'VoceBilancio', 'Decisione'];

    function VoceBilancioDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, VoceBilancio, Decisione) {
        var vm = this;

        vm.voceBilancio = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.decisiones = Decisione.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.voceBilancio.id !== null) {
                VoceBilancio.update(vm.voceBilancio, onSaveSuccess, onSaveError);
            } else {
                VoceBilancio.save(vm.voceBilancio, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('ordiniApp:voceBilancioUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dataCreazione = false;
        vm.datePickerOpenStatus.dataAggiornamento = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('VoceBilancioDetailController', VoceBilancioDetailController);

    VoceBilancioDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'VoceBilancio', 'Decisione'];

    function VoceBilancioDetailController($scope, $rootScope, $stateParams, previousState, entity, VoceBilancio, Decisione) {
        var vm = this;

        vm.voceBilancio = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('ordiniApp:voceBilancioUpdate', function(event, result) {
            vm.voceBilancio = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('VoceBilancioDeleteController',VoceBilancioDeleteController);

    VoceBilancioDeleteController.$inject = ['$uibModalInstance', 'entity', 'VoceBilancio'];

    function VoceBilancioDeleteController($uibModalInstance, entity, VoceBilancio) {
        var vm = this;

        vm.voceBilancio = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            VoceBilancio.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('voce-bilancio', {
            parent: 'entity',
            url: '/voce-bilancio?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.voceBilancio.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/voce-bilancio/voce-bilancios.html',
                    controller: 'VoceBilancioController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('voceBilancio');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('voce-bilancio-detail', {
            parent: 'entity',
            url: '/voce-bilancio/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.voceBilancio.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/voce-bilancio/voce-bilancio-detail.html',
                    controller: 'VoceBilancioDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('voceBilancio');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'VoceBilancio', function($stateParams, VoceBilancio) {
                    return VoceBilancio.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'voce-bilancio',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('voce-bilancio-detail.edit', {
            parent: 'voce-bilancio-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/voce-bilancio/voce-bilancio-dialog.html',
                    controller: 'VoceBilancioDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['VoceBilancio', function(VoceBilancio) {
                            return VoceBilancio.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('voce-bilancio.new', {
            parent: 'voce-bilancio',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/voce-bilancio/voce-bilancio-dialog.html',
                    controller: 'VoceBilancioDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                esercizio: null,
                                visualizza: false,
                                codice: null,
                                codiceEsteso: null,
                                descrizione: null,
                                utenteCreazione: null,
                                dataCreazione: null,
                                utenteAggiornamento: null,
                                dataAggiornamento: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('voce-bilancio', null, { reload: 'voce-bilancio' });
                }, function() {
                    $state.go('voce-bilancio');
                });
            }]
        })
        .state('voce-bilancio.edit', {
            parent: 'voce-bilancio',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/voce-bilancio/voce-bilancio-dialog.html',
                    controller: 'VoceBilancioDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['VoceBilancio', function(VoceBilancio) {
                            return VoceBilancio.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('voce-bilancio', null, { reload: 'voce-bilancio' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('voce-bilancio.delete', {
            parent: 'voce-bilancio',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/voce-bilancio/voce-bilancio-delete-dialog.html',
                    controller: 'VoceBilancioDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['VoceBilancio', function(VoceBilancio) {
                            return VoceBilancio.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('voce-bilancio', null, { reload: 'voce-bilancio' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('ordiniApp')
        .factory('VoceBilancio', VoceBilancio);

    VoceBilancio.$inject = ['$resource', 'DateUtils'];

    function VoceBilancio ($resource, DateUtils) {
        var resourceUrl =  'api/voce-bilancios/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dataCreazione = DateUtils.convertDateTimeFromServer(data.dataCreazione);
                        data.dataAggiornamento = DateUtils.convertDateTimeFromServer(data.dataAggiornamento);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('VoceBilancioSearch', VoceBilancioSearch);

    VoceBilancioSearch.$inject = ['$resource'];

    function VoceBilancioSearch($resource) {
        var resourceUrl =  'api/_search/voce-bilancios/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('VoceBilancioController', VoceBilancioController);

    // inca$ - aggiunta gestione search
    VoceBilancioController.$inject = ['$scope', '$state', '$uibModal', 'VoceBilancio', 'VoceBilancioSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function VoceBilancioController ($scope, $state, $uibModal, VoceBilancio, VoceBilancioSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        // inca$ - aggiunta gestione search
        vm.searchForm = searchForm;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                VoceBilancioSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                VoceBilancio.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.voceBilancios = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

     // inca$ - aggiunta gestione search
        function searchForm (field, type, domain) {
        	$uibModal.open({
                templateUrl: 'app/search/search-dialog.html',
                controller: 'SearchController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                	pScope: function() {
                        return $scope;
                    },
                    search: function() {
                        return VoceBilancioSearch;
                    },
                    controller: function() {
                        return vm;
                    },
                    field: function() {
                        return field;
                    },
                    type: function() {
                        return type;
                    },
                    domain: function() {
                        return domain;
                    }
                }
            }).result.then(function() {
                //$state.go('voce-bilancio', null, { reload: 'voce-bilancio' });
            }, function() {
                //$state.go('^');
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('UtenteDialogController', UtenteDialogController);

    UtenteDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', '$q', 'DataUtils', 'entity', 'Utente', 'User', 'Progetto', 'Finanziamento', 'Decisione', 'Struttura', 'UtenteFirma'];

    function UtenteDialogController ($timeout, $scope, $stateParams, $uibModalInstance, $q, DataUtils, entity, Utente, User, Progetto, Finanziamento, Decisione, Struttura, UtenteFirma) {
        var vm = this;

        vm.utente = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.users = User.query({size:100000000}); // inca$ - caricamento totale liste fk
        //vm.progettos = Progetto.query();
        //vm.finanziamentos = Finanziamento.query();
        //vm.decisiones = Decisione.query();
        vm.strutturas = Struttura.query();
        
        // inca$ - caricamento file firma
        {
	        if (entity.id!=null)
		        UtenteFirma.get({id : entity.id}, function(result) {
		 			vm.utente["firma"]=result.firma;
		        });
	        else
	        	vm.utente["firma"]=null;
        }	        
	        
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.utente.id !== null) {
                Utente.update(vm.utente, onSaveSuccess, onSaveError);
            } else {
                Utente.save(vm.utente, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('ordiniApp:utenteUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.setFirma = function ($file, utente) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        utente.firma = base64Data;
                        utente.firmaContentType = $file.type;
                    });
                });
            }
        };
        vm.datePickerOpenStatus.dataInizioDirezione = false;
        vm.datePickerOpenStatus.dataFineDirezione = false;
        vm.datePickerOpenStatus.dataCreazione = false;
        vm.datePickerOpenStatus.dataAggiornamento = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('UtenteDetailController', UtenteDetailController);

    UtenteDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Utente', 'User', 'Progetto', 'Finanziamento', 'Decisione', 'Struttura', 'UtenteFirma'];

    function UtenteDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Utente, User, Progetto, Finanziamento, Decisione, Struttura, UtenteFirma) {
        var vm = this;

        vm.utente = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        // inca$ - caricamento file firma
		UtenteFirma.get({id : entity.id}, function(result) {
 			vm.utente["firma"]=result.firma;
        });

		var unsubscribe = $rootScope.$on('ordiniApp:utenteUpdate', function(event, result) {
            vm.utente = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('UtenteDeleteController',UtenteDeleteController);

    UtenteDeleteController.$inject = ['$uibModalInstance', 'entity', 'Utente'];

    function UtenteDeleteController($uibModalInstance, entity, Utente) {
        var vm = this;

        vm.utente = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Utente.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('utente', {
            parent: 'entity',
            url: '/utente?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.utente.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/utente/utentes.html',
                    controller: 'UtenteController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('utente');
                    $translatePartialLoader.addPart('tipoSesso');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('utente-detail', {
            parent: 'entity',
            url: '/utente/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.utente.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/utente/utente-detail.html',
                    controller: 'UtenteDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('utente');
                    $translatePartialLoader.addPart('tipoSesso');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Utente', function($stateParams, Utente) {
                    return Utente.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'utente',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('utente-detail.edit', {
            parent: 'utente-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/utente/utente-dialog.html',
                    controller: 'UtenteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Utente', function(Utente) {
                            return Utente.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('utente.new', {
            parent: 'utente',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/utente/utente-dialog.html',
                    controller: 'UtenteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                sesso: null,
                                titolo: null,
                                titoloLavorativo: null,
                                sezione: null,
                                firma: null,
                                firmaContentType: null,
                                direttore: false,
                                dataInizioDirezione: null,
                                dataFineDirezione: null,
                                utenteCreazione: null,
                                dataCreazione: null,
                                utenteAggiornamento: null,
                                dataAggiornamento: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('utente', null, { reload: 'utente' });
                }, function() {
                    $state.go('utente');
                });
            }]
        })
        .state('utente.edit', {
            parent: 'utente',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/utente/utente-dialog.html',
                    controller: 'UtenteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Utente', function(Utente) {
                            return Utente.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('utente', null, { reload: 'utente' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('utente.delete', {
            parent: 'utente',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/utente/utente-delete-dialog.html',
                    controller: 'UtenteDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Utente', function(Utente) {
                            return Utente.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('utente', null, { reload: 'utente' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('ordiniApp')
        .factory('Utente', Utente);

    Utente.$inject = ['$resource', 'DateUtils'];

    function Utente ($resource, DateUtils) {
        var resourceUrl =  'api/utentes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dataInizioDirezione = DateUtils.convertLocalDateFromServer(data.dataInizioDirezione);
                        data.dataFineDirezione = DateUtils.convertLocalDateFromServer(data.dataFineDirezione);
                        data.dataCreazione = DateUtils.convertDateTimeFromServer(data.dataCreazione);
                        data.dataAggiornamento = DateUtils.convertDateTimeFromServer(data.dataAggiornamento);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dataInizioDirezione = DateUtils.convertLocalDateToServer(copy.dataInizioDirezione);
                    copy.dataFineDirezione = DateUtils.convertLocalDateToServer(copy.dataFineDirezione);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dataInizioDirezione = DateUtils.convertLocalDateToServer(copy.dataInizioDirezione);
                    copy.dataFineDirezione = DateUtils.convertLocalDateToServer(copy.dataFineDirezione);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('UtenteSearch', UtenteSearch);

    UtenteSearch.$inject = ['$resource'];

    function UtenteSearch($resource) {
        var resourceUrl =  'api/_search/utentes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('ordiniApp')
        .factory('UtenteFirma', UtenteFirma);

    UtenteFirma.$inject = ['$resource', 'DateUtils'];

    function UtenteFirma ($resource, DateUtils) {
        var resourceUrl =  'api/utentes/firma/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dataCreazione = DateUtils.convertDateTimeFromServer(data.dataCreazione);
                        data.dataAggiornamento = DateUtils.convertDateTimeFromServer(data.dataAggiornamento);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('UtenteController', UtenteController);

    // inca$ - aggiunta gestione search
    UtenteController.$inject = ['$scope', '$state', 'DataUtils', '$uibModal', 'Utente', 'UtenteSearch', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function UtenteController ($scope, $state, DataUtils, $uibModal, Utente, UtenteSearch, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        // inca$ - aggiunta gestione search
        vm.searchForm = searchForm;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                UtenteSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Utente.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.utentes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

     // inca$ - aggiunta gestione search
        function searchForm (field, type, domain) {
        	$uibModal.open({
                templateUrl: 'app/search/search-dialog.html',
                controller: 'SearchController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                	pScope: function() {
                        return $scope;
                    },
                    search: function() {
                        return UtenteSearch;
                    },
                    controller: function() {
                        return vm;
                    },
                    field: function() {
                        return field;
                    },
                    type: function() {
                        return type;
                    },
                    domain: function() {
                        return domain;
                    }
                }
            }).result.then(function() {
                //$state.go('utente', null, { reload: 'utente' });
            }, function() {
                //$state.go('^');
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('StrutturaDialogController', StrutturaDialogController);

    StrutturaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Struttura', 'Impegno', 'Gae', 'Utente', 'Modello'];

    function StrutturaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Struttura, Impegno, Gae, Utente, Modello) {
        var vm = this;

        vm.struttura = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.impegnos = Impegno.query();
        vm.gaes = Gae.query();
        vm.utentes = Utente.query();
        vm.modellos = Modello.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.struttura.id !== null) {
                Struttura.update(vm.struttura, onSaveSuccess, onSaveError);
            } else {
                Struttura.save(vm.struttura, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('ordiniApp:strutturaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dataCreazione = false;
        vm.datePickerOpenStatus.dataAggiornamento = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('StrutturaDetailController', StrutturaDetailController);

    StrutturaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Struttura', 'Impegno', 'Gae', 'Utente', 'Modello'];

    function StrutturaDetailController($scope, $rootScope, $stateParams, previousState, entity, Struttura, Impegno, Gae, Utente, Modello) {
        var vm = this;

        vm.struttura = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('ordiniApp:strutturaUpdate', function(event, result) {
            vm.struttura = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('StrutturaDeleteController',StrutturaDeleteController);

    StrutturaDeleteController.$inject = ['$uibModalInstance', 'entity', 'Struttura'];

    function StrutturaDeleteController($uibModalInstance, entity, Struttura) {
        var vm = this;

        vm.struttura = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Struttura.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('struttura', {
            parent: 'entity',
            url: '/struttura?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.struttura.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/struttura/strutturas.html',
                    controller: 'StrutturaController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('struttura');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('struttura-detail', {
            parent: 'entity',
            url: '/struttura/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.struttura.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/struttura/struttura-detail.html',
                    controller: 'StrutturaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('struttura');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Struttura', function($stateParams, Struttura) {
                    return Struttura.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'struttura',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('struttura-detail.edit', {
            parent: 'struttura-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/struttura/struttura-dialog.html',
                    controller: 'StrutturaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Struttura', function(Struttura) {
                            return Struttura.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('struttura.new', {
            parent: 'struttura',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/struttura/struttura-dialog.html',
                    controller: 'StrutturaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                uo: null,
                                descrizione: null,
                                utenteCreazione: null,
                                dataCreazione: null,
                                utenteAggiornamento: null,
                                dataAggiornamento: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('struttura', null, { reload: 'struttura' });
                }, function() {
                    $state.go('struttura');
                });
            }]
        })
        .state('struttura.edit', {
            parent: 'struttura',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/struttura/struttura-dialog.html',
                    controller: 'StrutturaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Struttura', function(Struttura) {
                            return Struttura.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('struttura', null, { reload: 'struttura' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('struttura.delete', {
            parent: 'struttura',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/struttura/struttura-delete-dialog.html',
                    controller: 'StrutturaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Struttura', function(Struttura) {
                            return Struttura.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('struttura', null, { reload: 'struttura' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('ordiniApp')
        .factory('Struttura', Struttura);

    Struttura.$inject = ['$resource', 'DateUtils'];

    function Struttura ($resource, DateUtils) {
        var resourceUrl =  'api/strutturas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dataCreazione = DateUtils.convertDateTimeFromServer(data.dataCreazione);
                        data.dataAggiornamento = DateUtils.convertDateTimeFromServer(data.dataAggiornamento);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('StrutturaSearch', StrutturaSearch);

    StrutturaSearch.$inject = ['$resource'];

    function StrutturaSearch($resource) {
        var resourceUrl =  'api/_search/strutturas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('StrutturaController', StrutturaController);

    // inca$ - aggiunta gestione search
    StrutturaController.$inject = ['$scope', '$state', '$uibModal', 'Struttura', 'StrutturaSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function StrutturaController ($scope, $state, $uibModal, Struttura, StrutturaSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        // inca$ - aggiunta gestione search
        vm.searchForm = searchForm;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                StrutturaSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Struttura.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.strutturas = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

     // inca$ - aggiunta gestione search
        function searchForm (field, type, domain) {
        	$uibModal.open({
                templateUrl: 'app/search/search-dialog.html',
                controller: 'SearchController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                	pScope: function() {
                        return $scope;
                    },
                    search: function() {
                        return StrutturaSearch;
                    },
                    controller: function() {
                        return vm;
                    },
                    field: function() {
                        return field;
                    },
                    type: function() {
                        return type;
                    },
                    domain: function() {
                        return domain;
                    }
                }
            }).result.then(function() {
                //$state.go('struttura', null, { reload: 'struttura' });
            }, function() {
                //$state.go('^');
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('RuoloFunzioneDialogController', RuoloFunzioneDialogController);

    RuoloFunzioneDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'RuoloFunzione', 'Operazione', 'Ruolo', 'Funzione'];

    function RuoloFunzioneDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, RuoloFunzione, Operazione, Ruolo, Funzione) {
        var vm = this;

        vm.ruoloFunzione = entity;
        vm.clear = clear;
        vm.save = save;
        vm.operaziones = Operazione.query();
        vm.ruolos = Ruolo.query();
        vm.funziones = Funzione.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.ruoloFunzione.id !== null) {
                RuoloFunzione.update(vm.ruoloFunzione, onSaveSuccess, onSaveError);
            } else {
                RuoloFunzione.save(vm.ruoloFunzione, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('ordiniApp:ruoloFunzioneUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('RuoloFunzioneDetailController', RuoloFunzioneDetailController);

    RuoloFunzioneDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'RuoloFunzione', 'Operazione', 'Ruolo', 'Funzione'];

    function RuoloFunzioneDetailController($scope, $rootScope, $stateParams, previousState, entity, RuoloFunzione, Operazione, Ruolo, Funzione) {
        var vm = this;

        vm.ruoloFunzione = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('ordiniApp:ruoloFunzioneUpdate', function(event, result) {
            vm.ruoloFunzione = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('RuoloFunzioneDeleteController',RuoloFunzioneDeleteController);

    RuoloFunzioneDeleteController.$inject = ['$uibModalInstance', 'entity', 'RuoloFunzione'];

    function RuoloFunzioneDeleteController($uibModalInstance, entity, RuoloFunzione) {
        var vm = this;

        vm.ruoloFunzione = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            RuoloFunzione.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ruolo-funzione', {
            parent: 'entity',
            url: '/ruolo-funzione?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.ruoloFunzione.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ruolo-funzione/ruolo-funziones.html',
                    controller: 'RuoloFunzioneController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ruoloFunzione');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('ruolo-funzione-detail', {
            parent: 'entity',
            url: '/ruolo-funzione/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.ruoloFunzione.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ruolo-funzione/ruolo-funzione-detail.html',
                    controller: 'RuoloFunzioneDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ruoloFunzione');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'RuoloFunzione', function($stateParams, RuoloFunzione) {
                    return RuoloFunzione.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ruolo-funzione',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ruolo-funzione-detail.edit', {
            parent: 'ruolo-funzione-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ruolo-funzione/ruolo-funzione-dialog.html',
                    controller: 'RuoloFunzioneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RuoloFunzione', function(RuoloFunzione) {
                            return RuoloFunzione.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ruolo-funzione.new', {
            parent: 'ruolo-funzione',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ruolo-funzione/ruolo-funzione-dialog.html',
                    controller: 'RuoloFunzioneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ruolo-funzione', null, { reload: 'ruolo-funzione' });
                }, function() {
                    $state.go('ruolo-funzione');
                });
            }]
        })
        .state('ruolo-funzione.edit', {
            parent: 'ruolo-funzione',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ruolo-funzione/ruolo-funzione-dialog.html',
                    controller: 'RuoloFunzioneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RuoloFunzione', function(RuoloFunzione) {
                            return RuoloFunzione.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ruolo-funzione', null, { reload: 'ruolo-funzione' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ruolo-funzione.delete', {
            parent: 'ruolo-funzione',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ruolo-funzione/ruolo-funzione-delete-dialog.html',
                    controller: 'RuoloFunzioneDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RuoloFunzione', function(RuoloFunzione) {
                            return RuoloFunzione.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ruolo-funzione', null, { reload: 'ruolo-funzione' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('ordiniApp')
        .factory('RuoloFunzione', RuoloFunzione);

    RuoloFunzione.$inject = ['$resource'];

    function RuoloFunzione ($resource) {
        var resourceUrl =  'api/ruolo-funziones/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('RuoloFunzioneSearch', RuoloFunzioneSearch);

    RuoloFunzioneSearch.$inject = ['$resource'];

    function RuoloFunzioneSearch($resource) {
        var resourceUrl =  'api/_search/ruolo-funziones/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('RuoloFunzioneController', RuoloFunzioneController);

    // inca$ - aggiunta gestione search
    RuoloFunzioneController.$inject = ['$scope', '$state', '$uibModal', 'RuoloFunzione', 'RuoloFunzioneSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function RuoloFunzioneController ($scope, $state, $uibModal, RuoloFunzione, RuoloFunzioneSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        // inca$ - aggiunta gestione search
        vm.searchForm = searchForm;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                RuoloFunzioneSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                RuoloFunzione.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.ruoloFunziones = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

     // inca$ - aggiunta gestione search
        function searchForm (field, type, domain) {
        	$uibModal.open({
                templateUrl: 'app/search/search-dialog.html',
                controller: 'SearchController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                	pScope: function() {
                        return $scope;
                    },
                    search: function() {
                        return RuoloFunzioneSearch;
                    },
                    controller: function() {
                        return vm;
                    },
                    field: function() {
                        return field;
                    },
                    type: function() {
                        return type;
                    },
                    domain: function() {
                        return domain;
                    }
                }
            }).result.then(function() {
                //$state.go('ruolo-funzione', null, { reload: 'ruolo-funzione' });
            }, function() {
                //$state.go('^');
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('RuoloDialogController', RuoloDialogController);

    RuoloDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Ruolo', 'RuoloFunzione'];

    function RuoloDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Ruolo, RuoloFunzione) {
        var vm = this;

        vm.ruolo = entity;
        vm.clear = clear;
        vm.save = save;
        vm.ruolofunziones = RuoloFunzione.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.ruolo.id !== null) {
                Ruolo.update(vm.ruolo, onSaveSuccess, onSaveError);
            } else {
                Ruolo.save(vm.ruolo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('ordiniApp:ruoloUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('RuoloDetailController', RuoloDetailController);

    RuoloDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Ruolo', 'RuoloFunzione'];

    function RuoloDetailController($scope, $rootScope, $stateParams, previousState, entity, Ruolo, RuoloFunzione) {
        var vm = this;

        vm.ruolo = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('ordiniApp:ruoloUpdate', function(event, result) {
            vm.ruolo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('RuoloDeleteController',RuoloDeleteController);

    RuoloDeleteController.$inject = ['$uibModalInstance', 'entity', 'Ruolo'];

    function RuoloDeleteController($uibModalInstance, entity, Ruolo) {
        var vm = this;

        vm.ruolo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Ruolo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ruolo', {
            parent: 'entity',
            url: '/ruolo',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.ruolo.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ruolo/ruolos.html',
                    controller: 'RuoloController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ruolo');
                    $translatePartialLoader.addPart('authorityName');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('ruolo-detail', {
            parent: 'entity',
            url: '/ruolo/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.ruolo.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ruolo/ruolo-detail.html',
                    controller: 'RuoloDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ruolo');
                    $translatePartialLoader.addPart('authorityName');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Ruolo', function($stateParams, Ruolo) {
                    return Ruolo.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ruolo',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ruolo-detail.edit', {
            parent: 'ruolo-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ruolo/ruolo-dialog.html',
                    controller: 'RuoloDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Ruolo', function(Ruolo) {
                            return Ruolo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ruolo.new', {
            parent: 'ruolo',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ruolo/ruolo-dialog.html',
                    controller: 'RuoloDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                authorityName: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ruolo', null, { reload: 'ruolo' });
                }, function() {
                    $state.go('ruolo');
                });
            }]
        })
        .state('ruolo.edit', {
            parent: 'ruolo',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ruolo/ruolo-dialog.html',
                    controller: 'RuoloDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Ruolo', function(Ruolo) {
                            return Ruolo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ruolo', null, { reload: 'ruolo' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ruolo.delete', {
            parent: 'ruolo',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ruolo/ruolo-delete-dialog.html',
                    controller: 'RuoloDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Ruolo', function(Ruolo) {
                            return Ruolo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ruolo', null, { reload: 'ruolo' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('ordiniApp')
        .factory('Ruolo', Ruolo);

    Ruolo.$inject = ['$resource'];

    function Ruolo ($resource) {
        var resourceUrl =  'api/ruolos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('RuoloSearch', RuoloSearch);

    RuoloSearch.$inject = ['$resource'];

    function RuoloSearch($resource) {
        var resourceUrl =  'api/_search/ruolos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('RuoloController', RuoloController);

    RuoloController.$inject = ['$scope', '$state', 'Ruolo', 'RuoloSearch'];

    function RuoloController ($scope, $state, Ruolo, RuoloSearch) {
        var vm = this;
        
        vm.ruolos = [];
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            Ruolo.query(function(result) {
                vm.ruolos = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            RuoloSearch.query({query: vm.searchQuery}, function(result) {
                vm.ruolos = result;
            });
        }
   }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('ProgettoDialogController', ProgettoDialogController);

    ProgettoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Progetto', 'Finanziamento', 'Utente'];

    function ProgettoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Progetto, Finanziamento, Utente) {
        var vm = this;

        vm.progetto = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.finanziamentos = Finanziamento.query({size:100000000}); // inca$ - caricamento totale liste fk
        vm.utentes = Utente.query({size:100000000}); // inca$ - caricamento totale liste fk

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.progetto.id !== null) {
                Progetto.update(vm.progetto, onSaveSuccess, onSaveError);
            } else {
                Progetto.save(vm.progetto, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('ordiniApp:progettoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dataCreazione = false;
        vm.datePickerOpenStatus.dataAggiornamento = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('ProgettoDetailController', ProgettoDetailController);

    ProgettoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Progetto', 'Finanziamento', 'Utente'];

    function ProgettoDetailController($scope, $rootScope, $stateParams, previousState, entity, Progetto, Finanziamento, Utente) {
        var vm = this;

        vm.progetto = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('ordiniApp:progettoUpdate', function(event, result) {
            vm.progetto = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('ProgettoDeleteController',ProgettoDeleteController);

    ProgettoDeleteController.$inject = ['$uibModalInstance', 'entity', 'Progetto'];

    function ProgettoDeleteController($uibModalInstance, entity, Progetto) {
        var vm = this;

        vm.progetto = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Progetto.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('progetto', {
            parent: 'entity',
            url: '/progetto?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.progetto.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/progetto/progettos.html',
                    controller: 'ProgettoController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('progetto');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('progetto-detail', {
            parent: 'entity',
            url: '/progetto/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.progetto.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/progetto/progetto-detail.html',
                    controller: 'ProgettoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('progetto');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Progetto', function($stateParams, Progetto) {
                    return Progetto.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'progetto',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('progetto-detail.edit', {
            parent: 'progetto-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/progetto/progetto-dialog.html',
                    controller: 'ProgettoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Progetto', function(Progetto) {
                            return Progetto.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('progetto.new', {
            parent: 'progetto',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/progetto/progetto-dialog.html',
                    controller: 'ProgettoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                codice: null,
                                titolo: null,
                                utenteCreazione: null,
                                dataCreazione: null,
                                utenteAggiornamento: null,
                                dataAggiornamento: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('progetto', null, { reload: 'progetto' });
                }, function() {
                    $state.go('progetto');
                });
            }]
        })
        .state('progetto.edit', {
            parent: 'progetto',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/progetto/progetto-dialog.html',
                    controller: 'ProgettoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Progetto', function(Progetto) {
                            return Progetto.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('progetto', null, { reload: 'progetto' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('progetto.delete', {
            parent: 'progetto',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/progetto/progetto-delete-dialog.html',
                    controller: 'ProgettoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Progetto', function(Progetto) {
                            return Progetto.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('progetto', null, { reload: 'progetto' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('ordiniApp')
        .factory('Progetto', Progetto);

    Progetto.$inject = ['$resource', 'DateUtils'];

    function Progetto ($resource, DateUtils) {
        var resourceUrl =  'api/progettos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dataCreazione = DateUtils.convertDateTimeFromServer(data.dataCreazione);
                        data.dataAggiornamento = DateUtils.convertDateTimeFromServer(data.dataAggiornamento);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('ProgettoSearch', ProgettoSearch);

    ProgettoSearch.$inject = ['$resource'];

    function ProgettoSearch($resource) {
        var resourceUrl =  'api/_search/progettos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('ProgettoController', ProgettoController);

    // inca$ - aggiunta gestione search
    ProgettoController.$inject = ['$scope', '$state', '$uibModal', 'Progetto', 'ProgettoSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ProgettoController ($scope, $state, $uibModal, Progetto, ProgettoSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        // inca$ - aggiunta gestione search
        vm.searchForm = searchForm;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                ProgettoSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Progetto.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.progettos = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }
        // inca$ - aggiunta gestione search
        function searchForm (field, type, domain) {
        	$uibModal.open({
                templateUrl: 'app/search/search-dialog.html',
                controller: 'SearchController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                	pScope: function() {
                        return $scope;
                    },
                    search: function() {
                        return ProgettoSearch;
                    },
                    controller: function() {
                        return vm;
                    },
                    field: function() {
                        return field;
                    },
                    type: function() {
                        return type;
                    },
                    domain: function() {
                        return domain;
                    }
                }
            }).result.then(function() {
                //$state.go('progetto', null, { reload: 'progetto' });
            }, function() {
                //$state.go('^');
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('ordineItems', ordineItems);

    ordineItems.$inject = ['$http'];

    function ordineItems ($http) {
        var service = {
        };

        var vm = this;
        vm.id=null;

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('OrdineDialogController', OrdineDialogController);

    OrdineDialogController.$inject = ['$filter', '$window', '$timeout', '$scope', '$rootScope', '$stateParams', '$uibModal', '$uibModalInstance', '$q', 'entity', 'DettaglioOrdineDBSearch', 'Permissions', 'Currencies', 'MailSigns', 'DataUtils', 'Ordine', 'Documento', 'Dichiarazione', 'Decisione', 'DettaglioOrdine', 'DocumentoFile', 'AdminCommands'];

    function OrdineDialogController ($filter, $window, $timeout, $scope, $rootScope, $stateParams, $uibModal, $uibModalInstance, $q, entity, DettaglioOrdineDBSearch, Permissions, Currencies, MailSigns, DataUtils, Ordine, Documento, Dichiarazione, Decisione, DettaglioOrdine, DocumentoFile, AdminCommands) {
        var vm = this;

        // inca$ - variabili gestione preview e invio
        vm.visualizza = false;
        vm.invia = false;
        vm.isPreview = false; // quando viene premuto Preview, isPreview viene settata definitivamente a true;
        vm.isValidating = false; // quando viene premuto Valida o Respingi, isValidating viene settato definitivamente a true;
        vm.oldStato;
        vm.dateformat='dd/MM/yyyy';
        $scope.functionNameForAutocomplete = 'ordine'; // per gestire l'autocompletamento
        vm.numeroDecimaliImporto=2;

        vm.ordine = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.downloadFile = DataUtils.downloadFile;
        vm.previewFile = DataUtils.previewFile;
        vm.openStorageFile = openStorageFile;
        vm.downloadStorageFile = downloadStorageFile;
        vm.docFileName = docFileName;
        vm.save = save;
        vm.save2 = save2;
        vm.save3 = save3;
    	vm.utenteLogin = Permissions.getAccount().login;
//        vm.documentopdfs = Documento.query({filter: 'ordinepdf-is-null'});
//        $q.all([vm.ordine.$promise, vm.documentopdfs.$promise]).then(function() {
//            if (!vm.ordine.documentoPdf || !vm.ordine.documentoPdf.id) {
//                return $q.reject();
//            }
//            return Documento.get({id : vm.ordine.documentoPdf.id}).$promise;
//        }).then(function(documentoPdf) {
//            vm.documentopdfs.push(documentoPdf);
//        });
        vm.dichiaraziones = Dichiarazione.query({filter: 'ordine-is-null', valid: true});
        $q.all([vm.ordine.$promise, vm.dichiaraziones.$promise]).then(function() {
            if (!vm.ordine.dichiarazione || !vm.ordine.dichiarazione.id) {
                return $q.reject();
            }
            return Dichiarazione.get({id : vm.ordine.dichiarazione.id}).$promise;
        }).then(function(dichiarazione) {
            vm.dichiaraziones.push(dichiarazione);
        });
        //vm.dettaglioordines = DettaglioOrdine.query({size:100000000}); // inca$ - caricamento totale liste fk
        // inca$ - gestione validazione e rifiuto
        vm.validate = validate;
        vm.reject = reject;
        vm.disableSave = disableSave; // inca$ - imposta l'abilitazione di Salva
        vm.disableValidateOrReject = disableValidateOrReject; // inca$ - imposta l'abilitazione dei button Valida e Respingi
        vm.disablePreviewOrSend = disablePreviewOrSend;
        vm.showMotivazioneRifiuto = showMotivazioneRifiuto;
        vm.showInformazioniAmministrazione = showInformazioniAmministrazione;
        vm.disableInformazioniAmministrazione = disableInformazioniAmministrazione;
        vm.showProtocollo = showProtocollo;
        vm.disableProtocollo = disableProtocollo;
        // inca$ - aggiunta gestione rifiuto
        vm.rejectDialogForm = rejectDialogForm;
        vm.eraseHiddenFields = eraseHiddenFields;
        // inca$ - gestione dettaglio
        vm.dettagliOrdine = null;
        vm.findDettagliOrdine = findDettagliOrdine;
        vm.addDettaglioOrdine = addDettaglioOrdine;
        vm.editDettaglioOrdine = editDettaglioOrdine;
        vm.deleteDettaglioOrdine = deleteDettaglioOrdine;
        vm.disableInsertDetails = disableInsertDetails;
        // inca$ - gestione totali dettagli
        vm.totaleImponibile = 0;
        vm.totaleIva = 0;
        vm.totaleOrdine = 0;
        vm.calcTotaliDattaglio=calcTotaliDattaglio;
        vm.percentualeIvaInit=percentualeIvaInit;
        // inca$ - gestione currencies
        vm.currencies = null;
        // inca$ - gestione invio mail documenti
        vm.sendMailSigns = sendMailSigns;
        vm.viewMailSigns = viewMailSigns;
        vm.mailSent = mailSent;
        //inca$ - gestione fuzioni superutente
        vm.viewUpdateStato = viewUpdateStato;
        vm.updateStato = updateStato;
        vm.statoForUpdate = vm.ordine.stato;
        vm.updateStatoDone = updateStatoDone;
        vm.currencySymbol = currencySymbol;
        vm.dichiarazioneChanged = dichiarazioneChanged;
        vm.editDichiarazione = editDichiarazione;
        vm.editDecisione = editDecisione;
        vm.decisioneEsteso = null;
        vm.refreshDecisioneEsteso = refreshDecisioneEsteso;
        // inca$ - aggiunta gestione invio multiplo
        vm.sendDialogForm = sendDialogForm;
        // inca$ - gestione stato colorato
        vm.statoColour = statoColour;
        vm.statoLinkedColour = statoLinkedColour;
        vm.disablePercentualeIva = disablePercentualeIva;
        vm.printIvaOnDetails = printIvaOnDetails;
        
    	// all'ingresso della funzione, consideriamo lo stato
    	// di rifiutato come se fosse in compilazione
        {
       		// inca$ - gestione chiusura e invio
        	if ((vm.ordine.stato == 'RIFIUTATO_DA_AMMINISTRAZIONE' ||
            	vm.ordine.stato == 'RIFIUTATO_DA_RESPONSABILE' ||
            	vm.ordine.stato == 'RIFIUTATO_DA_DIRETTORE') &&
        		((vm.ordine.utenteCreazione == vm.utenteLogin ||
        		vm.ordine.dichiarazione.decisione.responsabileProcedimento.user.login == vm.utenteLogin) ||
        		Permissions.hasRole('ROLE_SUPERUTENTE'))) {
				vm.ordine.stato = 'IN_COMPILAZIONE';
				//vm.ordine.file = null;
        	}
        }
        
        function openStorageFile (documento) {
        	var	type = documento.fileContentType;
        	var data = documento.file;
        	
        	if (documento.simpleStorageService) {
        		DocumentoFile.get({id : documento.id}, function(result) {
        			console.log(result.fileContentType);
        			//console.log(result.file);
         			vm.openFile(result.fileContentType, result.file);
                }, onGetFileError);
        	} else
            	vm.openFile(type, data);
        }

        function downloadStorageFile (documento, filename) {
        	var	type = documento.fileContentType;
        	var data = documento.file;

        	if (documento.simpleStorageService) {
        		DocumentoFile.get({id : documento.id}, function(result) {
        			console.log(result.fileContentType);
        			//console.log(result.file);
         			vm.downloadFile(result.fileContentType, result.file, filename);
                }, onGetFileError);
        	} else
            	vm.downloadFile(type, data, filename);
        }

        function onGetFileError () {
        	modalScrollTop();
        };	

        function statoLinkedColour (stato, tipoDocumento, classField) {
        	if (stato=='IN_COMPILAZIONE')
        		classField = classField+" stato-field-compilatore";
        	else if (stato=='INVIATO') {
        		if (tipoDocumento=='decisione')
        			classField = classField+" stato-field-amministrazione";
        		else
        			classField = classField+" stato-field-responsabile";
        	}
        	else if (stato=='RIFIUTATO_DA_RESPONSABILE')
        		classField = classField+" stato-field-rifiuto";
        	else if (stato=='INVIATO_A_AMMINISTRAZIONE')
        		classField = classField+" stato-field-amministrazione";
        	else if (stato=='RIFIUTATO_DA_AMMINISTRAZIONE')
        		classField = classField+" stato-field-rifiuto";
        	else if (stato=='INVIATO_A_DIRETTORE')
        		classField = classField+" stato-field-direttore";
        	else if (stato=='RIFIUTATO_DA_DIRETTORE')
        		classField = classField+" stato-field-rifiuto";
        	else if (stato=='VALIDATO')
        		classField = classField+" stato-field-completato";
        	return classField;
        }

        function statoColour (stato) {
        	//return "stato-visibile-field form-control"; // default
        	return statoLinkedColour (stato, 'ordine', "stato-visibile-field");
        }
        
        // inca$ - caricamento file solo se da DB
        {
        	if (entity.documentoPdf!=null&&!entity.documentoPdf.simpleStorageService)
	    		DocumentoFile.get({id : entity.documentoPdf.id}, function(result) {
	     			vm.ordine.documentoPdf["file"]=result.file;
	            });
        }

        // inca$ - inizializzazione caricamento ruoli
        Permissions.loadRoles();

        // inca$ - inizializzazione caricamento currencies
        Currencies.loadCurrencyList(vm);

        // inca$ - carico i documenti allegati
        vm.findDettagliOrdine();
        
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
            
            if (vm.ordine.dichiarazione.decisione.id!=null) {
            	refreshDecisioneEsteso ();
            }
        });

        function refreshDecisioneEsteso () {
        	if (vm.ordine.dichiarazione!=null && vm.ordine.dichiarazione.decisione!=null)
        		vm.decisioneEsteso="ID: "+vm.ordine.dichiarazione.decisione.id+" - "+vm.ordine.dichiarazione.decisione.impegno.codice+" - "+vm.ordine.dichiarazione.decisione.stato;
        	else
        		vm.decisioneEsteso="";
        }
        
        function clear () {
        	// inca$ - chiudiamo solo se non è stata fatta preview
        	if (!vm.isPreview)
        		$uibModalInstance.dismiss('cancel');
        }

        function save () {

        	vm.eraseHiddenFields();

       		// memorizziamo SEMPRE lo stato precedente al salvataggio
       		vm.oldStato = vm.ordine.stato;

        	// inca$ - gestione chiusura e invio
        	if (vm.ordine.stato==null)
        		vm.ordine.stato='IN_COMPILAZIONE';

        	if (vm.invia==true) {
        		
        		// se si volesse inviare direttamente senza dialog di invio multiplo
        		// basta attivare save2() e disattivare sendDialogForm(); 
        		// save2(); 
                sendDialogForm();

        	} else
                save3();
        }

        function save2 () {
        	if (vm.ordine.stato=='IN_COMPILAZIONE')
    			if (vm.ordine.dichiarazione.decisione.impegno.gae.finanziamento.responsabileFondi.direttore == true ||
    				vm.ordine.dichiarazione.decisione.impegno.gae.finanziamento.responsabileFondi.user.login == vm.utenteLogin)
    				vm.ordine.stato='INVIATO_A_AMMINISTRAZIONE';
    			else
    				vm.ordine.stato='INVIATO';
            vm.invia = false;
        }

        function save3 () {
	        vm.isSaving = true;
	        if (vm.ordine.id !== null) {
				if (vm.ordine.documentoPdf != null &&
						(vm.ordine.documentoPdf.annoProtocollo != null ||
						vm.ordine.documentoPdf.numeroProtocollo != null)) {
					Documento.update(vm.ordine.documentoPdf);
				}
	            Ordine.update(vm.ordine, onSaveSuccess, onSaveError);
	        } else {
	            Ordine.save(vm.ordine, onSaveSuccess, onSaveError);
	        }
        }

        function onSaveSuccess (result) {
			// inca$ - gestione preview
			if (vm.visualizza == true) {
				vm.ordine=result;
				$scope.editForm.$setValidity();
	            $scope.$emit('ordiniApp:ordineUpdate', result);
	        	// inca$ - non più funzionante su chrome a causa dell'errore
	        	// Not allowed to navigate top frame to data URL
				//$window.open('data:' + result.documentoPdf.fileContentType + ';base64,' + result.documentoPdf.file);
	            var type = result.documentoPdf.fileContentType;
	            var data = result.documentoPdf.file;
	        	var win = window.open();
	        	vm.previewFile(type, data);

				// sono costretto a settare il valore delle date a causa di un azzeramento per il comportamento anomalo
				// della proprietà uib-datepicker-popup="{{vm.dateformat}}"
				var data = angular.element(document.querySelector('#field_data'));
				data.val($filter('date')(result.data,vm.dateformat));
				var dataOfferta = angular.element(document.querySelector('#field_dataOfferta'));
				dataOfferta.val($filter('date')(result.dataOfferta,vm.dateformat));

                vm.visualizza=false;
			} else {
	            $scope.$emit('ordiniApp:ordineUpdate', result);
	            $uibModalInstance.close(result);
			}
            vm.isSaving = false;
        }

        function onSaveError () {
        	// inca$ - mia funzione per fare scroll to top
        	modalScrollTop();

            vm.isSaving = false;
        	// inca$ - gestione preview
       		vm.isPreview=false;

       		// torniamo SEMPRE allo stato precedente in caso di errore
       		vm.ordine.stato = vm.oldStato;

       		// inca$ - gestione valida o respingi
			if (vm.isValidating == true) {
    			//vm.ordine.stato = vm.oldStato;
				vm.isValidating = false;
			}
        }

    	// inca$ - gestione preview
        vm.preview = function () {
        	vm.visualizza=true;
        	vm.isPreview = true;
        }

        // inca$ - gestione invio
        vm.send = function () {
        	vm.invia=true;
        }

        vm.setFile = function ($file, ordine) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        ordine.file = base64Data;
                        ordine.fileContentType = $file.type;
                    });
                });
            }
        };
        vm.datePickerOpenStatus.dataProtocolloOrdine = false;
        vm.datePickerOpenStatus.dataOfferta = false;
        vm.datePickerOpenStatus.dataCreazione = false;
        vm.datePickerOpenStatus.dataAggiornamento = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function validate () {

            // inca$ - gestione validazione
        	if (vm.ordine.stato == 'INVIATO') {
    			vm.ordine.stato = 'INVIATO_A_AMMINISTRAZIONE';

    			vm.isValidating = true;
    			vm.oldStato = 'INVIATO';
    			vm.isSaving = true;
        		Ordine.update(vm.ordine, onSaveSuccess, onSaveError);

			} else if (vm.ordine.stato == 'INVIATO_A_AMMINISTRAZIONE') {
				vm.ordine.stato = 'INVIATO_A_DIRETTORE';

				vm.isValidating = true;
				vm.oldStato = 'INVIATO_A_AMMINISTRAZIONE';
				vm.isSaving = true;
				Ordine.update(vm.ordine, onSaveSuccess, onSaveError);

			} else if (vm.ordine.stato == 'INVIATO_A_DIRETTORE') {
				vm.ordine.stato = 'VALIDATO';
	
				vm.isValidating = true;
				vm.oldStato = 'INVIATO_A_DIRETTORE';
				vm.isSaving = true;
				Ordine.update(vm.ordine, onSaveSuccess, onSaveError);
			}
        }

        function reject () {

        	// inca$ - gestione rifiuto
    		if (vm.ordine.stato == 'INVIATO') {
    			vm.ordine.stato = 'RIFIUTATO_DA_RESPONSABILE';

    			vm.isValidating = true;
    			vm.oldStato = 'INVIATO';
    			vm.isSaving = true;

    			Ordine.update(vm.ordine, onSaveSuccess, onSaveError);

    		} else if (vm.ordine.stato == 'INVIATO_A_AMMINISTRAZIONE') {
				vm.ordine.stato = 'RIFIUTATO_DA_AMMINISTRAZIONE';

				vm.isValidating = true;
				vm.oldStato = 'INVIATO_A_AMMINISTRAZIONE';
				vm.isSaving = true;
				
				Ordine.update(vm.ordine, onSaveSuccess, onSaveError);

			} else if (vm.ordine.stato == 'INVIATO_A_DIRETTORE') {
				vm.ordine.stato = 'RIFIUTATO_DA_DIRETTORE';

				vm.isValidating = true;
				vm.oldStato = 'INVIATO_A_DIRETTORE';
				vm.isSaving = true;
				
				Ordine.update(vm.ordine, onSaveSuccess, onSaveError);

			}


        }

        // inca$ - gestione save, preview o send
        function disableSave () {

        	if (vm.ordine.stato == null) {
        		return false;
        	}

        	// permetto l'amministrazione di inserire il protocollo
        	if (!disableProtocollo())
        		return false;

        	return disableSavePreviewOrSend();
        }

        // inca$ - gestione inserimento allegati e dettagli
        function disableInsertDetails () {

        	if (disableSave())
        		return true;
        	
        	if (vm.ordine.stato == null) {
        		return true;
        	}
			if (vm.ordine.stato != 'IN_COMPILAZIONE') {
				return true;
			} else {
				return false;
			}

        }

        // inca$ - gestione save, preview o send
        function disablePreviewOrSend () {

        	if (vm.ordine.stato == null) {
        		return true;
        	}
        	if (vm.dettagliOrdine == null || vm.dettagliOrdine.length==0) {
        		return true;
        	}
        	return disableSavePreviewOrSend();

        }

        // inca$ - gestione save, preview o send
        function disableSavePreviewOrSend () {

           	// ricordiamoci che il direttore potrebbe essere che sia lui a creare la decisione di contrattare
           	// oppure sia lui il responsabile del procedimento, pertanto va prima verificato questa condizione
           	// successivamente quella del ruolo direttore
           	if (vm.ordine.dichiarazione.decisione.responsabileProcedimento.user.login == vm.utenteLogin ||
				vm.ordine.utenteCreazione == vm.utenteLogin||
				Permissions.hasRole('ROLE_SUPERUTENTE')) {

				if ((vm.ordine.stato == 'INVIATO')||
						(vm.ordine.stato == 'INVIATO_A_AMMINISTRAZIONE')||
						(vm.ordine.stato == 'INVIATO_A_DIRETTORE')||
						(vm.ordine.stato == 'VALIDATO')) {
					return true;
				} else {
					return false;
				}
    		} else if ((Permissions.hasOneOfRoles(['ROLE_AMMINISTRAZIONE']) &&
        			vm.ordine.stato == 'VALIDATO')) {
       			return true;
    		}

       		return true;
        }

        // inca$ - gestione valida o respingi
        function disableValidateOrReject () {

			if (vm.ordine.stato == null)
				return true;

    		if ((((Permissions.hasOneOfRoles(['ROLE_SUPERUTENTE']) || vm.ordine.dichiarazione.decisione.impegno.gae.finanziamento.responsabileFondi.user.login == vm.utenteLogin)) && vm.ordine.stato == 'INVIATO') ||
       			(Permissions.hasOneOfRoles(['ROLE_SUPERUTENTE','ROLE_AMMINISTRAZIONE']) && vm.ordine.stato == 'INVIATO_A_AMMINISTRAZIONE') ||
       			(Permissions.hasOneOfRoles(['ROLE_SUPERUTENTE','ROLE_DIRETTORE']) && vm.ordine.stato == 'INVIATO_A_DIRETTORE')) {
    			return false;
    		}
       		return true;
        }

        // inca$ - gestione campo motivazione rifiuto
        function showMotivazioneRifiuto () {

			if (vm.ordine.stato == null)
				return false;

			if (vm.ordine.motivazioneRifiuto != null)
				return true;

			if ((Permissions.hasOneOfRoles(['ROLE_AMMINISTRAZIONE','ROLE_DIRETTORE','ROLE_SUPERUTENTE']) ||
					(vm.ordine.stato == 'RIFIUTATO_DA_AMMINISTRAZIONE' || vm.ordine.stato == 'RIFIUTATO_DA_RESPONSABILE' || vm.ordine.stato == 'RIFIUTATO_DA_DIRETTORE')))
    			return true;

			return false;
        }

        // inca$ - gestione campo protocollo
        function showInformazioniAmministrazione () {
        	//return true;
			if (vm.ordine.stato == null)
				return false;
			
			if ((Permissions.hasOneOfRoles(['ROLE_AMMINISTRAZIONE','ROLE_SUPERUTENTE']) ||
					vm.ordine.codiceTerzoFornitore !=null ||
					vm.ordine.dataProtocolloOrdine !=null ||
					vm.ordine.identificativoContratto !=null ))
    			return true;

			return false;
        }

        // inca$ - gestione campi informazioni amministrazione
        function disableInformazioniAmministrazione () {
        	//return false;
        	
			if (vm.ordine.stato == null)
				return true;

			if ((Permissions.hasOneOfRoles(['ROLE_AMMINISTRAZIONE','ROLE_SUPERUTENTE']) &&
					vm.ordine.stato == 'VALIDATO'))
    			return false;

			return true;
        }

        // inca$ - gestione campo protocollo
        function showProtocollo () {

			if (vm.ordine.stato == null)
				return false;
			
			if (vm.ordine.documentoPdf==null)
				return false;
			
			if ((Permissions.hasOneOfRoles(['ROLE_AMMINISTRAZIONE','ROLE_SUPERUTENTE']) ||
					vm.ordine.documentoPdf.numeroProtocollo !=null))
    			return true;

			return false;
        }

        // inca$ - gestione campo protocollo
        function disableProtocollo () {

			if (vm.ordine.stato == null)
				return true;

			if ((Permissions.hasOneOfRoles(['ROLE_AMMINISTRAZIONE','ROLE_SUPERUTENTE']) &&
					vm.ordine.stato == 'VALIDATO'))
    			return false;

			return true;
        }

        // inca$ - aggiunta gestione rifiuto
        function rejectDialogForm() {
        	$uibModal.open({
                templateUrl: 'app/util/entity-reject.html',
                controller: 'EntityRejectController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    controller: function() {
                        return vm;
                    },
                    entityName: function() {
                        return 'ordine';
                    }
                }
            }).result.then(function() {
            	vm.reject();
            }, function() {
            });
        }

        // inca$ - aggiunta gestione rifiuto
        function sendDialogForm() {
        	$uibModal.open({
                templateUrl: 'app/util/send/multiple-send.html',
                controller: 'MultipleSendController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    controller: function() {
                        return vm;
                    },
                    entityName: function() {
                        return 'ordine';
                    },
                    entity: function() {
                        return vm.ordine;
                    }
                }
            }).result.then(function(result) {
            	if (result) 
            		vm.save2();
                vm.save3();

            }, function() {
                vm.invia = false;
            });
        }

        function eraseHiddenFields () {
        }
        
        function findDettagliOrdine () {
        	if (vm.ordine.id!=null) 
        		vm.dettagliOrdine = DettaglioOrdineDBSearch.query({size: 100000000, query: {ordineId: vm.ordine.id}}, dettagliOnSuccess);
            
        	function dettagliOnSuccess(data, headers) {
                vm.calcTotaliDattaglio();
            }

        }

        function addDettaglioOrdine () {
        	
        	//findDettagliOrdine ();
        	
        	$uibModal.open({
              templateUrl: 'app/entities/dettaglio-ordine/dettaglio-ordine-dialog.html',
              controller: 'DettaglioOrdineDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('dettaglioOrdine');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: function () {
						return {
                            quantita: null,
                            descrizioneArticolo: null,
                            codiceArticolo: null,
                            importoUnitario: null,
                            id: null,
                            ordine: vm.ordine
						}
                    },
                    controller: function() {
                        return vm;
                    },
                    entityName: function() {
                        return 'dettaglioOrdine';
                    },
                    ordineItems: function() {
                        return vm.ordine;
                    } 
                }
            }).result.then(function() {
            	vm.findDettagliOrdine();
            }, function() {
            });
        }

        function editDettaglioOrdine (dettaglioOrdine) {
        	
        	findDettagliOrdine ();
        	
        	$uibModal.open({
              templateUrl: 'app/entities/dettaglio-ordine/dettaglio-ordine-dialog.html',
              controller: 'DettaglioOrdineDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('dettaglioOrdine');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: dettaglioOrdine,
                    controller: function() {
                        return vm;
                    },
                    entityName: function() {
                        return 'dettaglioOrdine';
                    },
                    ordineItems: function() {
                        return vm.ordine;
                    }
                }
            }).result.then(function() {
            	vm.findDettagliOrdine();
            }, function() {
            });
        }

        function deleteDettaglioOrdine (dettaglioOrdine) {
            
        	findDettagliOrdine ();
        	
        	$uibModal.open({
                templateUrl: 'app/entities/dettaglio-ordine/dettaglio-ordine-delete-dialog.html',
                controller: 'DettaglioOrdineDeleteController',                       
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('dettaglioOrdine');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: function() {
                        return dettaglioOrdine;
                    }
                }
            }).result.then(function() {
            	vm.findDettagliOrdine();
            }, function() {
            });

        };
        
        function calcTotaliDattaglio() {
            vm.totaleImponibile=0;
            vm.totaleIva=0;
            vm.totaleOrdine=0;
        	for (var i = 0, len = vm.dettagliOrdine.length; i < len; i++) {
        		var dettaglio=vm.dettagliOrdine[i];
                vm.totaleImponibile=Number(vm.totaleImponibile.toFixed(vm.numeroDecimaliImporto))+(dettaglio.importoUnitario*dettaglio.quantita);
                vm.totaleIva=Number(vm.totaleIva.toFixed(vm.numeroDecimaliImporto))+(dettaglio.importoUnitario*dettaglio.quantita*dettaglio.percentualeIva/100);
            }
        	vm.totaleImponibile=Number(vm.totaleImponibile.toFixed(vm.numeroDecimaliImporto));
        	vm.totaleIva=Number(vm.totaleIva.toFixed(vm.numeroDecimaliImporto));
            vm.totaleOrdine=vm.totaleImponibile+vm.totaleIva;
        }
        
        function percentualeIvaInit() {
        	if (vm.ordine.id==null)
        		return vm.ordine.percentualeIva=22;
        }

        function viewMailSigns () {
    		
        	if (vm.ordine.stato == null)
    			return false;

    		if (Permissions.hasOneOfRoles(['ROLE_SUPERUTENTE']) && vm.ordine.stato == 'VALIDATO')
    			return true;
    		
    		return false;
        }

        function sendMailSigns () {
        	MailSigns.sendMail(vm, vm.ordine.id);
        }
    
        function mailSent (result) {
        	$uibModalInstance.dismiss('cancel');
        }

        function viewUpdateStato () {
    		
        	if (vm.ordine.stato == null)
    			return false;

    		if (Permissions.hasOneOfRoles(['ROLE_SUPERUTENTE'])) 
    			return true;
    		
    		return false;
        }

        function updateStato () {
        	AdminCommands.updateStatoOrdine(vm, vm.ordine.id, vm.statoForUpdate);
        }

        function updateStatoDone (result) {
        	$uibModalInstance.dismiss('cancel');
        }

        function currencySymbol () {
        	if (vm.ordine.valuta==null)
        		return "€";
        	
        	var symbol = currencySymbols[vm.ordine.valuta];
        	
        	if (symbol!=null)
                return symbol;
        	else
                return vm.ordine.valuta;
               
        }
        
        function dichiarazioneChanged () {
        	if (vm.ordine.dichiarazione!=null) {
        		vm.ordine.luogoConsegna=vm.ordine.dichiarazione.decisione.luogoConsegna;
        	
        		Decisione.get({id : vm.ordine.dichiarazione.decisione.id}, function(result) {
         			vm.ordine.dichiarazione.decisione=result;
                });

        	}
        
        	vm.refreshDecisioneEsteso();
        }

        function editDichiarazione () {
        	
        	if (vm.ordine!=null && vm.ordine.dichiarazione!=null) {
            	$uibModal.open({
                    templateUrl: 'app/entities/dichiarazione/dichiarazione-dialog.html',
                    controller: 'DichiarazioneDialogController',
                      controllerAs: 'vm',
                      backdrop: 'static',
                      size: 'md',
                      resolve: {
                          translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                              $translatePartialLoader.addPart('dichiarazione');
                              $translatePartialLoader.addPart('decisione');
                              $translatePartialLoader.addPart('statoDichiarazione');
                              $translatePartialLoader.addPart('tipoEsclusivita');
                              $translatePartialLoader.addPart('documento'); // inca$ - aggiungo la traduzione di documento
                              $translatePartialLoader.addPart('global');
                              return $translate.refresh();
                          }],
    	                  entity: ['Dichiarazione', function(Dichiarazione) {
    	                	  return Dichiarazione.get({id : vm.ordine.dichiarazione.id}).$promise;
	                      }],
                          controller: function() {
                              return vm;
                          },
                          entityName: function() {
                              return 'dichiarazione';
                          },
                      }
                }).result.then(function(dichiarazione) {
                	vm.ordine.dichiarazione=dichiarazione;
                	
                    // ricarichiamo il valore nella select list
                	$q.all([vm.ordine.$promise, vm.dichiaraziones.$promise]).then(function() {
                        if (!dichiarazione || !dichiarazione.id) {
                            return $q.reject();
                        }
                        return Dichiarazione.get({id : dichiarazione.id}).$promise;
                    }).then(function(dichiarazioneLoaded) {
    	            	for (var i=0;i<vm.dichiaraziones.length;i++){
    	   	        		if (vm.dichiaraziones[i].id==dichiarazione.id) {
    	   	        			vm.dichiaraziones.splice(i,1);
    	   	        		}
    	            	}
                        vm.dichiaraziones.push(dichiarazioneLoaded);
    	        		if (dichiarazioneLoaded.id=dichiarazione.id) {
		        			vm.ordine.dichiarazione=dichiarazioneLoaded;
		        		}
                    });
                	
        		    // ricarichiamo il file dato che potrebbe essere stato rigenerato
                	if (entity.documentoPdf!=null)
        	    		DocumentoFile.get({id : entity.documentoPdf.id}, function(result) {
        	     			vm.ordine.documentoPdf["file"]=result.file;
        	            });


                }, function() {
                });
        	}
        }

        function editDecisione () {
        	
        	if (vm.ordine!=null && vm.ordine.dichiarazione!=null) {
        		
	        	$uibModal.open({
	              templateUrl: 'app/entities/decisione/decisione-dialog.html',
	              controller: 'DecisioneDialogController',
	                controllerAs: 'vm',
	                backdrop: 'static',
	                size: 'md',
	                resolve: {
	                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
	                        $translatePartialLoader.addPart('decisione');
	                        $translatePartialLoader.addPart('tipoOrdine');
	                        $translatePartialLoader.addPart('tipoDecisione');
	                        $translatePartialLoader.addPart('statoDecisione');
	                        $translatePartialLoader.addPart('documento'); // inca$ - aggiungo la traduzione di documento
	                        $translatePartialLoader.addPart('global');
	                        return $translate.refresh();
	                    }],
	                    entity: ['Decisione', function(Decisione) {
	                        return Decisione.get({id : vm.ordine.dichiarazione.decisione.id}).$promise;
	                    }],
	                    controller: function() {
	                        return vm;
	                    },
	                    entityName: function() {
	                        return 'decisione';
	                    },
	                }
	            }).result.then(function(decisione) {
	            	vm.ordine.dichiarazione.decisione=decisione;
	            	
	            	vm.refreshDecisioneEsteso();

        		    // ricarichiamo il file dato che potrebbe essere stato rigenerato
//	            	if (entity.documentoPdf!=null)
//	    	    		DocumentoFile.get({id : entity.documentoPdf.id}, function(result) {
//	    	     			vm.ordine.documentoPdf["file"]=result.file;
//	    	            });
	            	
	            }, function() {
	            });
        	}
        }

        function docFileName (ordine, fileContentType) {
        	var extn = null;
        	if (ordine.documentoPdf.fileContentType!=null)
        		extn = ordine.documentoPdf.fileContentType.split("/").pop();
        	else
        		extn = fileContentType.split("/").pop();
        	return findAndReplace(ordine.dichiarazione.decisione.impegno.codice,"/","_").replace(/[|&;$%@"<>()+,]/g, "")+"_ordine_ID_"+ordine.id+"."+extn;
        }

        function findAndReplace(string, target, replacement) {
        	 var i = 0, length = string.length;
        	 for (i; i < length; i++) {
        	   string = string.replace(target, replacement);
        	 }
        	 return string;
        }

        function disablePercentualeIva () {

        	if (vm.dettagliOrdine != null && vm.dettagliOrdine.length>0) {
        		return true;
        	}
        	return false;

        }

        function printIvaOnDetails () {

        	if (vm.dettagliOrdine != null && vm.dettagliOrdine.length>0) {
        		
            	for (var i = 0, len = vm.dettagliOrdine.length; i < len; i++) {
            		var dettaglio=vm.dettagliOrdine[i];
            		if (dettaglio.percentualeIva!=vm.ordine.percentualeIva)
            			return true;
                }
        	}
        	return false;

        }
    }

})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('OrdineDetailController', OrdineDetailController);

    OrdineDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Ordine', 'Documento', 'Dichiarazione', 'DettaglioOrdine', 'DocumentoFile'];

    function OrdineDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Ordine, Documento, Dichiarazione, DettaglioOrdine, DocumentoFile) {
        var vm = this;

        vm.ordine = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.openStorageFile = openStorageFile;

        function openStorageFile (documento) {
        	var	type = documento.fileContentType;
        	var data = documento.file;
        	
        	if (documento.simpleStorageService) {
        		DocumentoFile.get({id : documento.id}, function(result) {
        			console.log(result.fileContentType);
        			//console.log(result.file);
         			vm.openFile(result.fileContentType, result.file);
                }, onGetFileError);
        	} else
            	vm.openFile(type, data);
        }

        function onGetFileError () {
        	modalScrollTop();
        };	

        // inca$ - caricamento file solo se da DB
        {
        	if (entity.documentoPdf!=null&&!entity.documentoPdf.simpleStorageService)
	    		DocumentoFile.get({id : entity.documentoPdf.id}, function(result) {
	     			vm.ordine.documentoPdf["file"]=result.file;
	            });
        }

        var unsubscribe = $rootScope.$on('ordiniApp:ordineUpdate', function(event, result) {
            vm.ordine = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('OrdineDeleteController',OrdineDeleteController);

    OrdineDeleteController.$inject = ['$uibModalInstance', 'entity', 'Ordine'];

    function OrdineDeleteController($uibModalInstance, entity, Ordine) {
        var vm = this;

        vm.ordine = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Ordine.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ordine', {
            parent: 'entity',
            url: '/ordine?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.ordine.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ordine/ordines.html',
                    controller: 'OrdineController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                	value: 'id,desc', // inca$ - default order
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ordine');
                    $translatePartialLoader.addPart('decisione'); // inca$ - aggiungo la traduzione di decisione
                    $translatePartialLoader.addPart('statoOrdine');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('documento'); // inca$ - aggiungo la traduzione di documento
                    return $translate.refresh();
                }]
            }
        })
        .state('ordine-detail', {
            parent: 'entity',
            url: '/ordine/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.ordine.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ordine/ordine-detail.html',
                    controller: 'OrdineDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ordine');
                    $translatePartialLoader.addPart('statoOrdine');
                    $translatePartialLoader.addPart('documento'); // inca$ - aggiungo la traduzione di documento
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Ordine', function($stateParams, Ordine) {
                    return Ordine.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ordine',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ordine-detail.edit', {
            parent: 'ordine-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ordine/ordine-dialog.html',
                    controller: 'OrdineDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Ordine', function(Ordine) {
                            return Ordine.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ordine.new', {
            parent: 'ordine',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ordine/ordine-dialog.html',
                    controller: 'OrdineDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                stato: null,
                                codiceTerzoFornitore: null,
                                dataProtocolloOrdine: null,
                                annoContratto: null,
                                identificativoContratto: null,
                                destinatarioOrdine: null,
                                numeroOfferta: null,
                                dataOfferta: null,
                                consegnatariMerce: null,
                                luogoConsegna: null,
                                extraUE: false,
                                valuta: null,
                                percentualeIva: null,
                                informazioniProgetto: null,
                                motivazioneRifiuto: null,
                                utenteCreazione: null,
                                dataCreazione: null,
                                utenteAggiornamento: null,
                                dataAggiornamento: null,
                                versioneRecord: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ordine', null, { reload: 'ordine' });
                }, function() {
                    $state.go('ordine');
                });
            }]
        })
        .state('ordine.edit', {
            parent: 'ordine',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ordine/ordine-dialog.html',
                    controller: 'OrdineDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Ordine', function(Ordine) {
                            return Ordine.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ordine', null, { reload: 'ordine' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ordine.delete', {
            parent: 'ordine',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ordine/ordine-delete-dialog.html',
                    controller: 'OrdineDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Ordine', function(Ordine) {
                            return Ordine.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ordine', null, { reload: 'ordine' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('ordiniApp')
        .factory('Ordine', Ordine);

    Ordine.$inject = ['$resource', 'DateUtils'];

    function Ordine ($resource, DateUtils) {
        var resourceUrl =  'api/ordines/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dataProtocolloOrdine = DateUtils.convertLocalDateFromServer(data.dataProtocolloOrdine);
                        data.dataOfferta = DateUtils.convertLocalDateFromServer(data.dataOfferta);
                        data.dataCreazione = DateUtils.convertDateTimeFromServer(data.dataCreazione);
                        data.dataAggiornamento = DateUtils.convertDateTimeFromServer(data.dataAggiornamento);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dataProtocolloOrdine = DateUtils.convertLocalDateToServer(copy.dataProtocolloOrdine);
                    copy.dataOfferta = DateUtils.convertLocalDateToServer(copy.dataOfferta);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dataProtocolloOrdine = DateUtils.convertLocalDateToServer(copy.dataProtocolloOrdine);
                    copy.dataOfferta = DateUtils.convertLocalDateToServer(copy.dataOfferta);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('OrdineSearch', OrdineSearch);

    OrdineSearch.$inject = ['$resource'];

    function OrdineSearch($resource) {
        var resourceUrl =  'api/_search/ordines/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('OrdineController', OrdineController);

    // inca$ - aggiunta gestione search
    OrdineController.$inject = ['$scope', '$state', '$uibModal', 'DataUtils', 'Ordine', 'OrdineSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function OrdineController ($scope, $state, $uibModal, DataUtils, Ordine, OrdineSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        // inca$ - aggiunta gestione search
        vm.searchForm = searchForm;
        // inca$ - gestione stato colorato
        vm.statoColour = statoColour;
        vm.rupName = rupName;
        
        function rupName (ordine) {
       		return ordine.dichiarazione.decisione.responsabileProcedimento.user.firstName+" "+ordine.dichiarazione.decisione.responsabileProcedimento.user.lastName;
        }
        
        function statoColour (stato) {
        	//return "stato-visibile-field form-control"; // default
        	var classField = "stato-field-table";
        	if (stato=='IN_COMPILAZIONE')
        		classField = classField+" stato-field-compilatore";
        	else if (stato=='INVIATO')
        		classField = classField+" stato-field-responsabile";
        	else if (stato=='RIFIUTATO_DA_RESPONSABILE')
        		classField = classField+" stato-field-rifiuto";
        	else if (stato=='INVIATO_A_AMMINISTRAZIONE')
        		classField = classField+" stato-field-amministrazione";
        	else if (stato=='RIFIUTATO_DA_AMMINISTRAZIONE')
        		classField = classField+" stato-field-rifiuto";
        	else if (stato=='INVIATO_A_DIRETTORE')
        		classField = classField+" stato-field-direttore";
        	else if (stato=='RIFIUTATO_DA_DIRETTORE')
        		classField = classField+" stato-field-rifiuto";
        	else if (stato=='VALIDATO')
        		classField = classField+" stato-field-completato";
        	return classField;
        }

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                OrdineSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Ordine.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.ordines = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        // inca$ - aggiunta gestione search
        function searchForm (field, type, domain) {
        	$uibModal.open({
                templateUrl: 'app/search/search-dialog.html',
                controller: 'SearchController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                	pScope: function() {
                        return $scope;
                    },
                    search: function() {
                        return OrdineSearch;
                    },
                    controller: function() {
                        return vm;
                    },
                    field: function() {
                        return field;
                    },
                    type: function() {
                        return type;
                    },
                    domain: function() {
                        return domain;
                    }
                }
            }).result.then(function() {
                //$state.go('decisione', null, { reload: 'decisione' });
            }, function() {
                //$state.go('^');
            });
        }
    
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('DocumentoDBSearch', DocumentoDBSearch);

    DocumentoDBSearch.$inject = ['$resource'];

    function DocumentoDBSearch($resource) {
        var resourceUrl =  'api/_dbsearch/documentos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('OperazioneDialogController', OperazioneDialogController);

    OperazioneDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Operazione', 'RuoloFunzione'];

    function OperazioneDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Operazione, RuoloFunzione) {
        var vm = this;

        vm.operazione = entity;
        vm.clear = clear;
        vm.save = save;
        vm.ruolofunziones = RuoloFunzione.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.operazione.id !== null) {
                Operazione.update(vm.operazione, onSaveSuccess, onSaveError);
            } else {
                Operazione.save(vm.operazione, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('ordiniApp:operazioneUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('OperazioneDetailController', OperazioneDetailController);

    OperazioneDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Operazione', 'RuoloFunzione'];

    function OperazioneDetailController($scope, $rootScope, $stateParams, previousState, entity, Operazione, RuoloFunzione) {
        var vm = this;

        vm.operazione = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('ordiniApp:operazioneUpdate', function(event, result) {
            vm.operazione = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('OperazioneDeleteController',OperazioneDeleteController);

    OperazioneDeleteController.$inject = ['$uibModalInstance', 'entity', 'Operazione'];

    function OperazioneDeleteController($uibModalInstance, entity, Operazione) {
        var vm = this;

        vm.operazione = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Operazione.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('operazione', {
            parent: 'entity',
            url: '/operazione',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.operazione.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/operazione/operaziones.html',
                    controller: 'OperazioneController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('operazione');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('operazione-detail', {
            parent: 'entity',
            url: '/operazione/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.operazione.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/operazione/operazione-detail.html',
                    controller: 'OperazioneDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('operazione');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Operazione', function($stateParams, Operazione) {
                    return Operazione.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'operazione',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('operazione-detail.edit', {
            parent: 'operazione-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/operazione/operazione-dialog.html',
                    controller: 'OperazioneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Operazione', function(Operazione) {
                            return Operazione.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('operazione.new', {
            parent: 'operazione',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/operazione/operazione-dialog.html',
                    controller: 'OperazioneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                codice: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('operazione', null, { reload: 'operazione' });
                }, function() {
                    $state.go('operazione');
                });
            }]
        })
        .state('operazione.edit', {
            parent: 'operazione',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/operazione/operazione-dialog.html',
                    controller: 'OperazioneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Operazione', function(Operazione) {
                            return Operazione.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('operazione', null, { reload: 'operazione' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('operazione.delete', {
            parent: 'operazione',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/operazione/operazione-delete-dialog.html',
                    controller: 'OperazioneDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Operazione', function(Operazione) {
                            return Operazione.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('operazione', null, { reload: 'operazione' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('ordiniApp')
        .factory('Operazione', Operazione);

    Operazione.$inject = ['$resource'];

    function Operazione ($resource) {
        var resourceUrl =  'api/operaziones/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('OperazioneSearch', OperazioneSearch);

    OperazioneSearch.$inject = ['$resource'];

    function OperazioneSearch($resource) {
        var resourceUrl =  'api/_search/operaziones/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('OperazioneController', OperazioneController);

    OperazioneController.$inject = ['$scope', '$state', 'Operazione', 'OperazioneSearch'];

    function OperazioneController ($scope, $state, Operazione, OperazioneSearch) {
        var vm = this;
        
        vm.operaziones = [];
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            Operazione.query(function(result) {
                vm.operaziones = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            OperazioneSearch.query({query: vm.searchQuery}, function(result) {
                vm.operaziones = result;
            });
        }    
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('ModelloDialogController', ModelloDialogController);

    ModelloDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Modello', 'Struttura'];

    function ModelloDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Modello, Struttura) {
        var vm = this;

        vm.modello = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.strutturas = Struttura.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.modello.id !== null) {
                Modello.update(vm.modello, onSaveSuccess, onSaveError);
            } else {
                Modello.save(vm.modello, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('ordiniApp:modelloUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setFile = function ($file, modello) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        modello.file = base64Data;
                        modello.fileContentType = $file.type;
                    });
                });
            }
        };
        vm.datePickerOpenStatus.dataCreazione = false;
        vm.datePickerOpenStatus.dataAggiornamento = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('ModelloDetailController', ModelloDetailController);

    ModelloDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Modello', 'Struttura'];

    function ModelloDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Modello, Struttura) {
        var vm = this;

        vm.modello = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;

        var unsubscribe = $rootScope.$on('ordiniApp:modelloUpdate', function(event, result) {
            vm.modello = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('ModelloDeleteController',ModelloDeleteController);

    ModelloDeleteController.$inject = ['$uibModalInstance', 'entity', 'Modello'];

    function ModelloDeleteController($uibModalInstance, entity, Modello) {
        var vm = this;

        vm.modello = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Modello.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('modello', {
            parent: 'entity',
            url: '/modello?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.modello.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/modello/modellos.html',
                    controller: 'ModelloController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('modello');
                    $translatePartialLoader.addPart('tipoModello');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('modello-detail', {
            parent: 'entity',
            url: '/modello/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.modello.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/modello/modello-detail.html',
                    controller: 'ModelloDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('modello');
                    $translatePartialLoader.addPart('tipoModello');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Modello', function($stateParams, Modello) {
                    return Modello.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'modello',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('modello-detail.edit', {
            parent: 'modello-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/modello/modello-dialog.html',
                    controller: 'ModelloDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Modello', function(Modello) {
                            return Modello.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('modello.new', {
            parent: 'modello',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/modello/modello-dialog.html',
                    controller: 'ModelloDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                descrizione: null,
                                tipo: null,
                                file: null,
                                fileContentType: null,
                                utenteCreazione: null,
                                dataCreazione: null,
                                utenteAggiornamento: null,
                                dataAggiornamento: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('modello', null, { reload: 'modello' });
                }, function() {
                    $state.go('modello');
                });
            }]
        })
        .state('modello.edit', {
            parent: 'modello',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/modello/modello-dialog.html',
                    controller: 'ModelloDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Modello', function(Modello) {
                            return Modello.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('modello', null, { reload: 'modello' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('modello.delete', {
            parent: 'modello',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/modello/modello-delete-dialog.html',
                    controller: 'ModelloDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Modello', function(Modello) {
                            return Modello.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('modello', null, { reload: 'modello' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('ordiniApp')
        .factory('Modello', Modello);

    Modello.$inject = ['$resource', 'DateUtils'];

    function Modello ($resource, DateUtils) {
        var resourceUrl =  'api/modellos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dataCreazione = DateUtils.convertDateTimeFromServer(data.dataCreazione);
                        data.dataAggiornamento = DateUtils.convertDateTimeFromServer(data.dataAggiornamento);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('ModelloSearch', ModelloSearch);

    ModelloSearch.$inject = ['$resource'];

    function ModelloSearch($resource) {
        var resourceUrl =  'api/_search/modellos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('ModelloController', ModelloController);

    // inca$ - aggiunta gestione search
    ModelloController.$inject = ['$scope', '$state', '$uibModal', 'DataUtils', 'Modello', 'ModelloSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ModelloController ($scope, $state, $uibModal, DataUtils, Modello, ModelloSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        // inca$ - aggiunta gestione search
        vm.searchForm = searchForm;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                ModelloSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Modello.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.modellos = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

     // inca$ - aggiunta gestione search
        function searchForm (field, type, domain) {
        	$uibModal.open({
                templateUrl: 'app/search/search-dialog.html',
                controller: 'SearchController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                	pScope: function() {
                        return $scope;
                    },
                    search: function() {
                        return ModelloSearch;
                    },
                    controller: function() {
                        return vm;
                    },
                    field: function() {
                        return field;
                    },
                    type: function() {
                        return type;
                    },
                    domain: function() {
                        return domain;
                    }
                }
            }).result.then(function() {
                //$state.go('modello', null, { reload: 'modello' });
            }, function() {
                //$state.go('^');
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('ImpegnoDialogController', ImpegnoDialogController);

    ImpegnoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Impegno', 'Decisione', 'Gae', 'Struttura', 'VoceBilancio', 'Utente'];

    function ImpegnoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Impegno, Decisione, Gae, Struttura, VoceBilancio, Utente) {
        var vm = this;

        vm.impegno = entity;
        vm.impegnoEsteso = null;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.decisiones = Decisione.query();
        //vm.gaes = Gae.query({size:100000000, viewableOnly: true}); // inca$ - caricamento totale liste fk
        vm.gaes = Gae.query({size:100000000}); // inca$ - caricamento totale liste fk
        vm.strutturas = Struttura.query();
    	vm.esercizioVoce = esercizioVoce;
        vm.vocebilancios = VoceBilancio.query({size:100000000, filterOn: true, viewableOnly: true, esercizio: vm.esercizioVoce()}); // inca$ - caricamento totale liste fk
        vm.utentes = Utente.query({size:100000000}); // inca$ - caricamento totale liste fk

        {
        	if (vm.impegno.decisione!=null)
        		vm.impegnoEsteso = "ID: "+vm.impegno.decisione.id+' - '+vm.impegno.decisione.impegno.codice+' - '+vm.impegno.decisione.stato;
        	else
        		vm.impegnoEsteso = null;
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.impegno.id !== null) {
                Impegno.update(vm.impegno, onSaveSuccess, onSaveError);
            } else {
                Impegno.save(vm.impegno, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('ordiniApp:impegnoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dataCreazione = false;
        vm.datePickerOpenStatus.dataAggiornamento = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

    
        function esercizioVoce () {
        	if (vm.impegno!=null && vm.impegno.voceBilancio!=null)
        		return vm.impegno.voceBilancio.esercizio;
        	if (vm.impegno!=null && vm.impegno.esercizio!=null)
        		return vm.impegno.esercizio;
        	return (new Date()).getFullYear();
        }
        
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('ImpegnoDetailController', ImpegnoDetailController);

    ImpegnoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Impegno', 'Decisione', 'Gae', 'Struttura', 'VoceBilancio', 'Utente'];

    function ImpegnoDetailController($scope, $rootScope, $stateParams, previousState, entity, Impegno, Decisione, Gae, Struttura, VoceBilancio, Utente) {
        var vm = this;

        vm.impegno = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('ordiniApp:impegnoUpdate', function(event, result) {
            vm.impegno = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('ImpegnoDeleteController',ImpegnoDeleteController);

    ImpegnoDeleteController.$inject = ['$uibModalInstance', 'entity', 'Impegno'];

    function ImpegnoDeleteController($uibModalInstance, entity, Impegno) {
        var vm = this;

        vm.impegno = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Impegno.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('impegno', {
            parent: 'entity',
            url: '/impegno?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.impegno.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/impegno/impegnos.html',
                    controller: 'ImpegnoController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('impegno');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('impegno-detail', {
            parent: 'entity',
            url: '/impegno/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.impegno.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/impegno/impegno-detail.html',
                    controller: 'ImpegnoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('impegno');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Impegno', function($stateParams, Impegno) {
                    return Impegno.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'impegno',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('impegno-detail.edit', {
            parent: 'impegno-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/impegno/impegno-dialog.html',
                    controller: 'ImpegnoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Impegno', function(Impegno) {
                            return Impegno.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('impegno.new', {
            parent: 'impegno',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/impegno/impegno-dialog.html',
                    controller: 'ImpegnoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                esercizio: null,
                                esercizioOrigine: null,
                                codice: null,
                                descrizione: null,
                                utenteCreazione: null,
                                dataCreazione: null,
                                utenteAggiornamento: null,
                                dataAggiornamento: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('impegno', null, { reload: 'impegno' });
                }, function() {
                    $state.go('impegno');
                });
            }]
        })
        .state('impegno.edit', {
            parent: 'impegno',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/impegno/impegno-dialog.html',
                    controller: 'ImpegnoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Impegno', function(Impegno) {
                            return Impegno.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('impegno', null, { reload: 'impegno' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('impegno.delete', {
            parent: 'impegno',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/impegno/impegno-delete-dialog.html',
                    controller: 'ImpegnoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Impegno', function(Impegno) {
                            return Impegno.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('impegno', null, { reload: 'impegno' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('ordiniApp')
        .factory('Impegno', Impegno);

    Impegno.$inject = ['$resource', 'DateUtils'];

    function Impegno ($resource, DateUtils) {
        var resourceUrl =  'api/impegnos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dataCreazione = DateUtils.convertDateTimeFromServer(data.dataCreazione);
                        data.dataAggiornamento = DateUtils.convertDateTimeFromServer(data.dataAggiornamento);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('ImpegnoSearch', ImpegnoSearch);

    ImpegnoSearch.$inject = ['$resource'];

    function ImpegnoSearch($resource) {
        var resourceUrl =  'api/_search/impegnos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('ImpegnoDBSearch', ImpegnoDBSearch);

    ImpegnoDBSearch.$inject = ['$resource'];

    function ImpegnoDBSearch($resource) {
        var resourceUrl =  'api/_dbsearch/impegnos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('ImpegnoController', ImpegnoController);

    // inca$ - aggiunta gestione search
    ImpegnoController.$inject = ['$scope', '$state', '$uibModal', 'Impegno', 'ImpegnoSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function ImpegnoController ($scope, $state, $uibModal, Impegno, ImpegnoSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        // inca$ - aggiunta gestione search
        vm.searchForm = searchForm;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                ImpegnoSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Impegno.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.impegnos = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

     // inca$ - aggiunta gestione search
        function searchForm (field, type, domain) {
        	$uibModal.open({
                templateUrl: 'app/search/search-dialog.html',
                controller: 'SearchController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                	pScope: function() {
                        return $scope;
                    },
                    search: function() {
                        return ImpegnoSearch;
                    },
                    controller: function() {
                        return vm;
                    },
                    field: function() {
                        return field;
                    },
                    type: function() {
                        return type;
                    },
                    domain: function() {
                        return domain;
                    }
                }
            }).result.then(function() {
                //$state.go('impegno', null, { reload: 'impegno' });
            }, function() {
                //$state.go('^');
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('GaeDialogController', GaeDialogController);

    GaeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Gae', 'Decisione', 'Finanziamento', 'Struttura'];

    function GaeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Gae, Decisione, Finanziamento, Struttura) {
        var vm = this;

        vm.gae = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.decisiones = Decisione.query();
        vm.finanziamentos = Finanziamento.query({size:100000000}); // inca$ - caricamento totale liste fk
        vm.strutturas = Struttura.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.gae.id !== null) {
                Gae.update(vm.gae, onSaveSuccess, onSaveError);
            } else {
                Gae.save(vm.gae, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('ordiniApp:gaeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dataCreazione = false;
        vm.datePickerOpenStatus.dataAggiornamento = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('GaeDetailController', GaeDetailController);

    GaeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Gae', 'Decisione', 'Finanziamento', 'Struttura'];

    function GaeDetailController($scope, $rootScope, $stateParams, previousState, entity, Gae, Decisione, Finanziamento, Struttura) {
        var vm = this;

        vm.gae = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('ordiniApp:gaeUpdate', function(event, result) {
            vm.gae = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('GaeDeleteController',GaeDeleteController);

    GaeDeleteController.$inject = ['$uibModalInstance', 'entity', 'Gae'];

    function GaeDeleteController($uibModalInstance, entity, Gae) {
        var vm = this;

        vm.gae = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Gae.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('gae', {
            parent: 'entity',
            url: '/gae?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.gae.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/gae/gaes.html',
                    controller: 'GaeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('gae');
                    $translatePartialLoader.addPart('fontiFinanziamento');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('gae-detail', {
            parent: 'entity',
            url: '/gae/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.gae.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/gae/gae-detail.html',
                    controller: 'GaeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('gae');
                    $translatePartialLoader.addPart('fontiFinanziamento');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Gae', function($stateParams, Gae) {
                    return Gae.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'gae',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('gae-detail.edit', {
            parent: 'gae-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/gae/gae-dialog.html',
                    controller: 'GaeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Gae', function(Gae) {
                            return Gae.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('gae.new', {
            parent: 'gae',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/gae/gae-dialog.html',
                    controller: 'GaeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                esercizio: null,
                                visualizza: false,
                                codice: null,
                                descrizione: null,
                                fonteFondi: null,
                                cup: null,
                                utenteCreazione: null,
                                dataCreazione: null,
                                utenteAggiornamento: null,
                                dataAggiornamento: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('gae', null, { reload: 'gae' });
                }, function() {
                    $state.go('gae');
                });
            }]
        })
        .state('gae.edit', {
            parent: 'gae',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/gae/gae-dialog.html',
                    controller: 'GaeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Gae', function(Gae) {
                            return Gae.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('gae', null, { reload: 'gae' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('gae.delete', {
            parent: 'gae',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/gae/gae-delete-dialog.html',
                    controller: 'GaeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Gae', function(Gae) {
                            return Gae.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('gae', null, { reload: 'gae' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('ordiniApp')
        .factory('Gae', Gae);

    Gae.$inject = ['$resource', 'DateUtils'];

    function Gae ($resource, DateUtils) {
        var resourceUrl =  'api/gaes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dataCreazione = DateUtils.convertDateTimeFromServer(data.dataCreazione);
                        data.dataAggiornamento = DateUtils.convertDateTimeFromServer(data.dataAggiornamento);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('GaeSearch', GaeSearch);

    GaeSearch.$inject = ['$resource'];

    function GaeSearch($resource) {
        var resourceUrl =  'api/_search/gaes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('GaeController', GaeController);

    // inca$ - aggiunta gestione search
    GaeController.$inject = ['$scope', '$state', '$uibModal', 'Gae', 'GaeSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function GaeController ($scope, $state, $uibModal, Gae, GaeSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        // inca$ - aggiunta gestione search
        vm.searchForm = searchForm;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                GaeSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Gae.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.gaes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }


     // inca$ - aggiunta gestione search
        function searchForm (field, type, domain) {
        	$uibModal.open({
                templateUrl: 'app/search/search-dialog.html',
                controller: 'SearchController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                	pScope: function() {
                        return $scope;
                    },
                    search: function() {
                        return GaeSearch;
                    },
                    controller: function() {
                        return vm;
                    },
                    field: function() {
                        return field;
                    },
                    type: function() {
                        return type;
                    },
                    domain: function() {
                        return domain;
                    }
                }
            }).result.then(function() {
                //$state.go('gae', null, { reload: 'gae' });
            }, function() {
                //$state.go('^');
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('FunzioneDialogController', FunzioneDialogController);

    FunzioneDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Funzione', 'RuoloFunzione'];

    function FunzioneDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Funzione, RuoloFunzione) {
        var vm = this;

        vm.funzione = entity;
        vm.clear = clear;
        vm.save = save;
        vm.ruolofunziones = RuoloFunzione.query();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.funzione.id !== null) {
                Funzione.update(vm.funzione, onSaveSuccess, onSaveError);
            } else {
                Funzione.save(vm.funzione, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('ordiniApp:funzioneUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('FunzioneDetailController', FunzioneDetailController);

    FunzioneDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Funzione', 'RuoloFunzione'];

    function FunzioneDetailController($scope, $rootScope, $stateParams, previousState, entity, Funzione, RuoloFunzione) {
        var vm = this;

        vm.funzione = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('ordiniApp:funzioneUpdate', function(event, result) {
            vm.funzione = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('FunzioneDeleteController',FunzioneDeleteController);

    FunzioneDeleteController.$inject = ['$uibModalInstance', 'entity', 'Funzione'];

    function FunzioneDeleteController($uibModalInstance, entity, Funzione) {
        var vm = this;

        vm.funzione = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Funzione.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('funzione', {
            parent: 'entity',
            url: '/funzione',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.funzione.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/funzione/funziones.html',
                    controller: 'FunzioneController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('funzione');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('funzione-detail', {
            parent: 'entity',
            url: '/funzione/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.funzione.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/funzione/funzione-detail.html',
                    controller: 'FunzioneDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('funzione');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Funzione', function($stateParams, Funzione) {
                    return Funzione.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'funzione',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('funzione-detail.edit', {
            parent: 'funzione-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/funzione/funzione-dialog.html',
                    controller: 'FunzioneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Funzione', function(Funzione) {
                            return Funzione.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('funzione.new', {
            parent: 'funzione',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/funzione/funzione-dialog.html',
                    controller: 'FunzioneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('funzione', null, { reload: 'funzione' });
                }, function() {
                    $state.go('funzione');
                });
            }]
        })
        .state('funzione.edit', {
            parent: 'funzione',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/funzione/funzione-dialog.html',
                    controller: 'FunzioneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Funzione', function(Funzione) {
                            return Funzione.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('funzione', null, { reload: 'funzione' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('funzione.delete', {
            parent: 'funzione',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/funzione/funzione-delete-dialog.html',
                    controller: 'FunzioneDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Funzione', function(Funzione) {
                            return Funzione.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('funzione', null, { reload: 'funzione' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('ordiniApp')
        .factory('Funzione', Funzione);

    Funzione.$inject = ['$resource'];

    function Funzione ($resource) {
        var resourceUrl =  'api/funziones/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('FunzioneSearch', FunzioneSearch);

    FunzioneSearch.$inject = ['$resource'];

    function FunzioneSearch($resource) {
        var resourceUrl =  'api/_search/funziones/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('FunzioneController', FunzioneController);

    FunzioneController.$inject = ['$scope', '$state', 'Funzione', 'FunzioneSearch'];

    function FunzioneController ($scope, $state, Funzione, FunzioneSearch) {
        var vm = this;
        
        vm.funziones = [];
        vm.search = search;
        vm.loadAll = loadAll;

        loadAll();

        function loadAll() {
            Funzione.query(function(result) {
                vm.funziones = result;
            });
        }

        function search () {
            if (!vm.searchQuery) {
                return vm.loadAll();
            }
            FunzioneSearch.query({query: vm.searchQuery}, function(result) {
                vm.funziones = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('FinanziamentoDialogController', FinanziamentoDialogController);

    FinanziamentoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Finanziamento', 'Gae', 'Utente', 'Progetto'];

    function FinanziamentoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Finanziamento, Gae, Utente, Progetto) {
        var vm = this;

        vm.finanziamento = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.gaes = Gae.query({size:100000000}); // inca$ - caricamento totale liste fk
        vm.utentes = Utente.query({size:100000000}); // inca$ - caricamento totale liste fk
        vm.progettos = Progetto.query({size:100000000}); // inca$ - caricamento totale liste fk

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.finanziamento.id !== null) {
                Finanziamento.update(vm.finanziamento, onSaveSuccess, onSaveError);
            } else {
                Finanziamento.save(vm.finanziamento, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('ordiniApp:finanziamentoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dataCreazione = false;
        vm.datePickerOpenStatus.dataAggiornamento = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('FinanziamentoDetailController', FinanziamentoDetailController);

    FinanziamentoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Finanziamento', 'Gae', 'Utente', 'Progetto'];

    function FinanziamentoDetailController($scope, $rootScope, $stateParams, previousState, entity, Finanziamento, Gae, Utente, Progetto) {
        var vm = this;

        vm.finanziamento = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('ordiniApp:finanziamentoUpdate', function(event, result) {
            vm.finanziamento = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('FinanziamentoDeleteController',FinanziamentoDeleteController);

    FinanziamentoDeleteController.$inject = ['$uibModalInstance', 'entity', 'Finanziamento'];

    function FinanziamentoDeleteController($uibModalInstance, entity, Finanziamento) {
        var vm = this;

        vm.finanziamento = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Finanziamento.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('finanziamento', {
            parent: 'entity',
            url: '/finanziamento?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.finanziamento.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/finanziamento/finanziamentos.html',
                    controller: 'FinanziamentoController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('finanziamento');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('finanziamento-detail', {
            parent: 'entity',
            url: '/finanziamento/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.finanziamento.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/finanziamento/finanziamento-detail.html',
                    controller: 'FinanziamentoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('finanziamento');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Finanziamento', function($stateParams, Finanziamento) {
                    return Finanziamento.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'finanziamento',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('finanziamento-detail.edit', {
            parent: 'finanziamento-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/finanziamento/finanziamento-dialog.html',
                    controller: 'FinanziamentoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Finanziamento', function(Finanziamento) {
                            return Finanziamento.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('finanziamento.new', {
            parent: 'finanziamento',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/finanziamento/finanziamento-dialog.html',
                    controller: 'FinanziamentoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                codice: null,
                                titolo: null,
                                soggettoFinanziatore: null,
                                utenteCreazione: null,
                                dataCreazione: null,
                                utenteAggiornamento: null,
                                dataAggiornamento: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('finanziamento', null, { reload: 'finanziamento' });
                }, function() {
                    $state.go('finanziamento');
                });
            }]
        })
        .state('finanziamento.edit', {
            parent: 'finanziamento',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/finanziamento/finanziamento-dialog.html',
                    controller: 'FinanziamentoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Finanziamento', function(Finanziamento) {
                            return Finanziamento.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('finanziamento', null, { reload: 'finanziamento' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('finanziamento.delete', {
            parent: 'finanziamento',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/finanziamento/finanziamento-delete-dialog.html',
                    controller: 'FinanziamentoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Finanziamento', function(Finanziamento) {
                            return Finanziamento.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('finanziamento', null, { reload: 'finanziamento' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('ordiniApp')
        .factory('Finanziamento', Finanziamento);

    Finanziamento.$inject = ['$resource', 'DateUtils'];

    function Finanziamento ($resource, DateUtils) {
        var resourceUrl =  'api/finanziamentos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dataCreazione = DateUtils.convertDateTimeFromServer(data.dataCreazione);
                        data.dataAggiornamento = DateUtils.convertDateTimeFromServer(data.dataAggiornamento);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('FinanziamentoSearch', FinanziamentoSearch);

    FinanziamentoSearch.$inject = ['$resource'];

    function FinanziamentoSearch($resource) {
        var resourceUrl =  'api/_search/finanziamentos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('FinanziamentoController', FinanziamentoController);

    // inca$ - aggiunta gestione search
    FinanziamentoController.$inject = ['$scope', '$state', '$uibModal', 'Finanziamento', 'FinanziamentoSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function FinanziamentoController ($scope, $state, $uibModal, Finanziamento, FinanziamentoSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        // inca$ - aggiunta gestione search
        vm.searchForm = searchForm;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                FinanziamentoSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Finanziamento.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.finanziamentos = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        // inca$ - aggiunta gestione search
        function searchForm (field, type, domain) {
        	$uibModal.open({
                templateUrl: 'app/search/search-dialog.html',
                controller: 'SearchController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                	pScope: function() {
                        return $scope;
                    },
                    search: function() {
                        return FinanziamentoSearch;
                    },
                    controller: function() {
                        return vm;
                    },
                    field: function() {
                        return field;
                    },
                    type: function() {
                        return type;
                    },
                    domain: function() {
                        return domain;
                    }
                }
            }).result.then(function() {
                //$state.go('finanziamento', null, { reload: 'finanziamento' });
            }, function() {
                //$state.go('^');
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('DocumentoDialogController', DocumentoDialogController);

    DocumentoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'Documento', 'Decisione', 'Dichiarazione', 'DocumentoFile'];

    function DocumentoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, Documento, Decisione, Dichiarazione, DocumentoFile) {
        var vm = this;

        vm.documento = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.openStorageFile = openStorageFile;
        vm.save = save;
//        vm.decisiones = Decisione.query();
//        vm.dichiaraziones = Dichiarazione.query(); // non serve in quanto non rendiamo possibile cambiare l'aggancio alla dichiarazione

        // inca$ - caricamento file solo se da DB
        {
        	if (entity.file!=null&&!entity.simpleStorageService)
	    		DocumentoFile.get({id : entity.id}, function(result) {
	     			vm.documento["file"]=result.file;
	            });
        }

        function openStorageFile (type, data) {
        	if (entity.simpleStorageService) {
        		DocumentoFile.get({id : entity.id}, function(result) {
        			//console.log(result.fileContentType);
        			//console.log(result.file);
         			vm.openFile(result.fileContentType, result.file);
                }, onGetFileError);
        	} else
            	vm.openFile(type, data);
        }

        function onGetFileError () {
        	modalScrollTop();
        };	

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.documento.id !== null) {
                Documento.update(vm.documento, onSaveSuccess, onSaveError);
            } else {
                Documento.save(vm.documento, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('ordiniApp:documentoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setFile = function ($file, documento) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        documento.file = base64Data;
                        documento.fileContentType = $file.type;
                    });
                });
            }
        };
        vm.datePickerOpenStatus.dataCreazione = false;
        vm.datePickerOpenStatus.dataAggiornamento = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('DocumentoDetailController', DocumentoDetailController);

    DocumentoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Documento', 'Decisione', 'Dichiarazione', 'DocumentoFile'];

    function DocumentoDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Documento, Decisione, Dichiarazione, DocumentoFile) {
        var vm = this;

        vm.documento = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.openStorageFile = openStorageFile;

        function openStorageFile (type, data) {
        	if (entity.simpleStorageService) {
        		DocumentoFile.get({id : entity.id}, function(result) {
        			//console.log(result.fileContentType);
        			//console.log(result.file);
         			vm.openFile(result.fileContentType, result.file);
                }, onGetFileError);
        	} else
            	vm.openFile(type, data);
        }

        function onGetFileError () {
        	modalScrollTop();
        };	

        // inca$ - caricamento file solo se da DB
        {
        	if (entity.file!=null&&!entity.simpleStorageService)
	    		DocumentoFile.get({id : entity.id}, function(result) {
	     			vm.documento["file"]=result.file;
	            });
        }

        var unsubscribe = $rootScope.$on('ordiniApp:documentoUpdate', function(event, result) {
            vm.documento = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('DocumentoDeleteController',DocumentoDeleteController);

    DocumentoDeleteController.$inject = ['$uibModalInstance', 'entity', 'Documento'];

    function DocumentoDeleteController($uibModalInstance, entity, Documento) {
        var vm = this;

        vm.documento = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Documento.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('DocumentoAttachController', DocumentoAttachController);

    DocumentoAttachController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'Permissions', 'entity', 'Documento', 'Decisione', 'Dichiarazione', 'controller', 'entityName'];

    // inca$ - derivato da DocumentoDialogController
    function DocumentoAttachController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, Permissions, entity, Documento, Decisione, Dichiarazione, controller, entityName) {
        var vm = this;

        vm.documento = entity;
        vm.clear = clear;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;
        vm.decisiones = Decisione.query();
        vm.dichiaraziones = Dichiarazione.query();
        vm.controller = controller;
        vm.entityName = entityName;
        vm.showProtocollo = showProtocollo;
        vm.disableProtocollo = disableProtocollo;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {

        	entity[vm.entityName]=vm.controller[vm.entityName];
        	vm.isSaving = true;
            if (vm.documento.id !== null) {
                Documento.update(vm.documento, onSaveSuccess, onSaveError);
            } else {
                Documento.save(vm.documento, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('ordiniApp:documentoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


        vm.setFile = function ($file, documento) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        documento.file = base64Data;
                        documento.fileContentType = $file.type;
                    });
                });
            }
        };

        // inca$ - gestione campo protocollo
        function showProtocollo () {

			if (vm.controller[vm.entityName].stato == null)
				return false;

			if ((Permissions.hasOneOfRoles(['ROLE_AMMINISTRAZIONE','ROLE_SUPERUTENTE']) ||
					vm.controller[vm.entityName].numeroProtocollo !=null))
    			return true;

			return false;
        }

        // inca$ - gestione campo protocollo
        function disableProtocollo () {

			if (vm.controller[vm.entityName].stato == null)
				return true;

			if ((Permissions.hasOneOfRoles(['ROLE_AMMINISTRAZIONE','ROLE_SUPERUTENTE']) &&
					vm.controller[vm.entityName].stato == 'VALIDATO'))
    			return false;

			return true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('documento', {
            parent: 'entity',
            url: '/documento?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.documento.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/documento/documentos.html',
                    controller: 'DocumentoController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('documento');
                    $translatePartialLoader.addPart('tipoDocumento');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('documento-detail', {
            parent: 'entity',
            url: '/documento/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.documento.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/documento/documento-detail.html',
                    controller: 'DocumentoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('documento');
                    $translatePartialLoader.addPart('tipoDocumento');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Documento', function($stateParams, Documento) {
                    return Documento.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'documento',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('documento-detail.edit', {
            parent: 'documento-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/documento/documento-dialog.html',
                    controller: 'DocumentoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Documento', function(Documento) {
                            return Documento.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('documento.new', {
            parent: 'documento',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/documento/documento-dialog.html',
                    controller: 'DocumentoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                tipo: null,
                                file: null,
                                fileContentType: null,
                                annoProtocollo: null,
                                numeroProtocollo: null,
                                simpleStorageService: false,
                                bucketName: null,
                                keyName: null,
                                utenteCreazione: null,
                                dataCreazione: null,
                                utenteAggiornamento: null,
                                dataAggiornamento: null,
                                versioneFile: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('documento', null, { reload: 'documento' });
                }, function() {
                    $state.go('documento');
                });
            }]
        })
        .state('documento.edit', {
            parent: 'documento',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/documento/documento-dialog.html',
                    controller: 'DocumentoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Documento', function(Documento) {
                            return Documento.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('documento', null, { reload: 'documento' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('documento.delete', {
            parent: 'documento',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/documento/documento-delete-dialog.html',
                    controller: 'DocumentoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Documento', function(Documento) {
                            return Documento.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('documento', null, { reload: 'documento' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('ordiniApp')
        .factory('Documento', Documento);

    Documento.$inject = ['$resource', 'DateUtils'];

    function Documento ($resource, DateUtils) {
        var resourceUrl =  'api/documentos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dataCreazione = DateUtils.convertDateTimeFromServer(data.dataCreazione);
                        data.dataAggiornamento = DateUtils.convertDateTimeFromServer(data.dataAggiornamento);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('DocumentoSearch', DocumentoSearch);

    DocumentoSearch.$inject = ['$resource'];

    function DocumentoSearch($resource) {
        var resourceUrl =  'api/_search/documentos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('ordiniApp')
        .factory('DocumentoFile', DocumentoFile);

    DocumentoFile.$inject = ['$resource', 'DateUtils'];

    function DocumentoFile ($resource, DateUtils) {
        var resourceUrl =  'api/documentos/file/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dataCreazione = DateUtils.convertDateTimeFromServer(data.dataCreazione);
                        data.dataAggiornamento = DateUtils.convertDateTimeFromServer(data.dataAggiornamento);
                    }
                    return data;
                }
            }/*, il salvataggio è disabilitato poichè questo service ha il solo scopo di reperire il file mancante
            'update': { method:'PUT' }*/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('DocumentoDBSearch', DocumentoDBSearch);

    DocumentoDBSearch.$inject = ['$resource'];

    function DocumentoDBSearch($resource) {
        var resourceUrl =  'api/_dbsearch/documentos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('DocumentoController', DocumentoController);

    // inca$ - aggiunta gestione search
    DocumentoController.$inject = ['$scope', '$state', '$uibModal', 'DataUtils', 'Documento', 'DocumentoSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function DocumentoController ($scope, $state, $uibModal, DataUtils, Documento, DocumentoSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        // inca$ - aggiunta gestione search
        vm.searchForm = searchForm;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                DocumentoSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Documento.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.documentos = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        // inca$ - aggiunta gestione search
        function searchForm (field, type, domain) {
        	$uibModal.open({
                templateUrl: 'app/search/search-dialog.html',
                controller: 'SearchController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                	pScope: function() {
                        return $scope;
                    },
                    search: function() {
                        return DocumentoSearch;
                    },
                    controller: function() {
                        return vm;
                    },
                    field: function() {
                        return field;
                    },
                    type: function() {
                        return type;
                    },
                    domain: function() {
                        return domain;
                    }
                }
            }).result.then(function() {
                //$state.go('documento', null, { reload: 'documento' });
            }, function() {
                //$state.go('^');
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('DichiarazioneDialogController', DichiarazioneDialogController);

    DichiarazioneDialogController.$inject = ['$filter', '$window', '$timeout', '$scope', '$stateParams', '$uibModal', '$uibModalInstance', '$q', 'Permissions', 'MailSigns', 'DataUtils', 'entity', 'DocumentoDBSearch', 'Dichiarazione', 'Decisione', 'Documento', 'DocumentoFile', 'AdminCommands', 'Currencies'];

    function DichiarazioneDialogController ($filter, $window, $timeout, $scope, $stateParams, $uibModal, $uibModalInstance, $q, Permissions, MailSigns, DataUtils, entity, DocumentoDBSearch, Dichiarazione, Decisione, Documento, DocumentoFile, AdminCommands, Currencies) {
        var vm = this;
        
        // inca$ - variabili gestione preview e invio
        vm.visualizza = false;
        vm.invia = false;
        vm.isPreview = false; // quando viene premuto Preview, isPreview viene settata definitivamente a true;
        vm.isValidating = false; // quando viene premuto Valida o Respingi, isValidating viene settato definitivamente a true;
        vm.oldStato;
        vm.dateformat='dd/MM/yyyy';
        $scope.functionNameForAutocomplete = 'dichiarazione'; // per gestire l'autocompletamento

        vm.dichiarazione = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.downloadFile = DataUtils.downloadFile;
        vm.previewFile = DataUtils.previewFile;
        vm.openStorageFile = openStorageFile;
        vm.downloadStorageFile = downloadStorageFile;
        vm.documentoFileName = documentoFileName;
        vm.docFileName = docFileName;
        vm.save = save;
        vm.save2 = save2;
        vm.save3 = save3;
    	vm.utenteLogin = Permissions.getAccount().login;
//        vm.documentopdfs = Documento.query({filter: 'dichiarazionepdf-is-null'});
//        $q.all([vm.dichiarazione.$promise, vm.documentopdfs.$promise]).then(function() {
//            if (!vm.dichiarazione.documentoPdf || !vm.dichiarazione.documentoPdf.id) {
//                return $q.reject();
//            }
//            return Documento.get({id : vm.dichiarazione.documentoPdf.id}).$promise;
//        }).then(function(documentoPdf) {
//            vm.documentopdfs.push(documentoPdf);
//        });
        vm.decisiones = Decisione.query({filter: 'dichiarazione-is-null', valid: true});
        $q.all([vm.dichiarazione.$promise, vm.decisiones.$promise]).then(function() {
            if (!vm.dichiarazione.decisione || !vm.dichiarazione.decisione.id) {
                return $q.reject();
            }
            return Decisione.get({id : vm.dichiarazione.decisione.id}).$promise;
        }).then(function(decisione) {
            vm.decisiones.push(decisione);
        });
        //vm.documentos = Documento.query();
        // inca$ - gestione validazione e rifiuto
        vm.validate = validate;
        vm.reject = reject;
        vm.disableSave = disableSave; // inca$ - imposta l'abilitazione di Salva
        vm.disableValidateOrReject = disableValidateOrReject; // inca$ - imposta l'abilitazione dei button Valida e Respingi
        vm.disablePreviewOrSend = disablePreviewOrSend;
        vm.showMotivazioneRifiuto = showMotivazioneRifiuto;
        vm.showProtocollo = showProtocollo;
        vm.disableProtocollo = disableProtocollo;
        // inca$ - aggiunta gestione rifiuto
        vm.rejectDialogForm = rejectDialogForm;
        vm.eraseHiddenFields = eraseHiddenFields;
        vm.attachForm = attachForm;
        vm.documentiAllegati = null;
        vm.findAttachedDocs = findAttachedDocs;
        vm.deleteAttachedDoc = deleteAttachedDoc;
        vm.downloadAttachedDoc = downloadAttachedDoc;
        vm.disableInsertDetails = disableInsertDetails;
        vm.today = today;
        // inca$ - gestione currencies
        vm.currencies = null;
        //inca$ - gestione invio mail documenti
        vm.sendMailSigns = sendMailSigns;
        vm.viewMailSigns = viewMailSigns;
        vm.mailSent = mailSent;
        //inca$ - gestione fuzioni superutente
        vm.viewUpdateStato = viewUpdateStato;
        vm.updateStato = updateStato;
        vm.statoForUpdate = vm.dichiarazione.stato;
        vm.updateStatoDone = updateStatoDone;
        vm.currencySymbol = currencySymbol;
        // inca$ - aggiunta gestione invio multiplo
        vm.sendDialogForm = sendDialogForm;
        vm.editDecisione = editDecisione;
        vm.decisioneChanged = decisioneChanged;
        // inca$ - gestione stato colorato
        vm.statoColour = statoColour;
        vm.statoLinkedColour = statoLinkedColour;
        vm.motivazioneSceltaFornitoreBase = motivazioneSceltaFornitoreBase;
        vm.fornitoreScelto="";

        function motivazioneSceltaFornitoreBase () {
        	var territorio = vm.dichiarazione.territorio;
        	if (territorio==null)
        		territorio="";
        	else
        		territorio=" per il territorio "+territorio.toLowerCase();
        	// il fornitore è stato scelto senza nessuna comparazione ed è presente nè dichiarazione di esclusività nè di unicità
        	var fornitoreScelto = "l’operatore economico "+vm.dichiarazione.fornitoreScelto+" è stato scelto in base alla seguente motivazione: ";
        	// il fornitore è stato scelto senza nessuna comparazione ed è presente una dichiarazione di esclusività
        	var fornitoreSceltoNCEsclusivita = "è stata acquisita un'unica offerta dall’operatore economico  "+vm.dichiarazione.fornitoreScelto+",  scelto in base alla seguente motivazione: gli articoli da acquisire sono distribuiti solo dall’operatore economico  "+vm.dichiarazione.fornitoreScelto+territorio+" come da dichiarazione di esclusività fornita dall’operatore economico insieme all’offerta";
        	// il fornitore è stato scelto senza nessuna comparazione ed è presente una dichiarazione di unicità
        	var fornitoreSceltoNCUnicita = "è stata acquisita un'unica offerta dall’operatore economico "+vm.dichiarazione.fornitoreScelto+", scelto in base alla seguente motivazione: le caratteristiche degli articoli da acquisire sono insostituibili e non riscontrabili in altri prodotti come da dichiarazione di unicità fornita dall’operatore economico insieme all’offerta";

        	if (vm.documentiAllegati!=null) {
            	for (var j = 0, len = vm.documentiAllegati.length; j < len; j++) {
            		if (vm.documentiAllegati[j].tipo=='DICHIARAZIONE_ESCLUSIVITA') {
                		return fornitoreSceltoNCEsclusivita;
            		}
            	}
            	for (var j = 0, len = vm.documentiAllegati.length; j < len; j++) {
            		if (vm.documentiAllegati[j].tipo=='DICHIARAZIONE_UNICITA') {
                		return fornitoreSceltoNCUnicita;
            		}
            	}
        	}
        	// il fornitore è stato scelto senza nessuna comparazione ed è presente nè dichiarazione di esclusività nè di unicità
        	vm.fornitoreScelto=fornitoreScelto;
        	return fornitoreScelto;
        };	

        // all'ingresso della funzione, consideriamo lo stato
    	// di rifiutato come se fosse in compilazione
        {
       		// inca$ - gestione chiusura e invio
        	if ((vm.dichiarazione.stato == 'RIFIUTATO_DA_AMMINISTRAZIONE' ||
            	vm.dichiarazione.stato == 'RIFIUTATO_DA_RESPONSABILE') &&
        		((vm.dichiarazione.utenteCreazione == vm.utenteLogin ||
        		vm.dichiarazione.decisione.responsabileProcedimento.user.login == vm.utenteLogin) ||
        		Permissions.hasRole('ROLE_SUPERUTENTE'))) {
				vm.dichiarazione.stato = 'IN_COMPILAZIONE';
				//vm.dichiarazione.file = null;
        	}
        }
        
        function openStorageFile (documento) {
        	var	type = documento.fileContentType;
        	var data = documento.file;
        	
        	if (documento.simpleStorageService) {
        		DocumentoFile.get({id : documento.id}, function(result) {
        			console.log(result.fileContentType);
        			//console.log(result.file);
         			vm.openFile(result.fileContentType, result.file);
                }, onGetFileError);
        	} else
            	vm.openFile(type, data);
        }

        function downloadStorageFile (documento, filename) {
        	var	type = documento.fileContentType;
        	var data = documento.file;

        	if (documento.simpleStorageService) {
        		DocumentoFile.get({id : documento.id}, function(result) {
        			console.log(result.fileContentType);
        			//console.log(result.file);
         			vm.downloadFile(result.fileContentType, result.file, filename);
                }, onGetFileError);
        	} else
            	vm.downloadFile(type, data, filename);
        }

        function onGetFileError () {
        	modalScrollTop();
        };	

        function statoLinkedColour (stato, tipoDocumento, classField) {
        	if (stato=='IN_COMPILAZIONE')
        		classField = classField+" stato-field-compilatore";
        	else if (stato=='INVIATO') {
        		if (tipoDocumento=='decisione')
        			classField = classField+" stato-field-amministrazione";
        		else
        			classField = classField+" stato-field-responsabile";
        	}
        	else if (stato=='RIFIUTATO_DA_RESPONSABILE')
        		classField = classField+" stato-field-rifiuto";
        	else if (stato=='INVIATO_A_AMMINISTRAZIONE')
        		classField = classField+" stato-field-amministrazione";
        	else if (stato=='RIFIUTATO_DA_AMMINISTRAZIONE')
        		classField = classField+" stato-field-rifiuto";
        	else if (stato=='INVIATO_A_DIRETTORE')
        		classField = classField+" stato-field-direttore";
        	else if (stato=='RIFIUTATO_DA_DIRETTORE')
        		classField = classField+" stato-field-rifiuto";
        	else if (stato=='VALIDATO')
        		classField = classField+" stato-field-completato";
        	return classField;
        }

        function statoColour (stato) {
        	//return "stato-visibile-field form-control"; // default
        	return statoLinkedColour (stato, 'dichiarazione', "stato-visibile-field");
        }

        function today () {
        	return new Date();
        }

        // inca$ - caricamento file solo se da DB
        {
        	if (entity.documentoPdf!=null&&!entity.documentoPdf.simpleStorageService)
	    		DocumentoFile.get({id : entity.documentoPdf.id}, function(result) {
	     			vm.dichiarazione.documentoPdf["file"]=result.file;
	            });
        }

        // inca$ - inizializzazione caricamento ruoli
        Permissions.loadRoles();

        // inca$ - inizializzazione caricamento currencies
        Currencies.loadCurrencyList(vm);

        // inca$ - carico i documenti allegati
        vm.findAttachedDocs();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
            
            // inca$ - serve come workaround per un bug del ui-datepicker che azzera
            // i campi quando si richiama la funzione da un altra funzione
            if (vm.dichiarazione.id!=null) {
                $scope.editForm.data.$setValidity("required", true);
    	        $scope.editForm.$invalid = false;
            }

        });

        function decisioneChanged () {
        	if (vm.dichiarazione.decisione!=null) {
        		vm.dichiarazione.ordineMepa = !vm.dichiarazione.decisione.funzionaleAllaRicerca
        		vm.dichiarazione.descrizione = vm.dichiarazione.decisione.descrizione;
        	}
        }
        
        function clear () {
        	// inca$ - chiudiamo solo se non è stata fatta preview
        	if (!vm.isPreview)
        		$uibModalInstance.dismiss('cancel');
        }

        function save () {

        	vm.eraseHiddenFields();

       		// memorizziamo SEMPRE lo stato precedente al salvataggio
       		vm.oldStato = vm.dichiarazione.stato;

        	// inca$ - gestione chiusura e invio
        	if (vm.dichiarazione.stato==null)
        		vm.dichiarazione.stato='IN_COMPILAZIONE';

//    		if (vm.visualizza!=true&&vm.isSaving!=true) {
//                if (vm.dichiarazione.stato=='IN_COMPILAZIONE') {
//        			vm.dichiarazione.file=null;
//        		}
//    		}

        	if (vm.invia==true) {
        		
        		// se si volesse inviare direttamente senza dialog di invio multiplo
        		// basta attivare save2() e disattivare sendDialogForm(); 
        		// save2(); 
                sendDialogForm();

        	} else
                save3();
        }

        function save2 () {
    		if (vm.dichiarazione.stato=='IN_COMPILAZIONE')
    			if (vm.dichiarazione.decisione.impegno.gae.finanziamento.responsabileFondi.direttore == true ||
    				vm.dichiarazione.decisione.impegno.gae.finanziamento.responsabileFondi.user.login == vm.utenteLogin)
    				vm.dichiarazione.stato='INVIATO_A_AMMINISTRAZIONE';
    			else
    				vm.dichiarazione.stato='INVIATO';
            vm.invia = false;
        }

        function save3 () {
            vm.isSaving = true;
            if (vm.dichiarazione.id !== null) {
				if (vm.dichiarazione.documentoPdf != null &&
						(vm.dichiarazione.documentoPdf.annoProtocollo != null ||
						vm.dichiarazione.documentoPdf.numeroProtocollo != null)) {
					Documento.update(vm.dichiarazione.documentoPdf);
				}
                Dichiarazione.update(vm.dichiarazione, onSaveSuccess, onSaveError);
            } else {
                Dichiarazione.save(vm.dichiarazione, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
			// inca$ - gestione preview
			if (vm.visualizza == true) {
				vm.dichiarazione=result;
				$scope.editForm.$setValidity();
	            $scope.$emit('ordiniApp:dichiarazioneUpdate', result);
	        	// inca$ - non più funzionante su chrome a causa dell'errore
	        	// Not allowed to navigate top frame to data URL
				//$window.open('data:' + result.documentoPdf.fileContentType + ';base64,' + result.documentoPdf.file);
	            var type = result.documentoPdf.fileContentType;
	            var data = result.documentoPdf.file;
	        	vm.previewFile(type, data);

				// sono costretto a settare il valore delle date a causa di un azzeramento per il comportamento anomalo
				// della proprietà uib-datepicker-popup="{{vm.dateformat}}"
				var data = angular.element(document.querySelector('#field_data'));
				data.val($filter('date')(result.data,vm.dateformat));

				vm.visualizza=false;
			} else {
	            $scope.$emit('ordiniApp:dichiarazioneUpdate', result);
	            $uibModalInstance.close(result);
			}
            vm.isSaving = false;
        }

        function onSaveError () {

        	// inca$ - mia funzione per fare scroll to top
        	modalScrollTop();

            vm.isSaving = false;
        	// inca$ - gestione preview
       		vm.isPreview=false;

       		// torniamo SEMPRE allo stato precedente in caso di errore
       		vm.dichiarazione.stato = vm.oldStato;

       		// inca$ - gestione valida o respingi
			if (vm.isValidating == true) {
    			//vm.dichiarazione.stato = vm.oldStato;
				vm.isValidating = false;
			}
        }

    	// inca$ - gestione preview
        vm.preview = function () {
        	vm.visualizza=true;
        	vm.isPreview = true;
        }

        // inca$ - gestione invio
        vm.send = function () {
        	vm.invia=true;
        }

        vm.datePickerOpenStatus.data = false;

        vm.setFile = function ($file, dichiarazione) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        dichiarazione.file = base64Data;
                        dichiarazione.fileContentType = $file.type;
                    });
                });
            }
        };
        vm.datePickerOpenStatus.dataCreazione = false;
        vm.datePickerOpenStatus.dataAggiornamento = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function validate () {

            // inca$ - gestione validazione
        	if (vm.dichiarazione.stato == 'INVIATO') {
    			vm.dichiarazione.stato = 'INVIATO_A_AMMINISTRAZIONE';

    			vm.isValidating = true;
    			vm.oldStato = 'INVIATO';
    			vm.isSaving = true;
        		Dichiarazione.update(vm.dichiarazione, onSaveSuccess, onSaveError);

			} else if (vm.dichiarazione.stato == 'INVIATO_A_AMMINISTRAZIONE') {
				vm.dichiarazione.stato = 'VALIDATO';

				vm.isValidating = true;
				vm.oldStato = 'INVIATO_A_AMMINISTRAZIONE';
				vm.isSaving = true;
				Dichiarazione.update(vm.dichiarazione, onSaveSuccess, onSaveError);

			}
        }

        function reject () {

        	// inca$ - gestione rifiuto
    		if (vm.dichiarazione.stato == 'INVIATO') {
    			vm.dichiarazione.stato = 'RIFIUTATO_DA_RESPONSABILE';

    			vm.isValidating = true;
    			vm.oldStato = 'INVIATO';
    			vm.isSaving = true;

    			Dichiarazione.update(vm.dichiarazione, onSaveSuccess, onSaveError);

    		} else if (vm.dichiarazione.stato == 'INVIATO_A_AMMINISTRAZIONE') {
				vm.dichiarazione.stato = 'RIFIUTATO_DA_AMMINISTRAZIONE';

				vm.isValidating = true;
				vm.oldStato = 'INVIATO_A_AMMINISTRAZIONE';
				vm.isSaving = true;

				Dichiarazione.update(vm.dichiarazione, onSaveSuccess, onSaveError);

			}

        }

        // inca$ - gestione save, preview o send
        function disableSave () {

        	if (vm.dichiarazione.stato == null) {
        		return false;
        	}

        	// permetto l'amministrazione di inserire il protocollo
        	if (!disableProtocollo())
        		return false;

        	return disableSavePreviewOrSend();
        }

        // inca$ - gestione inserimento allegati e dettagli
        function disableInsertDetails () {

        	if (disableSave())
        		return true;

        	if (vm.dichiarazione.stato == null) {
        		return true;
        	}

			if (vm.dichiarazione.stato != 'IN_COMPILAZIONE') {
				return true;
			} else {
				return false;
			}

        }

        // inca$ - gestione save, preview o send
        function disablePreviewOrSend () {

        	if (vm.dichiarazione.stato == null) {
        		return true;
        	}
        	return disableSavePreviewOrSend();

        }

        // inca$ - gestione save, preview o send
        function disableSavePreviewOrSend () {

           	// ricordiamoci che il direttore potrebbe essere che sia lui a creare la decisione di contrattare
           	// oppure sia lui il responsabile del procedimento, pertanto va prima verificato questa condizione
           	// successivamente quella del ruolo direttore
           	if (vm.dichiarazione.decisione.responsabileProcedimento.user.login == vm.utenteLogin ||
				vm.dichiarazione.utenteCreazione == vm.utenteLogin||
				Permissions.hasRole('ROLE_SUPERUTENTE')) {

				if ((vm.dichiarazione.stato == 'INVIATO')||
						(vm.dichiarazione.stato == 'INVIATO_A_AMMINISTRAZIONE')||
						(vm.dichiarazione.stato == 'VALIDATO')) {
					return true;
				} else {
					return false;
				}
    		} else if ((Permissions.hasOneOfRoles(['ROLE_AMMINISTRAZIONE']) &&
        			vm.dichiarazione.stato == 'VALIDATO')) {
       			return true;
    		}

       		return true;
        }

        // inca$ - gestione valida o respingi
        function disableValidateOrReject () {

			if (vm.dichiarazione.stato == null)
				return true;

    		if ((((Permissions.hasOneOfRoles(['ROLE_SUPERUTENTE']) || vm.dichiarazione.decisione.impegno.gae.finanziamento.responsabileFondi.user.login == vm.utenteLogin)) && vm.dichiarazione.stato == 'INVIATO') ||
       			(Permissions.hasOneOfRoles(['ROLE_SUPERUTENTE','ROLE_AMMINISTRAZIONE']) && vm.dichiarazione.stato == 'INVIATO_A_AMMINISTRAZIONE')) {
    			return false;
    		}
       		return true;
        }

        // inca$ - gestione campo motivazione rifiuto
        function showMotivazioneRifiuto () {

			if (vm.dichiarazione.stato == null)
				return false;

			if (vm.dichiarazione.motivazioneRifiuto != null)
				return true;

			if ((Permissions.hasOneOfRoles(['ROLE_AMMINISTRAZIONE','ROLE_SUPERUTENTE']) ||
					(vm.dichiarazione.stato == 'RIFIUTATO_DA_AMMINISTRAZIONE' || vm.dichiarazione.stato == 'RIFIUTATO_DA_RESPONSABILE')))
    			return true;

			return false;
        }

        // inca$ - gestione campo protocollo
        function showProtocollo () {

			if (vm.dichiarazione.stato == null)
				return false;

			if (vm.dichiarazione.documentoPdf==null)
				return false;

			if ((Permissions.hasOneOfRoles(['ROLE_AMMINISTRAZIONE','ROLE_SUPERUTENTE']) ||
					vm.dichiarazione.documentoPdf.numeroProtocollo !=null))
    			return true;

			return false;
        }

        // inca$ - gestione campo protocollo
        function disableProtocollo () {

			if (vm.dichiarazione.stato == null)
				return true;

			if ((Permissions.hasOneOfRoles(['ROLE_AMMINISTRAZIONE','ROLE_SUPERUTENTE']) &&
					vm.dichiarazione.stato == 'VALIDATO'))
    			return false;

			return true;
        }

        // inca$ - aggiunta gestione rifiuto
        function rejectDialogForm() {
        	$uibModal.open({
                templateUrl: 'app/util/entity-reject.html',
                controller: 'EntityRejectController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    controller: function() {
                        return vm;
                    },
                    entityName: function() {
                        return 'dichiarazione';
                    }
                }
            }).result.then(function() {
            	vm.reject();
            }, function() {
            });
        }

        // inca$ - aggiunta gestione rifiuto
        function sendDialogForm() {
        	$uibModal.open({
                templateUrl: 'app/util/send/multiple-send.html',
                controller: 'MultipleSendController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    controller: function() {
                        return vm;
                    },
                    entityName: function() {
                        return 'dichiarazione';
                    },
                    entity: function() {
                        return vm.dichiarazione;
                    }
                }
            }).result.then(function(result) {
            	if (result) 
            		vm.save2();
                vm.save3();

            }, function() {
                vm.invia = false;
            });
        }

        function eraseHiddenFields () {

        	if (vm.dichiarazione.ordineMepa!=null &&
        			vm.dichiarazione.ordineMepa==false) {
        		vm.dichiarazione.strumentoMepaScelto=null;
        		vm.dichiarazione.sezioneMepa=null;
        		vm.dichiarazione.criteriRicercaArticoli=null;
        		vm.dichiarazione.numeroOfferteMepa=null;
        	}

        	if (vm.dichiarazione.beneInvantariabile!=null &&
        			vm.dichiarazione.beneInvantariabile==false) {
        		vm.dichiarazione.edificio=null;
        		vm.dichiarazione.indirizzo=null;
        		vm.dichiarazione.numeroStanza=null;
        		vm.dichiarazione.nomeAssegnatarioBene=null;
        	}

        	if (vm.documentiAllegati!=null) {
        		var exist = false;
            	for (var j = 0, len = vm.documentiAllegati.length; j < len; j++) {
            		if (vm.documentiAllegati[j].tipo=='DICHIARAZIONE_ESCLUSIVITA') {
            			exist = true;
            			break;
            		}
            	}
            	if (!exist)
            		vm.dichiarazione.territorio=null;
        	}
        		
        }

        function attachForm () {

        	findAttachedDocs ();

        	$uibModal.open({
                templateUrl: 'app/entities/documento/documento-attach.html',
                controller: 'DocumentoAttachController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('documento');
                        $translatePartialLoader.addPart('tipoDocumento');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: function () {
						return {
						    tipo: null,
						    file: null,
						    fileContentType: null,
						    simpleStorageService: false,
						    annoProtocollo: null,
						    numeroProtocollo: null,
						    id: null
						}
                    },
                    controller: function() {
                        return vm;
                    },
                    entityName: function() {
                        return 'dichiarazione';
                    }
                }
            }).result.then(function() {
            	vm.findAttachedDocs();
            }, function() {
            });
        }

        function findAttachedDocs () {
        	if (vm.dichiarazione.id!=null)
        		vm.documentiAllegati = DocumentoDBSearch.query({size: 100000000, query: {dichiarazioneId: vm.dichiarazione.id}}, dettagliOnSuccess);

        	function dettagliOnSuccess(data, headers) {
            	for (var i = 0, len = vm.documentiAllegati.length; i < len; i++) {
            		if (!vm.documentiAllegati[i].simpleStorageService)
	            		DocumentoFile.get({id : vm.documentiAllegati[i].id}, function(result) {
	                    	for (var j = 0, len2 = vm.documentiAllegati.length; j < len2; j++) {
	                    		if (vm.documentiAllegati[j].id==result.id) {
	                    			vm.documentiAllegati[j]["file"]=result.file;
	                    			break;
	                    		}
	                    	}
	                    });
                }
            }
        }

        function deleteAttachedDoc (documento) {

        	findAttachedDocs ();

        	$uibModal.open({
                templateUrl: 'app/entities/documento/documento-delete-dialog.html',
                controller: 'DocumentoDeleteController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    entity: function() {
                        return documento;
                    }
                }
            }).result.then(function() {
            	vm.findAttachedDocs();
            }, function() {
            });

        };

        // questo metodo non funziona su firefox e atri browser vecchi
        function downloadAttachedDoc (documento) {

        	var binaryImg = atob(documento.file);
        	var length = binaryImg.length;
        	var arrayBuffer = new ArrayBuffer(length);
        	var uintArray = new Uint8Array(arrayBuffer);
        	for (var i = 0; i < length; i++) {
        	    uintArray[i] = binaryImg.charCodeAt(i);
        	}

            var url = URL.createObjectURL(new Blob([uintArray]));
            var a = document.createElement('a');
            a.href = url;

            var extn = documento.fileContentType.split("/").pop();
            if (extn!=null)
            	a.download = 'allegato_'+documento.id+"."+extn;
            else
            	a.download = 'allegato_'+documento.id;

            a.target = '_blank';
            a.click();
        }

        function editDecisione () {
        	
        	if (vm.dichiarazione!=null) {
        		
	        	$uibModal.open({
	              templateUrl: 'app/entities/decisione/decisione-dialog.html',
	              controller: 'DecisioneDialogController',
	                controllerAs: 'vm',
	                backdrop: 'static',
	                size: 'md',
	                resolve: {
	                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
	                        $translatePartialLoader.addPart('decisione');
	                        $translatePartialLoader.addPart('tipoOrdine');
	                        $translatePartialLoader.addPart('tipoDecisione');
	                        $translatePartialLoader.addPart('statoDecisione');
	                        $translatePartialLoader.addPart('documento'); // inca$ - aggiungo la traduzione di documento
	                        $translatePartialLoader.addPart('global');
	                        return $translate.refresh();
	                    }],
	                    entity: ['Decisione', function(Decisione) {
	                        return Decisione.get({id : vm.dichiarazione.decisione.id}).$promise;
	                    }],
	                    controller: function() {
	                        return vm;
	                    },
	                    entityName: function() {
	                        return 'decisione';
	                    },
	                }
	            }).result.then(function(decisione) {
	            	vm.dichiarazione.decisione=decisione;
	            	
                    // ricarichiamo il valore nella select list
        		    $q.all([vm.dichiarazione.$promise, vm.decisiones.$promise]).then(function() {
        	            if (!decisione || !decisione.id) {
        	                return $q.reject();
        	            }
        	            return Decisione.get({id : decisione.id}).$promise;
        	        }).then(function(decisioneLoaded) {
    	            	for (var i=0;i<vm.decisiones.length;i++){
    	   	        		if (vm.decisiones[i].id==decisione.id) {
    	   	        			vm.decisiones.splice(i,1);
    	   	        		}
    	            	}
         	            vm.decisiones.push(decisioneLoaded);
    	        		if (decisioneLoaded.id==decisione.id) {
		        			vm.dichiarazione.decisione=decisioneLoaded;
		        		}
        	        });
        		    
        		    // ricarichiamo il file dato che potrebbe essere stato rigenerato
        		    if (entity.documentoPdf!=null&&!entity.documentoPdf.simpleStorageService)
        	    		DocumentoFile.get({id : entity.documentoPdf.id}, function(result) {
        	     			vm.dichiarazione.documentoPdf["file"]=result.file;
        	            });

        	    
	            }, function() {
	            });
        	}
        }

        function viewMailSigns () {
    		
        	if (vm.dichiarazione.stato == null)
    			return false;

    		if (Permissions.hasOneOfRoles(['ROLE_SUPERUTENTE']) && 
    				vm.dichiarazione.stato == 'VALIDATO' &&
    				vm.dichiarazione.ordineMepa == true)
    			return true;
    		
    		return false;
        }

        function sendMailSigns () {
        	MailSigns.sendMailMepa(vm, vm.dichiarazione.id);
        }
    
        function mailSent (result) {
        	$uibModalInstance.dismiss('cancel');
        }

        function viewUpdateStato () {
    		
        	if (vm.dichiarazione.stato == null)
    			return false;

    		if (Permissions.hasOneOfRoles(['ROLE_SUPERUTENTE'])) 
    			return true;
    		
    		return false;
        }

        function updateStato () {
        	AdminCommands.updateStatoDichiarazione(vm, vm.dichiarazione.id, vm.statoForUpdate);
        }

        function updateStatoDone (result) {
        	$uibModalInstance.dismiss('cancel');
        }

        function currencySymbol () {
        	if (vm.dichiarazione.valuta==null)
        		return "€";
        	
        	var symbol = currencySymbols[vm.dichiarazione.valuta];
        	
        	if (symbol!=null)
                return symbol;
        	else
                return vm.dichiarazione.valuta;
               
        }

        function documentoFileName (documento, numero) {
        	return findAndReplace(documento.dichiarazione.decisione.impegno.codice,"/","_").replace(/[|&;$%@"<>()+,]/g, "")+"_"+documento.tipo.toLowerCase()+"_"+(numero+1)+"_ID_"+documento.id;
        }
        
        function docFileName (dichiarazione, fileContentType) {
        	var extn = null;
        	if (dichiarazione.documentoPdf.fileContentType!=null)
        		extn = dichiarazione.documentoPdf.fileContentType.split("/").pop();
        	else
        		extn = fileContentType.split("/").pop();
        	return findAndReplace(dichiarazione.decisione.impegno.codice,"/","_").replace(/[|&;$%@"<>()+,]/g, "")+"_dichiarazione_RUP_ID_"+dichiarazione.id+"."+extn;
        }

        function findAndReplace(string, target, replacement) {
        	 var i = 0, length = string.length;
        	 for (i; i < length; i++) {
        	   string = string.replace(target, replacement);
        	 }
        	 return string;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('DichiarazioneDetailController', DichiarazioneDetailController);

    DichiarazioneDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Dichiarazione', 'Documento', 'Decisione', 'DocumentoFile'];

    function DichiarazioneDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Dichiarazione, Documento, Decisione, DocumentoFile) {
        var vm = this;

        vm.dichiarazione = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.openStorageFile = openStorageFile;

        function openStorageFile (documento) {
        	var	type = documento.fileContentType;
        	var data = documento.file;
        	
        	if (documento.simpleStorageService) {
        		DocumentoFile.get({id : documento.id}, function(result) {
        			console.log(result.fileContentType);
        			//console.log(result.file);
         			vm.openFile(result.fileContentType, result.file);
                }, onGetFileError);
        	} else
            	vm.openFile(type, data);
        }

        function onGetFileError () {
        	modalScrollTop();
        };	

        // inca$ - caricamento file solo se da DB
        {
        	if (entity.documentoPdf!=null&&!entity.documentoPdf.simpleStorageService)
	    		DocumentoFile.get({id : entity.documentoPdf.id}, function(result) {
	     			vm.dichiarazione.documentoPdf["file"]=result.file;
	            });
        }

        var unsubscribe = $rootScope.$on('ordiniApp:dichiarazioneUpdate', function(event, result) {
            vm.dichiarazione = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('DichiarazioneDeleteController',DichiarazioneDeleteController);

    DichiarazioneDeleteController.$inject = ['$uibModalInstance', 'entity', 'Dichiarazione'];

    function DichiarazioneDeleteController($uibModalInstance, entity, Dichiarazione) {
        var vm = this;

        vm.dichiarazione = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Dichiarazione.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('dichiarazione', {
            parent: 'entity',
            url: '/dichiarazione?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.dichiarazione.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/dichiarazione/dichiaraziones.html',
                    controller: 'DichiarazioneController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc', // inca$ - default order
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dichiarazione');
                    $translatePartialLoader.addPart('decisione'); // inca$ - aggiungo la traduzione di decisione
                    $translatePartialLoader.addPart('statoDichiarazione');
                    $translatePartialLoader.addPart('tipoEsclusivita');
                    $translatePartialLoader.addPart('documento'); // inca$ - aggiungo la traduzione di documento
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('dichiarazione-detail', {
            parent: 'entity',
            url: '/dichiarazione/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.dichiarazione.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/dichiarazione/dichiarazione-detail.html',
                    controller: 'DichiarazioneDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dichiarazione');
                    $translatePartialLoader.addPart('statoDichiarazione');
                    $translatePartialLoader.addPart('tipoEsclusivita');
                    $translatePartialLoader.addPart('documento'); // inca$ - aggiungo la traduzione di documento
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Dichiarazione', function($stateParams, Dichiarazione) {
                    return Dichiarazione.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'dichiarazione',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('dichiarazione-detail.edit', {
            parent: 'dichiarazione-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dichiarazione/dichiarazione-dialog.html',
                    controller: 'DichiarazioneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Dichiarazione', function(Dichiarazione) {
                            return Dichiarazione.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dichiarazione.new', {
            parent: 'dichiarazione',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dichiarazione/dichiarazione-dialog.html',
                    controller: 'DichiarazioneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                data: null,
                                stato: null,
                                nessunaComparazione: false,
                                descrizione: null,
                                ordineMepa: false,
                                strumentoMepaScelto: null,
                                sezioneMepa: null,
                                criteriRicercaArticoli: null,
                                numeroOfferteMepa: null,
                                fornitoreScelto: null,
                                motivazioneSceltaProdotto: null,
                                motivazioneSceltaFornitore: null,
                                spesaEffettiva: null,
                                valuta: null,
                                beneInventariabile: false,
                                edificio: null,
                                indirizzo: null,
                                numeroStanza: null,
                                nomeAssegnatarioBene: null,
                                territorio: null,
                                motivazioneRifiuto: null,
                                utenteCreazione: null,
                                dataCreazione: null,
                                utenteAggiornamento: null,
                                dataAggiornamento: null,
                                versioneRecord: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('dichiarazione', null, { reload: 'dichiarazione' });
                }, function() {
                    $state.go('dichiarazione');
                });
            }]
        })
        .state('dichiarazione.edit', {
            parent: 'dichiarazione',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dichiarazione/dichiarazione-dialog.html',
                    controller: 'DichiarazioneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Dichiarazione', function(Dichiarazione) {
                            return Dichiarazione.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dichiarazione', null, { reload: 'dichiarazione' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dichiarazione.delete', {
            parent: 'dichiarazione',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dichiarazione/dichiarazione-delete-dialog.html',
                    controller: 'DichiarazioneDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Dichiarazione', function(Dichiarazione) {
                            return Dichiarazione.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dichiarazione', null, { reload: 'dichiarazione' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('ordiniApp')
        .factory('Dichiarazione', Dichiarazione);

    Dichiarazione.$inject = ['$resource', 'DateUtils'];

    function Dichiarazione ($resource, DateUtils) {
        var resourceUrl =  'api/dichiaraziones/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.data = DateUtils.convertLocalDateFromServer(data.data);
                        data.dataCreazione = DateUtils.convertDateTimeFromServer(data.dataCreazione);
                        data.dataAggiornamento = DateUtils.convertDateTimeFromServer(data.dataAggiornamento);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.data = DateUtils.convertLocalDateToServer(copy.data);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.data = DateUtils.convertLocalDateToServer(copy.data);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('DichiarazioneSearch', DichiarazioneSearch);

    DichiarazioneSearch.$inject = ['$resource'];

    function DichiarazioneSearch($resource) {
        var resourceUrl =  'api/_search/dichiaraziones/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('DichiarazioneController', DichiarazioneController);

    // inca$ - aggiunta gestione search, $uibModal
    DichiarazioneController.$inject = ['$scope', '$state', '$uibModal', 'DataUtils', 'Dichiarazione', 'DichiarazioneSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function DichiarazioneController ($scope, $state, $uibModal, DataUtils, Dichiarazione, DichiarazioneSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        // inca$ - aggiunta gestione search
        vm.searchForm = searchForm;
        // inca$ - gestione stato colorato
        vm.statoColour = statoColour;
        vm.rupName = rupName;
        
        function rupName (dichiarazione) {
       		return dichiarazione.decisione.responsabileProcedimento.user.firstName+" "+dichiarazione.decisione.responsabileProcedimento.user.lastName;
        }

        function statoColour (stato) {
        	//return "stato-visibile-field form-control"; // default
        	var classField = "stato-field-table";
        	if (stato=='IN_COMPILAZIONE')
        		classField = classField+" stato-field-compilatore";
        	else if (stato=='INVIATO')
        		classField = classField+" stato-field-responsabile";
        	else if (stato=='RIFIUTATO_DA_RESPONSABILE')
        		classField = classField+" stato-field-rifiuto";
        	else if (stato=='INVIATO_A_AMMINISTRAZIONE')
        		classField = classField+" stato-field-amministrazione";
        	else if (stato=='RIFIUTATO_DA_AMMINISTRAZIONE')
        		classField = classField+" stato-field-rifiuto";
        	else if (stato=='INVIATO_A_DIRETTORE')
        		classField = classField+" stato-field-direttore";
        	else if (stato=='RIFIUTATO_DA_DIRETTORE')
        		classField = classField+" stato-field-rifiuto";
        	else if (stato=='VALIDATO')
        		classField = classField+" stato-field-completato";
        	return classField;
        }

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                DichiarazioneSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Dichiarazione.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.dichiaraziones = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

     // inca$ - aggiunta gestione search
        function searchForm (field, type, domain) {
        	$uibModal.open({
                templateUrl: 'app/search/search-dialog.html',
                controller: 'SearchController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                	pScope: function() {
                        return $scope;
                    },
                    search: function() {
                        return DichiarazioneSearch;
                    },
                    controller: function() {
                        return vm;
                    },
                    field: function() {
                        return field;
                    },
                    type: function() {
                        return type;
                    },
                    domain: function() {
                        return domain;
                    }
                }
            }).result.then(function() {
                //$state.go('dichiarazione', null, { reload: 'dichiarazione' });
            }, function() {
                //$state.go('^');
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('DettaglioOrdineDialogController', DettaglioOrdineDialogController);

    DettaglioOrdineDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ordineItems', 'DettaglioOrdine', 'Ordine'];

    function DettaglioOrdineDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ordineItems, DettaglioOrdine, Ordine) {
        var vm = this;

        vm.dettaglioOrdine = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        //vm.ordines = Ordine.query(); // non serve in quanto non rendiamo possibile cambiare l'aggancio all'ordine
    	//vm.isFromOrdine=(vm.dettaglioOrdine.ordine!=null)&&(vm.dettaglioOrdine.id==null); // in modo che il campo dettaglioOrdine.ordine non sia visibile se si proviene da Ordine
        vm.isFromOrdine = isFromOrdine;
        vm.ordineItems = ordineItems;
        $scope.functionNameForAutocomplete = 'dettaglio-ordine'; // per gestire l'autocompletamento
        
        {
        	if (isFromOrdine()) {
                if (vm.dettaglioOrdine.id == null) {
                	vm.dettaglioOrdine.percentualeIva=ordineItems.percentualeIva;
                }
        	} 
        }
        
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
        	
            vm.isSaving = true;
            if (vm.dettaglioOrdine.id !== null) {
                DettaglioOrdine.update(vm.dettaglioOrdine, onSaveSuccess, onSaveError);
            } else {
                DettaglioOrdine.save(vm.dettaglioOrdine, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('ordiniApp:dettaglioOrdineUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dataCreazione = false;
        vm.datePickerOpenStatus.dataAggiornamento = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
        
        function isFromOrdine () {
        	// inca$ - il service ordineItems, se chiamato dalle modal in OrdineDialogController
        	// assume il valore dell'entità Ordine caricata nella modal, per cui id è valorizzato
        	if (ordineItems.id!=null)
        		return true;
       		
        	return false;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('DettaglioOrdineDetailController', DettaglioOrdineDetailController);

    DettaglioOrdineDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'DettaglioOrdine', 'Ordine'];

    function DettaglioOrdineDetailController($scope, $rootScope, $stateParams, previousState, entity, DettaglioOrdine, Ordine) {
        var vm = this;

        vm.dettaglioOrdine = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('ordiniApp:dettaglioOrdineUpdate', function(event, result) {
            vm.dettaglioOrdine = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('DettaglioOrdineDeleteController',DettaglioOrdineDeleteController);

    DettaglioOrdineDeleteController.$inject = ['$uibModalInstance', 'entity', 'DettaglioOrdine'];

    function DettaglioOrdineDeleteController($uibModalInstance, entity, DettaglioOrdine) {
        var vm = this;

        vm.dettaglioOrdine = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            DettaglioOrdine.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('dettaglio-ordine', {
            parent: 'entity',
            url: '/dettaglio-ordine?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.dettaglioOrdine.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/dettaglio-ordine/dettaglio-ordines.html',
                    controller: 'DettaglioOrdineController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dettaglioOrdine');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('dettaglio-ordine-detail', {
            parent: 'entity',
            url: '/dettaglio-ordine/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.dettaglioOrdine.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/dettaglio-ordine/dettaglio-ordine-detail.html',
                    controller: 'DettaglioOrdineDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dettaglioOrdine');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'DettaglioOrdine', function($stateParams, DettaglioOrdine) {
                    return DettaglioOrdine.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'dettaglio-ordine',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('dettaglio-ordine-detail.edit', {
            parent: 'dettaglio-ordine-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dettaglio-ordine/dettaglio-ordine-dialog.html',
                    controller: 'DettaglioOrdineDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DettaglioOrdine', function(DettaglioOrdine) {
                            return DettaglioOrdine.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dettaglio-ordine.new', {
            parent: 'dettaglio-ordine',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dettaglio-ordine/dettaglio-ordine-dialog.html',
                    controller: 'DettaglioOrdineDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                quantita: null,
                                descrizioneArticolo: null,
                                codiceArticolo: null,
                                importoUnitario: null,
                                percentualeIva: null,
                                descrizioneIva: null,
                                utenteCreazione: null,
                                dataCreazione: null,
                                utenteAggiornamento: null,
                                dataAggiornamento: null,
                                versioneRecord: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('dettaglio-ordine', null, { reload: 'dettaglio-ordine' });
                }, function() {
                    $state.go('dettaglio-ordine');
                });
            }]
        })
        .state('dettaglio-ordine.edit', {
            parent: 'dettaglio-ordine',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dettaglio-ordine/dettaglio-ordine-dialog.html',
                    controller: 'DettaglioOrdineDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DettaglioOrdine', function(DettaglioOrdine) {
                            return DettaglioOrdine.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dettaglio-ordine', null, { reload: 'dettaglio-ordine' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dettaglio-ordine.delete', {
            parent: 'dettaglio-ordine',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dettaglio-ordine/dettaglio-ordine-delete-dialog.html',
                    controller: 'DettaglioOrdineDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DettaglioOrdine', function(DettaglioOrdine) {
                            return DettaglioOrdine.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dettaglio-ordine', null, { reload: 'dettaglio-ordine' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('ordiniApp')
        .factory('DettaglioOrdine', DettaglioOrdine);

    DettaglioOrdine.$inject = ['$resource', 'DateUtils'];

    function DettaglioOrdine ($resource, DateUtils) {
        var resourceUrl =  'api/dettaglio-ordines/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dataCreazione = DateUtils.convertDateTimeFromServer(data.dataCreazione);
                        data.dataAggiornamento = DateUtils.convertDateTimeFromServer(data.dataAggiornamento);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('DettaglioOrdineSearch', DettaglioOrdineSearch);

    DettaglioOrdineSearch.$inject = ['$resource'];

    function DettaglioOrdineSearch($resource) {
        var resourceUrl =  'api/_search/dettaglio-ordines/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('DettaglioOrdineDBSearch', DettaglioOrdineDBSearch);

    DettaglioOrdineDBSearch.$inject = ['$resource'];

    function DettaglioOrdineDBSearch($resource) {
        var resourceUrl =  'api/_dbsearch/dettaglio-ordines/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('DettaglioOrdineController', DettaglioOrdineController);

    // inca$ - aggiunta gestione search, $uibModal
    DettaglioOrdineController.$inject = ['$scope', '$state', '$uibModal', 'DettaglioOrdine', 'DettaglioOrdineSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function DettaglioOrdineController ($scope, $state, $uibModal, DettaglioOrdine, DettaglioOrdineSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;
        
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        // inca$ - aggiunta gestione search
        vm.searchForm = searchForm;

        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                DettaglioOrdineSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                DettaglioOrdine.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.dettaglioOrdines = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        // inca$ - aggiunta gestione search
        function searchForm (field, type, domain) {
        	$uibModal.open({
                templateUrl: 'app/search/search-dialog.html',
                controller: 'SearchController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                	pScope: function() {
                        return $scope;
                    },
                    search: function() {
                        return DettaglioOrdineSearch;
                    },
                    controller: function() {
                        return vm;
                    },
                    field: function() {
                        return field;
                    },
                    type: function() {
                        return type;
                    },
                    domain: function() {
                        return domain;
                    }
                }
            }).result.then(function() {
                //$state.go('decisione', null, { reload: 'decisione' });
            }, function() {
                //$state.go('^');
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('DecisioneImpegnoDeleteController',DecisioneImpegnoDeleteController);

    DecisioneImpegnoDeleteController.$inject = ['$uibModalInstance', 'entity', 'Impegno'];

    function DecisioneImpegnoDeleteController($uibModalInstance, entity, Impegno) {
        var vm = this;

        vm.impegno = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (impegno) {
        	impegno.decisione=null;
            Impegno.update(impegno,
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('DecisioneImpegniController', DecisioneImpegniController);

    DecisioneImpegniController.$inject = ['$scope', '$state', '$uibModal', '$uibModalInstance', 'Impegno', 'VoceBilancio', 'ImpegnoDBSearch', 'ParseLinks', 'AlertService', 'decisione'];

    function DecisioneImpegniController ($scope, $state, $uibModal, $uibModalInstance, Impegno, VoceBilancio, ImpegnoDBSearch, ParseLinks, AlertService, decisione) {
        var vm = this;
        
        vm.decisione = decisione;
    	vm.esercizio = esercizio;
    	vm.esercizioVoce = esercizioVoce;
        vm.vocebilancios = VoceBilancio.query({size:100000000, filterOn: true, viewableOnly: true, esercizio: vm.esercizioVoce()}); // inca$ - caricamento totale liste fk
        vm.itemsPerPage = 1000000;
        vm.clear = clear;
        vm.loadAll = loadAll;
        vm.save = save;
        vm.impegni = null;
        vm.impegniItems = null;
        vm.impegniSelectedItems = [];

        loadAll();

        $scope.$watch('vm.impegniItems', function(newValues){
        	vm.impegniSelectedItems.length = 0;
            angular.forEach(newValues, function(item) {
                if (item.value == true) {
                	vm.impegniSelectedItems.push(item);
                }
            });
            //console.log(vm.impegniSelectedItems);
        }, true);

        function loadAll () {
            ImpegnoDBSearch.query({
            	param: {responsabileGaeId: vm.decisione.impegno.gae.finanziamento.responsabileFondi.id}
            }, onSuccess, onError);
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.impegni = data;
                vm.impegniItems=[];
                for(var i=0; i < vm.totalItems; i++) {
                	// attenzione, inserisco solo impegni aggiuntivi nell'esercizio attuale!!!
                	if (vm.impegni[i].esercizio==vm.esercizio())
                		vm.impegniItems = vm.impegniItems.concat([{ impegno : vm.impegni[i], value: false}]);
                }
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function clear () {
        	$uibModalInstance.dismiss('cancel');
        }

        function save () {

            var totalItems = vm.impegniSelectedItems.length;
            vm.selCounter=totalItems;
            var impegniItems=[];
            for(var i=0; i < totalItems; i++) {
            	var impegno = vm.impegniSelectedItems[i].impegno;
            	impegno.decisione=vm.decisione;
            	Impegno.update(impegno, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
        	modalScrollTop();
    		vm.selCounter--;
    		if (vm.selCounter==0) {
                $uibModalInstance.close(true);
    		}
        }

        function onSaveError () {
        	modalScrollTop();
        }
    
        function esercizio () {
        	if (vm.decisione!=null && vm.decisione.data!=null)
        		return vm.decisione.data.getFullYear();
        	return (new Date()).getFullYear();
        }

        function esercizioVoce () {
        	if (vm.decisione!=null && vm.decisione.data!=null)
        		return vm.decisione.data.getFullYear();
        	return (new Date()).getFullYear();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('DecisioneDialogController', DecisioneDialogController);

    DecisioneDialogController.$inject = ['$filter', '$window', '$timeout', '$scope', '$stateParams', '$uibModal', '$uibModalInstance', '$q', 'Permissions', 'DataUtils', 'entity', 'Decisione', 'Documento', 'VoceBilancio', 'Impegno', 'Utente', 'DocumentoFile', 'AdminCommands', 'ImpegnoDBSearch'];

    function DecisioneDialogController ($filter, $window, $timeout, $scope, $stateParams, $uibModal, $uibModalInstance, $q, Permissions, DataUtils, entity, Decisione, Documento, VoceBilancio, Impegno, Utente, DocumentoFile, AdminCommands, ImpegnoDBSearch) {
        var vm = this;

        // inca$ - variabili gestione preview e invio
        vm.visualizza = false;
        vm.invia = false;
        vm.isPreview = false; // quando viene premuto Preview, isPreview viene settato definitivamente a true;
        vm.isValidating = false; // quando viene premuto Valida o Respingi, isValidating viene settato definitivamente a true;
        vm.oldStato;
        vm.dateformat='dd/MM/yyyy';
        $scope.functionNameForAutocomplete = 'decisione'; // per gestire l'autocompletamento
        
        vm.decisione = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.downloadFile = DataUtils.downloadFile;
        vm.previewFile = DataUtils.previewFile;
        vm.openStorageFile = openStorageFile;
        vm.downloadStorageFile = downloadStorageFile;
        vm.docFileName = docFileName;
        vm.save = save;
    	vm.utenteLogin = Permissions.getAccount().login;
//        vm.documentopdfs = Documento.query({filter: 'decisionepdf-is-null'});
//        $q.all([vm.decisione.$promise, vm.documentopdfs.$promise]).then(function() {
//            if (!vm.decisione.documentoPdf || !vm.decisione.documentoPdf.id) {
//                return $q.reject();
//            }
//            return Documento.get({id : vm.decisione.documentoPdf.id}).$promise;
//        }).then(function(documentoPdf) {
//            vm.documentopdfs.push(documentoPdf);
//        });
    	vm.esercizio = esercizio;
    	vm.esercizioVoce = esercizioVoce;
    	vm.loadImpegniList = loadImpegniList;
        vm.vocebilancios = VoceBilancio.query({size:100000000, filterOn: true, viewableOnly: true, esercizio: vm.esercizioVoce()}); // inca$ - caricamento totale liste fk
        //vm.impegnos = Impegno.query({size:100000000, filterOn: true, decisioneId: vm.decisione.id}); // inca$ - caricamento totale liste fk
        vm.loadImpegniList(); // carico la lista fk degli impegni
        vm.utentes = Utente.query({size:100000000}); // inca$ - caricamento totale liste fk
    	// inca$ - gestione validazione e rifiuto
        vm.validate = validate;
        vm.reject = reject;
        vm.disableSave = disableSave; // inca$ - imposta l'abilitazione di Salva
        vm.disableValidateOrReject = disableValidateOrReject; // inca$ - imposta l'abilitazione dei button Valida e Respingi
        vm.disablePreviewOrSend = disablePreviewOrSend;
        vm.showMotivazioneRifiuto = showMotivazioneRifiuto;
        vm.showProtocollo = showProtocollo;
        vm.disableProtocollo = disableProtocollo;
        // inca$ - aggiunta gestione rifiuto
        vm.rejectDialogForm = rejectDialogForm;
        vm.eraseHiddenFields = eraseHiddenFields;
        vm.today = today;
        vm.funzionaleAllaRicerca = funzionaleAllaRicerca;
        //inca$ - gestione fuzioni superutente
        vm.viewUpdateStato = viewUpdateStato;
        vm.updateStato = updateStato;
        vm.statoForUpdate = vm.decisione.stato;
        vm.updateStatoDone = updateStatoDone;
        // inca$ - gestione stato colorato
        vm.statoColour = statoColour;
        vm.rupName = rupName;
        // inca$ - gestione impegni aggiuntivi
        vm.impegniAggiuntivi = null;
        vm.impegniAggiuntiviLiberi = null;
        vm.findImpegniAggiuntivi = findImpegniAggiuntivi;
        vm.addImpegnoAggiuntivo = addImpegnoAggiuntivo;
        vm.deleteImpegnoAggiuntivo = deleteImpegnoAggiuntivo;
        vm.disableInsertDetails = disableInsertDetails;
        
        // inca$ - carico gli impegni aggiuntivi
    	vm.findImpegniAggiuntivi();
    	
    	// all'ingresso della funzione, consideriamo lo stato
    	// di rifiutato come se fosse in compilazione
    	{
       		// inca$ - gestione chiusura e invio
        	if ((vm.decisione.stato == 'RIFIUTATO_DA_AMMINISTRAZIONE' ||
        		vm.decisione.stato == 'RIFIUTATO_DA_DIRETTORE') &&
        		((vm.decisione.utenteCreazione == vm.utenteLogin ||
        		vm.decisione.responsabileProcedimento.user.login == vm.utenteLogin) ||
        		Permissions.hasRole('ROLE_SUPERUTENTE'))) {
				vm.decisione.stato = 'IN_COMPILAZIONE';
				//vm.decisione.file = null;
        	}
    	}

        function loadImpegniList () {
        	var impegno=vm.decisione.impegno;
        	vm.impegnos = Impegno.query({size:100000000, filterOn: true, decisioneId: vm.decisione.id}, dettagliOnSuccess);
            
        	function dettagliOnSuccess(data, headers) {
            	vm.decisione.impegno=impegno;
            }

        }
        
        function openStorageFile (documento) {
        	var	type = documento.fileContentType;
        	var data = documento.file;

        	if (documento.simpleStorageService) {
        		DocumentoFile.get({id : documento.id}, function(result) {
        			//console.log(result.fileContentType);
        			//console.log(result.file);
         			vm.openFile(result.fileContentType, result.file);
                });
        	} else
            	vm.openFile(type, data);
//        		if (vm.decisione.documentoPdf["file"]==null)
//		    		DocumentoFile.get({id : entity.documentoPdf.id}, function(result) {
//		    			vm.decisione.documentoPdf["file"]=result.file;
//		    			vm.openFile(type, vm.decisione.documentoPdf["file"]);
//		    		});
        }

        function downloadStorageFile (documento, filename) {
        	var	type = documento.fileContentType;
        	var data = documento.file;

        	if (documento.simpleStorageService) {
        		DocumentoFile.get({id : documento.id}, function(result) {
        			//console.log(result.fileContentType);
        			//console.log(result.file);
         			vm.downloadFile(result.fileContentType, result.file, filename);
                }, onGetFileError);
        	} else
            	vm.downloadFile(type, data, filename);
        }
        
        function onGetFileError () {
        	modalScrollTop();
        };	

        function esercizio () {
        	if (vm.decisione!=null && vm.decisione.impegno!=null)
        		return vm.decisione.impegno.esercizio;
        	if (vm.decisione!=null && vm.decisione.data!=null)
        		return vm.decisione.data.getFullYear();
        	return (new Date()).getFullYear();
        }

        function esercizioVoce () {
        	if (vm.decisione!=null && vm.decisione.voceBilancio!=null)
        		return vm.decisione.voceBilancio.esercizio;
        	if (vm.decisione!=null && vm.decisione.data!=null)
        		return vm.decisione.data.getFullYear();
        	return (new Date()).getFullYear();
        }

        function rupName () {
        	if (vm.decisione!=null)
        		return vm.decisione.responsabileProcedimento.user.firstName+" "+vm.decisione.responsabileProcedimento.user.lastName;
        	return null;
        }
        
        function statoColour (stato) {
        	//return "stato-visibile-field form-control"; // default
        	var classField = "stato-visibile-field";
        	if (stato=='IN_COMPILAZIONE')
        		classField = classField+" stato-field-compilatore";
        	else if (stato=='INVIATO')
        		classField = classField+" stato-field-amministrazione";
        	else if (stato=='RIFIUTATO_DA_AMMINISTRAZIONE')
        		classField = classField+" stato-field-rifiuto";
        	else if (stato=='INVIATO_A_DIRETTORE')
        		classField = classField+" stato-field-direttore";
        	else if (stato=='RIFIUTATO_DA_DIRETTORE')
        		classField = classField+" stato-field-rifiuto";
        	else if (stato=='VALIDATO')
        		classField = classField+" stato-field-completato";
        	return classField;
        }

        function today () {
        	return new Date();
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
            
            // inca$ - serve come workaround per un bug del ui-datepicker che azzera
            // i campi quando si richiama la funzione da un altra funzione
            if (vm.decisione.id!=null) {
                $scope.editForm.data.$setValidity("required", true);
    	        $scope.editForm.$invalid = false;
            }

        });

        // inca$ - inizializzazione caricamento ruoli
        Permissions.loadRoles();

        // inca$ - caricamento file solo se da DB
        {
        	if (entity.documentoPdf!=null&&!entity.documentoPdf.simpleStorageService)
	    		DocumentoFile.get({id : entity.documentoPdf.id}, function(result) {
	     			vm.decisione.documentoPdf["file"]=result.file;
	            });
        }

        function funzionaleAllaRicerca () {
        	if (vm.decisione.funzionaleAllaRicerca==true)
        		vm.decisione.ordineMepa=false;
        }

        function clear () {
        	// inca$ - chiudiamo solo se non è stata fatta preview
        	if (!vm.isPreview)
        		$uibModalInstance.dismiss('cancel');
        }

        function save () {

        	vm.eraseHiddenFields();

       		// memorizziamo SEMPRE lo stato precedente al salvataggio
       		vm.oldStato = vm.decisione.stato;

        	// inca$ - gestione chiusura e invio
        	if (vm.decisione.stato == null)
				vm.decisione.stato = 'IN_COMPILAZIONE';

//			if (vm.visualizza != true && vm.isSaving != true) {
//				if (vm.decisione.stato == 'IN_COMPILAZIONE') {
//					vm.decisione.file = null;
//				}
//			}

			if (vm.invia == true) {
				if (vm.decisione.stato == 'IN_COMPILAZIONE')
					vm.decisione.stato = 'INVIATO';
				vm.invia = false;
			}

			vm.isSaving = true;
			if (vm.decisione.id !== null) {
				if (vm.decisione.documentoPdf != null &&
						(vm.decisione.documentoPdf.annoProtocollo != null ||
						vm.decisione.documentoPdf.numeroProtocollo != null)) {
					Documento.update(vm.decisione.documentoPdf);
				}
				Decisione.update(vm.decisione, onSaveSuccess, onSaveError);
			} else {
				Decisione.save(vm.decisione, onSaveSuccess, onSaveError);
			}
        }

        function onSaveSuccess (result) {
			// inca$ - gestione preview
			if (vm.visualizza == true) {
				vm.decisione=result;
				$scope.editForm.$setValidity();
	            $scope.$emit('ordiniApp:decisioneUpdate', result);
	        	// inca$ - non più funzionante su chrome a causa dell'errore
	        	// Not allowed to navigate top frame to data URL
				//$window.open('data:' + result.documentoPdf.fileContentType + ';base64,' + result.documentoPdf.file);
	            var type = result.documentoPdf.fileContentType;
	            var data = result.documentoPdf.file;
	        	vm.previewFile(type, data);

				// sono costretto a settare il valore delle date a causa di un azzeramento per il comportamento anomalo
				// della proprietà uib-datepicker-popup="{{vm.dateformat}}"
				var data = angular.element(document.querySelector('#field_data'));
				data.val($filter('date')(result.data,vm.dateformat));

				vm.visualizza=false;
			} else {
	            $scope.$emit('ordiniApp:decisioneUpdate', result);
	            $uibModalInstance.close(result);
			}
            vm.isSaving = false;
        }

        function onSaveError () {

        	// inca$ - mia funzione per fare scroll to top
        	modalScrollTop();

            vm.isSaving = false;
        	// inca$ - gestione preview
       		vm.isPreview=false;

       		// torniamo SEMPRE allo stato precedente in caso di errore
       		vm.decisione.stato = vm.oldStato;

       		// inca$ - gestione valida o respingi
			if (vm.isValidating == true) {
    			//vm.decisione.stato = vm.oldStato;
				vm.isValidating = false;
			}

        }

    	// inca$ - gestione preview
        vm.preview = function () {
        	vm.visualizza=true;
       		vm.isPreview=true;
        }

        // inca$ - gestione invio
        vm.send = function () {
        	vm.invia=true;
        }

        vm.datePickerOpenStatus.data = false;

        vm.setFile = function ($file, decisione) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                        decisione.file = base64Data;
                        decisione.fileContentType = $file.type;
                    });
                });
            }
        };
        vm.datePickerOpenStatus.dataCreazione = false;
        vm.datePickerOpenStatus.dataAggiornamento = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function validate () {

        	// inca$ - gestione validazione
    		if (vm.decisione.stato == 'INVIATO') {
    			vm.decisione.stato = 'INVIATO_A_DIRETTORE';

    			vm.isValidating = true;
    			vm.oldStato = 'INVIATO';
    			vm.isSaving = true;
        		Decisione.update(vm.decisione, onSaveSuccess, onSaveError);

    		} else if (vm.decisione.stato == 'INVIATO_A_DIRETTORE') {
    			vm.decisione.stato = 'VALIDATO';

    			vm.isValidating = true;
    			vm.oldStato = 'INVIATO_A_DIRETTORE';
    			vm.isSaving = true;
        		Decisione.update(vm.decisione, onSaveSuccess, onSaveError);

    		}
        }

        function reject () {

        	// inca$ - gestione rifiuto
    		if (vm.decisione.stato == 'INVIATO') {
    			vm.decisione.stato = 'RIFIUTATO_DA_AMMINISTRAZIONE';

    			vm.isValidating = true;
    			vm.oldStato = 'INVIATO';
    			vm.isSaving = true;

    			Decisione.update(vm.decisione, onSaveSuccess, onSaveError);

    		} else if (vm.decisione.stato == 'INVIATO_A_DIRETTORE') {
    			vm.decisione.stato = 'RIFIUTATO_DA_DIRETTORE';

    			vm.isValidating = true;
    			vm.oldStato = 'INVIATO_A_DIRETTORE';
    			vm.isSaving = true;

    			Decisione.update(vm.decisione, onSaveSuccess, onSaveError);

    		}
        }

        // inca$ - gestione save, preview o send
        function disableSave () {

        	if (vm.decisione.stato == null) {
        		return false;
        	}

        	// permetto l'amministrazione di inserire il protocollo
        	if (!disableProtocollo())
        		return false;

        	return disableSavePreviewOrSend();
        }

        // inca$ - gestione save, preview o send
        function disablePreviewOrSend () {

        	if (vm.decisione.stato == null) {
        		return true;
        	}
        	return disableSavePreviewOrSend();

        }

        // inca$ - gestione save, preview o send
        function disableSavePreviewOrSend () {

           	// ricordiamoci che il direttore potrebbe essere che sia lui a creare la decisione di contrattare
           	// oppure sia lui il responsabile del procedimento, pertanto va prima verificato questa condizione
           	// successivamente quella del ruolo direttore
           	if (vm.decisione.responsabileProcedimento.user.login == vm.utenteLogin ||
				vm.decisione.utenteCreazione == vm.utenteLogin||
				Permissions.hasRole('ROLE_SUPERUTENTE')) {

				if ((vm.decisione.stato == 'INVIATO')||
						(vm.decisione.stato == 'INVIATO_A_DIRETTORE')||
						(vm.decisione.stato == 'VALIDATO')) {
					return true;
				} else {
					return false;
				}
    		} else if ((Permissions.hasOneOfRoles(['ROLE_AMMINISTRAZIONE','ROLE_DIRETTORE']) &&
    					(vm.decisione.stato == 'INVIATO_A_DIRETTORE' ||
    					vm.decisione.stato == 'VALIDATO'))) {
    			return true;
    		}

           	return true;
        }

        // inca$ - gestione valida o respingi
        function disableValidateOrReject () {

			if (vm.decisione.stato == null)
				return true;

			if ((Permissions.hasOneOfRoles(['ROLE_AMMINISTRAZIONE','ROLE_SUPERUTENTE']) && vm.decisione.stato == 'INVIATO') ||
   				(Permissions.hasOneOfRoles(['ROLE_DIRETTORE','ROLE_SUPERUTENTE']) && vm.decisione.stato == 'INVIATO_A_DIRETTORE')) {
    			return false;
    		}
       		return true;
        }

        // inca$ - gestione campo motivazione rifiuto
        function showMotivazioneRifiuto () {

			if (vm.decisione.stato == null)
				return false;

			if (vm.decisione.motivazioneRifiuto != null)
				return true;

			if ((Permissions.hasOneOfRoles(['ROLE_AMMINISTRAZIONE','ROLE_SUPERUTENTE','ROLE_DIRETTORE']) ||
					(vm.decisione.stato == 'RIFIUTATO_DA_AMMINISTRAZIONE' || vm.decisione.stato == 'RIFIUTATO_DA_DIRETTORE')))
    			return true;

			return false;
        }

        // inca$ - gestione campo protocollo
        function showProtocollo () {

			if (vm.decisione.stato == null)
				return false;

			if (vm.decisione.documentoPdf==null)
				return false;

			if ((Permissions.hasOneOfRoles(['ROLE_AMMINISTRAZIONE','ROLE_SUPERUTENTE']) ||
					vm.decisione.documentoPdf.numeroProtocollo !=null))
    			return true;

			return false;
        }

        // inca$ - gestione campo protocollo
        function disableProtocollo () {

			if (vm.decisione.stato == null)
				return true;

			if ((Permissions.hasOneOfRoles(['ROLE_AMMINISTRAZIONE','ROLE_SUPERUTENTE']) &&
					vm.decisione.stato == 'VALIDATO'))
    			return false;

			return true;
        }

        // inca$ - aggiunta gestione rifiuto
        function rejectDialogForm() {
        	$uibModal.open({
                templateUrl: 'app/util/entity-reject.html',
                controller: 'EntityRejectController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    controller: function() {
                        return vm;
                    },
                    entityName: function() {
                        return 'decisione';
                    }
                }
            }).result.then(function() {
            	vm.reject();
            }, function() {
            });
        }

        function eraseHiddenFields () {

        	if (vm.decisione.spesa!=null &&
        			vm.decisione.spesa<40000) {
        		vm.decisione.spesaAutoritaVigilanza=null;
        	}
        }

        function docFileName (decisione, fileContentType) {
        	var extn = null;
        	if (decisione.documentoPdf.fileContentType!=null)
        		extn = decisione.documentoPdf.fileContentType.split("/").pop();
        	else
        		extn = fileContentType.split("/").pop();
        	return findAndReplace(decisione.impegno.codice,"/","_").replace(/[|&;$%@"<>()+,]/g, "")+"_decisione_ID_"+decisione.id+"."+extn;
        }

        function findAndReplace(string, target, replacement) {
        	 var i = 0, length = string.length;
        	 for (i; i < length; i++) {
        	   string = string.replace(target, replacement);
        	 }
        	 return string;
        }
    
        function viewUpdateStato () {
    		
        	if (vm.decisione.stato == null)
    			return false;

    		if (Permissions.hasOneOfRoles(['ROLE_SUPERUTENTE'])) 
    			return true;
    		
    		return false;
        }

        function updateStato () {
        	AdminCommands.updateStatoDecisione(vm, vm.decisione.id, vm.statoForUpdate);
        }

        function updateStatoDone (result) {
        	$uibModalInstance.dismiss('cancel');
        }

        function findImpegniAggiuntivi () {
        	if (vm.decisione.id!=null) 
        		vm.impegniAggiuntivi = ImpegnoDBSearch.query({size: 100000000, param: {decisioneId: vm.decisione.id}}, dettagliOnSuccess);
            
        	function dettagliOnSuccess(data, headers) {
            }

        }

        function addImpegnoAggiuntivo () {
        	
        	$uibModal.open({
              templateUrl: 'app/entities/decisione/decisione-impegni.html',
              controller: 'DecisioneImpegniController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('impegno');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    controller: function() {
                        return vm;
                    },
                    decisione: function() {
                        return vm.decisione;
                    } 
                }
            }).result.then(function() {
            	vm.findImpegniAggiuntivi();
            	vm.loadImpegniList();
            }, function() {
            	vm.findImpegniAggiuntivi();
            	vm.loadImpegniList();
            });
        }

        function deleteImpegnoAggiuntivo (impegno) {
            
        	$uibModal.open({
                templateUrl: 'app/entities/decisione/decisione-impegno-delete-dialog.html',
                controller: 'DecisioneImpegnoDeleteController',                       
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'md',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('impegno');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: function() {
                        return impegno;
                    }
                }
            }).result.then(function() {
            	vm.findImpegniAggiuntivi();
            	vm.loadImpegniList();
            }, function() {
            	vm.findImpegniAggiuntivi();
            	vm.loadImpegniList();
            });

        }
        
        // inca$ - gestione inserimento allegati e dettagli
        function disableInsertDetails () {

        	if (disableSave())
        		return true;
        	
        	if (vm.decisione.stato == null) {
        		return true;
        	}
			if (vm.decisione.stato != 'IN_COMPILAZIONE') {
				return true;
			} else {
				return false;
			}

        }

    
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('DecisioneDetailController', DecisioneDetailController);

    DecisioneDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'DataUtils', 'entity', 'Decisione', 'Documento', 'VoceBilancio', 'Impegno', 'Utente', 'DocumentoFile'];

    function DecisioneDetailController($scope, $rootScope, $stateParams, previousState, DataUtils, entity, Decisione, Documento, VoceBilancio, Impegno, Utente, DocumentoFile) {
        var vm = this;

        vm.decisione = entity;
        vm.previousState = previousState.name;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.openStorageFile = openStorageFile;

        function openStorageFile (documento) {
        	var	type = documento.fileContentType;
        	var data = documento.file;
        	
        	if (documento.simpleStorageService) {
        		DocumentoFile.get({id : documento.id}, function(result) {
        			console.log(result.fileContentType);
        			//console.log(result.file);
         			vm.openFile(result.fileContentType, result.file);
                }, onGetFileError);
        	} else
            	vm.openFile(type, data);
        }

        // inca$ - caricamento file solo se da DB
        {
        	if (entity.documentoPdf!=null&&!entity.documentoPdf.simpleStorageService)
	    		DocumentoFile.get({id : entity.documentoPdf.id}, function(result) {
	     			vm.decisione.documentoPdf["file"]=result.file;
	            });
        }

		var unsubscribe = $rootScope.$on('ordiniApp:decisioneUpdate', function(event, result) {
            vm.decisione = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('DecisioneDeleteController',DecisioneDeleteController);

    DecisioneDeleteController.$inject = ['$uibModalInstance', 'entity', 'Decisione'];

    function DecisioneDeleteController($uibModalInstance, entity, Decisione) {
        var vm = this;

        vm.decisione = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Decisione.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('decisione', {
            parent: 'entity',
            url: '/decisione?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.decisione.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/decisione/decisiones.html',
                    controller: 'DecisioneController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc', // inca$ - default order
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('decisione');
                    $translatePartialLoader.addPart('tipoOrdine');
                    $translatePartialLoader.addPart('tipoDecisione');
                    $translatePartialLoader.addPart('statoDecisione');
                    $translatePartialLoader.addPart('documento'); // inca$ - aggiungo la traduzione di documento
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('decisione-detail', {
            parent: 'entity',
            url: '/decisione/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'ordiniApp.decisione.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/decisione/decisione-detail.html',
                    controller: 'DecisioneDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('decisione');
                    $translatePartialLoader.addPart('tipoOrdine');
                    $translatePartialLoader.addPart('tipoDecisione');
                    $translatePartialLoader.addPart('statoDecisione');
                    $translatePartialLoader.addPart('documento'); // inca$ - aggiungo la traduzione di documento
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Decisione', function($stateParams, Decisione) {
                    return Decisione.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'decisione',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('decisione-detail.edit', {
            parent: 'decisione-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/decisione/decisione-dialog.html',
                    controller: 'DecisioneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Decisione', function(Decisione) {
                            return Decisione.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('decisione.new', {
            parent: 'decisione',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/decisione/decisione-dialog.html',
                    controller: 'DecisioneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                data: null,
                                tipoOrdine: null,
                                tipoDecisione: null,
                                stato: null,
                                funzionaleAllaRicerca: false,
                                pubblicazione: false,
                                oggetto: null,
                                descrizione: null,
                                cig: null,
                                cup: null,
                                dettaglioFondi: null,
                                spesa: null,
                                spesaAutoritaVigilanza: null,
                                giorniConsegna: null,
                                luogoConsegna: null,
                                motivazioneRifiuto: null,
                                utenteCreazione: null,
                                dataCreazione: null,
                                utenteAggiornamento: null,
                                dataAggiornamento: null,
                                versioneRecord: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('decisione', null, { reload: 'decisione' });
                }, function() {
                    $state.go('decisione');
                });
            }]
        })
        .state('decisione.edit', {
            parent: 'decisione',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/decisione/decisione-dialog.html',
                    controller: 'DecisioneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Decisione', function(Decisione) {
                            return Decisione.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('decisione', null, { reload: 'decisione' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('decisione.delete', {
            parent: 'decisione',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/decisione/decisione-delete-dialog.html',
                    controller: 'DecisioneDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Decisione', function(Decisione) {
                            return Decisione.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('decisione', null, { reload: 'decisione' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('ordiniApp')
        .factory('Decisione', Decisione);

    Decisione.$inject = ['$resource', 'DateUtils'];

    function Decisione ($resource, DateUtils) {
        var resourceUrl =  'api/decisiones/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.data = DateUtils.convertLocalDateFromServer(data.data);
                        data.dataCreazione = DateUtils.convertDateTimeFromServer(data.dataCreazione);
                        data.dataAggiornamento = DateUtils.convertDateTimeFromServer(data.dataAggiornamento);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.data = DateUtils.convertLocalDateToServer(copy.data);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.data = DateUtils.convertLocalDateToServer(copy.data);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('DecisioneSearch', DecisioneSearch);

    DecisioneSearch.$inject = ['$resource'];

    function DecisioneSearch($resource) {
        var resourceUrl =  'api/_search/decisiones/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('DecisioneController', DecisioneController);

    // inca$ - aggiunta gestione search, $uibModal
    DecisioneController.$inject = ['$scope', '$state', '$uibModal', 'DataUtils', 'Decisione', 'DecisioneSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants'];

    function DecisioneController ($scope, $state, $uibModal, DataUtils, Decisione, DecisioneSearch, ParseLinks, AlertService, pagingParams, paginationConstants) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.clear = clear;
        vm.search = search;
        vm.loadAll = loadAll;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
        // inca$ - aggiunta gestione search
        vm.searchForm = searchForm;
        // inca$ - gestione stato colorato
        vm.statoColour = statoColour;
        vm.rupName = rupName;
        
        function rupName (decisione) {
       		return decisione.responsabileProcedimento.user.firstName+" "+decisione.responsabileProcedimento.user.lastName;
        }

        function statoColour (stato) {
        	//return "stato-visibile-field form-control"; // default
        	var classField = "stato-field-table";
        	if (stato=='IN_COMPILAZIONE')
        		classField = classField+" stato-field-compilatore";
        	else if (stato=='INVIATO')
        		classField = classField+" stato-field-amministrazione";
        	else if (stato=='RIFIUTATO_DA_AMMINISTRAZIONE')
        		classField = classField+" stato-field-rifiuto";
        	else if (stato=='INVIATO_A_DIRETTORE')
        		classField = classField+" stato-field-direttore";
        	else if (stato=='RIFIUTATO_DA_DIRETTORE')
        		classField = classField+" stato-field-rifiuto";
        	else if (stato=='VALIDATO')
        		classField = classField+" stato-field-completato";
        	return classField;
        }


        loadAll();

        function loadAll () {
            if (pagingParams.search) {
                DecisioneSearch.query({
                    query: pagingParams.search,
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            } else {
                Decisione.query({
                    page: pagingParams.page - 1,
                    size: vm.itemsPerPage,
                    sort: sort()
                }, onSuccess, onError);
            }
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.decisiones = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search (searchQuery) {
            if (!searchQuery){
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear () {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        // inca$ - aggiunta gestione search
        function searchForm (field, type, domain) {
        	$uibModal.open({
                templateUrl: 'app/search/search-dialog.html',
                controller: 'SearchController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                	pScope: function() {
                        return $scope;
                    },
                    search: function() {
                        return DecisioneSearch;
                    },
                    controller: function() {
                        return vm;
                    },
                    field: function() {
                        return field;
                    },
                    type: function() {
                        return type;
                    },
                    domain: function() {
                        return domain;
                    }
                }
            }).result.then(function() {
                //$state.go('decisione', null, { reload: 'decisione' });
            }, function() {
                //$state.go('^');
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .filter('characters', characters);
        
    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
            	// inca$ - per gestire il search
            	//vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            	var e = $element.find('span[jh-sort-by=\'' + values[0] + '\']');
            	if (e.length == 0)
            		e = $element.find('th[jh-sort-by=\'' + values[0] + '\']');
            	vm.applyClass(e);
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('ordiniApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
   	    // inca$ - traduzione testo 
        template: '<div class="info">' +
                    'Lista {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
                    'di {{$ctrl.queryCount}} elementi.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('ordiniApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils ($filter) {

        var service = {
            convertDateTimeFromServer : convertDateTimeFromServer,
            convertLocalDateFromServer : convertLocalDateFromServer,
            convertLocalDateToServer : convertLocalDateToServer,
            dateformat : dateformat
        };

        return service;

        function convertDateTimeFromServer (date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer (date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer (date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat () {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            downloadFile: downloadFile,
            previewFile: previewFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
        	// inca$ - non più funzionante su chrome a causa dell'errore
        	// Not allowed to navigate top frame to data URL
            //$window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        	// inoltre la dimensione del data: in alcuni browser non deve superare dei limiti, per Chrome è 2MB
        	// vedi https://stackoverflow.com/questions/695151/data-protocol-url-size-limitations
        	
        	var bBlobUrl = true;
        	
        	var byteCharacters = atob(data);
        	if (byteCharacters.length < 1024 * 1024) // il limite è di 2 MB, però lo poniamo a 1 MB
        		bBlobUrl = false;
        	else {
        		bBlobUrl = true;

            	var byteNumbers = new Array(byteCharacters.length);
            	for (var i = 0; i < byteCharacters.length; i++) {
            	    byteNumbers[i] = byteCharacters.charCodeAt(i);
            	}
            	var byteArray = new Uint8Array(byteNumbers);
            	var blob = new Blob([byteArray], {type: type});
            	var blobUrl = window.URL.createObjectURL(blob);
        	}
        	
			if (bBlobUrl)
				var srcUrl = 'src="'+blobUrl+'" ';
			else
				var srcUrl = 'src="data:'+type+';base64,'+data+'" ';

        	var win = window.open();
        	win.document.write('<iframe '+
        			'width="'+(window.innerWidth-20)+'" '+
        			'height="'+(window.innerHeight-20)+'" '+
        			'id="pdfFrame" '+
        			'frameborder="0" '+
        			srcUrl+
        			//'sandbox="allow-same-origin allow-scripts allow-popups allow-forms" '+
        			'allowfullscreen>'+
        			'</iframe>');
        	
			if (bBlobUrl)
				window.URL.revokeObjectURL(blobUrl);
        }

        // inca$ - download file
        function downloadFile (type, data, filename) {

        	var bBlobUrl = true;
        	
        	var byteCharacters = atob(data);
        	if (byteCharacters.length < 1024 * 1024) // il limite è di 2 MB, però lo poniamo a 1 MB
        		bBlobUrl = false;
        	else {
        		bBlobUrl = true;

            	var byteNumbers = new Array(byteCharacters.length);
            	for (var i = 0; i < byteCharacters.length; i++) {
            	    byteNumbers[i] = byteCharacters.charCodeAt(i);
            	}
            	var byteArray = new Uint8Array(byteNumbers);
            	var blob = new Blob([byteArray], {type: type});
            	var blobUrl = window.URL.createObjectURL(blob);
        	}
        	
			if (bBlobUrl) {
	        	$("<a />", {
	          	  	  href: blobUrl,
	            	  download: filename
	            	})
	            	.appendTo("body")
	            	.get(0)
	            	.click();
			} else {
	        	$("<a />", {
	            	  href: 'data:' + type + ';base64,' + data,
	            	  download: filename
	            	})
	            	.appendTo("body")
	            	.get(0)
	            	.click();
			}

			if (bBlobUrl)
				window.URL.revokeObjectURL(blobUrl);

        }

        
        // inca$ - preview file
        function previewFile (type, data) {
	        
        	var bBlobUrl = true;
        	
        	var byteCharacters = atob(data);
        	if (byteCharacters.length < 1024 * 1024) // il limite è di 2 MB, però lo poniamo a 1 MB
        		bBlobUrl = false;
        	else {
        		bBlobUrl = true;

            	var byteNumbers = new Array(byteCharacters.length);
            	for (var i = 0; i < byteCharacters.length; i++) {
            	    byteNumbers[i] = byteCharacters.charCodeAt(i);
            	}
            	var byteArray = new Uint8Array(byteNumbers);
            	var blob = new Blob([byteArray], {type: type});
            	var blobUrl = window.URL.createObjectURL(blob);
        	}
        	
			if (bBlobUrl)
				var srcUrl = 'src="'+blobUrl+'" ';
			else
				var srcUrl = 'src="data:'+type+';base64,'+data+'" ';

			var win = window.open();
	    	win.document.write('<iframe '+
	    			'width="'+(window.innerWidth-20)+'" '+
	    			'height="'+(window.innerHeight-20)+'" '+
	    			'id="pdfFrame" '+
	    			'frameborder="0" '+
	    			srcUrl+
	    			'allowfullscreen>'+
	    			'</iframe>');

	    	if (bBlobUrl)
				window.URL.revokeObjectURL(blobUrl);
	    	
        }
        
        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('ordiniApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance', 'Permissions'];

    function LoginController ($rootScope, $state, $timeout, Auth, $uibModalInstance, Permissions) {
        var vm = this;

        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = false; // inca $ - cambio default
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;

        $timeout(function (){angular.element('#username').focus();});

        function cancel () {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login (event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }

                $rootScope.$broadcast('authenticationSuccess');

                // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                // since login is succesful, go to stored previousState and clear previousState
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                // inca$ - inizializzazione caricamento ruoli e permessi
                if (Permissions != null) {
                    Permissions.loadRoles();
                    Permissions.loadPermissionTree();
                }
                
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register () {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword () {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'cs': 'Český',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'it': 'Italiano',
                'ja': '日本語',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sk': 'Slovenský',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'tr': 'Türkçe',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文'
            }[lang];
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('ordiniApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            // inca$ - elimino l'inglese
            //'en',
            'it'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(paginationConfig);

    // inca$ - aggiunto per evitare l'errore 
    // Error: [$injector:strictdi] paginationConfig is not using explicit annotation and cannot be invoked in strict mode
    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('ordiniApp')
        .config(pagerConfig);

    // inca$ - aggiunto per evitare l'errore 
    // Error: [$injector:strictdi] pagerConfig is not using explicit annotation and cannot be invoked in strict mode
    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('ordiniApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        // inca$
                        timeout: 50000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('ordiniApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var errorHeader = httpResponse.headers('X-ordiniApp-error');
                var entityKey = httpResponse.headers('X-ordiniApp-params');
                if (errorHeader) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('ordiniApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

                // inca$ - gestione della security
            case 403:
                addErrorAlert('Not permitted','error.permission.denied');
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('ordiniApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var alertKey = response.headers('X-ordiniApp-alert');
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers('X-ordiniApp-params')});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('ordiniApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    
    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector'];

    function authExpiredInterceptor($rootScope, $q, $injector) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            // If we have an unauthorized request we redirect to the login page
            // Don't do this check on the account API to avoid infinite loop
            if (response.status === 401 && angular.isDefined(response.data.path) && response.data.path.indexOf('/api/account') === -1) {
                var Auth = $injector.get('Auth');
                var to = $rootScope.toState;
                var params = $rootScope.toStateParams;
                Auth.logout();
                if (to.name !== 'accessdenied') {
                    Auth.storePreviousState(to.name, params);
                }
                var LoginService = $injector.get('LoginService');
                LoginService.open();
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precendence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                
                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
                
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('ordiniApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to prefered language "en"');
                // inca$ - linguaggio preferito è italiano
                //$cookies.putObject(name, 'en');
                $cookies.putObject(name, 'it');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });

        $translateProvider.preferredLanguage('en');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);
        
        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('ordiniApp')
        .constant('VERSION', "1.2.29")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();

// inca$ - questa classe l'ho aggiunta per la gestione personalizzata dei campi in autocomplete
function TypeaheadCtrl($scope, $http, $state) {

  var _selected;

  $scope.selected = undefined;
  // Any function returning a promise object can be used to load values asynchronously
  $scope.getValue = function(val) {
	var name = document.activeElement.name;
	if (val.length<=10) {
		//var funzione = $state.current.parent;
		var funzione = $scope.functionNameForAutocomplete;
		return $http.get('api/'+funzione+'s/'+name, {
	//      params: {
	//        address: val,
	//        sensor: false
	//      }
	    }).then(function(response){
	      return response.data.map(function(item){
	        //return item.fondiProgetto;
	    	eval("var responseList = "+"item."+name);
	    	return responseList;
	      });
	    });
	}
	else {
		return null;
	}
  };

  $scope.ngModelOptionsSelected = function(value) {
    if (arguments.length) {
      _selected = value;
    } else {
      return _selected;
    }
  };

  $scope.modelOptions = {
    debounce: {
      default: 500,
      blur: 250
    },
    getterSetter: true
  };

}

TypeaheadCtrl.$inject = ["$scope", "$http", "$state"];

angular.module('ordiniApp').controller('TypeaheadCtrl', TypeaheadCtrl);
(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$stateParams', '$uibModalInstance', 'entity', 'User', 'JhiLanguageService'];

    function UserManagementDialogController ($stateParams, $uibModalInstance, entity, User, JhiLanguageService) {
        var vm = this;

        // inca$ - aggiunta ruoli
        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SUPERUTENTE', 'ROLE_COMPILATORE', 'ROLE_RESPONSABILE_DEI_FONDI', 'ROLE_AMMINISTRAZIONE', 'ROLE_DIRETTORE'];
        vm.clear = clear;
        vm.languages = null;
        vm.save = save;
        vm.user = entity;


        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController ($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load (login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management?page&sort',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'userManagement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                }
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort)
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]

            }        })
        .state('user-management-detail', {
            parent: 'admin',
            url: '/user/:login',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'user-management.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management.new', {
            parent: 'user-management',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            parent: 'user-management',
            url: '/{login}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management.delete', {
            parent: 'user-management',
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants, JhiLanguageService) {
        var vm = this;

        // inca$ - aggiunta ruoli
        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_SUPERUTENTE', 'ROLE_COMPILATORE', 'ROLE_RESPONSABILE_DEI_FONDI', 'ROLE_AMMINISTRAZIONE', 'ROLE_DIRETTORE'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;

        vm.loadAll();
        
        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll () {
            User.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            //hide anonymous user from user management: it's a required user for Spring Security
            var hiddenUsersSize = 0;
            for (var i in data) {
                if (data[i]['login'] === 'anonymoususer') {
                    data.splice(i, 1);
                    hiddenUsersSize++;
                }
            }
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count') - hiddenUsersSize;
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear () {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort () {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition () {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-tracker', {
            parent: 'admin',
            url: '/tracker',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'tracker.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/tracker/tracker.html',
                    controller: 'JhiTrackerController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tracker');
                    return $translate.refresh();
                }]
            },
            onEnter: ['JhiTrackerService', function(JhiTrackerService) {
                JhiTrackerService.subscribe();
            }],
            onExit: ['JhiTrackerService', function(JhiTrackerService) {
                JhiTrackerService.unsubscribe();
            }]
        });
    }
})();

(function() {
    'use strict';
    /* globals SockJS, Stomp */

    angular
        .module('ordiniApp')
        .factory('JhiTrackerService', JhiTrackerService);

    JhiTrackerService.$inject = ['$rootScope', '$window', '$cookies', '$http', '$q'];

    function JhiTrackerService ($rootScope, $window, $cookies, $http, $q) {
        var stompClient = null;
        var subscriber = null;
        var listener = $q.defer();
        var connected = $q.defer();
        var alreadyConnectedOnce = false;

        var service = {
            connect: connect,
            disconnect: disconnect,
            receive: receive,
            sendActivity: sendActivity,
            subscribe: subscribe,
            unsubscribe: unsubscribe
        };

        return service;

        function connect () {
            //building absolute path so that websocket doesnt fail when deploying with a context path
            var loc = $window.location;
            var url = '//' + loc.host + loc.pathname + 'websocket/tracker';
            var socket = new SockJS(url);
            stompClient = Stomp.over(socket);
            var stateChangeStart;
            var headers = {};
            headers[$http.defaults.xsrfHeaderName] = $cookies.get($http.defaults.xsrfCookieName);
            stompClient.connect(headers, function() {
                connected.resolve('success');
                sendActivity();
                if (!alreadyConnectedOnce) {
                    stateChangeStart = $rootScope.$on('$stateChangeStart', function () {
                        sendActivity();
                    });
                    alreadyConnectedOnce = true;
                }
            });
            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
            });
        }

        function disconnect () {
            if (stompClient !== null) {
                stompClient.disconnect();
                stompClient = null;
            }
        }

        function receive () {
            return listener.promise;
        }

        function sendActivity() {
            if (stompClient !== null && stompClient.connected) {
                stompClient
                    .send('/topic/activity',
                    {},
                    angular.toJson({'page': $rootScope.toState.name}));
            }
        }

        function subscribe () {
            connected.promise.then(function() {
                subscriber = stompClient.subscribe('/topic/tracker', function(data) {
                    listener.notify(angular.fromJson(data.body));
                });
            }, null, null);
        }

        function unsubscribe () {
            if (subscriber !== null) {
                subscriber.unsubscribe();
            }
            listener = $q.defer();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('JhiTrackerController', JhiTrackerController);

    JhiTrackerController.$inject = ['$cookies', '$http', 'JhiTrackerService'];

    function JhiTrackerController ($cookies, $http, JhiTrackerService) {
        // This controller uses a Websocket connection to receive user activities in real-time.
        var vm = this;

        vm.activities = [];

        JhiTrackerService.receive().then(null, null, function(activity) {
            showActivity(activity);
        });

        function showActivity(activity) {
            var existingActivity = false;
            for (var index = 0; index < vm.activities.length; index++) {
                if(vm.activities[index].sessionId === activity.sessionId) {
                    existingActivity = true;
                    if (activity.page === 'logout') {
                        vm.activities.splice(index, 1);
                    } else {
                        vm.activities[index] = activity;
                    }
                }
            }
            if (!existingActivity && (activity.page !== 'logout')) {
                vm.activities.push(activity);
            }
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('StorageMigrationService', StorageMigrationService);

    StorageMigrationService.$inject = ['$resource'];

    function StorageMigrationService ($resource) {
        var service = $resource('management/storage/migrate/:id', {}, {
            'migrate': {
                method: 'GET'
            },
            'migrateByDate': {
                method: 'GET',
                params: {fromDate: null, toDate: null}
	        }
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('StorageDialogController', StorageDialogController);

    StorageDialogController.$inject = ['$filter', '$uibModalInstance', 'StorageMigrationService', 'controller', 'goType'];

    function StorageDialogController($filter, $uibModalInstance, StorageMigrationService, controller, goType) {
        var vm = this;

        vm.controller=controller;
        vm.clear = clear;
        vm.confirmMigration = confirmMigration;
        vm.disabled=false;
        vm.selCounter=0;

        function disabled() {
            $uibModalInstance.dismiss('cancel');
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmMigration() {
        	//console.log(goType);
    		//console.log(vm.controller.storageSelectedItems);
            vm.disabled=true;

        	if (goType=='all') {
	            var dateFormat = 'yyyy-MM-dd';
	            var fromDate = $filter('date')(controller.fromDate, dateFormat);
	            var toDate = $filter('date')(controller.toDate, dateFormat);

	            StorageMigrationService.migrateByDate({fromDate: fromDate, toDate: toDate}, function(result, headers){
	                //vm.storage = result;
	                $uibModalInstance.close(true);
        			controller.onChangeDate();
	            });
        	} else if (goType=='selected') {
        		
                var totalItems = controller.storageSelectedItems.length;
                vm.selCounter=totalItems;
                var storageItems=[];
                for(var i=0; i < totalItems; i++) {
                	var decisione = controller.storageSelectedItems[i].decisione;

                	StorageMigrationService.migrate({id: decisione.id}, function(result, headers) {
    	                //vm.storage = result;
                		vm.selCounter--;
                		if (vm.selCounter==0) {
                            $uibModalInstance.close(true);
                			controller.onChangeDate();
                		}
    	            });
                }
        	}
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('storage', {
            parent: 'admin',
            url: '/storage',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'storage.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/storage/storage.html',
                    controller: 'StorageController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('storage');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('StorageService', StorageService);

    StorageService.$inject = ['$resource'];

    function StorageService ($resource) {
        var service = $resource('management/storage/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
	        }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('StorageController', StorageController);

    StorageController.$inject = ['$filter', '$scope', '$uibModal', 'StorageService', 'ParseLinks'];

    function StorageController ($filter, $scope, $uibModal, StorageService, ParseLinks) {
        var vm = this;

        vm.storage = null;
        vm.storageItems = null;
        vm.storageSelectedItems = [];
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.go=go;
        
        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        $scope.$watch('vm.storageItems', function(newValues){
        	vm.storageSelectedItems.length = 0;
            angular.forEach(newValues, function(item) {
                if (item.value == true) {
                	vm.storageSelectedItems.push(item);
                }
            });
            //console.log(vm.storageSelectedItems);
        }, true);
        
        
        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            StorageService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.storage = result;
                vm.links = ParseLinks.parse(headers('link'));
            	vm.totalItems = headers('X-Total-Count');
            	var pageItems = vm.storage.length;
                vm.storageItems=[];
                for(var i=0; i < pageItems; i++) {
                	vm.storageItems = vm.storageItems.concat([{ decisione : vm.storage[i], value: false}]);
                }
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }

        function go (goType) {
        	
	        $uibModal.open({
	            templateUrl: 'app/admin/storage/storage-dialog.html',
	            controller: 'StorageDialogController',
	            controllerAs: 'vm',
	            size: 'sm',
	            resolve: {
	                controller: function() {
	                    return vm;
	                },
	        		goType: function() {
	                    return goType;
	                }
	            }
	        }).result.finally(function () {
	            $state.go('^');
	        });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/jhipster/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            vm.cachesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
                if (key.indexOf('net.sf.ehcache.Cache') !== -1) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    vm.cachesStats[newKey] = {
                        'name': newKey,
                        'value': value
                    };
                }
            });
        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/jhipster/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('ordiniApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('ElasticsearchReindexDialogController', ElasticsearchReindexDialogController);

    ElasticsearchReindexDialogController.$inject = ['$uibModalInstance', 'ElasticsearchReindex'];

    function ElasticsearchReindexDialogController($uibModalInstance, ElasticsearchReindex) {
        var vm = this;

        vm.clear = clear;
        vm.confirmReindex = confirmReindex;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmReindex() {
            ElasticsearchReindex.reindex(function () {
                $uibModalInstance.close(true);
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('elasticsearch-reindex', {
            parent: 'admin',
            url: '/elasticsearch-reindex',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'elasticsearch.reindex.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/elasticsearch-reindex/elasticsearch-reindex.html',
                    controller: 'ElasticsearchReindexController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('elasticsearch-reindex');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        }).state('elasticsearch-reindex.dialog', {
            parent: 'elasticsearch-reindex',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/elasticsearch-reindex/elasticsearch-reindex-dialog.html',
                    controller: 'ElasticsearchReindexDialogController',
                    controllerAs: 'vm',
                    size: 'sm'
                }).result.finally(function () {
                    $state.go('^');
                });
            }]
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('ElasticsearchReindex', ElasticsearchReindex);

    ElasticsearchReindex.$inject = ['$resource'];

    function ElasticsearchReindex($resource) {
        var service = $resource('api/elasticsearch/index', {}, {
            'reindex': {method: 'POST'}
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('ElasticsearchReindexController', ElasticsearchReindexController);

    ElasticsearchReindexController.$inject = [];

    function ElasticsearchReindexController() {
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/jhipster/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate'];

    function SettingsController (Principal, Auth, JhiLanguageService, $translate) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('sessions', {
            parent: 'account',
            url: '/sessions',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.sessions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/sessions/sessions.html',
                    controller: 'SessionsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sessions');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('SessionsController', SessionsController);

    SessionsController.$inject = ['Sessions', 'Principal'];

    function SessionsController (Sessions, Principal) {
        var vm = this;

        vm.account = null;
        vm.error = null;
        vm.invalidate = invalidate;
        vm.sessions = Sessions.getAll();
        vm.success = null;


        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function invalidate (series) {
            Sessions.delete({series: encodeURIComponent(series)},
                function () {
                    vm.error = null;
                    vm.success = 'OK';
                    vm.sessions = Sessions.getAll();
                },
                function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'e-mail address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService'];

    function RegisterController ($translate, $timeout, Auth, LoginService) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#login').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey = $translate.use();
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && response.data === 'login already in use') {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'e-mail address already in use') {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small data-translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penality (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penality (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();
(function(){angular.module('ordiniApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/home/home.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="ibpm-ordini img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="home.title">Welcome, Java Hipster!</h1><p class="lead" data-translate="home.subtitle">This is your homepage</p><div ng-switch="vm.isAuthenticated()"><div class="alert alert-success" ng-switch-when="true" data-translate="home.logged.message" translate-values="{username: \'{{vm.account.login}}\'}">You are logged in as user "{{vm.account.login}}".</div><!--             <div class="alert alert-success" --><div><div>Contatti: <a href="https://www.ibpm.cnr.it/index.php?option=com_cnr&view=profile&id=551&lang=en" target="_blank">Mario Incarnato</a>, email: <a href="mailto:mario.incarnato@cnr.it">mario.incarnato@cnr.it</a></div><!--                 <div class="alert alert-warning" ng-switch-when="false" data-translate="global.messages.info.authenticated" translate-compile> --><!--                     If you want to <a class="alert-link" href="" ng-click="vm.login()">sign in</a>, you can try the default accounts:<br/>- Administrator (login="admin" and password="admin") <br/>- User (login="user" and password="user"). --><!--                 </div> --><!--                 <div class="alert alert-warning" ng-switch-when="false" data-translate="global.messages.info.register" translate-compile> --><!--                     You don\'t have an account yet? <a class="alert-link" ui-sref="register">Register a new account</a> --><!--                 </div> --></div></div><br><ul><li><a href="http://www.ibpm.cnr.it/" target="_blank" data-translate="home.link.ibpmhomepage">Homepage IBPM</a></li><li><a href="http://www.cnr.it" target="_blank" data-translate="home.link.cnrhomepage">Homepage CNR</a></li><li><a href="http://apps.ibpm.cnr.it/f2f/index" data-translate="home.link.f2fhomepage">IBPM Face2Face</a></li></ul><br><div ng-switch="vm.isAuthenticated()"><div class="alert alert-success" ng-switch-when="true"><div>Manuali e documentazione:</div><br><ul><li><a href="https://drive.google.com/file/d/1HtaIQf2iF1_h77xPTumS3bhRgvhgyeh9/view?usp=sharing" data-translate="home.link.manualesint">Manuale d\'uso sintetico</a></li><li><a href="https://drive.google.com/file/d/1V6yTppUK85B2TD7HRAguM7EC1LWGdbM1/view?usp=sharing" data-translate="home.link.manuale">Manuale d\'uso completo</a></li><li><a href="https://drive.google.com/file/d/1UTCvwZ_WxTJg68-mKKsmGkAWkI8F94NS/view?usp=sharing" data-translate="home.link.rapptec">Analisi, progettazione e realizzazione Ordini per la Ricerca</a></li><li><a href="https://drive.google.com/drive/folders/1vALywPOyhzFVuJJI7vh7XFmsgQsZS5Gg?usp=sharing" data-translate="home.link.dochomepage">Dichiarazioni di Esclusivit\uFFFD ed Unicit\uFFFD</a></li></ul></div></div></div></div></div>');
$templateCache.put('app/search/search-dialog.html','<form name="searchForm" ng-submit=""><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Aggiungere la condizione di ricerca</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-horizontal"><div class="form-group"><label class="col-sm-4 control-label">Condizione:</label><div class="col-sm-2"><select class="form-control" ng-model="vm.condition" ng-disabled="vm.isFirstCondition()"><option value="AND">e</option><option value="OR">o</option></select></div></div><div class="form-group" ng-hide="vm.isBoolean()"><label class="col-sm-4 control-label">Relazione:</label><div class="col-sm-5"><select class="form-control" ng-model="vm.relations.model"><option ng-repeat="option in vm.relations.availableOptions" value="{{option.id}}">{{option.name}}</option></select></div></div><!-- primo caso - campo generico --><div class="form-group" ng-show="vm.isText()"><label class="col-sm-4 control-label">Valore iniziale:</label><div class="col-sm-8"><input type="text" class="form-control" ng-model="vm.valoreIniziale" placeholder="Valore iniziale"></div></div><div class="form-group" ng-show="vm.isText()"><label class="col-sm-4 control-label">Valore finale:</label><div class="col-sm-8"><input type="text" class="form-control" ng-model="vm.valoreFinale" placeholder="Valore finale" ng-disabled="vm.isOnlyOneCondition()"></div></div><!-- secondo caso - campo data --><div class="form-group" ng-show="vm.isDate()"><label class="col-sm-4 control-label">Data iniziale:</label><div class="col-sm-8"><div class="input-group"><input type="text" class="form-control" ng-model="vm.dataIniziale" placeholder="Data iniziale" uib-datepicker-popup="{{vm.dateformat}}" is-open="vm.datePickerOpenStatus.dataIniziale" clear-text="Pulisci" current-text="Oggi" close-text="Chiudi"> <span class="input-group-btn"><button type="button" class="form-control" ng-click="vm.openCalendar(\'dataIniziale\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="form-group" ng-show="vm.isDate()"><label class="col-sm-4 control-label">Data finale:</label><div class="col-sm-8"><div class="input-group"><input type="text" class="form-control" ng-model="vm.dataFinale" placeholder="Data finale" ng-disabled="vm.isOnlyOneCondition()" uib-datepicker-popup="{{vm.dateformat}}" is-open="vm.datePickerOpenStatus.dataFinale" clear-text="Pulisci" current-text="Oggi" close-text="Chiudi"> <span class="input-group-btn"><button type="button" class="form-control" ng-click="vm.openCalendar(\'dataFinale\')" ng-disabled="vm.isOnlyOneCondition()"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><!-- terzo caso - campo data e ora--><div class="form-group" ng-show="vm.isDatetime()"><label class="col-sm-4 control-label">Data e ora iniziale:</label><div class="col-sm-8"><div class="input-group"><input type="text" class="form-control" ng-model="vm.dataOraIniziale" placeholder="Data iniziale" datetime-picker="{{vm.datetimeformat}}" is-open="vm.datePickerOpenStatus.dataOraIniziale" clear-text="Pulisci" current-text="Oggi" close-text="Chiudi"> <span class="input-group-btn"><button type="button" class="form-control" ng-click="vm.openCalendar(\'dataOraIniziale\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="form-group" ng-show="vm.isDatetime()"><label class="col-sm-4 control-label">Data e ora finale:</label><div class="col-sm-8"><div class="input-group"><input type="text" class="form-control" ng-model="vm.dataOraFinale" placeholder="Data finale" ng-disabled="vm.isOnlyOneCondition()" datetime-picker="{{vm.datetimeformat}}" is-open="vm.datePickerOpenStatus.dataOraFinale" clear-text="Pulisci" current-text="Oggi" close-text="Chiudi"> <span class="input-group-btn"><button type="button" class="form-control" ng-click="vm.openCalendar(\'dataOraFinale\')" ng-disabled="vm.isOnlyOneCondition()"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><!-- quarto caso - campo dominio--><div class="form-group" ng-show="vm.isDomain()"><label class="col-sm-4 control-label">Valori:</label><div class="col-sm-8"><select class="form-control" ng-model="vm.domains.model" ng-attr-size="{{vm.domains.availableOptions.length}}" multiple="multiple"><option ng-repeat="option in vm.domains.availableOptions" value="{{option.id}}">{{option.name}}</option></select></div></div><!-- quinto caso - campo boolean--><div class="form-group" ng-show="vm.isBoolean()"><label class="col-sm-4 control-label">Valore di selezione:</label><div class="col-sm-8"><input type="checkbox" class="form-control" ng-model="vm.valoreIniziale" placeholder="Valore di selezione"></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-info" ng-click="vm.addCondition()"><span class="glyphicon glyphicon-ok-circle"></span>&nbsp;<span>Aggiungi</span></button> <button type="submit" class="btn btn-primary" ng-click="vm.confirmSearch()"><span class="glyphicon glyphicon-search"></span>&nbsp;<span>Cerca</span></button></div></form>');
$templateCache.put('app/util/entity-reject.html','<form name="rejectForm" ng-submit="vm.confirm()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Motivazione del rifiuto alla validazione</h4></div><div class="modal-body"><div class="form-group" ng-if="vm.error!=null"><textarea rows="3" class="form-control alert-danger-inca" ng-model="vm.error"></textarea></div><jhi-alert-error></jhi-alert-error><p>Inserire la motivazione del rifiuto alla validazione della {{vm.entityName}}</p><hr><div class="form-group"><label class="control-label" data-translate="ordiniApp.{{vm.entityName}}.motivazioneRifiuto" for="field_motivazioneRifiuto">Motivazione Rifiuto</label><textarea rows="5" class="form-control" name="motivazioneRifiuto" id="field_motivazioneRifiuto" ng-model="vm.motivazioneRifiuto"></textarea><!-- IMPORTANTE non staccare i tag apertura e chiusura di texarea --></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annulla</span></button> <button type="submit" class="btn btn-primary"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Rifiuta</span></button></div></form>');
$templateCache.put('app/admin/audits/audits.html','<div><h2 data-translate="audits.title">Audits</h2><div class="row"><div class="col-md-5"><h4 data-translate="audits.filter.title">Filter by date</h4><p class="input-group"><span class="input-group-addon" data-translate="audits.filter.from">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon" data-translate="audits.filter.to">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span data-translate="audits.table.header.date">Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span data-translate="audits.table.header.principal">User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span data-translate="audits.table.header.status">State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span data-translate="audits.table.header.data">Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span data-translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2 data-translate="configuration.title">Configuration</h2><span data-translate="configuration.filter">Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><label ng-hide="filteredConfig.length == 0">Spring configuration</label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length == 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span data-translate="configuration.table.prefix">Prefix</span></th><th data-translate="configuration.table.properties" class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length == 0"><span>{{key}}</span></label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length == 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top"></iframe>');
$templateCache.put('app/admin/elasticsearch-reindex/elasticsearch-reindex-dialog.html','<form name="reindexForm" ng-submit="vm.confirmReindex()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="elasticsearch.reindex.dialog.title">Confirm reindex operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="elasticsearch.reindex.dialog.question">Are you sure you want to reindex Elasticsearch? This could take a while!</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span data-translate="elasticsearch.reindex.dialog.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-exclamation-sign"></span>&nbsp; <span data-translate="elasticsearch.reindex.dialog.confirm">Reindex</span></button></div></form>');
$templateCache.put('app/admin/elasticsearch-reindex/elasticsearch-reindex.html','<div class="clearfix"><h1 data-translate="elasticsearch.reindex.title">Reindex Elasticsearch</h1><jhi-alert></jhi-alert><p data-translate="elasticsearch.reindex.instructions1">This will send a request to reindex all data from your primary datasource into Elasticsearch. This will fix missing data and mapping issues, however you will lose any ES data and mapping that was defined outside of your application. This request will return immediately and the reindexing will run in the background. You will see "Elasticsearch: Successfully performed reindexing" in your logs when this is complete.</p><p data-translate="elasticsearch.reindex.instructions2">This can take a long time and is susceptible to concurrency issues so it should be performed when the number of users is low.</p><button type="button" class="btn btn-primary pull-right" ui-sref="elasticsearch-reindex.dialog"><span class="glyphicon glyphicon-exclamation-sign"></span> <span data-translate="elasticsearch.reindex.go">Go</span></button></div>');
$templateCache.put('app/admin/health/health.html','<div><h2 data-translate="health.title">Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="health.refresh.button">Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7" data-translate="health.table.service">Service Name</th><th class="col-md-2 text-center" data-translate="health.table.status">Status</th><th class="col-md-2 text-center" data-translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4 data-translate="health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" data-translate="health.details.name">Name</th><th class="col-md-6 text-left" data-translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 data-translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2 data-translate="logs.title">Logs</h2><p data-translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</p><span data-translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span data-translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span data-translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/storage/storage-dialog.html','<form name="reindexForm" ng-submit="vm.confirmMigration()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="storage.dialog.title">Conferma avvio migrazione</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="storage.dialog.question">Sei sicuro che vuoi migrare in S3 storage i documenti selezionati?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()" ng-disabled="vm.disabled"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp; <span data-translate="storage.dialog.cancel">Annulla</span></button> <button type="submit" class="btn btn-danger" ng-disabled="vm.disabled"><span class="glyphicon glyphicon-exclamation-sign"></span>&nbsp; <span data-translate="storage.dialog.confirm">Avvia migrazione</span></button></div></form>');
$templateCache.put('app/admin/storage/storage.html','<div><h2 data-translate="storage.title">Storage</h2><br><h4 data-translate="storage.filter.title">Filter by date</h4><br><div class="row"><div class="col-md-5"><p class="input-group"><span class="input-group-addon" data-translate="storage.filter.from">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon" data-translate="storage.filter.to">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'value\'; reverse=!reverse"><span data-translate="storage.table.header.sel">Seleziona</span></th><th ng-click="predicate = \'decisione.id\'; reverse=!reverse"><span data-translate="storage.table.header.id">ID</span></th><th ng-click="predicate = \'decisione.data\'; reverse=!reverse"><span data-translate="storage.table.header.data">Data</span></th><th ng-click="predicate = \'decisione.impegno.codice\'; reverse=!reverse"><span data-translate="storage.table.header.impegno">Impegno</span></th></tr></thead><tr ng-repeat="item in vm.storageItems | filter:filter | orderBy:predicate:reverse" ng-hide="item.decisione.filtered"><td><input type="checkbox" ng-model="item.value"></td><td><small>{{item.decisione.id}}</small></td><td><span>{{item.decisione.data| date:\'mediumDate\'}}</span></td><td>{{item.decisione.impegno.codice}}</td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination><div class="text-right"><button type="button" class="btn btn-primary" ng-click="vm.go(\'selected\')"><span class="glyphicon glyphicon-exclamation-sign"></span> <span data-translate="storage.go-selected">Go selected</span></button> <button type="button" class="btn btn-primary" ng-click="vm.go(\'all\')"><span class="glyphicon glyphicon-exclamation-sign"></span> <span data-translate="storage.go">Go all</span></button></div></div></div><br><jhi-alert-error></jhi-alert-error>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2 data-translate="metrics.title">Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="metrics.refresh.button">Refresh</span></button></p><h3 data-translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b data-translate="metrics.jvm.memory.title">Memory</b><p><span data-translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span data-translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" data-translate="metrics.updating">Updating...</div><h3 data-translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span data-translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span data-translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.jvm.http.table.code">Code</th><th data-translate="metrics.jvm.http.table.count">Count</th><th class="text-right" data-translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td data-translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" data-translate="metrics.servicesstats.table.count">Count</th><th class="text-right" data-translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" data-translate="metrics.servicesstats.table.min">Min</th><th class="text-right" data-translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" data-translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" data-translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" data-translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" data-translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 data-translate="metrics.ehcache.title">Ehcache statistics</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.ehcache.cachename">Cache name</th><th class="text-right" data-translate="metrics.ehcache.objects">Objects</th><th class="text-right" data-translate="metrics.ehcache.hits">Hits</th><th class="text-right" data-translate="metrics.ehcache.misses">Misses</th><th class="text-right" data-translate="metrics.ehcache.evictioncount">Eviction count</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.cachesStats" ng-once><td>{{v.name}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.objects\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.hits\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.misses\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.eviction-count\'].value}}</td></tr></tbody></table></div><h3 data-translate="metrics.datasource.title" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span data-translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right" data-translate="metrics.datasource.count">Count</th><th class="text-right" data-translate="metrics.datasource.mean">Mean</th><th class="text-right" data-translate="metrics.datasource.min">Min</th><th class="text-right" data-translate="metrics.datasource.p50">p50</th><th class="text-right" data-translate="metrics.datasource.p75">p75</th><th class="text-right" data-translate="metrics.datasource.p95">p95</th><th class="text-right" data-translate="metrics.datasource.p99">p99</th><th class="text-right" data-translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show" data-translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" data-translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th data-translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/tracker/tracker.html','<div><h2 data-translate="tracker.title">Real-time user activities</h2><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="tracker.table.userlogin">User</th><th data-translate="tracker.table.ipaddress">IP Address</th><th data-translate="tracker.table.page">Current page</th><th data-translate="tracker.table.time">Time</th><th></th></tr></thead><tbody><tr ng-repeat="activity in vm.activities"><td>{{activity.userLogin}}</td><td>{{activity.ipAddress}}</td><td>{{activity.page}}</td><td>{{activity.time}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="userManagement.delete.question" translate-values="{login: \'{{vm.user.login}}\'}">Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div><h2><span data-translate="userManagement.detail.title">User</span> "{{vm.user.login}}"</h2><dl class="dl-horizontal"><dt><span data-translate="userManagement.login">Login</span></dt><dd><span>{{vm.user.login}}</span></dd><dt><span data-translate="userManagement.firstName">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span data-translate="userManagement.lastName">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span data-translate="userManagement.email">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span data-translate="userManagement.activated">Activated</span></dt><dd>{{vm.user.activated}}</dd><dt><span data-translate="userManagement.langKey">Lang Key</span></dt><dd>{{vm.user.langKey}}</dd><dt><span data-translate="userManagement.createdBy">Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span data-translate="userManagement.createdDate">Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span data-translate="userManagement.lastModifiedBy">Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span data-translate="userManagement.profiles">Profiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span>{{authority}}</span></li></ul></dd></dl><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel" data-translate="userManagement.home.createOrEditLabel">Create or edit a User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label data-translate="global.field.id">ID</label><input type="text" class="form-control" name="id" ng-model="vm.user.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="userManagement.login">Login</label><input type="text" class="form-control" name="login" ng-model="vm.user.login" ng-required="vm.user.id == null" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.firstName">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label data-translate="userManagement.lastName">Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.email">Email</label><input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div><div class="form-group"><label for="activated"><input ng-disabled="vm.user.id === null" type="checkbox" id="activated" name="activated" ng-model="vm.user.activated"> <span data-translate="userManagement.activated">Activated</span></label></div><div class="form-group"><label data-translate="userManagement.langKey">Lang Key</label><select class="form-control" name="langKey" ng-model="vm.user.langKey" ng-options="language as language for language in vm.languages track by language"></select></div><div class="form-group"><label data-translate="userManagement.profiles">Profiles</label><select class="form-control" multiple="multiple" name="authority" ng-model="vm.user.authorities" ng-options="authority for authority in vm.authorities"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div><h2 data-translate="userManagement.home.title">Users</h2><jhi-alert></jhi-alert><div class="row"><div class="col-md-4"><button class="btn btn-primary" ui-sref="user-management.new"><span class="glyphicon glyphicon-flash"></span> <span data-translate="userManagement.home.createLabel">Create a new User</span></button></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="login"><span data-translate="userManagement.login">Login</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span data-translate="userManagement.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th></th><th jh-sort-by="langKey"><span data-translate="userManagement.langKey">Lang Key</span> <span class="glyphicon glyphicon-sort"></span></th><th><span data-translate="userManagement.profiles">Profiles</span></th><th jh-sort-by="createdDate"><span data-translate="userManagement.createdDate">Created Date</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedBy"><span data-translate="userManagement.lastModifiedBy">Last Modified By</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lastModifiedDate"><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}</td><td><span class="label label-danger" ng-click="vm.setActive(user, true)" ng-show="!user.activated" data-translate="userManagement.deactivated" style="cursor: pointer">Deactivated</span> <span class="label label-success" ng-click="vm.setActive(user, false)" ng-show="user.activated" data-translate="userManagement.activated" style="cursor: pointer">Activated</span></td><td>{{user.langKey}}</td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td>{{user.createdDate | date:\'dd/MM/yy HH:mm\'}}</td><td>{{user.lastModifiedBy}}</td><td>{{user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-management-detail({login:user.login})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="user-management.edit({login:user.login})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="user-management.delete({login:user.login})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login==user.login"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="activate.title">Activation</h1><div class="alert alert-success" ng-show="vm.success" data-translate="activate.messages.success" translate-compile><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="activate.messages.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="password.title" translate-values="{username: \'{{vm.account.login}}\'}">Password for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="password.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/account/register/register.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="register.title">Registration</h1><div class="alert alert-success" ng-show="vm.success" data-translate="register.messages.success"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="register.messages.error.fail"><strong>Registration failed!</strong> Please try again later.</div><div class="alert alert-danger" ng-show="vm.errorUserExists" data-translate="register.messages.error.userexists"><strong>Login name already registered!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.errorEmailExists" data-translate="register.messages.error.emailexists"><strong>E-mail is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div></div><div class="col-md-8 col-md-offset-2"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation><div class="form-group"><label class="control-label" for="login" data-translate="global.form.username">Username</label><input type="text" class="form-control" id="login" name="login" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.registerAccount.login" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" required><div ng-show="form.login.$dirty && form.login.$invalid"><p class="help-block" ng-show="form.login.$error.required" data-translate="register.messages.validate.login.required">Your username is required.</p><p class="help-block" ng-show="form.login.$error.minlength" data-translate="register.messages.validate.login.minlength">Your username is required to be at least 1 character.</p><p class="help-block" ng-show="form.login.$error.maxlength" data-translate="register.messages.validate.login.maxlength">Your username cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.login.$error.pattern" data-translate="register.messages.validate.login.pattern">Your username can only contain lower-case letters and digits.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.registerAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.registerAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.registerAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="register.form.button">Register</button></form><p></p><div class="alert alert-warning" data-translate="global.messages.info.authenticated" translate-compile>If you want to <a class="alert-link" href="" ng-click="vm.login()">sign in</a>, you can try the default accounts:<br>- Administrator (login="admin" and password="admin")<br>- User (login="user" and password="user").</div></div></div></div>');
$templateCache.put('app/account/sessions/sessions.html','<div><h2 data-translate="sessions.title" translate-values="{username: \'{{vm.account.login}}\'}">Active sessions for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="sessions.messages.success"><strong>Session invalidated!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="sessions.messages.error"><strong>An error has occured!</strong> The session could not be invalidated.</div><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="sessions.table.ipaddress">IP Address</th><th data-translate="sessions.table.useragent">User agent</th><th data-translate="sessions.table.date">Date</th><th></th></tr></thead><tbody><tr ng-repeat="session in vm.sessions"><td>{{session.ipAddress}}</td><td>{{session.userAgent}}</td><td>{{session.tokenDate | date:\'longDate\'}}</td><td><button type="submit" class="btn btn-primary" ng-click="vm.invalidate(session.series)" data-translate="sessions.table.button">Invalidate</button></td></tr></tbody></table></div></div>');
$templateCache.put('app/account/settings/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User settings for [<b>{{vm.settingsAccount.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="settings.messages.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName" data-translate="settings.form.firstname">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" data-translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" data-translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" data-translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName" data-translate="settings.form.lastname">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" data-translate="settings.messages.validate.lastname.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" data-translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" data-translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group"><label for="langKey" data-translate="settings.form.language">Language</label><select id="langKey" name="langKey" class="form-control" ng-model="vm.settingsAccount.langKey" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="settings.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/components/login/login.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="login.title">Sign in</h4></div><div class="modal-body"><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="login.title">Sign in</h1></div><div class="col-md-8 col-md-offset-2"><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="col-md-8 col-md-offset-2"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><label for="username" data-translate="global.form.username">Login</label><input type="text" class="form-control" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username"></div><div class="form-group"><label for="password" data-translate="login.form.password">Password</label><input type="password" class="form-control" id="password" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password"></div><div class="form-group"><label for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span data-translate="login.form.rememberme">Remember me</span></label></div><button type="submit" class="btn btn-primary" data-translate="login.form.button">Sign in</button></form><p></p><!--             <div class="alert alert-warning"> --><!--                 <a class="alert-link" href="" ng-click="vm.requestResetPassword()" data-translate="login.password.forgot">Did you forget your password?</a> --><!--             </div> --><!--             <div class="alert alert-warning" data-translate="global.messages.info.register" translate-compile> --><!--                 You don\'t have an account yet? <a class="alert-link" href="" ng-click="vm.register()">Register a new account</a> --><!--             </div> --></div></div></div>');
$templateCache.put('app/entities/dettaglio-ordine/dettaglio-ordine-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.dettaglioOrdine.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="ordiniApp.dettaglioOrdine.delete.question" translate-values="{id: \'{{vm.dettaglioOrdine.id}}\'}">Are you sure you want to delete this Dettaglio Ordine?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/dettaglio-ordine/dettaglio-ordine-detail.html','<div><h2><span data-translate="ordiniApp.dettaglioOrdine.detail.title">Dettaglio Ordine</span> {{vm.dettaglioOrdine.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="ordiniApp.dettaglioOrdine.quantita">Quantita</span></dt><dd><span>{{vm.dettaglioOrdine.quantita}}</span></dd><dt><span data-translate="ordiniApp.dettaglioOrdine.descrizioneArticolo">Descrizione Articolo</span></dt><dd><span>{{vm.dettaglioOrdine.descrizioneArticolo}}</span></dd><dt><span data-translate="ordiniApp.dettaglioOrdine.codiceArticolo">Codice Articolo</span></dt><dd><span>{{vm.dettaglioOrdine.codiceArticolo}}</span></dd><dt><span data-translate="ordiniApp.dettaglioOrdine.importoUnitario">Importo Unitario</span></dt><dd><span>{{vm.dettaglioOrdine.importoUnitario}}</span></dd><dt><span data-translate="ordiniApp.dettaglioOrdine.percentualeIva">Percentuale Iva</span></dt><dd><span>{{vm.dettaglioOrdine.percentualeIva}}</span></dd><dt><span data-translate="ordiniApp.dettaglioOrdine.descrizioneIva">Descrizione Iva</span></dt><dd><span>{{vm.dettaglioOrdine.descrizioneIva}}</span></dd><!--         <dt><span data-translate="ordiniApp.dettaglioOrdine.utenteCreazione">Utente Creazione</span></dt> --><!--         <dd> --><!--             <span>{{vm.dettaglioOrdine.utenteCreazione}}</span> --><!--         </dd> --><!--         <dt><span data-translate="ordiniApp.dettaglioOrdine.dataCreazione">Data Creazione</span></dt> --><!--         <dd> --><!--             <span>{{vm.dettaglioOrdine.dataCreazione | date:\'medium\'}}</span> --><!--         </dd> --><!--         <dt><span data-translate="ordiniApp.dettaglioOrdine.utenteAggiornamento">Utente Aggiornamento</span></dt> --><!--         <dd> --><!--             <span>{{vm.dettaglioOrdine.utenteAggiornamento}}</span> --><!--         </dd> --><!--         <dt><span data-translate="ordiniApp.dettaglioOrdine.dataAggiornamento">Data Aggiornamento</span></dt> --><!--         <dd> --><!--             <span>{{vm.dettaglioOrdine.dataAggiornamento | date:\'medium\'}}</span> --><!--         </dd> --><!--         <dt><span data-translate="ordiniApp.dettaglioOrdine.versioneRecord">Versione Record</span></dt> --><!--         <dd> --><!--             <span>{{vm.dettaglioOrdine.versioneRecord}}</span> --><!--         </dd> --><dt><span data-translate="ordiniApp.dettaglioOrdine.ordine">Ordine</span></dt><dd><a ui-sref="ordine-detail({id:vm.dettaglioOrdine.ordine.id})">{{vm.dettaglioOrdine.ordine.id}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="dettaglio-ordine-detail.edit({id:vm.dettaglioOrdine.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/dettaglio-ordine/dettaglio-ordine-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDettaglioOrdineLabel" data-translate="ordiniApp.dettaglioOrdine.home.createOrEditLabel">Create or edit a Dettaglio Ordine</h4></div><div class="modal-body" ng-controller="TypeaheadCtrl"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.dettaglioOrdine.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.dettaglioOrdine.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.dettaglioOrdine.quantita" for="field_quantita">Quantita</label><input type="number" class="form-control" name="quantita" id="field_quantita" ng-model="vm.dettaglioOrdine.quantita" required><div ng-show="editForm.quantita.$invalid"><p class="help-block" ng-show="editForm.quantita.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.quantita.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.dettaglioOrdine.descrizioneArticolo" for="field_descrizioneArticolo">Descrizione Articolo</label><textarea rows="3" type="text" class="form-control" name="descrizioneArticolo" id="field_descrizioneArticolo" ng-model="vm.dettaglioOrdine.descrizioneArticolo" autocomplete="off" required ng-maxlength="500"></textarea><div ng-show="editForm.descrizioneArticolo.$invalid"><p class="help-block" ng-show="editForm.descrizioneArticolo.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.descrizioneArticolo.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="500">This field cannot be longer than 500 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.dettaglioOrdine.codiceArticolo" for="field_codiceArticolo">Codice Articolo</label><input type="text" class="form-control" name="codiceArticolo" id="field_codiceArticolo" ng-model="vm.dettaglioOrdine.codiceArticolo" autocomplete="off" ng-maxlength="100"><div ng-show="editForm.codiceArticolo.$invalid"><p class="help-block" ng-show="editForm.codiceArticolo.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.dettaglioOrdine.importoUnitario" for="field_importoUnitario">Importo Unitario</label><input type="number" class="form-control" name="importoUnitario" id="field_importoUnitario" ng-model="vm.dettaglioOrdine.importoUnitario" required><div ng-show="editForm.importoUnitario.$invalid"><p class="help-block" ng-show="editForm.importoUnitario.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.importoUnitario.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.dettaglioOrdine.percentualeIva" for="field_percentualeIva">Percentuale Iva</label><input type="number" class="form-control" name="percentualeIva" id="field_percentualeIva" ng-model="vm.dettaglioOrdine.percentualeIva" required><div ng-show="editForm.percentualeIva.$invalid"><p class="help-block" ng-show="editForm.percentualeIva.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.percentualeIva.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.dettaglioOrdine.descrizioneIva" for="field_descrizioneIva">Descrizione Iva</label><input type="text" class="form-control" name="descrizioneIva" id="field_descrizioneIva" ng-model="vm.dettaglioOrdine.descrizioneIva" ng-maxlength="100"><div ng-show="editForm.descrizioneIva.$invalid"><p class="help-block" ng-show="editForm.descrizioneIva.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group" ng-if="!vm.isFromOrdine()"><label data-translate="ordiniApp.dettaglioOrdine.ordine" for="field_ordine">Ordine</label><select class="form-control" id="field_ordine" name="ordine" ng-model="vm.dettaglioOrdine.ordine" ng-options="ordine as ordine.id for ordine in vm.ordines track by ordine.id" required><option value=""></option></select></div><div ng-show="editForm.ordine.$invalid"><p class="help-block" ng-show="editForm.ordine.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/dettaglio-ordine/dettaglio-ordines.html','<div><h2 data-translate="ordiniApp.dettaglioOrdine.home.title">Dettaglio Ordines</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="dettaglio-ordine.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" data-translate="ordiniApp.dettaglioOrdine.home.createLabel">Create new Dettaglio Ordine</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'ordiniApp.dettaglioOrdine.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="quantita"><span data-translate="ordiniApp.dettaglioOrdine.quantita">Quantita</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="descrizioneArticolo"><span data-translate="ordiniApp.dettaglioOrdine.descrizioneArticolo">Descrizione Articolo</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="codiceArticolo"><span data-translate="ordiniApp.dettaglioOrdine.codiceArticolo">Codice Articolo</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="importoUnitario"><span data-translate="ordiniApp.dettaglioOrdine.importoUnitario">Importo Unitario</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="percentualeIva"><span data-translate="ordiniApp.dettaglioOrdine.percentualeIva">Percentuale Iva</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="descrizioneIva"><span data-translate="ordiniApp.dettaglioOrdine.descrizioneIva">Descrizione Iva</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><!--                     <th><span jh-sort-by="utenteCreazione"><span data-translate="ordiniApp.dettaglioOrdine.utenteCreazione">Utente Creazione</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th> --><!--                     <th><span jh-sort-by="dataCreazione"><span data-translate="ordiniApp.dettaglioOrdine.dataCreazione">Data Creazione</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw" field-type="date"></i></th> --><!--                     <th><span jh-sort-by="utenteAggiornamento"><span data-translate="ordiniApp.dettaglioOrdine.utenteAggiornamento">Utente Aggiornamento</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th> --><!--                     <th><span jh-sort-by="dataAggiornamento"><span data-translate="ordiniApp.dettaglioOrdine.dataAggiornamento">Data Aggiornamento</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw" field-type="date"></i></th> --><th><span jh-sort-by="versioneRecord"><span data-translate="ordiniApp.dettaglioOrdine.versioneRecord">Versione Record</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="ordine.id"><span data-translate="ordiniApp.dettaglioOrdine.ordine">Ordine</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th></th></tr></thead><tbody><tr ng-repeat="dettaglioOrdine in vm.dettaglioOrdines track by dettaglioOrdine.id"><td><a ui-sref="dettaglio-ordine-detail({id:dettaglioOrdine.id})">{{dettaglioOrdine.id}}</a></td><td>{{dettaglioOrdine.quantita}}</td><td>{{dettaglioOrdine.descrizioneArticolo}}</td><td>{{dettaglioOrdine.codiceArticolo}}</td><td>{{dettaglioOrdine.importoUnitario}}</td><td>{{dettaglioOrdine.percentualeIva}}</td><td>{{dettaglioOrdine.descrizioneIva}}</td><!--                     <td>{{dettaglioOrdine.utenteCreazione}}</td> --><!--                     <td>{{dettaglioOrdine.dataCreazione | date:\'medium\'}}</td> --><!--                     <td>{{dettaglioOrdine.utenteAggiornamento}}</td> --><!--                     <td>{{dettaglioOrdine.dataAggiornamento | date:\'medium\'}}</td> --><td>{{dettaglioOrdine.versioneRecord}}</td><td><a ui-sref="ordine-detail({id:dettaglioOrdine.ordine.id})">{{dettaglioOrdine.ordine.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="dettaglio-ordine-detail({id:dettaglioOrdine.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span></button> <button type="submit" ui-sref="dettaglio-ordine.edit({id:dettaglioOrdine.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span></button> <button type="submit" ui-sref="dettaglio-ordine.delete({id:dettaglioOrdine.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/decisione/decisione-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.decisione.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="ordiniApp.decisione.delete.question" translate-values="{id: \'{{vm.decisione.id}}\'}">Are you sure you want to delete this Decisione?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/decisione/decisione-detail.html','<div><h2><span data-translate="ordiniApp.decisione.detail.title">Decisione</span> {{vm.decisione.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="ordiniApp.decisione.data">Data</span></dt><dd><span>{{vm.decisione.data | date:\'mediumDate\'}}</span></dd><dt><span data-translate="ordiniApp.decisione.tipoOrdine">Tipo Ordine</span></dt><dd><span data-translate="{{\'ordiniApp.TipoOrdine.\' + vm.decisione.tipoOrdine}}">{{vm.decisione.tipoOrdine}}</span></dd><dt><span data-translate="ordiniApp.decisione.tipoDecisione">Tipo Decisione</span></dt><dd><span data-translate="{{\'ordiniApp.TipoDecisione.\' + vm.decisione.tipoDecisione}}">{{vm.decisione.tipoDecisione}}</span></dd><dt><span data-translate="ordiniApp.decisione.stato">Stato</span></dt><dd><span data-translate="{{\'ordiniApp.StatoDecisione.\' + vm.decisione.stato}}">{{vm.decisione.stato}}</span></dd><dt><span data-translate="ordiniApp.decisione.funzionaleAllaRicerca">Funzionale Alla Ricerca</span></dt><dd><span>{{vm.decisione.funzionaleAllaRicerca}}</span></dd><dt><span data-translate="ordiniApp.decisione.pubblicazione">Pubblicazione</span></dt><dd><span>{{vm.decisione.pubblicazione}}</span></dd><dt><span data-translate="ordiniApp.decisione.oggetto">Oggetto</span></dt><dd><span>{{vm.decisione.oggetto}}</span></dd><dt><span data-translate="ordiniApp.decisione.descrizione">Descrizione</span></dt><dd><span>{{vm.decisione.descrizione}}</span></dd><dt><span data-translate="ordiniApp.decisione.cig">Cig</span></dt><dd><span>{{vm.decisione.cig}}</span></dd><dt><span data-translate="ordiniApp.decisione.impegno">Impegno</span></dt><dd><a ui-sref="impegno-detail({id:vm.decisione.impegno.id})">{{vm.decisione.impegno.codice}}</a></dd><dt><span data-translate="ordiniApp.decisione.voceBilancio">Voce Bilancio</span></dt><dd><a ui-sref="voce-bilancio-detail({id:vm.decisione.voceBilancio.id})">{{vm.decisione.voceBilancio.codice}}</a></dd><dt><span data-translate="ordiniApp.decisione.dettaglioFondi">Fondi Gae</span></dt><dd><span>{{vm.decisione.dettaglioFondi}}</span></dd><dt><span data-translate="ordiniApp.decisione.responsabileProcedimento">Responsabile Procedimento</span></dt><dd><!--         \tinca$ - user.login al posto di user --> <a ui-sref="utente-detail({id:vm.decisione.responsabileProcedimento.id})">{{vm.decisione.responsabileProcedimento.user.login}}</a></dd><dt><span data-translate="ordiniApp.decisione.spesa">Spesa</span></dt><dd><span>{{vm.decisione.spesa | number}}</span></dd><dt><span data-translate="ordiniApp.decisione.spesaAutoritaVigilanza">Spesa Autorita Vigilanza</span></dt><dd><span>{{vm.decisione.spesaAutoritaVigilanza | number}}</span></dd><dt><span data-translate="ordiniApp.decisione.giorniConsegna">Giorni Consegna</span></dt><dd><span>{{vm.decisione.giorniConsegna}}</span></dd><dt><span data-translate="ordiniApp.decisione.luogoConsegna">Luogo Consegna</span></dt><dd><span>{{vm.decisione.luogoConsegna}}</span></dd><dt><span data-translate="ordiniApp.decisione.motivazioneRifiuto">Motivazione Rifiuto</span></dt><dd><span>{{vm.decisione.motivazioneRifiuto}}</span></dd><dt><span data-translate="ordiniApp.documento.file">File</span></dt><dd><div ng-if="vm.decisione.documentoPdf.file||vm.decisione.documentoPdf.simpleStorageService"><a ng-click="vm.openFile(vm.decisione.documentoPdf)" data-translate="entity.action.open">open</a> {{vm.decisione.documentoPdf.fileContentType}} {{vm.byteSize(vm.decisione.documentoPdf.file)}}</div></dd><dt><span data-translate="ordiniApp.documento.annoProtocollo">Anno Protocollo</span></dt><dd><span>{{vm.decisione.documentoPdf.annoProtocollo}}</span></dd><dt><span data-translate="ordiniApp.documento.numeroProtocollo">Numero Protocollo</span></dt><dd><span>{{vm.decisione.documentoPdf.numeroProtocollo}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="decisione-detail.edit({id:vm.decisione.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/decisione/decisione-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><!--  inca$ - aggiunta ng-hide --> <button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-hide="vm.isPreview" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDecisioneLabel" data-translate="ordiniApp.decisione.home.createOrEditLabel">Create or edit a Decisione</h4></div><div class="stato-visibile form-group col-xs-4"><!--         <label class="control-label" data-translate="ordiniApp.decisione.stato" for="field_stato">Stato</label> --> <input type="text" ng-class="vm.statoColour(vm.decisione.stato)" name="stato" id="field_stato" ng-model="vm.decisione.stato" readonly="readonly"></div><div class="stato-visibile-clear"><div>&nbsp;</div><div>&nbsp;</div><div>&nbsp;</div><div class="modal-body" ng-controller="TypeaheadCtrl"><jhi-alert></jhi-alert><jhi-alert-error></jhi-alert-error><div class="stato-visibile-clearform-group" ng-show="vm.decisione.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.decisione.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.decisione.data" for="field_data">Data</label><!--             <i><label class="control-label">&nbsp;(solitamente uguale alla data di creazione CIG)</label></i> --><div class="input-group"><input id="field_data" type="text" class="form-control" name="data" ng-value="::vm.decisione.data | date: \'dd/MM/yyyy\'" uib-datepicker-popup="{{vm.dateformat}}" ng-model="vm.decisione.data" is-open="vm.datePickerOpenStatus.data" clear-text="Pulisci" current-text="Oggi" close-text="Chiudi" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'data\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.data.$invalid"><p class="help-block" ng-show="editForm.data.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.decisione.tipoOrdine" for="field_tipoOrdine">Tipo Ordine</label><select class="form-control" name="tipoOrdine" ng-model="vm.decisione.tipoOrdine" id="field_tipoOrdine" required><option value="SERVIZIO" data-translate="ordiniApp.TipoOrdine.SERVIZIO">SERVIZIO</option><option value="FORNITURA" data-translate="ordiniApp.TipoOrdine.FORNITURA">FORNITURA</option></select><div ng-show="editForm.tipoOrdine.$invalid"><p class="help-block" ng-show="editForm.tipoOrdine.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.decisione.tipoDecisione" for="field_tipoDecisione">Tipo Decisione</label><select class="form-control" name="tipoDecisione" ng-model="vm.decisione.tipoDecisione" id="field_tipoDecisione" required><option value="PROCEDURA_ORDINARIA" data-translate="ordiniApp.TipoDecisione.PROCEDURA_ORDINARIA">PROCEDURA_ORDINARIA</option><option value="AFFIDAMENTO_DIRETTO" data-translate="ordiniApp.TipoDecisione.AFFIDAMENTO_DIRETTO">AFFIDAMENTO_DIRETTO</option></select><div ng-show="editForm.tipoDecisione.$invalid"><p class="help-block" ng-show="editForm.tipoDecisione.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><!--  inca$ - campo non editabile --><!--         <div class="form-group"> --><!--             <label class="control-label" data-translate="ordiniApp.decisione.stato" for="field_stato">Stato</label> --><!--             <select class="form-control" name="stato" ng-model="vm.decisione.stato" id="field_stato"> --><!--                 <option value="IN_COMPILAZIONE" data-translate="ordiniApp.StatoDecisione.IN_COMPILAZIONE">IN_COMPILAZIONE</option> --><!--                 <option value="INVIATO" data-translate="ordiniApp.StatoDecisione.INVIATO">INVIATO</option> --><!--                 <option value="INVIATO_A_DIRETTORE" data-translate="ordiniApp.StatoDecisione.INVIATO_A_DIRETTORE">INVIATO_A_DIRETTORE</option> --><!--                 <option value="RIFIUTATO_DA_AMMINISTRAZIONE" data-translate="ordiniApp.StatoDecisione.RIFIUTATO_DA_AMMINISTRAZIONE">RIFIUTATO_DA_AMMINISTRAZIONE</option> --><!--                 <option value="RIFIUTATO_DA_DIRETTORE" data-translate="ordiniApp.StatoDecisione.RIFIUTATO_DA_DIRETTORE">RIFIUTATO_DA_DIRETTORE</option> --><!--                 <option value="VALIDATO" data-translate="ordiniApp.StatoDecisione.VALIDATO">VALIDATO</option> --><!--             </select> --><!--             <div ng-show="editForm.stato.$invalid"> --><!--                 <p class="help-block" --><!--                     ng-show="editForm.stato.$error.required" data-translate="entity.validation.required"> --><!--                     This field is required. --><!--                 </p> --><!--             </div> --><!--         </div> --><div class="form-group"><label class="control-label" data-translate="ordiniApp.decisione.funzionaleAllaRicerca" for="field_funzionaleAllaRicerca">Funzionale Alla Ricerca</label><input type="checkbox" class="form-control" name="funzionaleAllaRicerca" id="field_funzionaleAllaRicerca" ng-model="vm.decisione.funzionaleAllaRicerca" ng-click="vm.funzionaleAllaRicerca()"><div ng-show="editForm.funzionaleAllaRicerca.$invalid"><p class="help-block" ng-show="editForm.funzionaleAllaRicerca.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.decisione.pubblicazione" for="field_pubblicazione">Funzionale Alla Ricerca</label><input type="checkbox" class="form-control" name="pubblicazione" id="field_pubblicazione" ng-model="vm.decisione.pubblicazione"><div ng-show="editForm.pubblicazione.$invalid"><p class="help-block" ng-show="editForm.pubblicazione.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.decisione.oggetto" for="field_oggetto">Oggetto</label><input type="text" class="form-control" name="oggetto" id="field_oggetto" ng-model="vm.decisione.oggetto" uib-typeahead="value for value in getValue($viewValue)" typeahead-loading="loadingLocations" typeahead-no-results="noResults" autocomplete="off" required ng-maxlength="100"><div ng-show="editForm.oggetto.$invalid"><p class="help-block" ng-show="editForm.oggetto.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.oggetto.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.decisione.descrizione" for="field_descrizione">Descrizione</label><textarea rows="3" class="form-control" name="descrizione" id="field_descrizione" ng-model="vm.decisione.descrizione" uib-typeahead="value for value in getValue($viewValue)" typeahead-loading="loadingLocations" typeahead-no-results="noResults" autocomplete="off" required ng-maxlength="1000"></textarea><div ng-show="editForm.descrizione.$invalid"><p class="help-block" ng-show="editForm.descrizione.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.descrizione.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="1000">This field cannot be longer than 1000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.decisione.cig" for="field_cig">Cig</label><input type="text" class="form-control" name="cig" id="field_cig" ng-model="vm.decisione.cig" required ng-maxlength="100"><div ng-show="editForm.cig.$invalid"><p class="help-block" ng-show="editForm.cig.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.cig.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label data-translate="ordiniApp.decisione.impegno" for="field_impegno">Impegno</label><select ng-disabled="vm.impegniAggiuntivi.length>0" class="form-control" id="field_impegno" name="impegno" ng-model="vm.decisione.impegno" ng-options="impegno as impegno.codice for impegno in vm.impegnos track by impegno.id" required><option value=""></option></select></div><div ng-show="editForm.impegno.$invalid"><p class="help-block" ng-show="editForm.impegno.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="ordiniApp.decisione.voceBilancio" for="field_voceBilancio">Voce Bilancio</label><select class="form-control" id="field_voceBilancio" name="voceBilancio" ng-model="vm.decisione.voceBilancio" ng-options="voceBilancio as voceBilancio.codice+\' - \'+voceBilancio.descrizione for voceBilancio in vm.vocebilancios | orderBy:\'codice\' track by voceBilancio.id" required><option value=""></option></select></div><div ng-show="editForm.voceBilancio.$invalid"><p class="help-block" ng-show="editForm.voceBilancio.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="panel panel-default"><div class="panel-heading"><label class="control-label">Impegni Aggiuntivi</label><button class="btn btn-default btn-xs pull-right" type="button" ng-disabled="editForm.$invalid||vm.decisione.id==null||vm.isSaving||vm.disableInsertDetails()" class="btn btn-primary btn-sm center-block" data-dismiss="alert" ng-click="vm.addImpegnoAggiuntivo()"><span class="glyphicon glyphicon-plus-sign"></span></button></div><div class="panel-body"><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>Impegno</span></th><th><span>Voce Bilancio</span></th><th></th></tr></thead><tbody><tr ng-repeat="impegnoAggiuntivo in vm.impegniAggiuntivi"><td>{{impegnoAggiuntivo.codice}}</td><td>{{impegnoAggiuntivo.voceBilancio.codice}} - {{impegnoAggiuntivo.voceBilancio.descrizione}}</td><td><button class="btn btn-default btn-xs pull-right" type="button" ng-disabled="editForm.$invalid||vm.decisione.id==null||vm.isSaving||vm.disableInsertDetails()" ng-click="vm.deleteImpegnoAggiuntivo(impegnoAggiuntivo)"><span class="glyphicon glyphicon-remove"></span></button></td></tr></tbody></table></div></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.decisione.dettaglioFondi" for="field_dettaglioFondi">Dettaglio Fondi</label><input type="text" class="form-control" name="dettaglioFondi" id="field_dettaglioFondi" ng-model="vm.decisione.dettaglioFondi" ng-maxlength="100" uib-typeahead="value for value in getValue($viewValue)" typeahead-loading="loadingLocations" typeahead-no-results="noResults" autocomplete="off"><div ng-show="editForm.dettaglioFondi.$invalid"><p class="help-block" ng-show="editForm.dettaglioFondi.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label data-translate="ordiniApp.decisione.responsabileProcedimento" for="field_responsabileProcedimento">Responsabile Procedimento</label><!--         \tinca$ - user.login al posto di user --><select class="form-control" id="field_responsabileProcedimento" name="responsabileProcedimento" ng-model="vm.decisione.responsabileProcedimento" ng-options="utente as utente.user.firstName+\' \'+utente.user.lastName for utente in vm.utentes | orderBy:\'user.lastName\' track by utente.id" required><option value=""></option></select></div><div ng-show="editForm.responsabileProcedimento.$invalid"><p class="help-block" ng-show="editForm.responsabileProcedimento.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.decisione.spesa" for="field_spesa">Spesa</label><input type="number" class="form-control" name="spesa" id="field_spesa" ng-model="vm.decisione.spesa" required min="0"><div ng-show="editForm.spesa.$invalid"><p class="help-block" ng-show="editForm.spesa.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.spesa.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be more than 0.</p><p class="help-block" ng-show="editForm.spesa.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group" ng-if="vm.decisione.spesa!=null&&vm.decisione.spesa>=50000"><label class="control-label" data-translate="ordiniApp.decisione.spesaAutoritaVigilanza" for="field_spesaAutoritaVigilanza">Spesa Autorita Vigilanza</label><input type="number" class="form-control" name="spesaAutoritaVigilanza" id="field_spesaAutoritaVigilanza" ng-model="vm.decisione.spesaAutoritaVigilanza" min="0"><div ng-show="editForm.spesaAutoritaVigilanza.$invalid"><p class="help-block" ng-show="editForm.spesaAutoritaVigilanza.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be more than 0.</p><p class="help-block" ng-show="editForm.spesaAutoritaVigilanza.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.decisione.giorniConsegna" for="field_giorniConsegna">Giorni Consegna</label><input type="number" class="form-control" name="giorniConsegna" id="field_giorniConsegna" ng-model="vm.decisione.giorniConsegna" required min="0"><div ng-show="editForm.giorniConsegna.$invalid"><p class="help-block" ng-show="editForm.giorniConsegna.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.giorniConsegna.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be more than 0.</p><p class="help-block" ng-show="editForm.giorniConsegna.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.decisione.luogoConsegna" for="field_luogoConsegna">Luogo Consegna</label><textarea rows="3" class="form-control" name="luogoConsegna" id="field_luogoConsegna" ng-model="vm.decisione.luogoConsegna" uib-typeahead="value for value in getValue($viewValue)" typeahead-loading="loadingLocations" typeahead-no-results="noResults" autocomplete="off" required ng-maxlength="500"></textarea><div ng-show="editForm.luogoConsegna.$invalid"><p class="help-block" ng-show="editForm.luogoConsegna.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.luogoConsegna.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="500">This field cannot be longer than 500 characters.</p></div></div><div class="form-group" ng-if="vm.showMotivazioneRifiuto()"><label class="control-label" data-translate="ordiniApp.decisione.motivazioneRifiuto" for="field_motivazioneRifiuto">Motivazione Rifiuto</label><textarea rows="5" class="form-control" name="motivazioneRifiuto" id="field_motivazioneRifiuto" ng-model="vm.decisione.motivazioneRifiuto" ng-maxlength="10000" readonly="readonly"></textarea><div ng-show="editForm.motivazioneRifiuto.$invalid"><p class="help-block" ng-show="editForm.motivazioneRifiuto.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="10000">This field cannot be longer than 10000 characters.</p></div></div><div class="form-group" ngf-drop ngf-change="vm.setFile($file, vm.decisione.documentoPdf)"><label class="control-label" data-translate="ordiniApp.documento.file" for="field_file">File</label><div><div ng-if="vm.decisione.documentoPdf.fileContentType||vm.decisione.documentoPdf.simpleStorageService" class="help-block clearfix"><a class="pull-left" ng-click="vm.openStorageFile(vm.decisione.documentoPdf)" data-translate="entity.action.open">open</a><br><a class="pull-left" ng-click="vm.downloadStorageFile(vm.decisione.documentoPdf, vm.docFileName(vm.decisione))" target="_blank">Download</a><br><span class="pull-left">{{vm.decisione.documentoPdf.fileContentType}} {{vm.byteSize(vm.decisione.documentoPdf.file)}}</span><!-- inca$ - rimozione cancellazione blob --><!--                     <button ng-click="vm.decisione.file=null;vm.decisione.fileContentType=null;" --><!--                             class="btn btn-default btn-xs pull-right"> --><!--                         <span class="glyphicon glyphicon-remove"></span> --><!--                     </button> --></div><!-- inca$ - rimozione aggiunta blob --><!--                 <button type="file" ngf-select class="btn btn-default btn-block" --><!--                         ngf-change="vm.setFile($file, vm.decisione)" data-translate="entity.action.addblob"> --><!--                     Add blob --><!--                 </button> --></div><input type="hidden" class="form-control" name="file" id="field_file" ng-model="vm.decisione.documentoPdf.file"> <input type="hidden" class="form-control" name="fileContentType" id="field_fileContentType" ng-model="vm.decisione.documentoPdf.fileContentType"></div><div class="panel panel-default" ng-if="vm.showProtocollo()"><div class="panel-heading"><label class="control-label">Informazioni Amministrazione</label></div><div class="panel-body"><div class="form-group" ng-if="vm.showProtocollo()"><label class="control-label" data-translate="ordiniApp.documento.annoProtocollo" for="field_annoProtocollo">Anno Protocollo</label><input type="number" class="form-control" name="annoProtocollo" id="field_annoProtocollo" ng-model="vm.decisione.documentoPdf.annoProtocollo" min="1" ng-readonly="vm.disableProtocollo()"><div ng-show="editForm.annoProtocollo.$invalid"><p class="help-block" ng-show="editForm.annoProtocollo.$error.min" data-translate="entity.validation.min" translate-value-min="1">This field should be more than 1.</p><p class="help-block" ng-show="editForm.annoProtocollo.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group" ng-if="vm.showProtocollo()"><label class="control-label" data-translate="ordiniApp.documento.numeroProtocollo" for="field_numeroProtocollo">Numero Protocollo</label><input type="number" class="form-control" name="numeroProtocollo" id="field_numeroProtocollo" ng-model="vm.decisione.documentoPdf.numeroProtocollo" min="1" ng-readonly="vm.disableProtocollo()"><div ng-show="editForm.numeroProtocollo.$invalid"><p class="help-block" ng-show="editForm.numeroProtocollo.$error.min" data-translate="entity.validation.min" translate-value-min="1">This field should be more than 1.</p><p class="help-block" ng-show="editForm.numeroProtocollo.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div></div></div><div class="container-fluid"><div class="row"><div class="col-xs-8 no-padding-left"><div class="input-group"><div class="form-group"><select class="form-control" name="statoForUpdate" ng-model="vm.statoForUpdate" id="field_statoForUpdate" ng-if="vm.viewUpdateStato()" required><option value="IN_COMPILAZIONE" data-translate="ordiniApp.StatoDecisione.IN_COMPILAZIONE">IN_COMPILAZIONE</option><option value="INVIATO" data-translate="ordiniApp.StatoDecisione.INVIATO">INVIATO</option><option value="INVIATO_A_DIRETTORE" data-translate="ordiniApp.StatoDecisione.INVIATO_A_DIRETTORE">INVIATO_A_DIRETTORE</option><option value="RIFIUTATO_DA_AMMINISTRAZIONE" data-translate="ordiniApp.StatoDecisione.RIFIUTATO_DA_AMMINISTRAZIONE">RIFIUTATO_DA_AMMINISTRAZIONE</option><option value="RIFIUTATO_DA_DIRETTORE" data-translate="ordiniApp.StatoDecisione.RIFIUTATO_DA_DIRETTORE">RIFIUTATO_DA_DIRETTORE</option><option value="VALIDATO" data-translate="ordiniApp.StatoDecisione.VALIDATO">VALIDATO</option></select><div ng-show="editForm.stato.$invalid"><p class="help-block" ng-show="editForm.stato.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><span class="input-group-btn"><button id="aggiorna-stato" type="button" ng-disabled="editForm.$invalid || vm.isSaving" ng-if="vm.viewUpdateStato()" class="btn btn-info" data-dismiss="alert" ng-click="vm.updateStato()"><span class="glyphicon glyphicon glyphicon-paperclip"></span>&nbsp;<span>Aggiorna Stato</span></button></span></div></div><div class="col-xs-4 no-padding-right"></div></div></div></div><div class="modal-footer"><!-- \t\tinca$ - aggiunta  ng-disabled --> <button type="button" ng-disabled="vm.isPreview" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving || vm.disableSave()" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button><!-- \t\tinca$ - tasto preview --> <button id="preview-decisione" type="submit" ng-disabled="editForm.$invalid || vm.isSaving || vm.disablePreviewOrSend()" class="btn btn-primary" ng-click="vm.preview()"><span class="glyphicon glyphicon-eye-open"></span>&nbsp;<span>Preview</span></button><!-- \t\tinca$ - tasto invio --> <button id="invia-decisione" type="submit" ng-disabled="editForm.$invalid || vm.isSaving || vm.isPreview || vm.disablePreviewOrSend()" class="btn btn-primary" ng-click="vm.send()"><span class="glyphicon glyphicon-send"></span>&nbsp;<span>Invia</span></button><!-- \t\tinca$ - tasto valida --> <button id="valida-decisione" type="button" ng-disabled="editForm.$invalid || vm.isSaving || vm.disableValidateOrReject()" class="btn btn-primary" data-dismiss="alert" ng-click="vm.validate()"><span class="glyphicon glyphicon-ok-circle"></span>&nbsp;<span>Valida</span></button><!-- \t\tinca$ - tasto rifiuta --> <button id="respingi-decisione" type="button" ng-disabled="editForm.$invalid || vm.isSaving || vm.disableValidateOrReject()" class="btn btn-primary" data-dismiss="alert" ng-click="vm.rejectDialogForm()"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Rifiuta</span></button></div></form>');
$templateCache.put('app/entities/decisione/decisione-impegni.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><!--  inca$ - aggiunta ng-hide --> <button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDecisioneLabel">Inserimento Impegni Aggiuntivi e Voci di Bilancio</h4></div><div class="modal-body"><h2>Impegni Aggiuntivi</h2><jhi-alert></jhi-alert><!-- \tinca$ - gestiore errore piu\' sofisticata --><jhi-alert-error></jhi-alert-error><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><!-- \t                    <th><span data-translate="global.field.id">ID</span></th> --><th><span>Impegno</span></th><th><span data-translate="ordiniApp.impegno.voceBilancio">Voce Bilancio</span></th><th>Inserisci</th></tr></thead><tbody><tr ng-repeat="item in vm.impegniItems | orderBy:\'impegno.id\' track by item.impegno.id"><!-- \t                    <td>{{item.impegno.id}}</td> --><td>{{item.impegno.codice}}</td><td><select class="form-control" id="field_voceBilancio" name="voceBilancio" ng-model="item.impegno.voceBilancio" ng-options="voceBilancio as voceBilancio.codice+\' - \'+voceBilancio.descrizione for voceBilancio in vm.vocebilancios | orderBy:\'id\' track by voceBilancio.id"><option value=""></option></select></td><td><input type="checkbox" class="form-control" ng-model="item.value"></td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/decisione/decisione-impegno-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.impegno)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Sei sicuro di volere eliminare l\'impegno {{vm.impegno.id}}?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/decisione/decisiones.html','<div><h2 data-translate="ordiniApp.decisione.home.title">Decisiones</h2><jhi-alert></jhi-alert><!-- \tinca$ - gestiore errore piu\' sofisticata --><jhi-alert-error></jhi-alert-error><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="decisione.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" data-translate="ordiniApp.decisione.home.createLabel">Create new Decisione</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'ordiniApp.decisione.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="data"><span data-translate="ordiniApp.decisione.data">Data</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw" field-type="date"></i></th><th><span jh-sort-by="stato"><span data-translate="ordiniApp.decisione.stato">Stato</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw" field-domain="ordiniApp.StatoDecisione"></i></th><th><span jh-sort-by="impegno.codice"><span data-translate="ordiniApp.decisione.impegno">Impegno</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><!--         \tinca$ - nome al posto di user --><th><span jh-sort-by="responsabileProcedimento.user.login"><span data-translate="ordiniApp.decisione.responsabileProcedimento">Responsabile Procedimento</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="tipoOrdine"><span data-translate="ordiniApp.decisione.tipoOrdine">Tipo Ordine</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw" field-domain="ordiniApp.TipoOrdine"></i></th><th><span jh-sort-by="tipoDecisione"><span data-translate="ordiniApp.decisione.tipoDecisione">Tipo Decisione</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw" field-domain="ordiniApp.TipoDecisione"></i></th><th><span jh-sort-by="funzionaleAllaRicerca"><span data-translate="ordiniApp.decisione.funzionaleAllaRicerca">Funzionale alla Ricerca</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw" field-type="boolean"></i></th><th><span jh-sort-by="pubblicazione"><span data-translate="ordiniApp.decisione.pubblicazione">Funzionale alla Ricerca</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw" field-type="boolean"></i></th><th><span jh-sort-by="oggetto"><span data-translate="ordiniApp.decisione.oggetto">Oggetto</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="descrizione"><span data-translate="ordiniApp.decisione.descrizione">Descrizione</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="cig"><span data-translate="ordiniApp.decisione.cig">Cig</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="voceBilancio.codice"><span data-translate="ordiniApp.decisione.voceBilancio">Voce Bilancio</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="dettaglioFondi"><span data-translate="ordiniApp.decisione.dettaglioFondi">Dettaglio Fondi</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="spesa"><span data-translate="ordiniApp.decisione.spesa">Spesa</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="spesaAutoritaVigilanza"><span data-translate="ordiniApp.decisione.spesaAutoritaVigilanza">Spesa Autorita Vigilanza</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="giorniConsegna"><span data-translate="ordiniApp.decisione.giorniConsegna">Giorni Consegna</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="luogoConsegna"><span data-translate="ordiniApp.decisione.luogoConsegna">Luogo Consegna</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><!--                     <th><span jh-sort-by="motivazioneRifiuto"><span data-translate="ordiniApp.decisione.motivazioneRifiuto">Motivazione Rifiuto</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th> --><!--                     <th><span jh-sort-by="documentoPdf.file"><span data-translate="ordiniApp.documento.file">File</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th> --><th><span jh-sort-by="documentoPdf.annoProtocollo"><span data-translate="ordiniApp.documento.annoProtocollo">Anno Protocollo</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="documentoPdf.numeroProtocollo"><span data-translate="ordiniApp.documento.numeroProtocollo">Numero Protocollo</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th></th></tr></thead><tbody><tr ng-repeat="decisione in vm.decisiones track by decisione.id"><!--                 \tinca$ - il link manda in modifica invece che in visualizzazione --><td><a ui-sref="decisione.edit({id:decisione.id})">{{decisione.id}}</a></td><td>{{decisione.data | date:\'mediumDate\'}}</td><td class="text-center"><div><p ng-class="vm.statoColour(decisione.stato)">{{decisione.stato}}</p></div></td><td><a ui-sref="impegno-detail({id:decisione.impegno.id})">{{decisione.impegno.codice}}</a></td><td><!--         \tinca$ - nome al posto di user --> <a ui-sref="utente-detail({id:decisione.responsabileProcedimento.id})">{{vm.rupName(decisione)}}</a></td><td data-translate="{{\'ordiniApp.TipoOrdine.\' + decisione.tipoOrdine}}">{{decisione.tipoOrdine}}</td><td data-translate="{{\'ordiniApp.TipoDecisione.\' + decisione.tipoDecisione}}">{{decisione.tipoDecisione}}</td><td><input type="checkbox" ng-model="decisione.funzionaleAllaRicerca" disabled="disabled"></td><td><input type="checkbox" ng-model="decisione.pubblicazione" disabled="disabled"></td><td>{{decisione.oggetto}}</td><td>{{decisione.descrizione}}</td><td>{{decisione.cig}}</td><td><a ui-sref="voce-bilancio-detail({id:decisione.voceBilancio.id})">{{decisione.voceBilancio.codice}}</a></td><td>{{decisione.dettaglioFondi}}</td><td>{{decisione.spesa | number}}</td><td>{{decisione.spesaAutoritaVigilanza | number}}</td><td>{{decisione.giorniConsegna}}</td><td>{{decisione.luogoConsegna}}</td><!--                     <td>{{decisione.motivazioneRifiuto}}</td> --><!--                     <td> --><!--                         <a ng-if="decisione.documentoPdf.file" ng-click="vm.openFile(decisione.documentoPdf.fileContentType, decisione.documentoPdf.file)" data-translate="entity.action.open">open</a> --><!--                         <span ng-if="decisione.documentoPdf.file">{{decisione.documentoPdf.fileContentType}}, {{vm.byteSize(decisione.documentoPdf.file)}}</span> --><!--                     </td> --><td>{{decisione.documentoPdf.annoProtocollo}}</td><td>{{decisione.documentoPdf.numeroProtocollo}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="decisione-detail({id:decisione.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span></button> <button type="submit" ui-sref="decisione.edit({id:decisione.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span></button> <button type="submit" ui-sref="decisione.delete({id:decisione.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/dichiarazione/dichiarazione-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.dichiarazione.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="ordiniApp.dichiarazione.delete.question" translate-values="{id: \'{{vm.dichiarazione.id}}\'}">Are you sure you want to delete this Dichiarazione?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/dichiarazione/dichiarazione-detail.html','<div><h2><span data-translate="ordiniApp.dichiarazione.detail.title">Dichiarazione</span> {{vm.dichiarazione.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="ordiniApp.dichiarazione.decisione">Decisione</span></dt><dd><a ui-sref="decisione-detail({id:vm.dichiarazione.decisione.id})">{{vm.dichiarazione.decisione.id}}</a></dd><dt><span data-translate="ordiniApp.dichiarazione.data">Data</span></dt><dd><span>{{vm.dichiarazione.data | date:\'mediumDate\'}}</span></dd><dt><span data-translate="ordiniApp.dichiarazione.stato">Stato</span></dt><dd><span data-translate="{{\'ordiniApp.StatoDichiarazione.\' + vm.dichiarazione.stato}}">{{vm.dichiarazione.stato}}</span></dd><dt><span data-translate="ordiniApp.dichiarazione.nessunaComparazione">Nessuna Comparazione</span></dt><dd><span>{{vm.dichiarazione.nessunaComparazione}}</span></dd><dt><span data-translate="ordiniApp.dichiarazione.descrizione">Descrizione</span></dt><dd><span>{{vm.dichiarazione.descrizione}}</span></dd><dt><span data-translate="ordiniApp.dichiarazione.ordineMepa">Ordine Mepa</span></dt><dd><span>{{vm.dichiarazione.ordineMepa}}</span></dd><dt><span data-translate="ordiniApp.dichiarazione.strumentoMepaScelto">Strumento Mepa Scelto</span></dt><dd><span>{{vm.dichiarazione.strumentoMepaScelto}}</span></dd><dt><span data-translate="ordiniApp.dichiarazione.sezioneMepa">Sezione Mepa</span></dt><dd><span>{{vm.dichiarazione.sezioneMepa}}</span></dd><dt><span data-translate="ordiniApp.dichiarazione.criteriRicercaArticoli">Criteri Ricerca Articoli</span></dt><dd><span>{{vm.dichiarazione.criteriRicercaArticoli}}</span></dd><dt><span data-translate="ordiniApp.dichiarazione.numeroOfferteMepa">Numero Offerte Mepa</span></dt><dd><span>{{vm.dichiarazione.numeroOfferteMepa}}</span></dd><dt><span data-translate="ordiniApp.dichiarazione.fornitoreScelto">Fornitore Scelto</span></dt><dd><span>{{vm.dichiarazione.fornitoreScelto}}</span></dd><dt><span data-translate="ordiniApp.dichiarazione.motivazioneSceltaProdotto">Motivazione Scelta Prodotto</span></dt><dd><span>{{vm.dichiarazione.motivazioneSceltaProdotto}}</span></dd><dt><span data-translate="ordiniApp.dichiarazione.motivazioneSceltaFornitore">Motivazione Scelta Fornitore</span></dt><dd><span>{{vm.dichiarazione.motivazioneSceltaFornitore}}</span></dd><dt><span data-translate="ordiniApp.dichiarazione.spesaEffettiva">Spesa Effettiva</span></dt><dd><span>{{vm.dichiarazione.spesaEffettiva | number}}</span></dd><dt><span data-translate="ordiniApp.dichiarazione.valuta">Valuta</span></dt><dd><span>{{vm.dichiarazione.valuta}}</span></dd><dt><span data-translate="ordiniApp.dichiarazione.beneInventariabile">Bene Inventariabile</span></dt><dd><span>{{vm.dichiarazione.beneInventariabile}}</span></dd><dt><span data-translate="ordiniApp.dichiarazione.edificio">Edificio</span></dt><dd><span>{{vm.dichiarazione.edificio}}</span></dd><dt><span data-translate="ordiniApp.dichiarazione.indirizzo">Indirizzo</span></dt><dd><span>{{vm.dichiarazione.indirizzo}}</span></dd><dt><span data-translate="ordiniApp.dichiarazione.numeroStanza">Numero Stanza</span></dt><dd><span>{{vm.dichiarazione.numeroStanza}}</span></dd><dt><span data-translate="ordiniApp.dichiarazione.nomeAssegnatarioBene">Nome Assegnatario Bene</span></dt><dd><span>{{vm.dichiarazione.nomeAssegnatarioBene}}</span></dd><dt><span data-translate="ordiniApp.dichiarazione.territorio">Territorio</span></dt><dd><span data-translate="{{\'ordiniApp.TipoEsclusivita.\' + vm.dichiarazione.territorio}}">{{vm.dichiarazione.territorio}}</span></dd><dt><span data-translate="ordiniApp.dichiarazione.motivazioneRifiuto">Motivazione Rifiuto</span></dt><dd><span>{{vm.dichiarazione.motivazioneRifiuto}}</span></dd><dt><span data-translate="ordiniApp.documento.file">File</span></dt><dd><div ng-if="vm.dichiarazione.documentoPdf.file||vm.dichiarazione.documentoPdf.simpleStorageService"><a ng-click="vm.openStorageFile(vm.dichiarazione.documentoPdf)" data-translate="entity.action.open">open</a> {{vm.dichiarazione.documentoPdf.fileContentType}} {{vm.byteSize(vm.dichiarazione.documentoPdf.file)}}</div></dd><dt><span data-translate="ordiniApp.documento.annoProtocollo">Anno Protocollo</span></dt><dd><span>{{vm.dichiarazione.documentoPdf.annoProtocollo}}</span></dd><dt><span data-translate="ordiniApp.documento.numeroProtocollo">Numero Protocollo</span></dt><dd><span>{{vm.dichiarazione.documentoPdf.numeroProtocollo}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="dichiarazione-detail.edit({id:vm.dichiarazione.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/dichiarazione/dichiarazione-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><!--  inca$ - aggiunta ng-hide --> <button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-hide="vm.isPreview" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDichiarazioneLabel" data-translate="ordiniApp.dichiarazione.home.createOrEditLabel">Create or edit a Dichiarazione</h4></div><div class="stato-visibile form-group col-xs-4"><!--         <label class="control-label" data-translate="ordiniApp.dichiarazione.stato" for="field_stato">Stato</label> --> <input type="text" ng-class="vm.statoColour(vm.dichiarazione.stato)" name="stato" id="field_stato" ng-model="vm.dichiarazione.stato" readonly="readonly"></div><div class="stato-visibile-clear"><div>&nbsp;</div><div>&nbsp;</div><div>&nbsp;</div><div class="modal-body" ng-controller="TypeaheadCtrl"><jhi-alert-error></jhi-alert-error><div class="form-group"><label data-translate="ordiniApp.dichiarazione.decisione" for="field_decisione">Decisione</label><div class="input-group"><select ng-class="vm.statoLinkedColour(vm.dichiarazione.decisione.stato, \'decisione\', \'form-control-field\')" id="field_decisione" name="decisione" ng-model="vm.dichiarazione.decisione" ng-options="decisione as \'ID: \'+decisione.id+\' - \'+decisione.impegno.codice+\' - \'+decisione.stato for decisione in vm.decisiones | orderBy:\'id\' track by decisione.id" ng-change="vm.decisioneChanged()" required><option value=""></option></select><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.editDecisione()"><i class="glyphicon glyphicon-edit"></i></button></span></div></div><div ng-show="editForm.decisione.$invalid"><p class="help-block" ng-show="editForm.decisione.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="stato-visibile-clearform-group" ng-show="vm.dichiarazione.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.dichiarazione.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.dichiarazione.data" for="field_data" ng-init="vm.dichiarazione.data = vm.dichiarazione.data || (vm.dichiarazione.data = vm.today())">Data</label><div class="input-group"><input id="field_data" type="text" class="form-control" name="data" ng-value="::vm.dichiarazione.data | date: \'dd/MM/yyyy\'" uib-datepicker-popup="{{vm.dateformat}}" ng-model="vm.dichiarazione.data" is-open="vm.datePickerOpenStatus.data" clear-text="Pulisci" current-text="Oggi" close-text="Chiudi" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'data\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.data.$invalid"><p class="help-block" ng-show="editForm.data.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><!--  inca$ - campo non editabile --><!--         <div class="form-group"> --><!--             <label class="control-label" data-translate="ordiniApp.dichiarazione.stato" for="field_stato">Stato</label> --><!--             <select class="form-control" name="stato" ng-model="vm.dichiarazione.stato" id="field_stato" required> --><!--                 <option value="IN_COMPILAZIONE" data-translate="ordiniApp.StatoDichiarazione.IN_COMPILAZIONE">IN_COMPILAZIONE</option> --><!--                 <option value="INVIATO" data-translate="ordiniApp.StatoDichiarazione.INVIATO">INVIATO</option> --><!--                 <option value="RIFIUTATO_DA_AMMINISTRAZIONE" data-translate="ordiniApp.StatoDichiarazione.RIFIUTATO_DA_AMMINISTRAZIONE">RIFIUTATO_DA_AMMINISTRAZIONE</option> --><!--                 <option value="VALIDATO" data-translate="ordiniApp.StatoDichiarazione.VALIDATO">VALIDATO</option> --><!--             </select> --><!--             <div ng-show="editForm.stato.$invalid"> --><!--                 <p class="help-block" --><!--                     ng-show="editForm.stato.$error.required" data-translate="entity.validation.required"> --><!--                     This field is required. --><!--                 </p> --><!--             </div> --><!--         </div> --><div class="form-group"><label class="control-label" data-translate="ordiniApp.dichiarazione.descrizione" for="field_descrizione">Descrizione</label><input type="text" class="form-control" name="descrizione" id="field_descrizione" ng-model="vm.dichiarazione.descrizione" required ng-maxlength="1000"><div ng-show="editForm.descrizione.$invalid"><p class="help-block" ng-show="editForm.descrizione.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.descrizione.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="1000">This field cannot be longer than 1000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.decisione.funzionaleAllaRicerca" for="field_funzionaleAllaRicerca">Ordine Mepa</label><input type="checkbox" class="form-control" name="funzionaleAllaRicerca" id="field_funzionaleAllaRicerca" ng-model="vm.dichiarazione.decisione.funzionaleAllaRicerca" ng-disabled="true"></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.dichiarazione.ordineMepa" for="field_ordineMepa">Ordine Mepa</label><input type="checkbox" class="form-control" name="ordineMepa" id="field_ordineMepa" ng-model="vm.dichiarazione.ordineMepa"><div ng-show="editForm.ordineMepa.$invalid"><p class="help-block" ng-show="editForm.ordineMepa.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group" ng-if="vm.dichiarazione.ordineMepa==true"><label class="control-label" data-translate="ordiniApp.dichiarazione.strumentoMepaScelto" for="field_strumentoMepaScelto">Strumento Mepa Scelto</label><input type="text" class="form-control" name="strumentoMepaScelto" id="field_strumentoMepaScelto" ng-model="vm.dichiarazione.strumentoMepaScelto" ng-maxlength="50" uib-typeahead="value for value in getValue($viewValue)" typeahead-loading="loadingLocations" typeahead-no-results="noResults" autocomplete="off"><div ng-show="editForm.strumentoMepaScelto.$invalid"><p class="help-block" ng-show="editForm.strumentoMepaScelto.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group" ng-if="vm.dichiarazione.ordineMepa==true"><label class="control-label" data-translate="ordiniApp.dichiarazione.sezioneMepa" for="field_sezioneMepa">Sezione Mepa</label><input type="text" class="form-control" name="sezioneMepa" id="field_sezioneMepa" ng-model="vm.dichiarazione.sezioneMepa" ng-maxlength="100" uib-typeahead="value for value in getValue($viewValue)" typeahead-loading="loadingLocations" typeahead-no-results="noResults" autocomplete="off"><div ng-show="editForm.sezioneMepa.$invalid"><p class="help-block" ng-show="editForm.sezioneMepa.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group" ng-if="vm.dichiarazione.ordineMepa==true"><label class="control-label" data-translate="ordiniApp.dichiarazione.criteriRicercaArticoli" for="field_criteriRicercaArticoli">Criteri Ricerca Articoli</label><input type="text" class="form-control" name="criteriRicercaArticoli" id="field_criteriRicercaArticoli" ng-model="vm.dichiarazione.criteriRicercaArticoli" ng-maxlength="500" uib-typeahead="value for value in getValue($viewValue)" typeahead-loading="loadingLocations" typeahead-no-results="noResults" autocomplete="off"><div ng-show="editForm.criteriRicercaArticoli.$invalid"><p class="help-block" ng-show="editForm.criteriRicercaArticoli.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="500">This field cannot be longer than 500 characters.</p></div></div><div class="form-group" ng-if="vm.dichiarazione.ordineMepa==true"><label class="control-label" data-translate="ordiniApp.dichiarazione.numeroOfferteMepa" for="field_numeroOfferteMepa">Numero Offerte Mepa</label><input type="number" class="form-control" name="numeroOfferteMepa" id="field_numeroOfferteMepa" ng-model="vm.dichiarazione.numeroOfferteMepa" min="1"><div ng-show="editForm.numeroOfferteMepa.$invalid"><p class="help-block" ng-show="editForm.numeroOfferteMepa.$error.min" data-translate="entity.validation.min" translate-value-min="1">This field should be more than 1.</p><p class="help-block" ng-show="editForm.numeroOfferteMepa.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group" ng-if="vm.dichiarazione.ordineMepa==false"><label class="control-label" data-translate="ordiniApp.dichiarazione.nessunaComparazione" for="field_nessunaComparazione">Nessuna Comparazione</label><input type="checkbox" class="form-control" name="nessunaComparazione" id="field_nessunaComparazione" ng-model="vm.dichiarazione.nessunaComparazione" ng-change="vm.nessunaComparazioneChanged()"><div ng-show="editForm.nessunaComparazione.$invalid"><p class="help-block" ng-show="editForm.nessunaComparazione.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.dichiarazione.fornitoreScelto" for="field_fornitoreScelto">Fornitore Scelto</label><input type="text" class="form-control" name="fornitoreScelto" id="field_fornitoreScelto" ng-model="vm.dichiarazione.fornitoreScelto" required ng-maxlength="50" uib-typeahead="value for value in getValue($viewValue)" typeahead-loading="loadingLocations" typeahead-no-results="noResults" autocomplete="off"><div ng-show="editForm.fornitoreScelto.$invalid"><p class="help-block" ng-show="editForm.fornitoreScelto.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.fornitoreScelto.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group" ng-if="vm.dichiarazione.ordineMepa==false"><label class="control-label" data-translate="ordiniApp.dichiarazione.motivazioneSceltaProdotto" for="field_motivazioneSceltaProdotto" ng-if="vm.dichiarazione.nessunaComparazione==true">Motivazione Scelta Prodotto</label><label class="control-label" data-translate="ordiniApp.dichiarazione.motivazioneSceltaProdottoConComparazione" for="field_motivazioneSceltaProdotto" ng-if="vm.dichiarazione.nessunaComparazione==false">Motivazione Scelta Prodotto</label><!--             <label class="control-label">{{ labelMotivazioneSceltaProdotto }}</label> --><textarea rows="6" class="form-control" name="motivazioneSceltaProdotto" id="field_motivazioneSceltaProdotto" ng-model="vm.dichiarazione.motivazioneSceltaProdotto" required ng-maxlength="10000" uib-typeahead="value for value in getValue($viewValue)" typeahead-loading="loadingLocations" typeahead-no-results="noResults" autocomplete="off"></textarea><div ng-show="editForm.motivazioneSceltaProdotto.$invalid"><p class="help-block" ng-show="editForm.motivazioneSceltaProdotto.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.motivazioneSceltaProdotto.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="10000">This field cannot be longer than 10000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.dichiarazione.motivazioneSceltaFornitore" for="field_motivazioneSceltaFornitore">Motivazione Scelta Fornitore</label><textarea rows="3" type="text" ng-readonly="true" class="form-control" name="motivazioneSceltaFornitoreBase" id="field_motivazioneSceltaFornitoreBase" ng-if="vm.motivazioneSceltaFornitoreBase()!=null" ng-model="vm.fornitoreScelto"></textarea><textarea rows="3" type="text" class="form-control" name="motivazioneSceltaFornitore" id="field_motivazioneSceltaFornitore" ng-model="vm.dichiarazione.motivazioneSceltaFornitore" ng-maxlength="1000" uib-typeahead="value for value in getValue($viewValue)" typeahead-loading="loadingLocations" typeahead-no-results="noResults" autocomplete="off"></textarea><div ng-show="editForm.motivazioneSceltaFornitore.$invalid"><p class="help-block" ng-show="editForm.motivazioneSceltaFornitore.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="1000">This field cannot be longer than 1000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.dichiarazione.spesaEffettiva" for="field_spesaEffettiva">Spesa Effettiva</label><input type="number" class="form-control" name="spesaEffettiva" id="field_spesaEffettiva" ng-model="vm.dichiarazione.spesaEffettiva" required min="0"><div ng-show="editForm.spesaEffettiva.$invalid"><p class="help-block" ng-show="editForm.spesaEffettiva.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.spesaEffettiva.$error.min" data-translate="entity.validation.min" translate-value-min="0">This field should be more than 0.</p><p class="help-block" ng-show="editForm.spesaEffettiva.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.dichiarazione.valuta" for="field_valuta">Valuta</label><!--             <input type="text" class="form-control" name="valuta" id="field_valuta" --><!--                     ng-model="vm.dichiarazione.valuta" --><!--                     required ng-maxlength="20" /> --><div class="form-group"><select class="form-control" id="field_dichiarazione_valuta" name="valuta" ng-model="vm.dichiarazione.valuta" ng-init="vm.dichiarazione.valuta = vm.dichiarazione.valuta || \'EUR\'" ng-options="currency.code as currency.code+\' - \'+currency.description for currency in vm.currencies | orderBy:\'code\'" required><option value=""></option></select></div><div ng-show="editForm.valuta.$invalid"><p class="help-block" ng-show="editForm.valuta.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.valuta.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="20">This field cannot be longer than 20 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.dichiarazione.beneInventariabile" for="field_beneInventariabile">beneInventariabile</label><input type="checkbox" class="form-control" name="beneInventariabile" id="field_beneInventariabile" ng-model="vm.dichiarazione.beneInventariabile"><div ng-show="editForm.beneInventariabile.$invalid"><p class="help-block" ng-show="editForm.beneInventariabile.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group" ng-if="vm.dichiarazione.beneInventariabile==true"><label class="control-label" data-translate="ordiniApp.dichiarazione.edificio" for="field_edificio">Edificio</label><input type="text" class="form-control" name="edificio" id="field_edificio" ng-model="vm.dichiarazione.edificio" ng-maxlength="50" uib-typeahead="value for value in getValue($viewValue)" typeahead-loading="loadingLocations" typeahead-no-results="noResults" autocomplete="off"><div ng-show="editForm.edificio.$invalid"><p class="help-block" ng-show="editForm.edificio.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group" ng-if="vm.dichiarazione.beneInventariabile==true"><label class="control-label" data-translate="ordiniApp.dichiarazione.indirizzo" for="field_indirizzo">Indirizzo</label><input type="text" class="form-control" name="indirizzo" id="field_indirizzo" ng-model="vm.dichiarazione.indirizzo" ng-maxlength="50" uib-typeahead="value for value in getValue($viewValue)" typeahead-loading="loadingLocations" typeahead-no-results="noResults" autocomplete="off"><div ng-show="editForm.indirizzo.$invalid"><p class="help-block" ng-show="editForm.indirizzo.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group" ng-if="vm.dichiarazione.beneInventariabile==true"><label class="control-label" data-translate="ordiniApp.dichiarazione.numeroStanza" for="field_numeroStanza">Numero Stanza</label><input type="text" class="form-control" name="numeroStanza" id="field_numeroStanza" ng-model="vm.dichiarazione.numeroStanza" ng-maxlength="20"><div ng-show="editForm.numeroStanza.$invalid"><p class="help-block" ng-show="editForm.numeroStanza.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="20">This field cannot be longer than 20 characters.</p></div></div><div class="form-group" ng-if="vm.dichiarazione.beneInventariabile==true"><label class="control-label" data-translate="ordiniApp.dichiarazione.nomeAssegnatarioBene" for="field_nomeAssegnatarioBene">Nome Assegnatario Bene</label><input type="text" class="form-control" name="nomeAssegnatarioBene" id="field_nomeAssegnatarioBene" ng-model="vm.dichiarazione.nomeAssegnatarioBene" ng-maxlength="100"><div ng-show="editForm.nomeAssegnatarioBene.$invalid"><p class="help-block" ng-show="editForm.nomeAssegnatarioBene.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group" ng-if="vm.showMotivazioneRifiuto()"><label class="control-label" data-translate="ordiniApp.dichiarazione.motivazioneRifiuto" for="field_motivazioneRifiuto">Motivazione Rifiuto</label><textarea rows="5" type="text" class="form-control" name="motivazioneRifiuto" id="field_motivazioneRifiuto" ng-model="vm.dichiarazione.motivazioneRifiuto" ng-maxlength="10000" readonly="readonly"></textarea><div ng-show="editForm.motivazioneRifiuto.$invalid"><p class="help-block" ng-show="editForm.motivazioneRifiuto.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="10000">This field cannot be longer than 10000 characters.</p></div></div><div class="form-group" ngf-drop ngf-change="vm.setFile($file, vm.dichiarazione.documentoPdf)"><label class="control-label" data-translate="ordiniApp.documento.file" for="field_file">File</label><div><div ng-if="vm.dichiarazione.documentoPdf.file||vm.dichiarazione.documentoPdf.simpleStorageService" class="help-block clearfix"><a class="pull-left" ng-click="vm.openStorageFile(vm.dichiarazione.documentoPdf)" data-translate="entity.action.open">open</a><br><a class="pull-left" ng-click="vm.downloadStorageFile(vm.dichiarazione.documentoPdf, vm.docFileName(vm.dichiarazione))" target="_blank">Download</a><br><span class="pull-left">{{vm.dichiarazione.documentoPdf.fileContentType}} {{vm.byteSize(vm.dichiarazione.documentoPdf.file)}}</span><!-- inca$ - rimozione cancellazione blob --><!--                     <button ng-click="vm.dichiarazione.documentoPdf.file=null;vm.dichiarazione.documentoPdf.fileContentType=null;" --><!--                             class="btn btn-default btn-xs pull-right"> --><!--                         <span class="glyphicon glyphicon-remove"></span> --><!--                     </button> --></div><!-- inca$ - rimozione aggiunta blob --><!--                 <button type="file" ngf-select class="btn btn-default btn-block" --><!--                         ngf-change="vm.setFile($file, vm.dichiarazione)" data-translate="entity.action.addblob"> --><!--                     Add blob --><!--                 </button> --></div><input type="hidden" class="form-control" name="file" id="field_file" ng-model="vm.dichiarazione.documentoPdf.file"> <input type="hidden" class="form-control" name="fileContentType" id="field_fileContentType" ng-model="vm.dichiarazione.documentoPdf.fileContentType"></div><div class="panel panel-default" ng-if="vm.showProtocollo()"><div class="panel-heading"><label class="control-label">Informazioni Amministrazione</label></div><div class="panel-body"><div class="form-group" ng-if="vm.showProtocollo()"><label class="control-label" data-translate="ordiniApp.documento.annoProtocollo" for="field_annoProtocollo">Anno Protocollo</label><input type="number" class="form-control" name="annoProtocollo" id="field_annoProtocollo" ng-model="vm.dichiarazione.documentoPdf.annoProtocollo" min="1" ng-readonly="vm.disableProtocollo()"><div ng-show="editForm.annoProtocollo.$invalid"><p class="help-block" ng-show="editForm.annoProtocollo.$error.min" data-translate="entity.validation.min" translate-value-min="1">This field should be more than 1.</p><p class="help-block" ng-show="editForm.annoProtocollo.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group" ng-if="vm.showProtocollo()"><label class="control-label" data-translate="ordiniApp.documento.numeroProtocollo" for="field_numeroProtocollo">Numero Protocollo</label><input type="number" class="form-control" name="numeroProtocollo" id="field_numeroProtocollo" ng-model="vm.dichiarazione.documentoPdf.numeroProtocollo" min="1" ng-readonly="vm.disableProtocollo()"><div ng-show="editForm.numeroProtocollo.$invalid"><p class="help-block" ng-show="editForm.numeroProtocollo.$error.min" data-translate="entity.validation.min" translate-value-min="1">This field should be more than 1.</p><p class="help-block" ng-show="editForm.numeroProtocollo.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div></div></div><div class="panel panel-default"><div class="panel-heading"><label class="control-label">Documenti allegati</label><button class="btn btn-default btn-xs pull-right" type="button" ng-disabled="editForm.$invalid||vm.dichiarazione.id==null||vm.isSaving||vm.disableInsertDetails()" class="btn btn-primary btn-sm center-block" data-dismiss="alert" ng-click="vm.attachForm()"><span class="glyphicon glyphicon-plus-sign"></span></button></div><div class="panel-body"><div class="form-group" ng-repeat="documento in vm.documentiAllegati | filter: {tipo: \'DICHIARAZIONE_ESCLUSIVITA\'} : true"><label class="control-label" for="field_file">Dichiarazione di Esclusivit\xE0 del fornitore ID Documento {{documento.id}}</label><button ng-click="vm.deleteAttachedDoc(documento)" ng-disabled="editForm.$invalid||vm.dichiarazione.id==null||vm.isSaving||vm.disableInsertDetails()" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button><div><div ng-if="vm.dichiarazione" class="help-block clearfix"><a class="pull-left" ng-click="vm.openStorageFile(documento)" target="_blank">Apri</a><br><a class="pull-left" ng-click="vm.downloadStorageFile(documento, vm.documentoFileName(documento, $index))" target="_blank">Download</a><br><span class="pull-left">{{documento.fileContentType}} {{vm.byteSize(documento.file)}}</span></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.dichiarazione.territorio" for="field_territorio">Territorio</label><select class="form-control" name="territorio" ng-model="vm.dichiarazione.territorio" id="field_territorio"><option value=""></option><option value="REGIONALE" data-translate="ordiniApp.TipoEsclusivita.REGIONALE">REGIONALE</option><option value="NAZIONALE" data-translate="ordiniApp.TipoEsclusivita.NAZIONALE">NAZIONALE</option><option value="EUROPEO" data-translate="ordiniApp.TipoEsclusivita.EUROPEO">EUROPEO</option><option value="MONDIALE" data-translate="ordiniApp.TipoEsclusivita.MONDIALE">MONDIALE</option><option value="ALTRO" data-translate="ordiniApp.TipoEsclusivita.ALTRO">ALTRO</option></select></div><input type="hidden" class="form-control" name="file" id="field_file_esclusivita" ng-model="documento.file"> <input type="hidden" class="form-control" name="fileContentType" id="field_fileContentType_esclusivita" ng-model="documento.fileContentType"><hr></div><div class="form-group" ng-repeat="documento in vm.documentiAllegati | filter: {tipo: \'DICHIARAZIONE_UNICITA\'} : true"><label class="control-label" for="field_file">Dichiarazione di Unicit\xE0 del fornitore ID Documento {{documento.id}}</label><button ng-click="vm.deleteAttachedDoc(documento)" ng-disabled="editForm.$invalid||vm.dichiarazione.id==null||vm.isSaving||vm.disableInsertDetails()" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button><div><div ng-if="vm.dichiarazione" class="help-block clearfix"><a class="pull-left" ng-click="vm.openStorageFile(documento)" target="_blank">Apri</a><br><a class="pull-left" ng-click="vm.downloadStorageFile(documento, vm.documentoFileName(documento, $index))" target="_blank">Download</a><br><span class="pull-left">{{documento.fileContentType}} {{vm.byteSize(documento.file)}}</span></div></div><input type="hidden" class="form-control" name="file" id="field_file_unicita" ng-model="documento.file"> <input type="hidden" class="form-control" name="fileContentType" id="field_fileContentType_unicita" ng-model="documento.fileContentType"><hr></div><div class="form-group" ng-repeat="documento in vm.documentiAllegati | filter: {tipo: \'RICHIESTA_OFFERTA\'} : true"><label class="control-label" for="field_file">Richiesta offerta n. {{$index +1}}, ID Documento {{documento.id}}</label><button ng-click="vm.deleteAttachedDoc(documento)" ng-disabled="editForm.$invalid||vm.dichiarazione.id==null||vm.isSaving||vm.disableInsertDetails()" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button><div><div ng-if="vm.dichiarazione" class="help-block clearfix"><a class="pull-left" ng-click="vm.openStorageFile(documento)" target="_blank">Apri</a><br><a class="pull-left" ng-click="vm.downloadStorageFile(documento, vm.documentoFileName(documento, $index))" target="_blank">Download</a><br><span class="pull-left">{{documento.fileContentType}} {{vm.byteSize(documento.file)}}</span></div></div><input type="hidden" class="form-control" name="file" id="field_file_richiesta_offerta" ng-model="documento.file"> <input type="hidden" class="form-control" name="fileContentType" id="field_fileContentType_richiesta_offerta" ng-model="documento.fileContentType"><hr></div><div class="form-group" ng-repeat="documento in vm.documentiAllegati | filter: {tipo: \'OFFERTA\'} : true"><label class="control-label" for="field_file">Offerta n. {{$index +1}}, ID Documento {{documento.id}}</label><button ng-click="vm.deleteAttachedDoc(documento)" ng-disabled="editForm.$invalid||vm.dichiarazione.id==null||vm.isSaving||vm.disableInsertDetails()" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button><div><div ng-if="vm.dichiarazione" class="help-block clearfix"><a class="pull-left" ng-click="vm.openStorageFile(documento)" target="_blank">Apri</a><br><a class="pull-left" ng-click="vm.downloadStorageFile(documento, vm.documentoFileName(documento, $index))" target="_blank">Download</a><br><span class="pull-left">{{documento.fileContentType}} {{vm.byteSize(documento.file)}}</span></div></div><input type="hidden" class="form-control" name="file" id="field_file_offerta" ng-model="documento.file"> <input type="hidden" class="form-control" name="fileContentType" id="field_fileContentType_offerta" ng-model="documento.fileContentType"><hr></div><div class="form-group" ng-repeat="documento in vm.documentiAllegati | filter: {tipo: \'ALTRO\'} : true"><label class="control-label" for="field_file">Altro tipo di allegato, ID Documento {{documento.id}}</label><button ng-click="vm.deleteAttachedDoc(documento)" ng-disabled="editForm.$invalid||vm.dichiarazione.id==null||vm.isSaving||vm.disableInsertDetails()" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button><div><div ng-if="vm.dichiarazione" class="help-block clearfix"><a class="pull-left" ng-click="vm.openStorageFile(documento)" target="_blank">Apri</a><br><a class="pull-left" ng-click="vm.downloadStorageFile(documento, vm.documentoFileName(documento, $index))" target="_blank">Download</a><br><span class="pull-left">{{documento.fileContentType}} {{vm.byteSize(documento.file)}}</span></div></div><input type="hidden" class="form-control" name="file" id="field_file_altro" ng-model="documento.file"> <input type="hidden" class="form-control" name="fileContentType" id="field_fileContentType_altro" ng-model="documento.fileContentType"><hr></div></div></div><div class="container-fluid"><div class="row"><div class="col-xs-8 no-padding-left"><div class="input-group"><div class="form-group"><select class="form-control" name="statoForUpdate" ng-model="vm.statoForUpdate" id="field_statoForUpdate" ng-if="vm.viewUpdateStato()" required><option value="IN_COMPILAZIONE" data-translate="ordiniApp.StatoDichiarazione.IN_COMPILAZIONE">IN_COMPILAZIONE</option><option value="INVIATO" data-translate="ordiniApp.StatoDichiarazione.INVIATO">INVIATO</option><option value="INVIATO_A_AMMINISTRAZIONE" data-translate="ordiniApp.StatoDichiarazione.INVIATO_A_AMMINISTRAZIONE">INVIATO_A_AMMINISTRAZIONE</option><option value="RIFIUTATO_DA_RESPONSABILE" data-translate="ordiniApp.StatoDichiarazione.RIFIUTATO_DA_RESPONSABILE">RIFIUTATO_DA_RESPONSABILE</option><option value="RIFIUTATO_DA_AMMINISTRAZIONE" data-translate="ordiniApp.StatoDichiarazione.RIFIUTATO_DA_AMMINISTRAZIONE">RIFIUTATO_DA_AMMINISTRAZIONE</option><option value="VALIDATO" data-translate="ordiniApp.StatoDichiarazione.VALIDATO">VALIDATO</option></select><div ng-show="editForm.stato.$invalid"><p class="help-block" ng-show="editForm.stato.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><span class="input-group-btn"><button id="aggiorna-stato" type="button" ng-disabled="editForm.$invalid || vm.isSaving" ng-if="vm.viewUpdateStato()" class="btn btn-info" data-dismiss="alert" ng-click="vm.updateStato()"><span class="glyphicon glyphicon glyphicon-paperclip"></span>&nbsp;<span>Aggiorna Stato</span></button></span></div></div><div class="col-xs-4 no-padding-right"><button id="invia-mail" type="button" ng-disabled="editForm.$invalid || vm.isSaving" ng-if="vm.viewMailSigns()" class="btn btn-info" data-dismiss="alert" ng-click="vm.sendMailSigns()"><span class="glyphicon glyphicon glyphicon-paperclip"></span>&nbsp;<span>Invia email documenti</span></button></div></div></div></div><div class="modal-footer"><!-- \t\tinca$ - aggiunta  ng-disabled --> <button type="button" ng-disabled="vm.isPreview" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving || vm.disableSave()" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button><!-- \t\tinca$ - tasto preview --> <button id="preview-dichiarazione" type="submit" ng-disabled="editForm.$invalid || vm.isSaving || vm.disablePreviewOrSend()" class="btn btn-primary" ng-click="vm.preview()"><span class="glyphicon glyphicon-envelope"></span>&nbsp;<span>Preview</span></button><!-- \t\tinca$ - tasto invio --> <button id="invia-dichiarazione" type="submit" ng-disabled="editForm.$invalid || vm.isSaving || vm.isPreview || vm.disablePreviewOrSend()" class="btn btn-primary" ng-click="vm.send()"><span class="glyphicon glyphicon-send"></span>&nbsp;<span>Invia</span></button><!-- \t\tinca$ - tasto valida --> <button id="valida-dichiarazione" type="button" ng-disabled="editForm.$invalid || vm.isSaving || vm.disableValidateOrReject()" class="btn btn-primary" data-dismiss="alert" ng-click="vm.validate()"><span class="glyphicon glyphicon-ok-circle"></span>&nbsp;<span>Valida</span></button><!-- \t\tinca$ - tasto rifiuta --> <button id="respingi-dichiarazione" type="button" ng-disabled="editForm.$invalid || vm.isSaving || vm.disableValidateOrReject()" class="btn btn-primary" data-dismiss="alert" ng-click="vm.rejectDialogForm()"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Rifiuta</span></button></div></form>');
$templateCache.put('app/entities/dichiarazione/dichiaraziones.html','<div><h2 data-translate="ordiniApp.dichiarazione.home.title">Dichiaraziones</h2><jhi-alert></jhi-alert><!-- \tinca$ - gestiore errore piu\' sofisticata --><jhi-alert-error></jhi-alert-error><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="dichiarazione.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" data-translate="ordiniApp.dichiarazione.home.createLabel">Create new Dichiarazione</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'ordiniApp.dichiarazione.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="data"><span data-translate="ordiniApp.dichiarazione.data">Data</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw" field-type="date"></i></th><th><span jh-sort-by="stato"><span data-translate="ordiniApp.dichiarazione.stato">Stato</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw" field-domain="ordiniApp.StatoDichiarazione"></i></th><th><span jh-sort-by="decisione.impegno.codice"><span data-translate="ordiniApp.decisione.impegno">Impegno</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="decisione.responsabileProcedimento.user.login"><span data-translate="ordiniApp.decisione.responsabileProcedimento">Responsabile Procedimento</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="descrizione"><span data-translate="ordiniApp.dichiarazione.descrizione">Descrizione</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="ordineMepa"><span data-translate="ordiniApp.dichiarazione.ordineMepa">Ordine Mepa</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw" field-type="boolean"></i></th><!--                     <th><span jh-sort-by="strumentoMepaScelto"><span data-translate="ordiniApp.dichiarazione.strumentoMepaScelto">Strumento Mepa Scelto</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th> --><!--                     <th><span jh-sort-by="sezioneMepa"><span data-translate="ordiniApp.dichiarazione.sezioneMepa">Sezione Mepa</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th> --><!--                     <th><span jh-sort-by="criteriRicercaArticoli"><span data-translate="ordiniApp.dichiarazione.criteriRicercaArticoli">Criteri Ricerca Articoli</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th> --><!--                     <th><span jh-sort-by="numeroOfferteMepa"><span data-translate="ordiniApp.dichiarazione.numeroOfferteMepa">Numero Offerte Mepa</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th> --><th><span jh-sort-by="nessunaComparazione"><span data-translate="ordiniApp.dichiarazione.nessunaComparazione">Ordine Mepa</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw" field-type="boolean"></i></th><th><span jh-sort-by="fornitoreScelto"><span data-translate="ordiniApp.dichiarazione.fornitoreScelto">Fornitore Scelto</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><!--                     <th><span jh-sort-by="motivazioneSceltaProdotto"><span data-translate="ordiniApp.dichiarazione.motivazioneSceltaProdotto">Motivazione Scelta Prodotto</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th> --><!--                     <th><span jh-sort-by="motivazioneSceltaFornitore"><span data-translate="ordiniApp.dichiarazione.motivazioneSceltaFornitore">Motivazione Scelta Fornitore</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th> --><th><span jh-sort-by="spesaEffettiva"><span data-translate="ordiniApp.dichiarazione.spesaEffettiva">Spesa Effettiva</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="valuta"><span data-translate="ordiniApp.dichiarazione.valuta">Valuta</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><!--                     <th><span jh-sort-by="beneInventariabile"><span data-translate="ordiniApp.dichiarazione.beneInventariabile">Bene Inventariabile</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw" field-type="boolean"></i></th> --><!--                     <th><span jh-sort-by="edificio"><span data-translate="ordiniApp.dichiarazione.edificio">Edificio</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th> --><!--                     <th><span jh-sort-by="indirizzo"><span data-translate="ordiniApp.dichiarazione.indirizzo">Indirizzo</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th> --><!--                     <th><span jh-sort-by="numeroStanza"><span data-translate="ordiniApp.dichiarazione.numeroStanza">Numero Stanza</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th> --><!--                     <th><span jh-sort-by="nomeAssegnatarioBene"><span data-translate="ordiniApp.dichiarazione.nomeAssegnatarioBene">Nome Assegnatario Bene</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th> --><!--                     <th><span jh-sort-by="territorio"><span data-translate="ordiniApp.dichiarazione.territorio">Territorio</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw" field-domain="ordiniApp.TipoEsclusivita"></i></th> --><!--                     <th><span jh-sort-by="motivazioneRifiuto"><span data-translate="ordiniApp.dichiarazione.motivazioneRifiuto">Motivazione Rifiuto</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th> --><!--                     <th><span jh-sort-by="documentoPdf.file"><span data-translate="ordiniApp.documento.file">File</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th> --><th><span jh-sort-by="documentoPdf.annoProtocollo"><span data-translate="ordiniApp.documento.annoProtocollo">Anno Protocollo</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="documentoPdf.numeroProtocollo"><span data-translate="ordiniApp.documento.numeroProtocollo">Numero Protocollo</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="decisione.id"><span data-translate="ordiniApp.dichiarazione.decisione">Decisione</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th></th></tr></thead><tbody><tr ng-repeat="dichiarazione in vm.dichiaraziones track by dichiarazione.id"><!--                 \tinca$ - il link manda in modifica invece che in visualizzazione --><td><a ui-sref="dichiarazione.edit({id:dichiarazione.id})">{{dichiarazione.id}}</a></td><td>{{dichiarazione.data | date:\'mediumDate\'}}</td><td class="text-center"><div><p ng-class="vm.statoColour(dichiarazione.stato)">{{dichiarazione.stato}}</p></div></td><td><a ui-sref="impegno-detail({id:dichiarazione.decisione.impegno.id})">{{dichiarazione.decisione.impegno.codice}}</a></td><td><!--         \tinca$ - nome al posto di user --> <a ui-sref="utente-detail({id:dichiarazione.decisione.responsabileProcedimento.id})">{{vm.rupName(dichiarazione)}}</a></td><td>{{dichiarazione.descrizione}}</td><td><input type="checkbox" ng-model="dichiarazione.ordineMepa" disabled="disabled"></td><!--                     <td>{{dichiarazione.strumentoMepaScelto}}</td> --><!--                     <td>{{dichiarazione.sezioneMepa}}</td> --><!--                     <td>{{dichiarazione.criteriRicercaArticoli}}</td> --><!--                     <td>{{dichiarazione.numeroOfferteMepa}}</td> --><td><input type="checkbox" ng-model="dichiarazione.nessunaComparazione" disabled="disabled"></td><td>{{dichiarazione.fornitoreScelto}}</td><!--                     <td>{{dichiarazione.motivazioneSceltaProdotto}}</td> --><!--                     <td>{{dichiarazione.motivazioneSceltaFornitore}}</td> --><td>{{dichiarazione.spesaEffettiva | number}}</td><td>{{dichiarazione.valuta}}</td><!-- \t\t\t\t\t<td><input type="checkbox" ng-model="dichiarazione.beneInventariabile" disabled/></td> --><!--                     <td>{{dichiarazione.edificio}}</td> --><!--                     <td>{{dichiarazione.indirizzo}}</td> --><!--                     <td>{{dichiarazione.numeroStanza}}</td> --><!--                     <td>{{dichiarazione.nomeAssegnatarioBene}}</td> --><!--                     <td data-translate="{{\'ordiniApp.TipoEsclusivita.\' + dichiarazione.territorio}}">{{dichiarazione.territorio}}</td> --><!--                     <td>{{dichiarazione.motivazioneRifiuto}}</td> --><!--                     <td> --><!--                         <a ng-if="dichiarazione.documentoPdf.file" ng-click="vm.openFile(dichiarazione.documentoPdf.fileContentType, dichiarazione.documentoPdf.file)" data-translate="entity.action.open">open</a> --><!--                         <span ng-if="dichiarazione.documentoPdf.file">{{dichiarazione.documentoPdf.fileContentType}}, {{vm.byteSize(dichiarazione.documentoPdf.file)}}</span> --><!--                     </td> --><td>{{dichiarazione.documentoPdf.annoProtocollo}}</td><td>{{dichiarazione.documentoPdf.numeroProtocollo}}</td><td><a ui-sref="decisione-detail({id:dichiarazione.decisione.id})">{{dichiarazione.decisione.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="dichiarazione-detail({id:dichiarazione.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span></button> <button type="submit" ui-sref="dichiarazione.edit({id:dichiarazione.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span></button> <button type="submit" ui-sref="dichiarazione.delete({id:dichiarazione.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/documento/documento-attach.html','<form name="vm.editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDocumentoLabel">Allega un Documento</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.documento.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.documento.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.documento.tipo" for="field_tipo">Tipo</label><select class="form-control" name="tipo" ng-model="vm.documento.tipo" id="field_tipo" required><option value="DICHIARAZIONE_ESCLUSIVITA" data-translate="ordiniApp.TipoDocumento.DICHIARAZIONE_ESCLUSIVITA">DICHIARAZIONE_ESCLUSIVITA</option><option value="DICHIARAZIONE_UNICITA" data-translate="ordiniApp.TipoDocumento.DICHIARAZIONE_UNICITA">DICHIARAZIONE_UNICITA</option><option value="RICHIESTA_OFFERTA" data-translate="ordiniApp.TipoDocumento.RICHIESTA_OFFERTA">RICHIESTA_OFFERTA</option><option value="OFFERTA" data-translate="ordiniApp.TipoDocumento.OFFERTA">OFFERTA</option><option value="ALTRO" data-translate="ordiniApp.TipoDocumento.ALTRO">ALTRO</option></select><div ng-show="editForm.tipo.$invalid"><p class="help-block" ng-show="editForm.tipo.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group" ngf-drop ngf-change="vm.setFile($file, vm.documento)"><label class="control-label" data-translate="ordiniApp.documento.file" for="field_file">File</label><div><div ng-if="vm.documento.file" class="help-block clearfix"><a class="pull-left" ng-click="vm.openFile(vm.documento.fileContentType, vm.documento.file)" data-translate="entity.action.open">open</a><br><span class="pull-left">{{vm.documento.fileContentType}}, {{vm.byteSize(vm.documento.file)}}</span> <button type="button" ng-click="vm.documento.file=null;vm.documento.fileContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setFile($file, vm.documento)" data-translate="entity.action.addblob">Add blob</button></div><input type="hidden" class="form-control" name="file" id="field_file" ng-model="vm.documento.file" required> <input type="hidden" class="form-control" name="fileContentType" id="field_fileContentType" ng-model="vm.documento.fileContentType"><div ng-show="editForm.file.$invalid"><p class="help-block" ng-show="editForm.file.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group" ng-if="vm.showProtocollo()"><label class="control-label" data-translate="ordiniApp.documento.annoProtocollo" for="field_annoProtocollo">Anno Protocollo</label><input type="number" class="form-control" name="annoProtocollo" id="field_annoProtocollo" ng-model="vm.documento.annoProtocollo" min="1" ng-disabled="vm.disableProtocollo()"><div ng-show="editForm.annoProtocollo.$invalid"><p class="help-block" ng-show="editForm.annoProtocollo.$error.min" data-translate="entity.validation.min" translate-value-min="1">This field should be more than 1.</p><p class="help-block" ng-show="editForm.annoProtocollo.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group" ng-if="vm.showProtocollo()"><label class="control-label" data-translate="ordiniApp.documento.numeroProtocollo" for="field_numeroProtocollo">Numero Protocollo</label><input type="number" class="form-control" name="numeroProtocollo" id="field_numeroProtocollo" ng-model="vm.documento.numeroProtocollo" min="1" ng-disabled="vm.disableProtocollo()"><div ng-show="editForm.numeroProtocollo.$invalid"><p class="help-block" ng-show="editForm.numeroProtocollo.$error.min" data-translate="entity.validation.min" translate-value-min="1">This field should be more than 1.</p><p class="help-block" ng-show="editForm.numeroProtocollo.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/documento/documento-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.documento.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="ordiniApp.documento.delete.question" translate-values="{id: \'{{vm.documento.id}}\'}">Are you sure you want to delete this Documento?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/documento/documento-detail.html','<div><h2><span data-translate="ordiniApp.documento.detail.title">Documento</span> {{vm.documento.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="ordiniApp.documento.tipo">Tipo</span></dt><dd><span data-translate="{{\'ordiniApp.TipoDocumento.\' + vm.documento.tipo}}">{{vm.documento.tipo}}</span></dd><dt><span data-translate="ordiniApp.documento.file">File</span></dt><dd><div ng-if="vm.documento.file||vm.documento.simpleStorageService"><a ng-click="vm.openStorageFile(vm.documento.fileContentType, vm.documento.file)" data-translate="entity.action.open">open</a> {{vm.documento.fileContentType}} {{vm.byteSize(vm.documento.file)}}</div></dd><dt><span data-translate="ordiniApp.documento.annoProtocollo">Anno Protocollo</span></dt><dd><span>{{vm.documento.annoProtocollo}}</span></dd><dt><span data-translate="ordiniApp.documento.numeroProtocollo">Numero Protocollo</span></dt><dd><span>{{vm.documento.numeroProtocollo}}</span></dd><dt><span data-translate="ordiniApp.documento.simpleStorageService">Simple Storage Service</span></dt><dd><span>{{vm.documento.simpleStorageService}}</span></dd><dt><span data-translate="ordiniApp.documento.bucketName">Bucket Name</span></dt><dd><span>{{vm.documento.bucketName}}</span></dd><dt><span data-translate="ordiniApp.documento.keyName">Key Name</span></dt><dd><span>{{vm.documento.keyName}}</span></dd><dt><span data-translate="ordiniApp.documento.dichiarazione">Dichiarazione</span></dt><dd><a ui-sref="dichiarazione-detail({id:vm.documento.dichiarazione.id})">{{vm.documento.dichiarazione.id}}</a></dd><!--         <dt><span data-translate="ordiniApp.documento.versioneFile">Versione File</span></dt> --><!--         <dd> --><!--             <span>{{vm.documento.versioneFile}}</span> --><!--         </dd> --></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="documento-detail.edit({id:vm.documento.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/documento/documento-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDocumentoLabel" data-translate="ordiniApp.documento.home.createOrEditLabel">Create or edit a Documento</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.documento.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.documento.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.documento.tipo" for="field_tipo">Tipo</label><select class="form-control" name="tipo" ng-model="vm.documento.tipo" id="field_tipo" required><option value="DECISIONE" data-translate="ordiniApp.TipoDocumento.DECISIONE">DECISIONE</option><option value="DICHIARAZIONE" data-translate="ordiniApp.TipoDocumento.DICHIARAZIONE">DICHIARAZIONE</option><option value="DICHIARAZIONE_ESCLUSIVITA" data-translate="ordiniApp.TipoDocumento.DICHIARAZIONE_ESCLUSIVITA">DICHIARAZIONE_ESCLUSIVITA</option><option value="DICHIARAZIONE_UNICITA" data-translate="ordiniApp.TipoDocumento.DICHIARAZIONE_UNICITA">DICHIARAZIONE_UNICITA</option><option value="RICHIESTA_OFFERTA" data-translate="ordiniApp.TipoDocumento.RICHIESTA_OFFERTA">RICHIESTA_OFFERTA</option><option value="OFFERTA" data-translate="ordiniApp.TipoDocumento.OFFERTA">OFFERTA</option><option value="ORDINE" data-translate="ordiniApp.TipoDocumento.ORDINE">ORDINE</option><option value="ALTRO" data-translate="ordiniApp.TipoDocumento.ALTRO">ALTRO</option></select><div ng-show="editForm.tipo.$invalid"><p class="help-block" ng-show="editForm.tipo.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group" ngf-drop ngf-change="vm.setFile($file, vm.documento)"><label class="control-label" data-translate="ordiniApp.documento.file" for="field_file">File</label><div><div ng-if="vm.documento.file||vm.documento.simpleStorageService" class="help-block clearfix"><a class="pull-left" ng-click="vm.openStorageFile(vm.documento.fileContentType, vm.documento.file)" data-translate="entity.action.open">open</a><br><span class="pull-left">{{vm.documento.fileContentType}} {{vm.byteSize(vm.documento.file)}}</span><!--                     <button type="button" ng-click="vm.documento.file=null;vm.documento.fileContentType=null;" --><!--                             class="btn btn-default btn-xs pull-right"> --><!--                         <span class="glyphicon glyphicon-remove"></span> --><!--                     </button> --></div><!--                 <button type="button" ngf-select class="btn btn-default btn-block" --><!--                         ngf-change="vm.setFile($file, vm.documento)" data-translate="entity.action.addblob"> --><!--                     Add blob --><!--                 </button> --></div><input type="hidden" class="form-control" name="file" id="field_file" ng-model="vm.documento.file" required> <input type="hidden" class="form-control" name="fileContentType" id="field_fileContentType" ng-model="vm.documento.fileContentType"><div ng-show="editForm.file.$invalid"><p class="help-block" ng-show="editForm.file.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.documento.annoProtocollo" for="field_annoProtocollo">Anno Protocollo</label><input type="number" class="form-control" name="annoProtocollo" id="field_annoProtocollo" ng-model="vm.documento.annoProtocollo" min="1"><div ng-show="editForm.annoProtocollo.$invalid"><p class="help-block" ng-show="editForm.annoProtocollo.$error.min" data-translate="entity.validation.min" translate-value-min="1">This field should be more than 1.</p><p class="help-block" ng-show="editForm.annoProtocollo.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.documento.numeroProtocollo" for="field_numeroProtocollo">Numero Protocollo</label><input type="number" class="form-control" name="numeroProtocollo" id="field_numeroProtocollo" ng-model="vm.documento.numeroProtocollo" min="1"><div ng-show="editForm.numeroProtocollo.$invalid"><p class="help-block" ng-show="editForm.numeroProtocollo.$error.min" data-translate="entity.validation.min" translate-value-min="1">This field should be more than 1.</p><p class="help-block" ng-show="editForm.numeroProtocollo.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.documento.simpleStorageService" for="field_simpleStorageService">S 3</label><input type="checkbox" class="form-control" name="simpleStorageService" id="field_simpleStorageService" ng-model="vm.documento.simpleStorageService"><div ng-show="editForm.simpleStorageService.$invalid"><p class="help-block" ng-show="editForm.simpleStorageService.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.documento.bucketName" for="field_bucketName">Bucket Name</label><input type="text" class="form-control" name="bucketName" id="field_bucketName" ng-model="vm.documento.bucketName"></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.documento.keyName" for="field_keyName">Key Name</label><input type="text" class="form-control" name="keyName" id="field_keyName" ng-model="vm.documento.keyName" ng-maxlength="10000"><div ng-show="editForm.keyName.$invalid"><p class="help-block" ng-show="editForm.keyName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="10000">This field cannot be longer than 10000 characters.</p></div></div><!--         <div class="form-group"> --><!--             <label class="control-label" data-translate="ordiniApp.documento.versioneFile" for="field_versioneFile">Versione File</label> --><!--             <input type="number" class="form-control" name="versioneFile" id="field_versioneFile" --><!--                     ng-model="vm.documento.versioneFile" --><!--                      /> --><!--         </div> --><div class="form-group"><label data-translate="ordiniApp.documento.dichiarazione" for="field_dichiarazione">Dichiarazione</label><select class="form-control" id="field_dichiarazione" name="dichiarazione" ng-model="vm.documento.dichiarazione" ng-options="dichiarazione as dichiarazione.id for dichiarazione in vm.dichiaraziones track by dichiarazione.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/documento/documentos.html','<div><h2 data-translate="ordiniApp.documento.home.title">Documentos</h2><jhi-alert></jhi-alert><!-- \tinca$ - gestiore errore piu\' sofisticata --><jhi-alert-error></jhi-alert-error><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="documento.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" data-translate="ordiniApp.documento.home.createLabel">Create new Documento</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'ordiniApp.documento.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="tipo"><span data-translate="ordiniApp.documento.tipo">Tipo</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw" field-domain="ordiniApp.TipoDocumento"></i></th><!--                     <th><span jh-sort-by="file"><span data-translate="ordiniApp.documento.file">File</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th> --><th><span jh-sort-by="annoProtocollo"><span data-translate="ordiniApp.documento.annoProtocollo">Anno Protocollo</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="numeroProtocollo"><span data-translate="ordiniApp.documento.numeroProtocollo">Numero Protocollo</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="simpleStorageService"><span data-translate="ordiniApp.documento.simpleStorageService">Simple Storage Service</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="bucketName"><span data-translate="ordiniApp.documento.bucketName">Bucket Name</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="keyName"><span data-translate="ordiniApp.documento.keyName">Key Name</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><!--                     <th><span jh-sort-by="versioneFile"><span data-translate="ordiniApp.documento.versioneFile">Numero Protocollo</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th> --><th><span jh-sort-by="dichiarazione.id"><span data-translate="ordiniApp.documento.dichiarazione">Dichiarazione</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th></th></tr></thead><tbody><tr ng-repeat="documento in vm.documentos track by documento.id"><td><a ui-sref="documento-detail({id:documento.id})">{{documento.id}}</a></td><td data-translate="{{\'ordiniApp.TipoDocumento.\' + documento.tipo}}">{{documento.tipo}}</td><!--                     <td> --><!--                         <a ng-if="documento.file" ng-click="vm.openFile(documento.fileContentType, documento.file)" data-translate="entity.action.open">open</a> --><!--                         <span ng-if="documento.file">{{documento.fileContentType}}, {{vm.byteSize(documento.file)}}</span> --><!--                     </td> --><td>{{documento.annoProtocollo}}</td><td>{{documento.numeroProtocollo}}</td><td><input type="checkbox" ng-model="documento.simpleStorageService" disabled="disabled"></td><td>{{documento.bucketName}}</td><td>{{documento.keyName}}</td><!--                     <td>{{documento.versioneFile}}</td> --><td><a ui-sref="dichiarazione-detail({id:documento.dichiarazione.id})">{{documento.dichiarazione.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="documento-detail({id:documento.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span></button> <button type="submit" ui-sref="documento.edit({id:documento.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span></button> <button type="submit" ui-sref="documento.delete({id:documento.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/finanziamento/finanziamento-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.finanziamento.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="ordiniApp.finanziamento.delete.question" translate-values="{id: \'{{vm.finanziamento.id}}\'}">Are you sure you want to delete this Finanziamento?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/finanziamento/finanziamento-detail.html','<div><h2><span data-translate="ordiniApp.finanziamento.detail.title">Finanziamento</span> {{vm.finanziamento.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="ordiniApp.finanziamento.codice">Codice</span></dt><dd><span>{{vm.finanziamento.codice}}</span></dd><dt><span data-translate="ordiniApp.finanziamento.titolo">Titolo</span></dt><dd><span>{{vm.finanziamento.titolo}}</span></dd><dt><span data-translate="ordiniApp.finanziamento.soggettoFinanziatore">Soggetto Finanziatore</span></dt><dd><span>{{vm.finanziamento.soggettoFinanziatore}}</span></dd><dt><span data-translate="ordiniApp.finanziamento.responsabileFondi">Responsabile Fondi</span></dt><dd><!--         \tinca$ - user.login al posto di user --> <a ui-sref="utente-detail({id:vm.finanziamento.responsabileFondi.id})">{{vm.finanziamento.responsabileFondi.user.login}}</a></dd><dt><span data-translate="ordiniApp.finanziamento.responsabileScientifico">Responsabile Scientifico</span></dt><dd><a ui-sref="utente-detail({id:vm.finanziamento.responsabileScientifico.id})">{{vm.finanziamento.responsabileScientifico.user.login}}</a></dd><dt><span data-translate="ordiniApp.finanziamento.progetto">Progetto</span></dt><dd><a ui-sref="progetto-detail({id:vm.finanziamento.progetto.id})">{{vm.finanziamento.progetto.codice}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="finanziamento-detail.edit({id:vm.finanziamento.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/finanziamento/finanziamento-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myFinanziamentoLabel" data-translate="ordiniApp.finanziamento.home.createOrEditLabel">Create or edit a Finanziamento</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.finanziamento.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.finanziamento.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.finanziamento.codice" for="field_codice">Codice</label><input type="text" class="form-control" name="codice" id="field_codice" ng-model="vm.finanziamento.codice" required><div ng-show="editForm.codice.$invalid"><p class="help-block" ng-show="editForm.codice.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.finanziamento.titolo" for="field_titolo">Titolo</label><input type="text" class="form-control" name="titolo" id="field_titolo" ng-model="vm.finanziamento.titolo" required ng-maxlength="1000"><div ng-show="editForm.titolo.$invalid"><p class="help-block" ng-show="editForm.titolo.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.titolo.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="1000">This field cannot be longer than 1000 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.finanziamento.soggettoFinanziatore" for="field_soggettoFinanziatore">Soggetto Finanziatore</label><input type="text" class="form-control" name="soggettoFinanziatore" id="field_soggettoFinanziatore" ng-model="vm.finanziamento.soggettoFinanziatore" required><div ng-show="editForm.soggettoFinanziatore.$invalid"><p class="help-block" ng-show="editForm.soggettoFinanziatore.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="ordiniApp.finanziamento.responsabileFondi" for="field_responsabileFondi">Responsabile Fondi</label><!--         \tinca$ - user.login al posto di user --><select class="form-control" id="field_responsabileFondi" name="responsabileFondi" ng-model="vm.finanziamento.responsabileFondi" ng-options="utente as utente.user.login for utente in vm.utentes | orderBy:\'user.login\' track by utente.id" required><option value=""></option></select></div><div ng-show="editForm.responsabileFondi.$invalid"><p class="help-block" ng-show="editForm.responsabileFondi.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="ordiniApp.finanziamento.responsabileScientifico" for="field_responsabileScientifico">Responsabile Scientifico</label><!--         \tinca$ - user.login al posto di user --><select class="form-control" id="field_responsabileScientifico" name="responsabileScientifico" ng-model="vm.finanziamento.responsabileScientifico" ng-options="utente as utente.user.login for utente in vm.utentes | orderBy:\'user.login\' track by utente.id"><option value=""></option></select></div><div class="form-group"><label data-translate="ordiniApp.finanziamento.progetto" for="field_progetto">Progetto</label><select class="form-control" id="field_progetto" name="progetto" ng-model="vm.finanziamento.progetto" ng-options="progetto as progetto.codice+\' - \'+progetto.titolo for progetto in vm.progettos track by progetto.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/finanziamento/finanziamentos.html','<div><h2 data-translate="ordiniApp.finanziamento.home.title">Finanziamentos</h2><jhi-alert></jhi-alert><!-- \tinca$ - gestiore errore piu\' sofisticata --><jhi-alert-error></jhi-alert-error><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="finanziamento.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" data-translate="ordiniApp.finanziamento.home.createLabel">Create new Finanziamento</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'ordiniApp.finanziamento.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="codice"><span data-translate="ordiniApp.finanziamento.codice">Codice</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="titolo"><span data-translate="ordiniApp.finanziamento.titolo">Titolo</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="soggettoFinanziatore"><span data-translate="ordiniApp.finanziamento.soggettoFinanziatore">Soggetto Finanziatore</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="responsabileFondi.user.login"><span data-translate="ordiniApp.finanziamento.responsabileFondi">Responsabile Fondi</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="responsabileScientifico.user.login"><span data-translate="ordiniApp.finanziamento.responsabileScientifico">Responsabile Scientifico</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="progetto.codice"><span data-translate="ordiniApp.finanziamento.progetto">Progetto</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th></th></tr></thead><tbody><tr ng-repeat="finanziamento in vm.finanziamentos track by finanziamento.id"><td><a ui-sref="finanziamento-detail({id:finanziamento.id})">{{finanziamento.id}}</a></td><td>{{finanziamento.codice}}</td><td>{{finanziamento.titolo}}</td><td>{{finanziamento.soggettoFinanziatore}}</td><td><!--         \tinca$ - user.login al posto di user --> <a ui-sref="utente-detail({id:finanziamento.responsabileFondi.id})">{{finanziamento.responsabileFondi.user.login}}</a></td><td><!--         \tinca$ - user.login al posto di user --> <a ui-sref="utente-detail({id:finanziamento.responsabileScientifico.id})">{{finanziamento.responsabileScientifico.user.login}}</a></td><td><a ui-sref="progetto-detail({id:finanziamento.progetto.id})">{{finanziamento.progetto.codice}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="finanziamento-detail({id:finanziamento.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span></button> <button type="submit" ui-sref="finanziamento.edit({id:finanziamento.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span></button> <button type="submit" ui-sref="finanziamento.delete({id:finanziamento.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/funzione/funzione-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.funzione.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="ordiniApp.funzione.delete.question" translate-values="{id: \'{{vm.funzione.id}}\'}">Are you sure you want to delete this Funzione?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/funzione/funzione-detail.html','<div><h2><span data-translate="ordiniApp.funzione.detail.title">Funzione</span> {{vm.funzione.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="ordiniApp.funzione.nome">Nome</span></dt><dd><span>{{vm.funzione.nome}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="funzione-detail.edit({id:vm.funzione.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/funzione/funzione-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myFunzioneLabel" data-translate="ordiniApp.funzione.home.createOrEditLabel">Create or edit a Funzione</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.funzione.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.funzione.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.funzione.nome" for="field_nome">Nome</label><input type="text" class="form-control" name="nome" id="field_nome" ng-model="vm.funzione.nome" required><div ng-show="editForm.nome.$invalid"><p class="help-block" ng-show="editForm.nome.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/funzione/funziones.html','<div><h2 data-translate="ordiniApp.funzione.home.title">Funziones</h2><!-- \tinca$ - gestiore errore piu\' sofisticata --><jhi-alert-error></jhi-alert-error><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="funzione.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" data-translate="ordiniApp.funzione.home.createLabel">Create new Funzione</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'ordiniApp.funzione.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="ordiniApp.funzione.nome">Nome</span></th><th></th></tr></thead><tbody><tr ng-repeat="funzione in vm.funziones track by funzione.id"><td><a ui-sref="funzione-detail({id:funzione.id})">{{funzione.id}}</a></td><td>{{funzione.nome}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="funzione-detail({id:funzione.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span></button> <button type="submit" ui-sref="funzione.edit({id:funzione.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span></button> <button type="submit" ui-sref="funzione.delete({id:funzione.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/gae/gae-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.gae.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="ordiniApp.gae.delete.question" translate-values="{id: \'{{vm.gae.id}}\'}">Are you sure you want to delete this Gae?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/gae/gae-detail.html','<div><h2><span data-translate="ordiniApp.gae.detail.title">Gae</span> {{vm.gae.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="ordiniApp.gae.esercizio">Esercizio</span></dt><dd><span>{{vm.gae.esercizio}}</span></dd><dt><span data-translate="ordiniApp.gae.visualizza">Visualizza</span></dt><dd><!--             <span>{{vm.gae.visualizza}}</span> --> <span><input type="checkbox" ng-model="vm.gae.visualizza" disabled="disabled"></span></dd><dt><span data-translate="ordiniApp.gae.codice">Codice</span></dt><dd><span>{{vm.gae.codice}}</span></dd><dt><span data-translate="ordiniApp.gae.descrizione">Descrizione</span></dt><dd><span>{{vm.gae.descrizione}}</span></dd><dt><span data-translate="ordiniApp.gae.fonteFondi">Fonte Fondi</span></dt><dd><span data-translate="{{\'ordiniApp.FontiFinanziamento.\' + vm.gae.fonteFondi}}">{{vm.gae.fonteFondi}}</span></dd><dt><span data-translate="ordiniApp.gae.cup">Cup</span></dt><dd><span>{{vm.gae.cup}}</span></dd><dt><span data-translate="ordiniApp.gae.finanziamento">Finanziamento</span></dt><dd><a ui-sref="finanziamento-detail({id:vm.gae.finanziamento.id})">ID: {{vm.gae.finanziamento.id}} - {{vm.gae.finanziamento.codice}}</a></dd><dt><span data-translate="ordiniApp.gae.struttura">Struttura</span></dt><dd><a ui-sref="struttura-detail({id:vm.gae.struttura.id})">{{vm.gae.struttura.uo}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="gae-detail.edit({id:vm.gae.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/gae/gae-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myGaeLabel" data-translate="ordiniApp.gae.home.createOrEditLabel">Create or edit a Gae</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.gae.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.gae.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.gae.esercizio" for="field_esercizio">Esercizio</label><input type="number" class="form-control" name="esercizio" id="field_esercizio" ng-model="vm.gae.esercizio" required><div ng-show="editForm.esercizio.$invalid"><p class="help-block" ng-show="editForm.esercizio.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.esercizio.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.gae.visualizza" for="field_visualizza">Visualizza</label><input type="checkbox" class="form-control" name="visualizza" id="field_visualizza" ng-model="vm.gae.visualizza"><div ng-show="editForm.visualizza.$invalid"><p class="help-block" ng-show="editForm.visualizza.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.gae.codice" for="field_codice">Codice</label><input type="text" class="form-control" name="codice" id="field_codice" ng-model="vm.gae.codice" required><div ng-show="editForm.codice.$invalid"><p class="help-block" ng-show="editForm.codice.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.gae.descrizione" for="field_descrizione">Descrizione</label><input type="text" class="form-control" name="descrizione" id="field_descrizione" ng-model="vm.gae.descrizione" required ng-maxlength="1000"><div ng-show="editForm.descrizione.$invalid"><p class="help-block" ng-show="editForm.descrizione.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.descrizione.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="1000">This field cannot be longer than 1000 characters.</p></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.gae.fonteFondi" for="field_fonteFondi">Fonte Fondi</label><select class="form-control" name="fonteFondi" ng-model="vm.gae.fonteFondi" id="field_fonteFondi" required><option value="INTERNE" data-translate="ordiniApp.FontiFinanziamento.INTERNE">INTERNE</option><option value="ESTERNE" data-translate="ordiniApp.FontiFinanziamento.ESTERNE">ESTERNE</option></select><div ng-show="editForm.fonteFondi.$invalid"><p class="help-block" ng-show="editForm.fonteFondi.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.gae.cup" for="field_cup">Cup</label><input type="text" class="form-control" name="cup" id="field_cup" ng-model="vm.gae.cup"><div ng-show="editForm.cup.$invalid"></div></div><div class="form-group"><label data-translate="ordiniApp.gae.finanziamento" for="field_finanziamento">Finanziamento</label><select class="form-control" id="field_finanziamento" name="finanziamento" ng-model="vm.gae.finanziamento" ng-options="finanziamento as \'ID: \' + finanziamento.id + \' - \' + finanziamento.codice for finanziamento in vm.finanziamentos | orderBy:\'id\' track by finanziamento.id" required><option value=""></option></select></div><div ng-show="editForm.finanziamento.$invalid"><p class="help-block" ng-show="editForm.finanziamento.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="ordiniApp.gae.struttura" for="field_struttura">Struttura</label><select class="form-control" id="field_struttura" name="struttura" ng-model="vm.gae.struttura" ng-options="struttura as struttura.uo for struttura in vm.strutturas track by struttura.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></div></form>');
$templateCache.put('app/entities/gae/gaes.html','<div><h2 data-translate="ordiniApp.gae.home.title">Gaes</h2><jhi-alert></jhi-alert><!-- \tinca$ - gestiore errore piu\' sofisticata --><jhi-alert-error></jhi-alert-error><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="gae.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" data-translate="ordiniApp.gae.home.createLabel">Create new Gae</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'ordiniApp.gae.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="esercizio"><span data-translate="ordiniApp.gae.esercizio">Esercizio</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="visualizza"><span data-translate="ordiniApp.gae.visualizza">Visualizza</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw" field-type="boolean"></i></th><th><span jh-sort-by="codice"><span data-translate="ordiniApp.gae.codice">Codice</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="descrizione"><span data-translate="ordiniApp.gae.descrizione">Descrizione</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="fonteFondi"><span data-translate="ordiniApp.gae.fonteFondi">Fonte Fondi</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw" field-domain="ordiniApp.FontiFinanziamento"></i></th><th><span jh-sort-by="cup"><span data-translate="ordiniApp.gae.cup">Cup</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="finanziamento.codice"><span data-translate="ordiniApp.gae.finanziamento">Finanziamento</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="struttura.uo"><span data-translate="ordiniApp.gae.struttura">Struttura</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th></th></tr></thead><tbody><tr ng-repeat="gae in vm.gaes track by gae.id"><td><a ui-sref="gae-detail({id:gae.id})">{{gae.id}}</a></td><td>{{gae.esercizio}}</td><!--                     <td>{{gae.visualizza}}</td> --><td><input type="checkbox" ng-model="gae.visualizza" disabled="disabled"></td><td>{{gae.codice}}</td><td>{{gae.descrizione}}</td><td data-translate="{{\'ordiniApp.FontiFinanziamento.\' + gae.fonteFondi}}">{{gae.fonteFondi}}</td><td>{{gae.cup}}</td><td><a ui-sref="finanziamento-detail({id:gae.finanziamento.id})">{{gae.finanziamento.codice}}</a></td><td><a ui-sref="struttura-detail({id:gae.struttura.id})">{{gae.struttura.uo}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="gae-detail({id:gae.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span></button> <button type="submit" ui-sref="gae.edit({id:gae.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span></button> <button type="submit" ui-sref="gae.delete({id:gae.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/impegno/impegno-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.impegno.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="ordiniApp.impegno.delete.question" translate-values="{id: \'{{vm.impegno.id}}\'}">Are you sure you want to delete this Impegno?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/impegno/impegno-detail.html','<div><h2><span data-translate="ordiniApp.impegno.detail.title">Impegno</span> {{vm.impegno.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="ordiniApp.impegno.esercizio">Esercizio</span></dt><dd><span>{{vm.impegno.esercizio}}</span></dd><dt><span data-translate="ordiniApp.impegno.esercizioOrigine">Esercizio Origine</span></dt><dd><span>{{vm.impegno.esercizioOrigine}}</span></dd><dt><span data-translate="ordiniApp.impegno.codice">Codice</span></dt><dd><span>{{vm.impegno.codice}}</span></dd><dt><span data-translate="ordiniApp.impegno.descrizione">Descrizione</span></dt><dd><span>{{vm.impegno.descrizione}}</span></dd><dt><span data-translate="ordiniApp.impegno.gae">Gae</span></dt><dd><a ui-sref="gae-detail({id:vm.impegno.gae.id})">{{vm.impegno.gae.codice}}</a></dd><dt><span data-translate="ordiniApp.impegno.struttura">Struttura</span></dt><dd><a ui-sref="struttura-detail({id:vm.impegno.struttura.id})">{{vm.impegno.struttura.uo}}</a></dd><dt><span data-translate="ordiniApp.impegno.decisione">Decisione</span></dt><dd><a ui-sref="decisione-detail({id:vm.impegno.decisione.id})">{{vm.impegno.decisione.id}}</a></dd><dt><span data-translate="ordiniApp.impegno.voceBilancio">Voce Bilancio</span></dt><dd><a ui-sref="voce-bilancio-detail({id:vm.impegno.voceBilancio.id})">{{vm.impegno.voceBilancio.codice}}</a></dd><dt><span data-translate="ordiniApp.impegno.compilatore">Compilatore</span></dt><dd><a ui-sref="utente-detail({id:vm.impegno.compilatore.id})">{{vm.impegno.compilatore.user.login}}</a></dd><dt><span data-translate="ordiniApp.impegno.delegato">Delegato</span></dt><dd><a ui-sref="utente-detail({id:vm.impegno.delegato.id})">{{vm.impegno.delegato.user.login}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="impegno-detail.edit({id:vm.impegno.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/impegno/impegno-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myImpegnoLabel" data-translate="ordiniApp.impegno.home.createOrEditLabel">Create or edit a Impegno</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.impegno.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.impegno.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.impegno.esercizio" for="field_esercizio">Esercizio</label><input type="number" class="form-control" name="esercizio" id="field_esercizio" ng-model="vm.impegno.esercizio" required><div ng-show="editForm.esercizio.$invalid"><p class="help-block" ng-show="editForm.esercizio.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.esercizio.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.impegno.esercizioOrigine" for="field_esercizioOrigine">Esercizio Origine</label><input type="number" class="form-control" name="esercizioOrigine" id="field_esercizioOrigine" ng-model="vm.impegno.esercizioOrigine" required><div ng-show="editForm.esercizioOrigine.$invalid"><p class="help-block" ng-show="editForm.esercizioOrigine.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.esercizioOrigine.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.impegno.codice" for="field_codice">Codice</label><input type="text" class="form-control" name="codice" id="field_codice" ng-model="vm.impegno.codice" required ng-maxlength="255"><div ng-show="editForm.codice.$invalid"><p class="help-block" ng-show="editForm.codice.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.codice.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.impegno.descrizione" for="field_descrizione">Descrizione</label><input type="text" class="form-control" name="descrizione" id="field_descrizione" ng-model="vm.impegno.descrizione" required ng-maxlength="1000"><div ng-show="editForm.descrizione.$invalid"><p class="help-block" ng-show="editForm.descrizione.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.descrizione.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="1000">This field cannot be longer than 1000 characters.</p></div></div><div class="form-group"><label data-translate="ordiniApp.impegno.gae" for="field_gae">Gae</label><select class="form-control" id="field_gae" name="gae" ng-model="vm.impegno.gae" ng-options="gae as gae.codice for gae in vm.gaes | orderBy:\'codice\' track by gae.id" required><option value=""></option></select></div><div ng-show="editForm.gae.$invalid"><p class="help-block" ng-show="editForm.gae.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="ordiniApp.impegno.voceBilancio" for="field_voceBilancio">Voce Bilancio</label><select class="form-control" id="field_voceBilancio" name="voceBilancio" ng-model="vm.impegno.voceBilancio" ng-options="voceBilancio as voceBilancio.codice+\' - \'+voceBilancio.descrizione for voceBilancio in vm.vocebilancios | orderBy:\'id\' track by voceBilancio.id"><option value=""></option></select></div><div class="form-group"><label data-translate="ordiniApp.impegno.compilatore" for="field_compilatore">Compilatore</label><select class="form-control" id="field_compilatore" name="compilatore" ng-model="vm.impegno.compilatore" ng-options="utente as utente.user.firstName+\' \'+utente.user.lastName for utente in vm.utentes | orderBy:\'user.lastName\' track by utente.id"><option value=""></option></select></div><div class="form-group"><label data-translate="ordiniApp.impegno.delegato" for="field_delegato">Delegato</label><select class="form-control" id="field_delegato" name="delegato" ng-model="vm.impegno.delegato" ng-options="utente as utente.user.firstName+\' \'+utente.user.lastName for utente in vm.utentes | orderBy:\'user.lastName\' track by utente.id"><option value=""></option></select></div><div class="form-group"><label data-translate="ordiniApp.impegno.struttura" for="field_struttura">Struttura</label><select class="form-control" id="field_struttura" name="struttura" ng-model="vm.impegno.struttura" ng-options="struttura as struttura.uo for struttura in vm.strutturas track by struttura.id"><option value=""></option></select></div><div class="form-group" ng-show="vm.impegno.decisione.id"><label data-translate="ordiniApp.impegno.decisione" for="field_decisione">Decisione</label><input type="text" class="form-control" id="field_decisione" name="decisione" ng-model="vm.impegno.decisione.id" readonly="readonly"></div><div class="form-group"><label data-translate="ordiniApp.impegno.decisione" for="field_decisione">Decisione</label><input type="text" class="form-control" id="field_decisione" name="decisione" ng-model="vm.impegnoEsteso" readonly="readonly"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/impegno/impegnos.html','<div><h2 data-translate="ordiniApp.impegno.home.title">Impegnos</h2><jhi-alert></jhi-alert><!-- \tinca$ - gestiore errore piu\' sofisticata --><jhi-alert-error></jhi-alert-error><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="impegno.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" data-translate="ordiniApp.impegno.home.createLabel">Create new Impegno</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'ordiniApp.impegno.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="esercizio"><span data-translate="ordiniApp.impegno.esercizio">Esercizio</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="esercizioOrigine"><span data-translate="ordiniApp.impegno.esercizioOrigine">Esercizio Origine</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="codice"><span data-translate="ordiniApp.impegno.codice">Codice</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="descrizione"><span data-translate="ordiniApp.impegno.descrizione">Descrizione</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="gae.codice"><span data-translate="ordiniApp.impegno.gae">Gae</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="voceBilancio.codice"><span data-translate="ordiniApp.impegno.voceBilancio">Voce Bilancio</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="compilatore.user.login"><span data-translate="ordiniApp.impegno.compilatore">Compilatore</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="delegato.user.login"><span data-translate="ordiniApp.impegno.delegato">Delegato</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="struttura.uo"><span data-translate="ordiniApp.impegno.struttura">Struttura</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="decisione.id"><span data-translate="ordiniApp.impegno.decisione">Decisione</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th></th></tr></thead><tbody><tr ng-repeat="impegno in vm.impegnos track by impegno.id"><td><a ui-sref="impegno-detail({id:impegno.id})">{{impegno.id}}</a></td><td>{{impegno.esercizio}}</td><td>{{impegno.esercizioOrigine}}</td><td>{{impegno.codice}}</td><td>{{impegno.descrizione}}</td><td><a ui-sref="gae-detail({id:impegno.gae.id})">{{impegno.gae.codice}}</a></td><td><a ui-sref="voce-bilancio-detail({id:impegno.voceBilancio.id})">{{impegno.voceBilancio.codice}}</a></td><td><a ui-sref="utente-detail({id:impegno.compilatore.id})">{{impegno.compilatore.user.login}}</a></td><td><a ui-sref="utente-detail({id:impegno.delegato.id})">{{impegno.delegato.user.login}}</a></td><td><a ui-sref="struttura-detail({id:impegno.struttura.id})">{{impegno.struttura.uo}}</a></td><td><a ui-sref="decisione-detail({id:impegno.decisione.id})">{{impegno.decisione.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="impegno-detail({id:impegno.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span></button> <button type="submit" ui-sref="impegno.edit({id:impegno.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span></button> <button type="submit" ui-sref="impegno.delete({id:impegno.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/modello/modello-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.modello.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="ordiniApp.modello.delete.question" translate-values="{id: \'{{vm.modello.id}}\'}">Are you sure you want to delete this Modello?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/modello/modello-detail.html','<div><h2><span data-translate="ordiniApp.modello.detail.title">Modello</span> {{vm.modello.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="ordiniApp.modello.descrizione">Descrizione</span></dt><dd><span>{{vm.modello.descrizione}}</span></dd><dt><span data-translate="ordiniApp.modello.tipo">Tipo</span></dt><dd><span data-translate="{{\'ordiniApp.TipoModello.\' + vm.modello.tipo}}">{{vm.modello.tipo}}</span></dd><dt><span data-translate="ordiniApp.modello.file">File</span></dt><dd><div ng-if="vm.modello.file"><a ng-click="vm.openFile(vm.modello.fileContentType, vm.modello.file)" data-translate="entity.action.open">open</a> {{vm.modello.fileContentType}}, {{vm.byteSize(vm.modello.file)}}</div></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="modello-detail.edit({id:vm.modello.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/modello/modello-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myModelloLabel" data-translate="ordiniApp.modello.home.createOrEditLabel">Create or edit a Modello</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.modello.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.modello.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.modello.descrizione" for="field_descrizione">Descrizione</label><input type="text" class="form-control" name="descrizione" id="field_descrizione" ng-model="vm.modello.descrizione" required><div ng-show="editForm.descrizione.$invalid"><p class="help-block" ng-show="editForm.descrizione.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.modello.tipo" for="field_tipo">Tipo</label><select class="form-control" name="tipo" ng-model="vm.modello.tipo" id="field_tipo" required><option value="DECISIONE_DI_CONTRATTARE" data-translate="ordiniApp.TipoModello.DECISIONE_DI_CONTRATTARE">DECISIONE_DI_CONTRATTARE</option><option value="DICHIARAZIONE" data-translate="ordiniApp.TipoModello.DICHIARAZIONE">DICHIARAZIONE</option><option value="ORDINE" data-translate="ordiniApp.TipoModello.ORDINE">ORDINE</option></select><div ng-show="editForm.tipo.$invalid"><p class="help-block" ng-show="editForm.tipo.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group" ngf-drop ngf-change="vm.setFile($file, vm.modello)"><label class="control-label" data-translate="ordiniApp.modello.file" for="field_file">File</label><div><div ng-if="vm.modello.file" class="help-block clearfix"><a class="pull-left" ng-click="vm.openFile(vm.modello.fileContentType, vm.modello.file)" data-translate="entity.action.open">open</a><br><span class="pull-left">{{vm.modello.fileContentType}}, {{vm.byteSize(vm.modello.file)}}</span> <button type="button" ng-click="vm.modello.file=null;vm.modello.fileContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setFile($file, vm.modello)" data-translate="entity.action.addblob">Add blob</button></div><input type="hidden" class="form-control" name="file" id="field_file" ng-model="vm.modello.file"> <input type="hidden" class="form-control" name="fileContentType" id="field_fileContentType" ng-model="vm.modello.fileContentType"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/modello/modellos.html','<div><h2 data-translate="ordiniApp.modello.home.title">Modellos</h2><jhi-alert></jhi-alert><!-- \tinca$ - gestiore errore piu\' sofisticata --><jhi-alert-error></jhi-alert-error><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="modello.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" data-translate="ordiniApp.modello.home.createLabel">Create new Modello</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'ordiniApp.modello.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="descrizione"><span data-translate="ordiniApp.modello.descrizione">Descrizione</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="tipo"><span data-translate="ordiniApp.modello.tipo">Tipo</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw" field-domain="ordiniApp.TipoModello"></i></th><th><span jh-sort-by="file"><span data-translate="ordiniApp.modello.file">File</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th></th></tr></thead><tbody><tr ng-repeat="modello in vm.modellos track by modello.id"><td><a ui-sref="modello-detail({id:modello.id})">{{modello.id}}</a></td><td>{{modello.descrizione}}</td><td data-translate="{{\'ordiniApp.TipoModello.\' + modello.tipo}}">{{modello.tipo}}</td><td><a ng-if="modello.file" ng-click="vm.openFile(modello.fileContentType, modello.file)" data-translate="entity.action.open">open</a> <span ng-if="modello.file">{{modello.fileContentType}}, {{vm.byteSize(modello.file)}}</span></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="modello-detail({id:modello.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span></button> <button type="submit" ui-sref="modello.edit({id:modello.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span></button> <button type="submit" ui-sref="modello.delete({id:modello.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/operazione/operazione-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.operazione.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="ordiniApp.operazione.delete.question" translate-values="{id: \'{{vm.operazione.id}}\'}">Are you sure you want to delete this Operazione?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/operazione/operazione-detail.html','<div><h2><span data-translate="ordiniApp.operazione.detail.title">Operazione</span> {{vm.operazione.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="ordiniApp.operazione.codice">Codice</span></dt><dd><span>{{vm.operazione.codice}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="operazione-detail.edit({id:vm.operazione.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/operazione/operazione-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myOperazioneLabel" data-translate="ordiniApp.operazione.home.createOrEditLabel">Create or edit a Operazione</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.operazione.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.operazione.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.operazione.codice" for="field_codice">Codice</label><input type="text" class="form-control" name="codice" id="field_codice" ng-model="vm.operazione.codice" required><div ng-show="editForm.codice.$invalid"><p class="help-block" ng-show="editForm.codice.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/operazione/operaziones.html','<div><h2 data-translate="ordiniApp.operazione.home.title">Operaziones</h2><!-- \tinca$ - gestiore errore piu\' sofisticata --><jhi-alert-error></jhi-alert-error><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="operazione.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" data-translate="ordiniApp.operazione.home.createLabel">Create new Operazione</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'ordiniApp.operazione.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="ordiniApp.operazione.codice">Codice</span></th><th></th></tr></thead><tbody><tr ng-repeat="operazione in vm.operaziones track by operazione.id"><td><a ui-sref="operazione-detail({id:operazione.id})">{{operazione.id}}</a></td><td>{{operazione.codice}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="operazione-detail({id:operazione.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span></button> <button type="submit" ui-sref="operazione.edit({id:operazione.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span></button> <button type="submit" ui-sref="operazione.delete({id:operazione.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/ordine/ordine-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.ordine.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="ordiniApp.ordine.delete.question" translate-values="{id: \'{{vm.ordine.id}}\'}">Are you sure you want to delete this Ordine?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/ordine/ordine-detail.html','<div><h2><span data-translate="ordiniApp.ordine.detail.title">Ordine</span> {{vm.ordine.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="ordiniApp.ordine.dichiarazione">Dichiarazione</span></dt><dd><a ui-sref="dichiarazione-detail({id:vm.ordine.dichiarazione.id})">{{vm.ordine.dichiarazione.id}}</a></dd><dt><span data-translate="ordiniApp.ordine.stato">Stato</span></dt><dd><span data-translate="{{\'ordiniApp.StatoOrdine.\' + vm.ordine.stato}}">{{vm.ordine.stato}}</span></dd><dt><span data-translate="ordiniApp.ordine.codiceTerzoFornitore">Codice Terzo Fornitore</span></dt><dd><span>{{vm.ordine.codiceTerzoFornitore}}</span></dd><dt><span data-translate="ordiniApp.ordine.dataProtocolloOrdine">Data Protocollo Ordine</span></dt><dd><span>{{vm.ordine.dataProtocolloOrdine | date:\'mediumDate\'}}</span></dd><dt><span data-translate="ordiniApp.ordine.annoContratto">Anno Contratto</span></dt><dd><span>{{vm.ordine.annoContratto}}</span></dd><dt><span data-translate="ordiniApp.ordine.identificativoContratto">Identificativo Contratto</span></dt><dd><span>{{vm.ordine.identificativoContratto}}</span></dd><dt><span data-translate="ordiniApp.ordine.destinatarioOrdine">Destinatario Ordine</span></dt><dd><span>{{vm.ordine.destinatarioOrdine}}</span></dd><dt><span data-translate="ordiniApp.ordine.numeroOfferta">Numero Offerta</span></dt><dd><span>{{vm.ordine.numeroOfferta}}</span></dd><dt><span data-translate="ordiniApp.ordine.dataOfferta">Data Offerta</span></dt><dd><span>{{vm.ordine.dataOfferta | date:\'mediumDate\'}}</span></dd><dt><span data-translate="ordiniApp.ordine.consegnatariMerce">Consegnatari Merce</span></dt><dd><span>{{vm.ordine.consegnatariMerce}}</span></dd><dt><span data-translate="ordiniApp.ordine.luogoConsegna">Luogo Consegna</span></dt><dd><span>{{vm.ordine.luogoConsegna}}</span></dd><dt><span data-translate="ordiniApp.ordine.extraUE">Extra UE</span></dt><dd><span>{{vm.ordine.extraUE}}</span></dd><dt><span data-translate="ordiniApp.ordine.valuta">Valuta</span></dt><dd><span>{{vm.ordine.valuta}}</span></dd><dt><span data-translate="ordiniApp.ordine.percentualeIva">Percentuale Iva</span></dt><dd><span>{{vm.ordine.percentualeIva}}</span></dd><dt><span data-translate="ordiniApp.ordine.informazioniProgetto">Informazioni Progetto</span></dt><dd><span>{{vm.ordine.informazioniProgetto}}</span></dd><dt><span data-translate="ordiniApp.ordine.motivazioneRifiuto">Motivazione Rifiuto</span></dt><dd><span>{{vm.ordine.motivazioneRifiuto}}</span></dd><dt><span data-translate="ordiniApp.documento.file">File</span></dt><dd><div ng-if="vm.ordine.documentoPdf.file||vm.ordine.documentoPdf.simpleStorageService"><a ng-click="vm.openStorageFile(vm.ordine.documentoPdf)" data-translate="entity.action.open">open</a> {{vm.ordine.documentoPdf.fileContentType}} {{vm.byteSize(vm.ordine.documentoPdf.file)}}</div></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="ordine-detail.edit({id:vm.ordine.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/ordine/ordine-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><!--  inca$ - aggiunta ng-hide --> <button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-hide="vm.isPreview" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myOrdineLabel" data-translate="ordiniApp.ordine.home.createOrEditLabel">Create or edit a Ordine</h4></div><div class="stato-visibile form-group col-xs-4"><!--         <label class="control-label" data-translate="ordiniApp.ordine.stato" for="field_stato">Stato</label> --> <input type="text" ng-class="vm.statoColour(vm.ordine.stato)" name="stato" id="field_stato" ng-model="vm.ordine.stato" readonly="readonly"></div><div class="stato-visibile-clear"><div>&nbsp;</div><div>&nbsp;</div><div>&nbsp;</div><div class="modal-body" ng-controller="TypeaheadCtrl"><jhi-alert-error></jhi-alert-error><div class="form-group"><label>Dichiarazione RUP</label><div class="input-group"><select ng-class="vm.statoLinkedColour(vm.ordine.dichiarazione.stato, \'dichiarazione\', \'form-control\')" id="field_dichiarazione" name="dichiarazione" ng-model="vm.ordine.dichiarazione" ng-options="dichiarazione as \'ID: \'+dichiarazione.id+\' - \'+dichiarazione.decisione.impegno.codice+\' - \'+dichiarazione.stato for dichiarazione in vm.dichiaraziones | orderBy:\'id\' track by dichiarazione.id" ng-change="vm.dichiarazioneChanged()" required><option value=""></option></select><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.editDichiarazione()"><i class="glyphicon glyphicon-edit"></i></button></span></div></div><div ng-show="editForm.dichiarazione.$invalid"><p class="help-block" ng-show="editForm.dichiarazione.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label>Decisione di contrattare</label><div class="input-group"><input ng-class="vm.statoLinkedColour(vm.ordine.dichiarazione.decisione.stato, \'decisione\', \'form-control-field\')" id="field_decisione" name="decisione" ng-model="vm.decisioneEsteso" readonly="readonly"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.editDecisione()"><i class="glyphicon glyphicon-edit"></i></button></span></div></div><div class="form-group" ng-show="vm.ordine.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.ordine.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.ordine.destinatarioOrdine" for="field_destinatarioOrdine">Destinatario Ordine</label><textarea rows="6" type="text" class="form-control" name="destinatarioOrdine" id="field_destinatarioOrdine" ng-model="vm.ordine.destinatarioOrdine" uib-typeahead="value for value in getValue($viewValue)" typeahead-loading="loadingLocations" typeahead-no-results="noResults" autocomplete="off" required ng-maxlength="300"></textarea><div ng-show="editForm.destinatarioOrdine.$invalid"><p class="help-block" ng-show="editForm.destinatarioOrdine.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.destinatarioOrdine.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="300">This field cannot be longer than 300 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.ordine.numeroOfferta" for="field_numeroOfferta">Numero Offerta</label><input type="text" class="form-control" name="numeroOfferta" id="field_numeroOfferta" ng-model="vm.ordine.numeroOfferta" required ng-maxlength="100"><div ng-show="editForm.numeroOfferta.$invalid"><p class="help-block" ng-show="editForm.numeroOfferta.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.numeroOfferta.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.ordine.dataOfferta" for="field_dataOfferta">Data Offerta</label><div class="input-group"><input id="field_dataOfferta" type="text" class="form-control" name="dataOfferta" uib-datepicker-popup="{{vm.dateformat}}" ng-model="vm.ordine.dataOfferta" is-open="vm.datePickerOpenStatus.dataOfferta" clear-text="Pulisci" current-text="Oggi" close-text="Chiudi" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dataOfferta\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.dataOfferta.$invalid"><p class="help-block" ng-show="editForm.dataOfferta.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.ordine.consegnatariMerce" for="field_consegnatariMerce">Consegnatari Merce</label><input type="text" class="form-control" name="consegnatariMerce" id="field_consegnatariMerce" ng-model="vm.ordine.consegnatariMerce" uib-typeahead="value for value in getValue($viewValue)" typeahead-loading="loadingLocations" typeahead-no-results="noResults" autocomplete="off" required ng-maxlength="100"><div ng-show="editForm.consegnatariMerce.$invalid"><p class="help-block" ng-show="editForm.consegnatariMerce.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.consegnatariMerce.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.ordine.luogoConsegna" for="field_luogoConsegna">Luogo Consegna</label><input type="text" class="form-control" name="luogoConsegna" id="field_luogoConsegna" ng-model="vm.ordine.luogoConsegna" uib-typeahead="value for value in getValue($viewValue)" typeahead-loading="loadingLocations" typeahead-no-results="noResults" autocomplete="off" required ng-maxlength="200"><div ng-show="editForm.luogoConsegna.$invalid"><p class="help-block" ng-show="editForm.luogoConsegna.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.luogoConsegna.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="200">This field cannot be longer than 200 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.ordine.extraUE" for="field_extraUE">Extra UE</label><input type="checkbox" class="form-control" name="extraUE" id="field_extraUE" ng-model="vm.ordine.extraUE"><div ng-show="editForm.extraUE.$invalid"><p class="help-block" ng-show="editForm.extraUE.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.ordine.valuta" for="field_valuta">Valuta</label><!--             <input type="text" class="form-control" name="valuta" id="field_valuta" --><!--                     ng-model="vm.ordine.valuta" --><!--                     required ng-maxlength="20" /> --><div class="form-group"><select class="form-control" id="field_dichiarazione" name="valuta" ng-model="vm.ordine.valuta" ng-init="vm.ordine.valuta = vm.ordine.valuta || \'EUR\'" ng-options="currency.code as currency.code+\' - \'+currency.description for currency in vm.currencies | orderBy:\'code\'" required><option value=""></option></select></div><div ng-show="editForm.valuta.$invalid"><p class="help-block" ng-show="editForm.valuta.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.valuta.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="20">This field cannot be longer than 20 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.ordine.percentualeIva" for="field_percentualeIva">Percentuale Iva</label><input type="number" class="form-control" name="percentualeIva" id="field_percentualeIva" ng-disabled="vm.disablePercentualeIva()" ng-model="vm.ordine.percentualeIva" ng-init="vm.percentualeIvaInit()" required><div ng-show="editForm.percentualeIva.$invalid"><p class="help-block" ng-show="editForm.percentualeIva.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.percentualeIva.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.ordine.informazioniProgetto" for="field_informazioniProgetto">Informazioni Progetto</label><label class="control-label">(Opzionali)</label><textarea rows="5" type="text" class="form-control" name="informazioniProgetto" id="field_informazioniProgetto" ng-model="vm.ordine.informazioniProgetto" ng-maxlength="10000"></textarea><div ng-show="editForm.informazioniProgetto.$invalid"><p class="help-block" ng-show="editForm.informazioniProgetto.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="10000">This field cannot be longer than 10000 characters.</p></div></div><div class="form-group" ng-if="vm.showMotivazioneRifiuto()"><label class="control-label" data-translate="ordiniApp.ordine.motivazioneRifiuto" for="field_motivazioneRifiuto">Motivazione Rifiuto</label><textarea rows="5" type="text" class="form-control" name="motivazioneRifiuto" id="field_motivazioneRifiuto" ng-model="vm.ordine.motivazioneRifiuto" ng-maxlength="10000" readonly="readonly"></textarea><div ng-show="editForm.motivazioneRifiuto.$invalid"><p class="help-block" ng-show="editForm.motivazioneRifiuto.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="10000">This field cannot be longer than 10000 characters.</p></div></div><div class="form-group" ngf-drop ngf-change="vm.setFile($file, vm.ordine.documentoPdf)"><label class="control-label" data-translate="ordiniApp.documento.file" for="field_file">File</label><div><div ng-if="vm.ordine.documentoPdf.file||vm.ordine.documentoPdf.simpleStorageService" class="help-block clearfix"><a class="pull-left" ng-click="vm.openStorageFile(vm.ordine.documentoPdf)" data-translate="entity.action.open">open</a><br><a class="pull-left" ng-click="vm.downloadStorageFile(vm.ordine.documentoPdf, vm.docFileName(vm.ordine))" target="_blank">Download</a><br><span class="pull-left">{{vm.ordine.documentoPdf.fileContentType}} {{vm.byteSize(vm.ordine.documentoPdf.file)}}</span><!-- inca$ - rimozione cancellazione blob --><!--                     <button ng-click="vm.ordine.documentoPdf.file=null;vm.ordine.documentoPdf.fileContentType=null;" --><!--                             class="btn btn-default btn-xs pull-right"> --><!--                         <span class="glyphicon glyphicon-remove"></span> --><!--                     </button> --></div><!-- inca$ - rimozione aggiunta blob --><!--                 <button type="file" ngf-select class="btn btn-default btn-block" --><!--                         ngf-change="vm.setFile($file, vm.ordine)" data-translate="entity.action.addblob"> --><!--                     Add blob --><!--                 </button> --></div><input type="hidden" class="form-control" name="file" id="field_file" ng-model="vm.ordine.documentoPdf.file"> <input type="hidden" class="form-control" name="fileContentType" id="field_fileContentType" ng-model="vm.ordine.documentoPdf.fileContentType"></div><div class="panel panel-default" ng-if="vm.showProtocollo()||vm.showInformazioniAmministrazione()"><div class="panel-heading"><label class="control-label">Informazioni Amministrazione</label></div><div class="panel-body"><div class="form-group" ng-if="vm.showInformazioniAmministrazione()"><label class="control-label" data-translate="ordiniApp.ordine.codiceTerzoFornitore" for="field_codiceTerzoFornitore">Codice Terzo Fornitore</label><input type="text" class="form-control" name="codiceTerzoFornitore" id="field_codiceTerzoFornitore" ng-model="vm.ordine.codiceTerzoFornitore" ng-maxlength="100" ng-readonly="vm.disableInformazioniAmministrazione()"><div ng-show="editForm.codiceTerzoFornitore.$invalid"><p class="help-block" ng-show="editForm.codiceTerzoFornitore.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group" ng-if="vm.showInformazioniAmministrazione()"><label class="control-label" data-translate="ordiniApp.ordine.dataProtocolloOrdine" for="field_dataProtocolloOrdine">Data Protocollo Ordine</label><div class="input-group"><input id="field_dataProtocolloOrdine" type="text" class="form-control" name="dataProtocolloOrdine" uib-datepicker-popup="{{vm.dateformat}}" ng-model="vm.ordine.dataProtocolloOrdine" is-open="vm.datePickerOpenStatus.dataProtocolloOrdine" clear-text="Pulisci" current-text="Oggi" close-text="Chiudi" ng-readonly="vm.disableInformazioniAmministrazione()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dataProtocolloOrdine\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group" ng-if="vm.showInformazioniAmministrazione()"><label class="control-label" data-translate="ordiniApp.ordine.annoContratto" for="field_annoContratto">Anno Contratto</label><input type="number" class="form-control" name="annoContratto" id="field_annoContratto" ng-model="vm.ordine.annoContratto" min="1" ng-readonly="vm.disableInformazioniAmministrazione()"><div ng-show="editForm.annoContratto.$invalid"><p class="help-block" ng-show="editForm.annoContratto.$error.min" data-translate="entity.validation.min" translate-value-min="1">This field should be more than 1.</p><p class="help-block" ng-show="editForm.annoContratto.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group" ng-if="vm.showInformazioniAmministrazione()"><label class="control-label" data-translate="ordiniApp.ordine.identificativoContratto" for="field_identificativoContratto">Identificativo Contratto</label><input type="number" class="form-control" name="identificativoContratto" id="field_identificativoContratto" ng-model="vm.ordine.identificativoContratto" min="1" ng-readonly="vm.disableInformazioniAmministrazione()"><div ng-show="editForm.identificativoContratto.$invalid"><p class="help-block" ng-show="editForm.identificativoContratto.$error.min" data-translate="entity.validation.min" translate-value-min="1">This field should be more than 1.</p><p class="help-block" ng-show="editForm.identificativoContratto.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group" ng-if="vm.showProtocollo()"><label class="control-label" data-translate="ordiniApp.documento.annoProtocollo" for="field_annoProtocollo">Anno Protocollo</label><input type="number" class="form-control" name="annoProtocollo" id="field_annoProtocollo" ng-model="vm.ordine.documentoPdf.annoProtocollo" min="1" ng-readonly="vm.disableProtocollo()"><div ng-show="editForm.annoProtocollo.$invalid"><p class="help-block" ng-show="editForm.annoProtocollo.$error.min" data-translate="entity.validation.min" translate-value-min="1">This field should be more than 1.</p><p class="help-block" ng-show="editForm.annoProtocollo.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group" ng-if="vm.showProtocollo()"><label class="control-label" data-translate="ordiniApp.documento.numeroProtocollo" for="field_numeroProtocollo">Numero Protocollo</label><input type="number" class="form-control" name="numeroProtocollo" id="field_numeroProtocollo" ng-model="vm.ordine.documentoPdf.numeroProtocollo" min="1" ng-readonly="vm.disableProtocollo()"><div ng-show="editForm.numeroProtocollo.$invalid"><p class="help-block" ng-show="editForm.numeroProtocollo.$error.min" data-translate="entity.validation.min" translate-value-min="1">This field should be more than 1.</p><p class="help-block" ng-show="editForm.numeroProtocollo.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div></div></div><div class="panel panel-default"><div class="panel-heading"><label class="control-label">Dettaglio Articoli Ordine</label><button class="btn btn-default btn-xs pull-right" type="button" ng-disabled="editForm.$invalid||vm.ordine.id==null||vm.isSaving||vm.disableInsertDetails()" class="btn btn-primary btn-sm center-block" data-dismiss="alert" ng-click="vm.addDettaglioOrdine()"><span class="glyphicon glyphicon-plus-sign"></span></button></div><div class="panel-body"><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th class="text-center"><span>Quantit&agrave;</span></th><th><span>Descrizione Articolo</span></th><th><span>Codice Articolo</span></th><th class="text-right"><span>Importo Unitario</span></th><th class="text-right"><span>Totale</span></th><th></th></tr></thead><tbody><tr ng-repeat="dettaglioOrdine in vm.dettagliOrdine"><td align="center">{{dettaglioOrdine.quantita | number}}</td><td>{{dettaglioOrdine.descrizioneArticolo}}<div><em ng-if="vm.printIvaOnDetails()">IVA: {{dettaglioOrdine.percentualeIva}}%</em> <em ng-if="dettaglioOrdine.descrizioneIva!=null&&vm.printIvaOnDetails()">- {{dettaglioOrdine.descrizioneIva}}</em></div></td><td>{{dettaglioOrdine.codiceArticolo}}</td><td align="right">{{dettaglioOrdine.importoUnitario | currency: vm.currencySymbol : 5}}</td><td align="right">{{dettaglioOrdine.quantita*dettaglioOrdine.importoUnitario | currency: vm.currencySymbol}}</td><td><button class="btn btn-default btn-xs pull-right" type="button" ng-disabled="editForm.$invalid||vm.ordine.id==null||vm.isSaving||vm.disableInsertDetails()" ng-click="vm.deleteDettaglioOrdine(dettaglioOrdine)"><span class="glyphicon glyphicon-remove"></span></button> <button class="btn btn-default btn-xs pull-right" type="button" ng-disabled="editForm.$invalid||vm.ordine.id==null||vm.isSaving||vm.disableInsertDetails()" ng-click="vm.editDettaglioOrdine(dettaglioOrdine)"><span class="glyphicon glyphicon-edit"></span></button></td></tr><tr><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td><td>&nbsp;</td></tr><tr><td></td><td></td><td align="right"><b>Imponibile</b></td><td align="right"><b>Importo IVA</b></td><td align="right"><b>Totale Ordine</b></td><td></td></tr><tr><td></td><td></td><td align="right">{{vm.totaleImponibile | currency: vm.currencySymbol}}</td><td align="right">{{vm.totaleIva | currency: vm.currencySymbol}}</td><td align="right">{{vm.totaleOrdine | currency: vm.currencySymbol}}</td><td></td></tr></tbody></table><hr></div></div></div><div class="container-fluid"><div class="row"><div class="col-xs-8 no-padding-left"><div class="input-group"><div class="form-group"><select class="form-control" name="statoForUpdate" ng-model="vm.statoForUpdate" id="field_statoForUpdate" ng-if="vm.viewUpdateStato()" required><option value="IN_COMPILAZIONE" data-translate="ordiniApp.StatoOrdine.IN_COMPILAZIONE">IN_COMPILAZIONE</option><option value="INVIATO" data-translate="ordiniApp.StatoOrdine.INVIATO">INVIATO</option><option value="INVIATO_A_AMMINISTRAZIONE" data-translate="ordiniApp.StatoOrdine.INVIATO_A_AMMINISTRAZIONE">INVIATO_A_AMMINISTRAZIONE</option><option value="RIFIUTATO_DA_RESPONSABILE" data-translate="ordiniApp.StatoOrdine.RIFIUTATO_DA_RESPONSABILE">RIFIUTATO_DA_RESPONSABILE</option><option value="INVIATO_A_DIRETTORE" data-translate="ordiniApp.StatoOrdine.INVIATO_A_DIRETTORE">INVIATO_A_DIRETTORE</option><option value="RIFIUTATO_DA_AMMINISTRAZIONE" data-translate="ordiniApp.StatoOrdine.RIFIUTATO_DA_AMMINISTRAZIONE">RIFIUTATO_DA_AMMINISTRAZIONE</option><option value="RIFIUTATO_DA_DIRETTORE" data-translate="ordiniApp.StatoOrdine.RIFIUTATO_DA_DIRETTORE">RIFIUTATO_DA_DIRETTORE</option><option value="VALIDATO" data-translate="ordiniApp.StatoOrdine.VALIDATO">VALIDATO</option></select><div ng-show="editForm.stato.$invalid"><p class="help-block" ng-show="editForm.stato.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><span class="input-group-btn"><button id="aggiorna-stato" type="button" ng-disabled="editForm.$invalid || vm.isSaving" ng-if="vm.viewUpdateStato()" class="btn btn-info" data-dismiss="alert" ng-click="vm.updateStato()"><span class="glyphicon glyphicon glyphicon-paperclip"></span>&nbsp;<span>Aggiorna Stato</span></button></span></div></div><div class="col-xs-4 no-padding-right"><button id="invia-mail" type="button" ng-disabled="editForm.$invalid || vm.isSaving" ng-if="vm.viewMailSigns()" class="btn btn-info" data-dismiss="alert" ng-click="vm.sendMailSigns()"><span class="glyphicon glyphicon glyphicon-paperclip"></span>&nbsp;<span>Invia email documenti</span></button></div></div></div></div><div class="modal-footer"><!-- \t\tinca$ - aggiunta  ng-disabled --> <button type="button" ng-disabled="vm.isPreview" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving || vm.disableSave()" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button><!-- \t\tinca$ - tasto preview --> <button id="preview-ordine" type="submit" ng-disabled="editForm.$invalid || vm.isSaving || vm.disablePreviewOrSend()" class="btn btn-primary" ng-click="vm.preview()"><span class="glyphicon glyphicon-envelope"></span>&nbsp;<span>Preview</span></button><!-- \t\tinca$ - tasto invio --> <button id="invia-ordine" type="submit" ng-disabled="editForm.$invalid || vm.isSaving || vm.isPreview || vm.disablePreviewOrSend()" class="btn btn-primary" ng-click="vm.send()"><span class="glyphicon glyphicon-send"></span>&nbsp;<span>Invia</span></button><!-- \t\tinca$ - tasto valida --> <button id="valida-ordine" type="button" ng-disabled="editForm.$invalid || vm.isSaving || vm.disableValidateOrReject()" class="btn btn-primary" data-dismiss="alert" ng-click="vm.validate()"><span class="glyphicon glyphicon-ok-circle"></span>&nbsp;<span>Valida</span></button><!-- \t\tinca$ - tasto rifiuta --> <button id="respingi-ordine" type="button" ng-disabled="editForm.$invalid || vm.isSaving || vm.disableValidateOrReject()" class="btn btn-primary" data-dismiss="alert" ng-click="vm.rejectDialogForm()"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Rifiuta</span></button></div></form>');
$templateCache.put('app/entities/ordine/ordines.html','<div><h2 data-translate="ordiniApp.ordine.home.title">Ordines</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="ordine.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" data-translate="ordiniApp.ordine.home.createLabel">Create new Ordine</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'ordiniApp.ordine.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="stato"><span data-translate="ordiniApp.ordine.stato">Stato</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw" field-domain="ordiniApp.StatoOrdine"></i></th><th><span jh-sort-by="dichiarazione.decisione.impegno.codice"><span data-translate="ordiniApp.decisione.impegno">Impegno</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="dichiarazione.decisione.responsabileProcedimento.user.login"><span data-translate="ordiniApp.decisione.responsabileProcedimento">Responsabile Procedimento</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="destinatarioOrdine"><span data-translate="ordiniApp.ordine.destinatarioOrdine">Destinatario Ordine</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="numeroOfferta"><span data-translate="ordiniApp.ordine.numeroOfferta">Numero Offerta</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="dataOfferta"><span data-translate="ordiniApp.ordine.dataOfferta">Data Offerta</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw" field-type="date"></i></th><th><span jh-sort-by="consegnatariMerce"><span data-translate="ordiniApp.ordine.consegnatariMerce">Consegnatari Merce</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="luogoConsegna"><span data-translate="ordiniApp.ordine.luogoConsegna">Luogo Consegna</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="extraUE"><span data-translate="ordiniApp.ordine.extraUE">Extra UE</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="valuta"><span data-translate="ordiniApp.ordine.valuta">Valuta</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="percentualeIva"><span data-translate="ordiniApp.ordine.percentualeIva">Percentuale Iva</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><!--                     <th><span jh-sort-by="informazioniProgetto"><span data-translate="ordiniApp.ordine.informazioniProgetto">Informazioni Progetto</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th> --><!--                     <th><span jh-sort-by="utenteCreazione"><span data-translate="ordiniApp.ordine.utenteCreazione">Utente Creazione</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th> --><!--                     <th><span jh-sort-by="dataCreazione"><span data-translate="ordiniApp.ordine.dataCreazione">Data Creazione</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw" field-type="date"></i></th> --><!--                     <th><span jh-sort-by="utenteAggiornamento"><span data-translate="ordiniApp.ordine.utenteAggiornamento">Utente Aggiornamento</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th> --><!--                     <th><span jh-sort-by="dataAggiornamento"><span data-translate="ordiniApp.ordine.dataAggiornamento">Data Aggiornamento</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw" field-type="date"></i></th> --><!--                     <th><span jh-sort-by="documentoPdf.file"><span data-translate="ordiniApp.documento.file">File</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th> --><th><span jh-sort-by="codiceTerzoFornitore"><span data-translate="ordiniApp.ordine.codiceTerzoFornitore">Codice Terzo Fornitore</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="dataProtocolloOrdine"><span data-translate="ordiniApp.ordine.dataProtocolloOrdine">Data Protocollo Ordine</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="annoContratto"><span data-translate="ordiniApp.ordine.annoContratto">Anno Contratto</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="identificativoContratto"><span data-translate="ordiniApp.ordine.identificativoContratto">Identificativo Contratto</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="documentoPdf.annoProtocollo"><span data-translate="ordiniApp.documento.annoProtocollo">Anno Protocollo</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="documentoPdf.numeroProtocollo"><span data-translate="ordiniApp.documento.numeroProtocollo">Numero Protocollo</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><!--                     <th><span jh-sort-by="versioneRecord"><span data-translate="ordiniApp.ordine.versioneRecord">Versione Record</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th> --><th><span jh-sort-by="dichiarazione.id"><span data-translate="ordiniApp.ordine.dichiarazione">Dichiarazione</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th></th></tr></thead><tbody><tr ng-repeat="ordine in vm.ordines track by ordine.id"><td><a ui-sref="ordine.edit({id:ordine.id})">{{ordine.id}}</a></td><td class="text-center"><div><p ng-class="vm.statoColour(ordine.stato)">{{ordine.stato}}</p></div></td><td><a ui-sref="impegno-detail({id:ordine.dichiarazione.decisione.impegno.id})">{{ordine.dichiarazione.decisione.impegno.codice}}</a></td><td><!--         \tinca$ - nome al posto di user --> <a ui-sref="utente-detail({id:ordine.dichiarazione.decisione.responsabileProcedimento.id})">{{vm.rupName(ordine)}}</a></td><td>{{ordine.destinatarioOrdine}}</td><td>{{ordine.numeroOfferta}}</td><td>{{ordine.dataOfferta | date:\'mediumDate\'}}</td><td>{{ordine.consegnatariMerce}}</td><td>{{ordine.luogoConsegna}}</td><td>{{ordine.extraUE}}</td><td>{{ordine.valuta}}</td><td>{{ordine.percentualeIva}}</td><!--                     <td>{{ordine.informazioniProgetto}}</td> --><!--                     <td>{{ordine.utenteCreazione}}</td> --><!--                     <td>{{ordine.dataCreazione | date:\'medium\'}}</td> --><!--                     <td>{{ordine.utenteAggiornamento}}</td> --><!--                     <td>{{ordine.dataAggiornamento | date:\'medium\'}}</td> --><!--                     <td> --><!--                         <a ng-if="ordine.documentoPdf.file" ng-click="vm.openFile(ordine.documentoPdf.fileContentType, ordine.documentoPdf.file)" data-translate="entity.action.open">open</a> --><!--                         <span ng-if="ordine.documentoPdf.file">{{ordine.documentoPdf.fileContentType}}, {{vm.byteSize(ordine.documentoPdf.file)}}</span> --><!--                     </td> --><td>{{ordine.codiceTerzoFornitore}}</td><td>{{ordine.dataProtocolloOrdine | date:\'mediumDate\'}}</td><td>{{ordine.annoContratto}}</td><td>{{ordine.identificativoContratto}}</td><td>{{ordine.documentoPdf.annoProtocollo}}</td><td>{{ordine.documentoPdf.numeroProtocollo}}</td><!--                     <td>{{ordine.versioneRecord}}</td> --><td><a ui-sref="dichiarazione-detail({id:ordine.dichiarazione.id})">{{ordine.dichiarazione.id}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="ordine-detail({id:ordine.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span></button> <button type="submit" ui-sref="ordine.edit({id:ordine.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span></button> <button type="submit" ui-sref="ordine.delete({id:ordine.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/progetto/progetto-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.progetto.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="ordiniApp.progetto.delete.question" translate-values="{id: \'{{vm.progetto.id}}\'}">Are you sure you want to delete this Progetto?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/progetto/progetto-detail.html','<div><h2><span data-translate="ordiniApp.progetto.detail.title">Progetto</span> {{vm.progetto.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="ordiniApp.progetto.codice">Codice</span></dt><dd><span>{{vm.progetto.codice}}</span></dd><dt><span data-translate="ordiniApp.progetto.titolo">Titolo</span></dt><dd><span>{{vm.progetto.titolo}}</span></dd><dt><span data-translate="ordiniApp.progetto.responsabile">Responsabile</span></dt><dd><!--         \tinca$ - user.login al posto di user --> <a ui-sref="utente-detail({id:vm.progetto.responsabile.id})">{{vm.progetto.responsabile.user.login}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="progetto-detail.edit({id:vm.progetto.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/progetto/progetto-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProgettoLabel" data-translate="ordiniApp.progetto.home.createOrEditLabel">Create or edit a Progetto</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.progetto.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.progetto.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.progetto.codice" for="field_codice">Codice</label><input type="text" class="form-control" name="codice" id="field_codice" ng-model="vm.progetto.codice" required><div ng-show="editForm.codice.$invalid"><p class="help-block" ng-show="editForm.codice.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.progetto.titolo" for="field_titolo">Titolo</label><input type="text" class="form-control" name="titolo" id="field_titolo" ng-model="vm.progetto.titolo" required><div ng-show="editForm.titolo.$invalid"><p class="help-block" ng-show="editForm.titolo.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="ordiniApp.progetto.responsabile" for="field_responsabile">Responsabile</label><!--         \tinca$ - user.login al posto di user --><select class="form-control" id="field_responsabile" name="responsabile" ng-model="vm.progetto.responsabile" ng-options="utente as utente.user.login for utente in vm.utentes | orderBy:\'user.login\' track by utente.id" required><option value=""></option></select></div><div ng-show="editForm.responsabile.$invalid"><p class="help-block" ng-show="editForm.responsabile.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/progetto/progettos.html','<div><h2 data-translate="ordiniApp.progetto.home.title">Progettos</h2><jhi-alert></jhi-alert><!-- \tinca$ - gestiore errore piu\' sofisticata --><jhi-alert-error></jhi-alert-error><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="progetto.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" data-translate="ordiniApp.progetto.home.createLabel">Create new Progetto</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'ordiniApp.progetto.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="codice"><span data-translate="ordiniApp.progetto.codice">Codice</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="titolo"><span data-translate="ordiniApp.progetto.titolo">Titolo</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="responsabile.user"><span data-translate="ordiniApp.progetto.responsabile">Responsabile</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th></th></tr></thead><tbody><tr ng-repeat="progetto in vm.progettos track by progetto.id"><td><a ui-sref="progetto-detail({id:progetto.id})">{{progetto.id}}</a></td><td>{{progetto.codice}}</td><td>{{progetto.titolo}}</td><td><!--         \tinca$ - user.login al posto di user --> <a ui-sref="utente-detail({id:progetto.responsabile.id})">{{progetto.responsabile.user.login}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="progetto-detail({id:progetto.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span></button> <button type="submit" ui-sref="progetto.edit({id:progetto.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span></button> <button type="submit" ui-sref="progetto.delete({id:progetto.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/ruolo/ruolo-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.ruolo.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="ordiniApp.ruolo.delete.question" translate-values="{id: \'{{vm.ruolo.id}}\'}">Are you sure you want to delete this Ruolo?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/ruolo/ruolo-detail.html','<div><h2><span data-translate="ordiniApp.ruolo.detail.title">Ruolo</span> {{vm.ruolo.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="ordiniApp.ruolo.nome">Nome</span></dt><dd><span>{{vm.ruolo.nome}}</span></dd><dt><span data-translate="ordiniApp.ruolo.authorityName">Authority Name</span></dt><dd><span data-translate="{{\'ordiniApp.AuthorityName.\' + vm.ruolo.authorityName}}">{{vm.ruolo.authorityName}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="ruolo-detail.edit({id:vm.ruolo.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/ruolo/ruolo-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myRuoloLabel" data-translate="ordiniApp.ruolo.home.createOrEditLabel">Create or edit a Ruolo</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.ruolo.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.ruolo.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.ruolo.nome" for="field_nome">Nome</label><input type="text" class="form-control" name="nome" id="field_nome" ng-model="vm.ruolo.nome" required><div ng-show="editForm.nome.$invalid"><p class="help-block" ng-show="editForm.nome.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.ruolo.authorityName" for="field_authorityName">Authority Name</label><select class="form-control" name="authorityName" ng-model="vm.ruolo.authorityName" id="field_authorityName" required><option value="ROLE_SUPERUTENTE" data-translate="ordiniApp.AuthorityName.ROLE_SUPERUTENTE">ROLE_SUPERUTENTE</option><option value="ROLE_COMPILATORE" data-translate="ordiniApp.AuthorityName.ROLE_COMPILATORE">ROLE_COMPILATORE</option><option value="ROLE_RESPONSABILE_DEI_FONDI" data-translate="ordiniApp.AuthorityName.ROLE_RESPONSABILE_DEI_FONDI">ROLE_RESPONSABILE_DEI_FONDI</option><option value="ROLE_AMMINISTRAZIONE" data-translate="ordiniApp.AuthorityName.ROLE_AMMINISTRAZIONE">ROLE_AMMINISTRAZIONE</option><option value="ROLE_DIRETTORE" data-translate="ordiniApp.AuthorityName.ROLE_DIRETTORE">ROLE_DIRETTORE</option></select><div ng-show="editForm.authorityName.$invalid"><p class="help-block" ng-show="editForm.authorityName.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/ruolo/ruolos.html','<div><h2 data-translate="ordiniApp.ruolo.home.title">Ruolos</h2><!-- \tinca$ - gestiore errore piu\' sofisticata --><jhi-alert-error></jhi-alert-error><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="ruolo.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" data-translate="ordiniApp.ruolo.home.createLabel">Create new Ruolo</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'ordiniApp.ruolo.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="ordiniApp.ruolo.nome">Nome</span></th><th><span data-translate="ordiniApp.ruolo.authorityName">Authority Name</span></th><th></th></tr></thead><tbody><tr ng-repeat="ruolo in vm.ruolos track by ruolo.id"><td><a ui-sref="ruolo-detail({id:ruolo.id})">{{ruolo.id}}</a></td><td>{{ruolo.nome}}</td><td data-translate="{{\'ordiniApp.AuthorityName.\' + ruolo.authorityName}}">{{ruolo.authorityName}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="ruolo-detail({id:ruolo.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span></button> <button type="submit" ui-sref="ruolo.edit({id:ruolo.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span></button> <button type="submit" ui-sref="ruolo.delete({id:ruolo.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/ruolo-funzione/ruolo-funzione-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.ruoloFunzione.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="ordiniApp.ruoloFunzione.delete.question" translate-values="{id: \'{{vm.ruoloFunzione.id}}\'}">Are you sure you want to delete this Ruolo Funzione?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/ruolo-funzione/ruolo-funzione-detail.html','<div><h2><span data-translate="ordiniApp.ruoloFunzione.detail.title">Ruolo Funzione</span> {{vm.ruoloFunzione.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="ordiniApp.ruoloFunzione.ruolo">Ruolo</span></dt><dd><a ui-sref="ruolo-detail({id:vm.ruoloFunzione.ruolo.id})">{{vm.ruoloFunzione.ruolo.nome}}</a></dd><dt><span data-translate="ordiniApp.ruoloFunzione.funzione">Funzione</span></dt><dd><a ui-sref="funzione-detail({id:vm.ruoloFunzione.funzione.id})">{{vm.ruoloFunzione.funzione.nome}}</a></dd><dt><span data-translate="ordiniApp.ruoloFunzione.operazione">Operazione</span></dt><dd><span ng-repeat="operazione in vm.ruoloFunzione.operaziones"><a ui-sref="operazione-detail({id: operazione.id})">{{operazione.codice}}</a>{{$last ? \'\' : \', \'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="ruolo-funzione-detail.edit({id:vm.ruoloFunzione.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/ruolo-funzione/ruolo-funzione-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myRuoloFunzioneLabel" data-translate="ordiniApp.ruoloFunzione.home.createOrEditLabel">Create or edit a Ruolo Funzione</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.ruoloFunzione.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.ruoloFunzione.id" readonly="readonly"></div><div class="form-group"><label data-translate="ordiniApp.ruoloFunzione.ruolo" for="field_ruolo">Ruolo</label><select class="form-control" id="field_ruolo" name="ruolo" ng-model="vm.ruoloFunzione.ruolo" ng-options="ruolo as ruolo.nome for ruolo in vm.ruolos track by ruolo.id" required><option value=""></option></select></div><div ng-show="editForm.ruolo.$invalid"><p class="help-block" ng-show="editForm.ruolo.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="ordiniApp.ruoloFunzione.funzione" for="field_funzione">Funzione</label><select class="form-control" id="field_funzione" name="funzione" ng-model="vm.ruoloFunzione.funzione" ng-options="funzione as funzione.nome for funzione in vm.funziones track by funzione.id" required><option value=""></option></select></div><div ng-show="editForm.funzione.$invalid"><p class="help-block" ng-show="editForm.funzione.$error.required" data-translate="entity.validation.required">This field is required.</p></div><div class="form-group"><label data-translate="ordiniApp.ruoloFunzione.operazione" for="field_operazione">Operazione</label><select class="form-control" id="field_operazione" multiple="multiple" name="operazione" ng-model="vm.ruoloFunzione.operaziones" ng-options="operazione as operazione.codice for operazione in vm.operaziones track by operazione.id"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/ruolo-funzione/ruolo-funziones.html','<div><h2 data-translate="ordiniApp.ruoloFunzione.home.title">Ruolo Funziones</h2><jhi-alert></jhi-alert><!-- \tinca$ - gestiore errore piu\' sofisticata --><jhi-alert-error></jhi-alert-error><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="ruolo-funzione.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" data-translate="ordiniApp.ruoloFunzione.home.createLabel">Create new Ruolo Funzione</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'ordiniApp.ruoloFunzione.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="ruolo.nome"><span data-translate="ordiniApp.ruoloFunzione.ruolo">Ruolo</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="funzione.nome"><span data-translate="ordiniApp.ruoloFunzione.funzione">Funzione</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th></th></tr></thead><tbody><tr ng-repeat="ruoloFunzione in vm.ruoloFunziones track by ruoloFunzione.id"><td><a ui-sref="ruolo-funzione-detail({id:ruoloFunzione.id})">{{ruoloFunzione.id}}</a></td><td><a ui-sref="ruolo-detail({id:ruoloFunzione.ruolo.id})">{{ruoloFunzione.ruolo.nome}}</a></td><td><a ui-sref="funzione-detail({id:ruoloFunzione.funzione.id})">{{ruoloFunzione.funzione.nome}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="ruolo-funzione-detail({id:ruoloFunzione.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span></button> <button type="submit" ui-sref="ruolo-funzione.edit({id:ruoloFunzione.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span></button> <button type="submit" ui-sref="ruolo-funzione.delete({id:ruoloFunzione.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/struttura/struttura-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.struttura.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="ordiniApp.struttura.delete.question" translate-values="{id: \'{{vm.struttura.id}}\'}">Are you sure you want to delete this Struttura?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/struttura/struttura-detail.html','<div><h2><span data-translate="ordiniApp.struttura.detail.title">Struttura</span> {{vm.struttura.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="ordiniApp.struttura.uo">Uo</span></dt><dd><span>{{vm.struttura.uo}}</span></dd><dt><span data-translate="ordiniApp.struttura.descrizione">Descrizione</span></dt><dd><span>{{vm.struttura.descrizione}}</span></dd><dt><span data-translate="ordiniApp.struttura.modello">Modello</span></dt><dd><span ng-repeat="modello in vm.struttura.modellos"><a ui-sref="modello-detail({id: modello.id})">{{modello.descrizione}}</a>{{$last ? \'\' : \', \'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="struttura-detail.edit({id:vm.struttura.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/struttura/struttura-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myStrutturaLabel" data-translate="ordiniApp.struttura.home.createOrEditLabel">Create or edit a Struttura</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.struttura.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.struttura.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.struttura.uo" for="field_uo">Uo</label><input type="text" class="form-control" name="uo" id="field_uo" ng-model="vm.struttura.uo" required><div ng-show="editForm.uo.$invalid"><p class="help-block" ng-show="editForm.uo.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.struttura.descrizione" for="field_descrizione">Descrizione</label><input type="text" class="form-control" name="descrizione" id="field_descrizione" ng-model="vm.struttura.descrizione" required><div ng-show="editForm.descrizione.$invalid"><p class="help-block" ng-show="editForm.descrizione.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label data-translate="ordiniApp.struttura.modello" for="field_modello">Modello</label><select class="form-control" id="field_modello" multiple="multiple" name="modello" ng-model="vm.struttura.modellos" ng-options="modello as modello.descrizione for modello in vm.modellos track by modello.id"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/struttura/strutturas.html','<div><h2 data-translate="ordiniApp.struttura.home.title">Strutturas</h2><jhi-alert></jhi-alert><!-- \tinca$ - gestiore errore piu\' sofisticata --><jhi-alert-error></jhi-alert-error><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="struttura.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" data-translate="ordiniApp.struttura.home.createLabel">Create new Struttura</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'ordiniApp.struttura.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="uo"><span data-translate="ordiniApp.struttura.uo">Uo</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="descrizione"><span data-translate="ordiniApp.struttura.descrizione">Descrizione</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th></th></tr></thead><tbody><tr ng-repeat="struttura in vm.strutturas track by struttura.id"><td><a ui-sref="struttura-detail({id:struttura.id})">{{struttura.id}}</a></td><td>{{struttura.uo}}</td><td>{{struttura.descrizione}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="struttura-detail({id:struttura.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span></button> <button type="submit" ui-sref="struttura.edit({id:struttura.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span></button> <button type="submit" ui-sref="struttura.delete({id:struttura.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/utente/utente-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.utente.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="ordiniApp.utente.delete.question" translate-values="{id: \'{{vm.utente.id}}\'}">Are you sure you want to delete this Utente?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/utente/utente-detail.html','<div><h2><span data-translate="ordiniApp.utente.detail.title">Utente</span> {{vm.utente.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="ordiniApp.utente.user">User</span></dt><dd>{{vm.utente.user.login}}</dd><dt><span data-translate="ordiniApp.utente.sesso">Sesso</span></dt><dd><span data-translate="{{\'ordiniApp.TipoSesso.\' + vm.utente.sesso}}">{{vm.utente.sesso}}</span></dd><dt><span data-translate="ordiniApp.utente.titolo">Titolo</span></dt><dd><span>{{vm.utente.titolo}}</span></dd><dt><span data-translate="ordiniApp.utente.titoloLavorativo">Titolo Lavorativo</span></dt><dd><span>{{vm.utente.titoloLavorativo}}</span></dd><dt><span data-translate="ordiniApp.utente.sezione">Sezione</span></dt><dd><span>{{vm.utente.sezione}}</span></dd><dt><span data-translate="ordiniApp.utente.firma">Firma</span></dt><dd><div ng-if="vm.utente.firma"><a ng-click="vm.openFile(vm.utente.firmaContentType, vm.utente.firma)" data-translate="entity.action.open">open</a> {{vm.utente.firmaContentType}}, {{vm.byteSize(vm.utente.firma)}}</div></dd><dt><span data-translate="ordiniApp.utente.direttore">Direttore</span></dt><dd><!--             <span>{{vm.utente.direttore}}</span> --> <span><input type="checkbox" ng-model="vm.utente.direttore" disabled="disabled"></span></dd><dt><span data-translate="ordiniApp.utente.dataInizioDirezione">Data Inizio Direzione</span></dt><dd><span>{{vm.utente.dataInizioDirezione | date:\'mediumDate\'}}</span></dd><dt><span data-translate="ordiniApp.utente.dataFineDirezione">Data Fine Direzione</span></dt><dd><span>{{vm.utente.dataFineDirezione | date:\'mediumDate\'}}</span></dd><dt><span data-translate="ordiniApp.utente.struttura">Struttura</span></dt><dd><a ui-sref="struttura-detail({id:vm.utente.struttura.id})">{{vm.utente.struttura.descrizione}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="utente-detail.edit({id:vm.utente.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/utente/utente-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUtenteLabel" data-translate="ordiniApp.utente.home.createOrEditLabel">Create or edit a Utente</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.utente.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.utente.id" readonly="readonly"></div><div class="form-group"><label data-translate="ordiniApp.utente.user" for="field_user">User</label><select class="form-control" id="field_user" name="user" ng-model="vm.utente.user" ng-options="user as user.login for user in vm.users | orderBy:\'login\' track by user.id"><option value=""></option></select></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.utente.sesso" for="field_sesso">Sesso</label><select class="form-control" name="sesso" ng-model="vm.utente.sesso" id="field_sesso" required><option value="MASCHIO" data-translate="ordiniApp.TipoSesso.MASCHIO">MASCHIO</option><option value="FEMMINA" data-translate="ordiniApp.TipoSesso.FEMMINA">FEMMINA</option></select><div ng-show="editForm.sesso.$invalid"><p class="help-block" ng-show="editForm.sesso.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.utente.titolo" for="field_titolo">Titolo</label><input type="text" class="form-control" name="titolo" id="field_titolo" ng-model="vm.utente.titolo" required><div ng-show="editForm.titolo.$invalid"><p class="help-block" ng-show="editForm.titolo.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.utente.titoloLavorativo" for="field_titoloLavorativo">Titolo Lavorativo</label><input type="text" class="form-control" name="titoloLavorativo" id="field_titoloLavorativo" ng-model="vm.utente.titoloLavorativo" required><div ng-show="editForm.titoloLavorativo.$invalid"><p class="help-block" ng-show="editForm.titoloLavorativo.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.utente.sezione" for="field_sezione">Sezione</label><input type="text" class="form-control" name="sezione" id="field_sezione" ng-model="vm.utente.sezione"></div><div class="form-group" ngf-drop ngf-change="vm.setFirma($file, vm.utente)"><label class="control-label" data-translate="ordiniApp.utente.firma" for="field_firma">Firma</label><div><div ng-if="vm.utente.firma" class="help-block clearfix"><a class="pull-left" ng-click="vm.openFile(vm.utente.firmaContentType, vm.utente.firma)" data-translate="entity.action.open">open</a><br><span class="pull-left">{{vm.utente.firmaContentType}}, {{vm.byteSize(vm.utente.firma)}}</span> <button type="button" ng-click="vm.utente.firma=null;vm.utente.firmaContentType=null;" class="btn btn-default btn-xs pull-right"><span class="glyphicon glyphicon-remove"></span></button></div><button type="button" ngf-select class="btn btn-default btn-block" ngf-change="vm.setFirma($file, vm.utente)" data-translate="entity.action.addblob">Add blob</button></div><input type="hidden" class="form-control" name="firma" id="field_firma" ng-model="vm.utente.firma"> <input type="hidden" class="form-control" name="firmaContentType" id="field_firmaContentType" ng-model="vm.utente.firmaContentType"></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.utente.direttore" for="field_direttore">Direttore</label><input type="checkbox" class="form-control" name="direttore" id="field_direttore" ng-model="vm.utente.direttore"><div ng-show="editForm.direttore.$invalid"><p class="help-block" ng-show="editForm.direttore.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.utente.dataInizioDirezione" for="field_dataInizioDirezione">Data Inizio Direzione</label><div class="input-group"><input id="field_dataInizioDirezione" type="text" class="form-control" name="dataInizioDirezione" uib-datepicker-popup="{{dateformat}}" ng-model="vm.utente.dataInizioDirezione" is-open="vm.datePickerOpenStatus.dataInizioDirezione"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dataInizioDirezione\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.utente.dataFineDirezione" for="field_dataFineDirezione">Data Fine Direzione</label><div class="input-group"><input id="field_dataFineDirezione" type="text" class="form-control" name="dataFineDirezione" uib-datepicker-popup="{{dateformat}}" ng-model="vm.utente.dataFineDirezione" is-open="vm.datePickerOpenStatus.dataFineDirezione"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dataFineDirezione\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label data-translate="ordiniApp.utente.struttura" for="field_struttura">Struttura</label><select class="form-control" id="field_struttura" name="struttura" ng-model="vm.utente.struttura" ng-options="struttura as struttura.descrizione for struttura in vm.strutturas track by struttura.id"><option value=""></option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/utente/utentes.html','<div><h2 data-translate="ordiniApp.utente.home.title">Utentes</h2><jhi-alert></jhi-alert><!-- \tinca$ - gestiore errore piu\' sofisticata --><jhi-alert-error></jhi-alert-error><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="utente.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" data-translate="ordiniApp.utente.home.createLabel">Create new Utente</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'ordiniApp.utente.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="user.login"><span data-translate="ordiniApp.utente.user">User</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="sesso"><span data-translate="ordiniApp.utente.sesso">Sesso</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw" field-domain="ordiniApp.TipoSesso"></i></th><th><span jh-sort-by="titolo"><span data-translate="ordiniApp.utente.titolo">Titolo</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="titoloLavorativo"><span data-translate="ordiniApp.utente.titoloLavorativo">Titolo Lavorativo</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="sezione"><span data-translate="ordiniApp.utente.sezione">Sezione</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><!--                     <th><span jh-sort-by="firma"><span data-translate="ordiniApp.utente.firma">Firma</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th> --><th><span jh-sort-by="direttore"><span data-translate="ordiniApp.utente.direttore">Direttore</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="dataInizioDirezione"><span data-translate="ordiniApp.utente.dataInizioDirezione">Data Inizio Direzione</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw" field-type="boolean"></i></th><th><span jh-sort-by="dataFineDirezione"><span data-translate="ordiniApp.utente.dataFineDirezione">Data Fine Direzione</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw" field-type="date"></i></th><th><span jh-sort-by="struttura.descrizione"><span data-translate="ordiniApp.utente.struttura">Struttura</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th></th></tr></thead><tbody><tr ng-repeat="utente in vm.utentes track by utente.id"><td><a ui-sref="utente-detail({id:utente.id})">{{utente.id}}</a></td><td>{{utente.user.login}}</td><td data-translate="{{\'ordiniApp.TipoSesso.\' + utente.sesso}}">{{utente.sesso}}</td><td>{{utente.titolo}}</td><td>{{utente.titoloLavorativo}}</td><td>{{utente.sezione}}</td><!--                     <td> --><!--                         <a ng-if="utente.firma" ng-click="vm.openFile(utente.firmaContentType, utente.firma)" data-translate="entity.action.open">open</a> --><!--                         <span ng-if="utente.firma">{{utente.firmaContentType}}, {{vm.byteSize(utente.firma)}}</span> --><!--                     </td> --><!--                     <td>{{utente.direttore}}</td> --><td><input type="checkbox" ng-model="utente.direttore" disabled="disabled"></td><td>{{utente.dataInizioDirezione | date:\'mediumDate\'}}</td><td>{{utente.dataFineDirezione | date:\'mediumDate\'}}</td><td><a ui-sref="struttura-detail({id:utente.struttura.id})">{{utente.struttura.descrizione}}</a></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="utente-detail({id:utente.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="utente.edit({id:utente.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="utente.delete({id:utente.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/entities/voce-bilancio/voce-bilancio-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.voceBilancio.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="ordiniApp.voceBilancio.delete.question" translate-values="{id: \'{{vm.voceBilancio.id}}\'}">Are you sure you want to delete this Voce Bilancio?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/voce-bilancio/voce-bilancio-detail.html','<div><h2><span data-translate="ordiniApp.voceBilancio.detail.title">Voce Bilancio</span> {{vm.voceBilancio.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="ordiniApp.voceBilancio.esercizio">Esercizio</span></dt><dd><span>{{vm.voceBilancio.esercizio}}</span></dd><dt><span data-translate="ordiniApp.voceBilancio.visualizza">Visualizza</span></dt><dd><!--             <span>{{vm.voceBilancio.visualizza}}</span> --> <span><input type="checkbox" ng-model="vm.voceBilancio.visualizza" disabled="disabled"></span></dd><dt><span data-translate="ordiniApp.voceBilancio.codice">Codice</span></dt><dd><span>{{vm.voceBilancio.codice}}</span></dd><dt><span data-translate="ordiniApp.voceBilancio.codiceEsteso">Codice Esteso</span></dt><dd><span>{{vm.voceBilancio.codiceEsteso}}</span></dd><dt><span data-translate="ordiniApp.voceBilancio.descrizione">Descrizione</span></dt><dd><span>{{vm.voceBilancio.descrizione}}</span></dd><!--         <dt><span data-translate="ordiniApp.voceBilancio.utenteCreazione">Utente Creazione</span></dt> --><!--         <dd> --><!--             <span>{{vm.voceBilancio.utenteCreazione}}</span> --><!--         </dd> --><!--         <dt><span data-translate="ordiniApp.voceBilancio.dataCreazione">Data Creazione</span></dt> --><!--         <dd> --><!--             <span>{{vm.voceBilancio.dataCreazione | date:\'medium\'}}</span> --><!--         </dd> --><!--         <dt><span data-translate="ordiniApp.voceBilancio.utenteAggiornamento">Utente Aggiornamento</span></dt> --><!--         <dd> --><!--             <span>{{vm.voceBilancio.utenteAggiornamento}}</span> --><!--         </dd> --><!--         <dt><span data-translate="ordiniApp.voceBilancio.dataAggiornamento">Data Aggiornamento</span></dt> --><!--         <dd> --><!--             <span>{{vm.voceBilancio.dataAggiornamento | date:\'medium\'}}</span> --><!--         </dd> --></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="voce-bilancio-detail.edit({id:vm.voceBilancio.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/voce-bilancio/voce-bilancio-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myVoceBilancioLabel" data-translate="ordiniApp.voceBilancio.home.createOrEditLabel">Create or edit a Voce Bilancio</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.voceBilancio.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.voceBilancio.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.voceBilancio.esercizio" for="field_esercizio">Esercizio</label><input type="number" class="form-control" name="esercizio" id="field_esercizio" ng-model="vm.voceBilancio.esercizio" required><div ng-show="editForm.esercizio.$invalid"><p class="help-block" ng-show="editForm.esercizio.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.esercizio.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.voceBilancio.visualizza" for="field_visualizza">Visualizza</label><input type="checkbox" class="form-control" name="visualizza" id="field_visualizza" ng-model="vm.voceBilancio.visualizza"><div ng-show="editForm.visualizza.$invalid"><p class="help-block" ng-show="editForm.visualizza.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.voceBilancio.codice" for="field_codice">Codice</label><input type="text" class="form-control" name="codice" id="field_codice" ng-model="vm.voceBilancio.codice" required><div ng-show="editForm.codice.$invalid"><p class="help-block" ng-show="editForm.codice.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.voceBilancio.codiceEsteso" for="field_codiceEsteso">Codice Esteso</label><input type="text" class="form-control" name="codiceEsteso" id="field_codiceEsteso" ng-model="vm.voceBilancio.codiceEsteso" required><div ng-show="editForm.codiceEsteso.$invalid"><p class="help-block" ng-show="editForm.codiceEsteso.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="ordiniApp.voceBilancio.descrizione" for="field_descrizione">Descrizione</label><input type="text" class="form-control" name="descrizione" id="field_descrizione" ng-model="vm.voceBilancio.descrizione" required><div ng-show="editForm.descrizione.$invalid"><p class="help-block" ng-show="editForm.descrizione.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><!--         <div class="form-group"> --><!--             <label class="control-label" data-translate="ordiniApp.voceBilancio.utenteCreazione" for="field_utenteCreazione">Utente Creazione</label> --><!--             <input type="text" class="form-control" name="utenteCreazione" id="field_utenteCreazione" --><!--                     ng-model="vm.voceBilancio.utenteCreazione" --><!--                      /> --><!--         </div> --><!--         <div class="form-group"> --><!--             <label class="control-label" data-translate="ordiniApp.voceBilancio.dataCreazione" for="field_dataCreazione">Data Creazione</label> --><!--                 <div class="input-group"> --><!--                     <input id="field_dataCreazione" type="text" class="form-control" name="dataCreazione" datetime-picker="{{dateformat}}" ng-model="vm.voceBilancio.dataCreazione" is-open="vm.datePickerOpenStatus.dataCreazione" --><!--                       /> --><!--                     <span class="input-group-btn"> --><!--                         <button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dataCreazione\')"><i class="glyphicon glyphicon-calendar"></i></button> --><!--                     </span> --><!--                 </div> --><!--         </div> --><!--         <div class="form-group"> --><!--             <label class="control-label" data-translate="ordiniApp.voceBilancio.utenteAggiornamento" for="field_utenteAggiornamento">Utente Aggiornamento</label> --><!--             <input type="text" class="form-control" name="utenteAggiornamento" id="field_utenteAggiornamento" --><!--                     ng-model="vm.voceBilancio.utenteAggiornamento" --><!--                      /> --><!--         </div> --><!--         <div class="form-group"> --><!--             <label class="control-label" data-translate="ordiniApp.voceBilancio.dataAggiornamento" for="field_dataAggiornamento">Data Aggiornamento</label> --><!--                 <div class="input-group"> --><!--                     <input id="field_dataAggiornamento" type="text" class="form-control" name="dataAggiornamento" datetime-picker="{{dateformat}}" ng-model="vm.voceBilancio.dataAggiornamento" is-open="vm.datePickerOpenStatus.dataAggiornamento" --><!--                       /> --><!--                     <span class="input-group-btn"> --><!--                         <button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dataAggiornamento\')"><i class="glyphicon glyphicon-calendar"></i></button> --><!--                     </span> --><!--                 </div> --><!--         </div> --></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/voce-bilancio/voce-bilancios.html','<div><h2 data-translate="ordiniApp.voceBilancio.home.title">Voce Bilancios</h2><jhi-alert></jhi-alert><!-- \tinca$ - gestiore errore piu\' sofisticata --><jhi-alert-error></jhi-alert-error><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="voce-bilancio.new"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-xs" data-translate="ordiniApp.voceBilancio.home.createLabel">Create new Voce Bilancio</span></button></div><div class="col-xs-8 no-padding-right"><form name="searchForm" class="form-inline"><div class="input-group pull-right"><input type="text" class="form-control" ng-model="vm.searchQuery" id="searchQuery" placeholder="{{ \'ordiniApp.voceBilancio.home.search\' | translate }}"> <span class="input-group-btn width-min"><button class="btn btn-info" ng-click="vm.search(vm.searchQuery)"><span class="glyphicon glyphicon-search"></span></button> </span><span class="input-group-btn width-min" ng-if="vm.currentSearch"><button class="btn btn-info" ng-click="vm.clear()"><span class="glyphicon glyphicon-trash"></span></button></span></div></form></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="esercizio"><span data-translate="ordiniApp.voceBilancio.esercizio">Esercizio</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="visualizza"><span data-translate="ordiniApp.voceBilancio.visualizza">Visualizza</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw" field-type="boolean"></i></th><th><span jh-sort-by="codice"><span data-translate="ordiniApp.voceBilancio.codice">Codice</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="codiceEsteso"><span data-translate="ordiniApp.voceBilancio.codiceEsteso">Codice Esteso</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th><span jh-sort-by="descrizione"><span data-translate="ordiniApp.voceBilancio.descrizione">Descrizione</span> <span class="glyphicon glyphicon-sort"></span></span><i mi-search="vm.search" class="fa fa-search fa-fw"></i></th><th></th></tr></thead><tbody><tr ng-repeat="voceBilancio in vm.voceBilancios track by voceBilancio.id"><td><a ui-sref="voce-bilancio-detail({id:voceBilancio.id})">{{voceBilancio.id}}</a></td><td>{{voceBilancio.esercizio}}</td><!--                     <td>{{voceBilancio.visualizza}}</td> --><td><input type="checkbox" ng-model="voceBilancio.visualizza" disabled="disabled"></td><td>{{voceBilancio.codice}}</td><td>{{voceBilancio.codiceEsteso}}</td><td>{{voceBilancio.descrizione}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="voce-bilancio-detail({id:voceBilancio.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span></button> <button type="submit" ui-sref="voce-bilancio.edit({id:voceBilancio.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span></button> <button type="submit" ui-sref="voce-bilancio.delete({id:voceBilancio.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div class="alert alert-danger" data-translate="error.403">You are not authorized to access the page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="navbar navbar-default" role="navigation"><div class="container"><div class="navbar-header"><button type="button" class="navbar-toggle" ng-click="vm.toggleNavbar()"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button> <a class="navbar-brand logo" href="#/" ng-click="vm.collapseNavbar()"><img class="logo-img" src="content/images/logo-jhipster.png"> <span data-translate="global.title">Ordini</span> <span class="navbar-version">v{{VERSION}}</span></a></div><div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav navbar-right"><li ui-sref-active="active"><a ui-sref="home" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-home"></span> <span class="hidden-sm" data-translate="global.menu.home">Home</span></a></li><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><li ng-class="{active: vm.$state.includes(\'entity\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu"><span><span class="glyphicon glyphicon-th-list"></span> <span class="hidden-sm" data-translate="global.menu.entities.main">Entities </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="utente" ng-click="vm.collapseNavbar()" ng-if="vm.show(\'Utente\')"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.utente">Utente</span></a></li><li ui-sref-active="active"><a ui-sref="ruolo" ng-click="vm.collapseNavbar()" ng-if="vm.show(\'Ruolo\')"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.ruolo">Ruolo</span></a></li><li ui-sref-active="active"><a ui-sref="funzione" ng-click="vm.collapseNavbar()" ng-if="vm.show(\'Funzione\')"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.funzione">Funzione</span></a></li><li ui-sref-active="active"><a ui-sref="operazione" ng-click="vm.collapseNavbar()" ng-if="vm.show(\'Operazione\')"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.operazione">Operazione</span></a></li><li ui-sref-active="active"><a ui-sref="ruolo-funzione" ng-click="vm.collapseNavbar()" ng-if="vm.show(\'RuoloFunzione\')"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.ruoloFunzione">Ruolo-Funzione</span></a></li><li ui-sref-active="active"><a ui-sref="modello" ng-click="vm.collapseNavbar()" ng-if="vm.show(\'Modello\')"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.modello">Modello</span></a></li><li ui-sref-active="active"><a ui-sref="struttura" ng-click="vm.collapseNavbar()" ng-if="vm.show(\'Struttura\')"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.struttura">Struttura</span></a></li><li ui-sref-active="active"><a ui-sref="voce-bilancio" ng-click="vm.collapseNavbar()" ng-if="vm.show(\'VoceBilancio\')"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.voceBilancio">Voce Bilancio</span></a></li><li ui-sref-active="active"><a ui-sref="impegno" ng-click="vm.collapseNavbar()" ng-if="vm.show(\'Impegno\')"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.impegno">Impegno</span></a></li><li ui-sref-active="active"><a ui-sref="gae" ng-click="vm.collapseNavbar()" ng-if="vm.show(\'Gae\')"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.gae">Gae</span></a></li><li ui-sref-active="active"><a ui-sref="finanziamento" ng-click="vm.collapseNavbar()" ng-if="vm.show(\'Finanziamento\')"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.finanziamento">Finanziamento</span></a></li><li ui-sref-active="active"><a ui-sref="progetto" ng-click="vm.collapseNavbar()" ng-if="vm.show(\'Progetto\')"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.progetto">Progetto</span></a></li><li ui-sref-active="active"><a ui-sref="importa-impegni" ng-click="vm.collapseNavbar()" ng-if="vm.show(\'ImportaImpegni\')"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.importaImpegni">Importa Impegni da SIGLA</span></a></li><li ui-sref-active="active"><a ui-sref="documento" ng-click="vm.collapseNavbar()" ng-if="vm.show(\'Documento\')"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.documento">Documento</span></a></li><li ui-sref-active="active"><a ui-sref="decisione" ng-click="vm.collapseNavbar()" ng-if="vm.show(\'Decisione\')"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.decisione">Decisione</span></a></li><li ui-sref-active="active"><a ui-sref="dichiarazione" ng-click="vm.collapseNavbar()" ng-if="vm.show(\'Dichiarazione\')"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.dichiarazione">Dichiarazione</span></a></li><li ui-sref-active="active"><a ui-sref="ordine" ng-click="vm.collapseNavbar()" ng-if="vm.show(\'Ordine\')"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.ordine">Ordine</span></a></li><li ui-sref-active="active"><a ui-sref="dettaglio-ordine" ng-click="vm.collapseNavbar()" ng-if="vm.show(\'DettaglioOrdine\')"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.dettaglioOrdine">Dettaglio Ordine</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu"><span><span class="glyphicon glyphicon-user"></span> <span class="hidden-sm" data-translate="global.menu.account.main">Account </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="settings" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-wrench"></span>&nbsp; <span data-translate="global.menu.account.settings">Settings</span></a></li><li ui-sref-active="active" ng-switch-when="true" ng-if="vm.showSuperUser()"><a ui-sref="password" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-lock"></span>&nbsp; <span data-translate="global.menu.account.password">Password</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="sessions" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-cloud"></span>&nbsp; <span data-translate="global.menu.account.sessions">Sessions</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span data-translate="global.menu.account.logout">Sign out</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a href="" ng-click="vm.login()" id="login"><span class="glyphicon glyphicon-log-in"></span>&nbsp; <span data-translate="global.menu.account.login">Sign in</span></a></li><!--                         <li ui-sref-active="active" ng-switch-when="false"> --><!--                             <a ui-sref="register" ng-click="vm.collapseNavbar()"> --><!--                                 <span class="glyphicon glyphicon-plus-sign"></span>&nbsp; --><!--                                 <span data-translate="global.menu.account.register">Register</span> --><!--                             </a> --><!--                         </li> --></ul></li><li ng-class="{active: vm.$state.includes(\'admin\')}" ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu"><span><span class="glyphicon glyphicon-tower"></span> <span class="hidden-sm" data-translate="global.menu.admin.main">Administration</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="user-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span data-translate="global.menu.admin.userManagement">User management</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-tracker" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-eye-open"></span>&nbsp; <span data-translate="global.menu.admin.tracker">User tracker</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-dashboard"></span>&nbsp; <span data-translate="global.menu.admin.metrics">Metrics</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-health" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-heart"></span>&nbsp; <span data-translate="global.menu.admin.health">Health</span></a></li><li ui-sref-active="active"><a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span data-translate="global.menu.admin.configuration">Configuration</span></a></li><li ui-sref-active="active"><a ui-sref="audits" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-bell"></span>&nbsp; <span data-translate="global.menu.admin.audits">Audits</span></a></li><li ui-sref-active="active"><a ui-sref="logs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tasks"></span>&nbsp; <span data-translate="global.menu.admin.logs">Logs</span></a></li><li ng-show="vm.swaggerEnabled" ui-sref-active="active"><a ui-sref="docs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span data-translate="global.menu.admin.apidocs">API</span></a></li><li ui-sref-active="active"><a ui-sref="elasticsearch-reindex" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-exclamation-sign"></span>&nbsp; <span data-translate="global.menu.admin.elasticsearch-reindex">Elasticsearch Reindex</span></a></li><li ui-sref-active="active"><a ui-sref="storage" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-cloud"></span>&nbsp; <span data-translate="global.menu.admin.storage">Storage</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --><li ng-hide="vm.inProduction"><a href="/h2-console" target="_tab" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-hdd"></span>&nbsp; <span data-translate="global.menu.admin.database">Database</span></a></li></ul></li><li ui-sref-active="active" uib-dropdown class="dropdown pointer" ng-controller="JhiLanguageController as languageVm"><a class="dropdown-toggle" uib-dropdown-toggle href="" ng-if="languageVm.languages.length > 1"><span><span class="glyphicon glyphicon-flag"></span> <span class="hidden-sm" data-translate="global.menu.language">Language</span> <b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu ng-if="languageVm.languages.length > 1"><li active-menu="{{language}}" ng-repeat="language in languageVm.languages"><a href="" ng-click="languageVm.changeLanguage(language);vm.collapseNavbar();">{{language | findLanguageFromKey}}</a></li></ul></li></ul></div></div></nav>');
$templateCache.put('app/util/send/multiple-send.html','<form name="multipleSendForm" ng-submit="vm.confirm()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Invio dei documenti</h4></div><div class="modal-body"><div class="form-group alert alert-info" ng-if="vm.error!=null&&vm.error!=\'\'"><textarea rows="{{vm.errorRows}}" class="form-control alert-info-inca" ng-model="vm.error"></textarea></div><jhi-alert-error></jhi-alert-error><p>Selezionare i documenti che si desidera inviare al controllo successivo:</p><hr><div class="form-horizontal"><div class="form-group" ng-if="vm.decisione!=null"><label class="col-sm-6 control-label">Decisione di contrattare:</label><div class="col-sm-2"><input type="checkbox" class="form-control" ng-model="vm.cbDecisione" placeholder="Valore di selezione" ng-disabled="!vm.statoValido(vm.decisione.stato)"></div></div><div class="form-group" ng-if="vm.dichiarazione!=null"><label class="col-sm-6 control-label">Dichiarazione RUP:</label><div class="col-sm-2"><input type="checkbox" class="form-control" ng-model="vm.cbDichiarazione" placeholder="Valore di selezione" ng-disabled="!vm.statoValido(vm.dichiarazione.stato)"></div></div><div class="form-group" ng-if="vm.ordine!=null"><label class="col-sm-6 control-label">Ordine:</label><div class="col-sm-2"><input type="checkbox" class="form-control" ng-model="vm.cbOrdine" placeholder="Valore di selezione" ng-disabled="!vm.statoValido(vm.ordine.stato)"></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Annulla</span></button> <button type="submit" class="btn btn-primary" ng-disabled="!vm.inviaEnabled"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Invia</span></button></div></form>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="reset.finish.title">Reset password</h1><div class="alert alert-danger" data-translate="reset.finish.messages.keymissing" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p data-translate="reset.finish.messages.info">Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p data-translate="reset.finish.messages.error">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p data-translate="reset.finish.messages.success" translate-compile><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.finish.form.button">Reset Password</button></form></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="reset.request.title">Reset your password</h1><div class="alert alert-danger" data-translate="reset.request.messages.notfound" ng-show="vm.errorEmailNotExists"><strong>E-Mail address isn\'t registered!</strong> Please check and try again.</div><div class="alert alert-warning" ng-hide="vm.success"><p data-translate="reset.request.messages.info">Enter the e-mail address you used to register.</p></div><div class="alert alert-success" ng-show="vm.success == \'OK\'"><p data-translate="reset.request.messages.success">Check your e-mails for details on how to reset your password.</p></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.request.form.button">Reset</button></form></div></div></div>');}]);})();